function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("kfU2R", function(module, exports) {
    $parcel$export(module.exports, "CommandPaletteIntegration", ()=>$145d1b0a2223da5d$export$eb6ccee20cc51d7b);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $hmD0N;
    var $b5pc0;
    var $h2Vnd;
    var $d8lE2;
    var $bbRjE;
    var $9fuVs;
    var $jcw0u;
    var $4R6GH;
    var $koVbs;
    var $ezMlR;
    var $3oeAD;
    var $ht5ui;
    var $6ixD4;
    var $kqiyM;
    var $30J2m;
    var $faBOu;
    var $ad6ff;
    var $79Tnk;
    const $145d1b0a2223da5d$export$eb6ccee20cc51d7b = (props)=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("9fuVs")).default));
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ isOpen: isOpen }] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteIsOpen)();
        const { quickSearchCommand: quickSearchCommand } = (0, (0, parcelRequire("b5pc0")).useQuickSearchCommand)({
            keepSearch: true
        });
        (0, (0, parcelRequire("h2Vnd")).useCommandPaletteRegistry)();
        const onErrorAnalytics = (0, $5uXOq.useCallback)((attribution, error, id, attributes)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: `jira.commandPalette.${id}`,
                    packageName: 'jiraCommandPaletteIntegration',
                    teamName: attribution || 'deliveroo'
                },
                attributes: attributes
            });
        }, []);
        (0, (0, parcelRequire("kqiyM")).useRegisterSections)();
        (0, (0, parcelRequire("6ixD4")).useRegisterDismissCommand)();
        (0, (0, parcelRequire("ezMlR")).useCloseDotMenu)();
        (0, (0, parcelRequire("ht5ui")).useDisableCompalIfEmbed)();
        (0, (0, parcelRequire("faBOu")).useRegisterInitialCommands)();
        (0, (0, parcelRequire("3oeAD")).useCompalBridge)();
        const Wrapper = isOpen ? (0, (0, parcelRequire("9fuVs")).default) : (0, $5uXOq.Fragment);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": (0, $896c010256263437$export$70d2130cb02f61fa)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bbRjE")).CommandPaletteModal), {
            defaultFooterContent: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("30J2m")).FooterFeedbackContent), null),
            onAnalytics: (0, (0, parcelRequire("hmD0N")).handleAnalytics),
            onErrorAnalytics: onErrorAnalytics,
            ...(0, (0, parcelRequire("4R6GH")).fg)('aria_label_for_command_palette_search_input') && {
                defaultAriaLabel: formatMessage((0, (0, parcelRequire("ad6ff")).messages).defaultSearchInputAriaLabel)
            },
            defaultPlaceholder: formatMessage((0, (0, parcelRequire("ad6ff")).messages).defaultPlaceholder),
            defaultFallback: {
                onError: {
                    label: formatMessage((0, (0, parcelRequire("ad6ff")).messages).onErrorFallback)
                },
                onNoResults: {
                    label: formatMessage((0, (0, parcelRequire("ad6ff")).messages).noResultsFound)
                }
            },
            rootFallback: {
                label: formatMessage((0, (0, parcelRequire("ad6ff")).messages).noResultsFound),
                fallbackCommand: quickSearchCommand,
                fallbackSection: {
                    name: formatMessage((0, (0, parcelRequire("ad6ff")).messages).recommendedSection)
                }
            },
            ...props
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("79Tnk")).RegisterDynamicCommands), null)));
    };
});
parcelRegister("hmD0N", function(module, exports) {
    $parcel$export(module.exports, "handleAnalytics", ()=>$50c4f480d056336d$export$51232d58b72ca41a);
    var $jcw0u;
    var $8zOmE;
    const $50c4f480d056336d$var$packageName = 'jiraCommandPaletteIntegration';
    const $50c4f480d056336d$export$51232d58b72ca41a = (event, eventType, args)=>{
        const eventFunctions = {
            [(0, $4d5e0871c06cee03$export$a1562d08625f5d7e)]: (0, (0, parcelRequire("8zOmE")).fireUIAnalytics),
            [(0, $4d5e0871c06cee03$export$947dac6c72b26f81)]: (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics),
            [(0, $4d5e0871c06cee03$export$12346a674644c156)]: (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)
        };
        if (args?.actionSubject && args?.action || event.payload.actionSubject && event.payload.action) {
            const eventActionAndSubject = args?.actionSubject && args?.action ? `${args?.actionSubject} ${args?.action}` : `${event.payload.actionSubject} ${event.payload.action}`;
            if (args?.actionSubjectId) {
                eventFunctions[eventType]?.(event, eventActionAndSubject, args?.actionSubjectId, args?.attributes ? args?.attributes : {});
                return;
            }
            if (!args?.actionSubjectId) eventFunctions[eventType]?.(event, eventActionAndSubject, args?.attributes ? args?.attributes : {});
        } else (0, (0, parcelRequire("jcw0u")).default)({
            error: new Error('Action or ActionSubject not provided'),
            meta: {
                id: 'jira.commandPalette.analytics',
                packageName: $50c4f480d056336d$var$packageName,
                teamName: 'deliveroo'
            }
        });
    };
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("b5pc0", function(module, exports) {
    $parcel$export(module.exports, "useQuickSearchCommand", ()=>$d2e45573835e5a07$export$e5359a76eb8e8480);
    var $5uXOq = parcelRequire("5uXOq");
    var $tvuR8;
    var $5p1kJ;
    var $jh7L9;
    var $koVbs;
    var $7kfUM;
    var $gXRsr;
    var $huARL;
    var $cy1Ju;
    const $d2e45573835e5a07$export$e5359a76eb8e8480 = (props)=>{
        const keepSearch = props?.keepSearch;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        (0, (0, parcelRequire("gXRsr")).useFireQuickSearchAnalyticsOnClose)();
        const quickSearchCommand = (0, $5uXOq.useMemo)(()=>({
                id: (0, $cb5e5e9a3c6fee1b$export$2c1eb650fb9787f),
                name: formatMessage((0, (0, parcelRequire("7kfUM")).messages).searchCommandName),
                placeholder: formatMessage((0, (0, parcelRequire("7kfUM")).messages).searchInputPlaceHolder),
                keywords: formatMessage((0, (0, parcelRequire("7kfUM")).messages).searchYourIssuesSynonyms),
                components: {
                    LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("tvuR8"))))), {
                            label: ""
                        })
                },
                mode: '/',
                section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).quickSearch,
                priority: 1,
                analytics: {
                    action: 'quickSearchMode',
                    actionCategory: 'quick-search'
                },
                primaryAction: {
                    type: (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST,
                    components: {
                        Body: (0, (0, parcelRequire("huARL")).QuickSearchChildren),
                        Wrapper: (0, (0, parcelRequire("cy1Ju")).QuickSearchChildWrapper)
                    },
                    keepSearch: keepSearch
                }
            }), [
            formatMessage,
            keepSearch
        ]);
        return {
            quickSearchCommand: quickSearchCommand
        };
    };
});
const $cb5e5e9a3c6fee1b$export$2c1eb650fb9787f = 'quick-search';
parcelRegister("7kfUM", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$702b76be031743e3$export$defe85febe8b728c);
    var $7VHMR;
    const $702b76be031743e3$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        searchCommandName: {
            "id": "command-palette-quick-search.use-quick-search-command.search-command-name",
            "defaultMessage": "Search issues, projects, and more"
        },
        searchInputPlaceHolder: {
            "id": "command-palette-quick-search.use-quick-search-command.search-input-place-holder",
            "defaultMessage": "Search for issues, projects, boards, filters and plans"
        },
        searchYourIssuesSynonyms: {
            "id": "command-palette-quick-search.use-quick-search-command.search-your-issues-synonyms",
            "defaultMessage": "Find my ideas tickets requests tasks work"
        }
    });
});
parcelRegister("gXRsr", function(module, exports) {
    $parcel$export(module.exports, "useFireQuickSearchAnalyticsOnClose", ()=>$97a054a159b04e0e$export$5bb3a88a6bd57afb);
    var $5uXOq = parcelRequire("5uXOq");
    var $d8lE2;
    var $1XJ20;
    var $8zOmE;
    var $2NMNM;
    var $gjt52;
    const $97a054a159b04e0e$export$5bb3a88a6bd57afb = ()=>{
        const [{ isOpen: isOpen }] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteIsOpen)();
        const previousIsOpen = (0, (0, parcelRequire("1XJ20")).usePrevious)(isOpen);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ hasModalWrapperMounted: hasModalWrapperMounted }] = (0, (0, parcelRequire("gjt52")).useQuickSearchAnalytics)();
        const [attributes] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteAnalyticsAttributes)();
        const previousAttributes = (0, (0, parcelRequire("1XJ20")).usePrevious)(attributes);
        const [compalAttributes] = (0, (0, parcelRequire("gjt52")).useQuickSearchAnalyticsAttributes)();
        const previousCompalAttributes = (0, (0, parcelRequire("1XJ20")).usePrevious)(compalAttributes);
        (0, $5uXOq.useEffect)(()=>{
            if (hasModalWrapperMounted && previousIsOpen && !isOpen) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'close commandPaletteSearch', {
                ...previousCompalAttributes,
                ...previousAttributes
            });
        }, [
            createAnalyticsEvent,
            isOpen,
            previousIsOpen,
            hasModalWrapperMounted,
            previousCompalAttributes,
            previousAttributes
        ]);
    };
});
parcelRegister("gjt52", function(module, exports) {
    $parcel$export(module.exports, "useQuickSearchAnalytics", ()=>$9ee2833827559dc4$export$4717a2168cba99f2);
    $parcel$export(module.exports, "useQuickSearchAnalyticsAttributes", ()=>$9ee2833827559dc4$export$c5622799de43dc3a);
    var $bXrHm = parcelRequire("bXrHm");
    var $3sQ5x;
    var $iXqE5;
    var $c2I39;
    const $9ee2833827559dc4$var$initialState = {
        queryVersion: -1,
        query: '',
        searchSessionId: (0, ($parcel$interopDefault($bXrHm)))(),
        hasModalWrapperMounted: false,
        screenName: undefined,
        isCachedResult: false
    };
    const $9ee2833827559dc4$var$actions = {
        setQuery: (query)=>({ setState: setState, getState: getState })=>{
                setState({
                    queryVersion: getState().queryVersion + 1,
                    query: query
                });
            },
        reset: ()=>({ setState: setState })=>{
                setState({
                    ...$9ee2833827559dc4$var$initialState,
                    searchSessionId: (0, ($parcel$interopDefault($bXrHm)))()
                });
            },
        setHasModalWrapperMounted: (hasModalWrapperMounted)=>({ setState: setState })=>{
                setState({
                    hasModalWrapperMounted: hasModalWrapperMounted
                });
            },
        setScreenName: (screenName)=>({ setState: setState })=>{
                setState({
                    screenName: screenName
                });
            },
        setIsCachedResult: (isCachedResult)=>({ setState: setState })=>{
                setState({
                    isCachedResult: isCachedResult
                });
            }
    };
    const $9ee2833827559dc4$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $9ee2833827559dc4$var$initialState,
        actions: $9ee2833827559dc4$var$actions,
        name: 'quickSearchAnalytics'
    });
    const $9ee2833827559dc4$export$4717a2168cba99f2 = (0, (0, parcelRequire("3sQ5x")).createHook)($9ee2833827559dc4$var$store);
    const $9ee2833827559dc4$export$770c0b647b46c688 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($9ee2833827559dc4$var$store);
    const $9ee2833827559dc4$export$c5622799de43dc3a = (0, (0, parcelRequire("3sQ5x")).createHook)($9ee2833827559dc4$var$store, {
        selector: ({ query: query, queryVersion: queryVersion, searchSessionId: searchSessionId, screenName: screenName, isCachedResult: isCachedResult })=>({
                wordCount: (0, (0, parcelRequire("c2I39")).getWordCount)(query),
                queryLength: query.length,
                queryHash: (0, (0, parcelRequire("c2I39")).getQueryHash)(query),
                queryVersion: queryVersion,
                searchSessionId: searchSessionId,
                activeProduct: 'jira',
                isMultiProduct: false,
                screenName: screenName,
                isCachedResult: isCachedResult
            })
    });
});
parcelRegister("c2I39", function(module, exports) {
    $parcel$export(module.exports, "getQueryHash", ()=>$890efcd2fb211377$export$fa1c95a5ffa92036);
    $parcel$export(module.exports, "getWordCount", ()=>$890efcd2fb211377$export$dba3e2bcdbd49da4);
    $parcel$export(module.exports, "transformResultsForAnalytics", ()=>$890efcd2fb211377$export$902530edac79328);
    var $bdDiz = parcelRequire("bdDiz");
    const $890efcd2fb211377$export$fa1c95a5ffa92036 = (str)=>(0, $bdDiz.createHash)().update(str).digest('hex');
    const $890efcd2fb211377$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
    const $890efcd2fb211377$export$902530edac79328 = (data, isRecentResult)=>{
        const results = data?.scopes?.map((scope)=>({
                sectionId: scope.id,
                results: scope.results.map((result)=>({
                        containerId: result?.attributes && 'containerId' in result?.attributes ? result?.attributes?.containerId || 'UNAVAILABLE' : 'UNAVAILABLE',
                        isRecentResult: isRecentResult,
                        resultContentId: result.id,
                        resultType: scope.id
                    }))
            }));
        const resultCount = data?.scopes?.reduce((acc, scope)=>acc + scope.size, 0);
        return {
            results: results,
            sectionCount: data?.scopes?.length || 0,
            resultCount: resultCount,
            noResultsFetched: !results?.find((scope)=>scope.results.length > 0)
        };
    };
});
parcelRegister("huARL", function(module, exports) {
    $parcel$export(module.exports, "QuickSearchChildren", ()=>$ffa7e6b797c341b7$export$a68383740408995a);
    var $5uXOq = parcelRequire("5uXOq");
    var $jiSaf;
    var $6Xy8w;
    var $gjt52;
    var $1qxNN;
    var $b3BGu;
    var $5mZMv;
    const $ffa7e6b797c341b7$export$4630ed09821f1a78 = ()=>{
        const { fetch: fetch } = (0, (0, parcelRequire("1qxNN")).useQuickSearchWithRecentCache)();
        const getRecentResults = (0, (0, parcelRequire("b3BGu")).useGetRecentResults)();
        const getSearchResults = (0, (0, parcelRequire("5mZMv")).useGetSearchResults)();
        const [{ searchSessionId: searchSessionId }, { setQuery: setQuery, setIsCachedResult: setIsCachedResult, setScreenName: setScreenName }] = (0, (0, parcelRequire("gjt52")).useQuickSearchAnalytics)();
        const controllerRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>()=>controllerRef.current?.abort(), []);
        const isMountedRef = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useEffect)(()=>{
            isMountedRef.current = true;
            return ()=>{
                isMountedRef.current = false;
            };
        }, []);
        const loadChildren = (0, $5uXOq.useCallback)(async ({ search: search })=>{
            controllerRef.current?.abort();
            controllerRef.current = new AbortController();
            let response;
            let error;
            try {
                setQuery(search);
                response = await fetch(search, searchSessionId, controllerRef.current?.signal);
            } catch (e) {
                error = e instanceof Error ? e : new Error('Error not identified');
            }
            setIsCachedResult(response?.isCache || false);
            if (search && search.length > 0) {
                setScreenName('postQuerySearchResults');
                return {
                    ...getSearchResults({
                        search: search,
                        quickSearchResponseData: response?.result,
                        error: error
                    })
                };
            }
            setScreenName('preQuerySearchResults');
            return {
                ...getRecentResults({
                    search: search,
                    quickSearchResponseData: response?.result,
                    error: error
                })
            };
        }, [
            setIsCachedResult,
            setScreenName,
            getRecentResults,
            setQuery,
            fetch,
            searchSessionId,
            getSearchResults
        ]);
        return {
            loadChildren: loadChildren
        };
    };
    const $ffa7e6b797c341b7$export$a68383740408995a = ({ setChildResult: setChildResult, setLoading: setLoading, ...rest })=>{
        const { loadChildren: loadChildren } = $ffa7e6b797c341b7$export$4630ed09821f1a78();
        const loadChildCommands = (0, $5uXOq.useCallback)((searchTerm, obj)=>loadChildren({
                search: searchTerm
            }).then((result)=>{
                if (!obj.isMounted) return;
                setChildResult?.(result);
            }), [
            loadChildren,
            setChildResult
        ]);
        (0, (0, parcelRequire("6Xy8w")).useDebouncedLoadChildren)(loadChildCommands);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jiSaf")).components).Body, {
            setChildResult: setChildResult,
            setLoading: setLoading,
            ...rest
        });
    };
});
parcelRegister("jiSaf", function(module, exports) {
    $parcel$export(module.exports, "components", ()=>$44cb4d9bf5d8b8a6$export$9b5ac10f59f76296);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $dOktC;
    var $haBRL;
    var $dE25F;
    var $d4iCz;
    const $44cb4d9bf5d8b8a6$var$NameComponent = ({ children: children, ...rest })=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('fix_compal_name_wrapper')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), rest, children);
    };
    const $44cb4d9bf5d8b8a6$export$9b5ac10f59f76296 = {
        CommandRow: (0, parcelRequire("haBRL")).CommandRow,
        Name: $44cb4d9bf5d8b8a6$var$NameComponent,
        LeftIcon: (0, $5uXOq.Fragment),
        Wrapper: (0, $5uXOq.Fragment),
        Footer: (0, parcelRequire("dE25F")).Footer,
        Body: (0, (0, parcelRequire("dOktC")).CommandPaletteBody),
        Header: (0, parcelRequire("d4iCz")).Header
    };
});
parcelRegister("dOktC", function(module, exports) {
    $parcel$export(module.exports, "NoResultsContainer", ()=>$2bc4c9970ded9a96$export$2ab569a6937cb4e4);
    $parcel$export(module.exports, "CommandPaletteBody", ()=>$2bc4c9970ded9a96$export$b1023de69a8756e6);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $2NMNM;
    var $4R6GH;
    var $d8lE2;
    var $gM5ou;
    var $bYCTm;
    var $38IFv;
    var $cLshs;
    var $4nfzy;
    var $eKTyH;
    var $5aF2z;
    var $64ZBB;
    const $2bc4c9970ded9a96$var$CommandPaletteChildren = ({ results: results, noResultsFallback: noResultsFallback, renderAfterCommands: renderAfterCommands, resultsRefs: resultsRefs })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ isSearchFieldFocused: isSearchFieldFocused, loadingList: loadingList, registry: registry, activeRegistry: activeRegistry }, { setActiveIndex: setActiveIndex, removeCommandsById: removeCommandsById, executeCommand: executeCommand }] = (0, (0, parcelRequire("d8lE2")).useCommandPalette)();
        const onHoverCommand = (index)=>{
            if (index === undefined) return;
            setActiveIndex(index);
        };
        const onMouseDownCommand = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
        }, []);
        const onClickCommand = (0, $5uXOq.useCallback)((event, result)=>{
            executeCommand(result.command, {
                method: 'mouse',
                createAnalyticsEvent: createAnalyticsEvent,
                attributes: {
                    ...(0, (0, parcelRequire("gM5ou")).getAnalyticsAttributesFromResult)(result),
                    ...(0, (0, parcelRequire("gM5ou")).getRegistryData)(registry, activeRegistry, result?.command.id)
                }
            }, (0, (0, parcelRequire("gM5ou")).isSecondaryTrigger)(event));
        }, [
            activeRegistry,
            createAnalyticsEvent,
            executeCommand,
            registry
        ]);
        const localResultRefs = resultsRefs.current;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, !loadingList && noResultsFallback && (0, ($parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$export$2ab569a6937cb4e4, {
            "data-testid": (0, (0, parcelRequire("5aF2z")).NO_RESULTS_TEST_ID)
        }, noResultsFallback), results.map((result, index)=>{
            if (result.isGroup) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bYCTm")).CommandPaletteSearchResultGroupItem), {
                ref: (commandRef)=>{
                    if (commandRef) localResultRefs[index] = commandRef;
                },
                group: result.group,
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$var$GroupContainerComponent, {
                "data-testid": (0, (0, parcelRequire("5aF2z")).GROUP_TEST_ID),
                isFirstResult: index === 0
            }, result.renderGroup ? result.renderGroup() : result.group));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4nfzy")).CommandRowErrorBoundary), {
                key: index,
                teamName: typeof registry?.teamName === 'string' ? registry.teamName : 'deliveroo',
                onError: ()=>removeCommandsById([
                        result.command.id
                    ]),
                attributes: (0, (0, parcelRequire("gM5ou")).getRegistryData)(registry, activeRegistry, result?.command.id)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("38IFv")).CommandPaletteSearchResultListItem), {
                ref: (commandRef)=>{
                    if (commandRef) localResultRefs[index] = commandRef;
                },
                id: result.command.id,
                active: result.active,
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eKTyH")).CommandRow), {
                index: index,
                isSearchFieldFocused: isSearchFieldFocused,
                result: result,
                onHoverCommand: (ev)=>{
                    if (ev.movementX === 0 && ev.movementY === 0) return;
                    onHoverCommand(result.index);
                },
                onClickCommand: (event)=>onClickCommand(event, result),
                onMouseDownCommand: onMouseDownCommand
            })));
        }), renderAfterCommands?.({}));
    };
    const $2bc4c9970ded9a96$export$b1023de69a8756e6 = ({ results: results, total: total, fallback: fallback, renderAfterCommands: renderAfterCommands })=>{
        const [{ activeIndex: activeIndex, isSearchFieldFocused: isSearchFieldFocused, expandedCommand: expandedCommand, search: search }, { setActiveIndex: setActiveIndex }] = (0, (0, parcelRequire("d8lE2")).useCommandPalette)();
        const [prevActiveIndex, setPrevActiveIndex] = (0, $5uXOq.useState)(activeIndex);
        const resultsRefs = (0, $5uXOq.useRef)([]);
        const modalBodyRef = (0, $5uXOq.useRef)(null);
        const onArrowScroll = (0, $5uXOq.useCallback)((newActiveIndex)=>{
            setActiveIndex(newActiveIndex);
        }, [
            setActiveIndex
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!modalBodyRef.current || prevActiveIndex === activeIndex) return;
            setPrevActiveIndex(activeIndex);
            const scrollTo = activeIndex > prevActiveIndex ? (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).END : (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).START;
            const scrollToIndex = (0, (0, parcelRequire("64ZBB")).getScrollToIndex)(results, activeIndex, scrollTo);
            const scrolledToResult = resultsRefs.current[scrollToIndex];
            if (scrolledToResult && !(0, (0, parcelRequire("64ZBB")).isElementVisibleInContainer)(scrolledToResult, modalBodyRef.current)) {
                const lastIndex = results.length - 1;
                const firstIndex = results.findIndex((result)=>!result.isGroup);
                if (lastIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, modalBodyRef.current.scrollHeight);
                else if (firstIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, 0);
                else {
                    if ((0, (0, parcelRequire("4R6GH")).fg)('compal_smooth_transition_on_size_change')) {
                        (0, (0, parcelRequire("64ZBB")).scrollResultIntoView)({
                            target: scrolledToResult,
                            direction: scrollTo,
                            scrollContainer: modalBodyRef.current
                        });
                        return;
                    }
                    (0, (0, parcelRequire("64ZBB")).scrollResultIntoViewOld)(scrolledToResult, scrollTo);
                }
            }
        }, [
            activeIndex,
            prevActiveIndex,
            results
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!modalBodyRef.current?.scrollTo) return;
            modalBodyRef.current.scrollTo(0, 0);
        }, [
            expandedCommand,
            search
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isSearchFieldFocused) return ()=>{};
            const handleArrowScroll = (ev)=>{
                if (ev.key === 'ArrowUp') {
                    ev.preventDefault();
                    activeIndex > 0 && onArrowScroll(activeIndex - 1);
                }
                if (ev.key === 'ArrowDown') {
                    ev.preventDefault();
                    activeIndex < total - 1 && onArrowScroll(activeIndex + 1);
                }
            };
            window.addEventListener('keydown', handleArrowScroll);
            return ()=>{
                window.removeEventListener('keydown', handleArrowScroll);
            };
        }, [
            isSearchFieldFocused,
            total,
            activeIndex,
            setActiveIndex,
            onArrowScroll
        ]);
        const noResultsFallback = (0, $5uXOq.useMemo)(()=>fallback?.onNoResults?.renderLabel?.() || fallback?.onNoResults?.label, [
            fallback
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cLshs")).CommandPaletteSearchResultListWrapper), {
            ref: modalBodyRef,
            ...(0, (0, parcelRequire("4R6GH")).fg)('a11y_violations_fixes') && {
                noResultsFallback: noResultsFallback
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$var$CommandPaletteChildren, {
            results: results,
            noResultsFallback: noResultsFallback,
            renderAfterCommands: renderAfterCommands,
            resultsRefs: resultsRefs
        }));
    };
    const $2bc4c9970ded9a96$var$GroupContainerComponent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_h2xaw7": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81oud _vwz41kw7 _syaz1wmz _1yt41f6d",
                __cmplp.className
            ])
        });
    });
    const $2bc4c9970ded9a96$export$2ab569a6937cb4e4 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1h6o _syaz1e9r _1yt4wd81",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bYCTm", function(module, exports) {
    $parcel$export(module.exports, "CommandPaletteSearchResultGroupItem", ()=>$85a6ab23a77e1ea6$export$591c26128e5fd757);
    var $5uXOq = parcelRequire("5uXOq");
    const $85a6ab23a77e1ea6$export$591c26128e5fd757 = (0, $5uXOq.forwardRef)(({ group: group, ...rest }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref,
            "data-testid": (0, $2350562822a34d03$export$617744f059bfc3ba),
            id: group ? `${0, $2350562822a34d03$export$9ed1834ff36a8f29}-${group}` : undefined,
            ...rest
        }));
});
const $2350562822a34d03$export$9ffb4923f81813d9 = 'compal-menu';
const $2350562822a34d03$export$b28d6b416aaf953a = `${$2350562822a34d03$export$9ffb4923f81813d9}-item`;
const $2350562822a34d03$export$9ed1834ff36a8f29 = `${$2350562822a34d03$export$9ffb4923f81813d9}-group`;
const $2350562822a34d03$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $2350562822a34d03$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $2350562822a34d03$export$d3cd230e107fbce = 'command-palette.ui.modal.header.search-input';
const $2350562822a34d03$export$9e40a0642460a944 = 'compal-menu-screen-reader';
parcelRegister("38IFv", function(module, exports) {
    $parcel$export(module.exports, "CommandPaletteSearchResultListItem", ()=>$9082b0edc4f10018$export$1f8fa9d1eef77b32);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    const $9082b0edc4f10018$export$1f8fa9d1eef77b32 = (0, $5uXOq.forwardRef)(({ id: id, active: active, ...rest }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref,
            "data-testid": (0, $2350562822a34d03$export$617744f059bfc3ba),
            ...(0, (0, parcelRequire("4R6GH")).fg)('compal_listbox_to_menu') ? {
                'aria-current': active,
                role: 'menuitem'
            } : {
                'aria-selected': active,
                role: 'option'
            },
            id: `${(0, $2350562822a34d03$export$b28d6b416aaf953a)}-${id}`,
            ...rest
        }));
});
parcelRegister("cLshs", function(module, exports) {
    $parcel$export(module.exports, "CommandPaletteSearchResultListWrapper", ()=>$42c35fc284860d36$export$95554f6fb39a83c2);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $cSD7y;
    var $4R6GH;
    var $koVbs;
    var $zfug2;
    var $6LGvc;
    const $42c35fc284860d36$var$CommandPaletteSearchResultListWrapperNew = (0, $5uXOq.forwardRef)(({ noResultsFallback: noResultsFallback, children: children, as: as, ...props }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const resizerRef = (0, $5uXOq.useRef)(null);
        const height = (0, (0, parcelRequire("6LGvc")).useSmoothExpand)(resizerRef);
        (0, $5uXOq.useEffect)(()=>{
            if (ref && 'current' in ref && ref.current) {
                const currentRef = ref.current;
                currentRef.style.height = `${height}px`;
            }
        }, [
            height,
            ref
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $42c35fc284860d36$var$wrapperStyles,
            testId: (0, $2350562822a34d03$export$85eefac753ab5bdb),
            id: (0, $2350562822a34d03$export$9ffb4923f81813d9),
            role: noResultsFallback && (0, (0, parcelRequire("4R6GH")).fg)('a11y_violations_fixes') ? 'group' : (0, (0, parcelRequire("4R6GH")).fg)('compal_listbox_to_menu') ? 'menu' : 'listbox',
            ref: ref,
            "aria-label": formatMessage((0, (0, parcelRequire("zfug2")).messages).commandPaletteSearchResultListBoxLabel),
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            ref: resizerRef,
            direction: "column",
            gap: "space.050"
        }, children));
    });
    const $42c35fc284860d36$var$CommandPaletteSearchResultListWrapperOld = (0, $5uXOq.forwardRef)(({ noResultsFallback: noResultsFallback, ...props }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($42c35fc284860d36$var$Wrapper, {
            "data-testid": (0, $2350562822a34d03$export$85eefac753ab5bdb),
            id: (0, $2350562822a34d03$export$9ffb4923f81813d9),
            role: noResultsFallback && (0, (0, parcelRequire("4R6GH")).fg)('a11y_violations_fixes') ? 'group' : (0, (0, parcelRequire("4R6GH")).fg)('compal_listbox_to_menu') ? 'menu' : 'listbox',
            ref: ref,
            "aria-label": formatMessage((0, (0, parcelRequire("zfug2")).messages).commandPaletteSearchResultListBoxLabel),
            ...props
        });
    });
    const $42c35fc284860d36$export$95554f6fb39a83c2 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('compal_smooth_transition_on_size_change', $42c35fc284860d36$var$CommandPaletteSearchResultListWrapperNew, $42c35fc284860d36$var$CommandPaletteSearchResultListWrapperOld);
    const $42c35fc284860d36$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_c71l4u42 _18m91wug _vchhusvi _1yt41bpf _1e0c1txw _2lx21bp4 _zulp1b66 _1tke8vuz",
                __cmplp.className
            ])
        });
    });
    const $42c35fc284860d36$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: '0',
        paddingTop: 'space.100',
        paddingBottom: 'space.100',
        transition: 'height 0.15s ease-out',
        overflowY: 'auto',
        maxHeight: '376px'
    });
});
parcelRegister("zfug2", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$2745ea1cb0c1a200$export$defe85febe8b728c);
    var $7VHMR;
    const $2745ea1cb0c1a200$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        commandPaletteSearchResultListBoxLabel: {
            "id": "command-palette.common.command-palette-search-dropdown.command-palette-search-result-list-wrapper.command-palette-search-result-list-box-label",
            "defaultMessage": "List of commands"
        }
    });
});
parcelRegister("6LGvc", function(module, exports) {
    $parcel$export(module.exports, "useSmoothExpand", ()=>$38452c6bcba6455a$export$674ba8b02d2bfe86);
    var $5uXOq = parcelRequire("5uXOq");
    const $38452c6bcba6455a$var$MAX_HEIGHT = 376;
    const $38452c6bcba6455a$var$STARTING_HEIGHT = 56;
    const $38452c6bcba6455a$var$ADDITIONAL_HEIGHT = 16;
    const $38452c6bcba6455a$export$674ba8b02d2bfe86 = (content)=>{
        const [height, setHeight] = (0, $5uXOq.useState)($38452c6bcba6455a$var$STARTING_HEIGHT);
        const callback = (0, $5uXOq.useCallback)(()=>{
            const contentClientHeight = content.current?.clientHeight;
            if (!contentClientHeight) return;
            if (contentClientHeight > $38452c6bcba6455a$var$MAX_HEIGHT) setHeight($38452c6bcba6455a$var$MAX_HEIGHT);
            else setHeight(contentClientHeight + $38452c6bcba6455a$var$ADDITIONAL_HEIGHT);
        }, [
            content
        ]);
        (0, $5uXOq.useEffect)(()=>{
            let resizeObserver;
            if (content.current && typeof ResizeObserver !== 'undefined') {
                resizeObserver = new ResizeObserver(callback);
                resizeObserver.observe(content.current);
            }
            return ()=>{
                if (resizeObserver) resizeObserver.disconnect();
            };
        }, [
            callback,
            content
        ]);
        return height;
    };
});
parcelRegister("4nfzy", function(module, exports) {
    $parcel$export(module.exports, "CommandRowErrorBoundary", ()=>$53a0c321a39d3b85$export$223f3c3c93a14a83);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    const $53a0c321a39d3b85$export$223f3c3c93a14a83 = ({ children: children, teamName: teamName, onError: onError, attributes: attributes })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "command-palette-row",
            packageName: "jiraCommandPalette",
            fallback: "unmount",
            teamName: teamName,
            onError: onError,
            attributes: attributes
        }, children);
});
parcelRegister("eKTyH", function(module, exports) {
    $parcel$export(module.exports, "CommandRow", ()=>$9e51067b4d29f53f$export$3ef5d254c3c573e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $gM5ou;
    var $haBRL;
    const $9e51067b4d29f53f$export$3ef5d254c3c573e3 = ({ index: index, result: result, isSearchFieldFocused: isSearchFieldFocused, onHoverCommand: onHoverCommand, onClickCommand: onClickCommand, onMouseDownCommand: onMouseDownCommand })=>{
        const { command: command } = result;
        const isActive = !!(result.active && isSearchFieldFocused);
        const isFirstCommand = result.index === 0;
        const rowProps = {
            index: index,
            isActive: isActive,
            command: command,
            isFirstCommand: isFirstCommand,
            onMouseMove: onHoverCommand,
            onClick: onClickCommand,
            onMouseDown: onMouseDownCommand,
            analyticsAttributes: (0, (0, parcelRequire("gM5ou")).getAnalyticsAttributesFromResult)(result)
        };
        if (command.components?.CommandRow) return (0, ($parcel$interopDefault($5uXOq))).createElement(command.components.CommandRow, rowProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("haBRL")).CommandRow), rowProps);
    };
});
parcelRegister("haBRL", function(module, exports) {
    $parcel$export(module.exports, "CommandRow", ()=>$04586313afa284d7$export$3ef5d254c3c573e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $kgoHi;
    var $8CUq3;
    var $dCm1o;
    var $dzeHJ;
    var $3m7XM;
    var $3sBlN;
    const $04586313afa284d7$export$3ef5d254c3c573e3 = ({ index: index, command: command, isActive: isActive, isFirstCommand: isFirstCommand, analyticsAttributes: analyticsAttributes, ...rest })=>{
        const InnerContainer = $04586313afa284d7$var$CommandContainerInner;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandContainerWrapper, {
            "data-testid": command.id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandContainer, {
            index: index,
            active: isActive,
            "data-active": isActive,
            "data-testid": (0, $593123af132e266c$export$b0017db5728101cc)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(InnerContainer, {
            "data-testid": (0, $593123af132e266c$export$47c379a40b00a339),
            ...rest
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandLeftIconAndNameContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandIconsContainer, {
            "data-testid": (0, $593123af132e266c$export$d6dd1cf63aae711c)
        }, command.components?.LeftIcon && ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            testId: (0, $593123af132e266c$export$7b41978523c7dd4a),
            alignItems: "center",
            justifyContent: "center",
            xcss: [
                $04586313afa284d7$var$iconStyles,
                isActive && $04586313afa284d7$var$iconActiveStyles
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(command.components.LeftIcon, null)) : (0, ($parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandLeftIconContainer, {
            "data-testid": (0, $593123af132e266c$export$7b41978523c7dd4a),
            active: isActive
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(command.components.LeftIcon, null))), command.mode && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dzeHJ")).OutlinedLozenge), {
            "data-testid": (0, $593123af132e266c$export$72c5368f559dd523)
        }, command.mode)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3m7XM")).RenderCommandName), {
            command: command,
            isActive: isActive
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sBlN")).RightContent), {
            command: command,
            isFirstCommand: isFirstCommand,
            isActive: isActive
        }))));
    };
    const $04586313afa284d7$var$CommandContainerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $04586313afa284d7$var$CommandContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { active: active, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81oud _syazjjyb _1yt4swc3",
                !!__cmplp.active && "_syazaj1x _bfhk29zg _kqswh2mm _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _19woidpf _1mp4v77o _1rus194a",
                __cmplp.className
            ])
        });
    });
    const $04586313afa284d7$var$CommandContainerInner = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt467l7 _1e0c1txw _4cvr1h6o _80omtlke _lcxv1wug",
                __cmplp.className
            ])
        });
    });
    const $04586313afa284d7$var$CommandIconsContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwx1b66 _zulp1b66 _1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $04586313afa284d7$var$iconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '24px',
        height: '24px',
        color: 'color.icon.subtle'
    });
    const $04586313afa284d7$var$iconActiveStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.icon'
    });
    const $04586313afa284d7$var$CommandLeftIconContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { active: active, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bsb1tcg _4t3i1tcg _vwz41tcg _1bah1h6o _1wpz1y6m _1f027vkz _nbgx7vkz",
                __cmplp.active ? "_syaz2zfp" : "_syazbkuv",
                __cmplp.className
            ])
        });
    });
    const $04586313afa284d7$var$CommandLeftIconAndNameContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _16jlkb7n _1o9zkb7n _i0dlf1ug _vwz41tcg _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dzeHJ", function(module, exports) {
    $parcel$export(module.exports, "OutlinedLozenge", ()=>$0f9445e21ac061f1$export$224f9ad7f31e0de6);
    $parcel$export(module.exports, "FilledLozenge", ()=>$0f9445e21ac061f1$export$586a428fe10f5ae0);
    $parcel$export(module.exports, "SearchLozenge", ()=>$0f9445e21ac061f1$export$2ccc7861eeb7b337);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $0f9445e21ac061f1$var$Lozenge = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _2rko1l7b _1o9zidpf _4t3igktf _1bsbgktf _11c8qk37 _vwz41crf _syaz1aqp",
                __cmplp.className
            ])
        });
    });
    const $0f9445e21ac061f1$export$224f9ad7f31e0de6 = (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81u0j _k48p1pd9 _1p1dangw _bfhk1j9a _19it1x8r _syazuxqy _vchhusvi",
                __cmplp.className
            ])
        });
    });
    const $0f9445e21ac061f1$export$586a428fe10f5ae0 = (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _11c81u0j _1p1dangw _1pbykb7n _1cs8stnw _1kt9b3bt _1s6k1d2d _154psxj9 _rfx31l7b _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
                __cmplp.className
            ])
        });
    });
    const $0f9445e21ac061f1$export$2ccc7861eeb7b337 = (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4otz2 _1bsb1ris _11c81oud _vwz4dlk8 _bfhk1yrq",
                __cmplp.className
            ])
        });
    });
});
const $593123af132e266c$export$b0017db5728101cc = 'command-palette.ui.modal.body.command-container';
const $593123af132e266c$export$47c379a40b00a339 = 'command-palette.common.ui.command-palette-row-view.inner-container';
const $593123af132e266c$export$7b41978523c7dd4a = 'command-palette.ui.modal.body.command-left-icon-container';
const $593123af132e266c$export$72c5368f559dd523 = 'command-palette.ui.modal.body.command-mode';
const $593123af132e266c$export$d6dd1cf63aae711c = 'command-palette.ui.modal.body.command-icon-container';
parcelRegister("3m7XM", function(module, exports) {
    $parcel$export(module.exports, "RenderCommandName", ()=>$c1bc24527d77cdc3$export$931d3f1d35f6c058);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $hWZau;
    var $kgoHi;
    var $8CUq3;
    var $dCm1o;
    var $gGkxR;
    const $c1bc24527d77cdc3$export$931d3f1d35f6c058 = ({ command: command, isActive: isActive })=>{
        const renderCommandName = (0, $5uXOq.useCallback)(()=>{
            if (command.components?.Name) return (0, ($parcel$interopDefault($5uXOq))).createElement(command.components.Name, {
                isActive: isActive
            }, command.name);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gGkxR")).TruncateWithTooltipOnActive), {
                isActive: isActive
            }, command.name);
        }, [
            command,
            isActive
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandNameContainer, {
            "data-testid": (0, $c5fb72cffbe58dfe$export$1858c2a91b8b53ba),
            active: isActive
        }, command.breadcrumb?.length ? (0, ($parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandBreadcrumbContainer, {
            "data-testid": (0, $c5fb72cffbe58dfe$export$5e3a644e2bbe06f3)
        }, command.breadcrumb.map((BreadCrumb, index, arr)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, {
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandBreadcrumbItem, {
                isParent: index !== arr.length - 1,
                "data-testid": (0, $c5fb72cffbe58dfe$export$fb5462105b23e3e5),
                active: isActive
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(BreadCrumb, {
                isActive: isActive
            })), index !== arr.length - 1 && ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                justifyContent: "center",
                xcss: $c1bc24527d77cdc3$var$iconWrapperStyles,
                alignItems: "center",
                testId: (0, $c5fb72cffbe58dfe$export$4675b4d60d9881d4)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hWZau"))))), {
                color: "currentColor",
                label: "separator"
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandChevronContainer, {
                "data-testid": (0, $c5fb72cffbe58dfe$export$4675b4d60d9881d4)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hWZau"))))), {
                color: "currentColor",
                label: "separator"
            })))))) : renderCommandName());
    };
    const $c1bc24527d77cdc3$var$CommandNameContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { active: active, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _vwz41tcg",
                __cmplp.active ? "_syaz1qfn" : "_syaz1a45",
                __cmplp.className
            ])
        });
    });
    const $c1bc24527d77cdc3$var$CommandBreadcrumbContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $c1bc24527d77cdc3$var$CommandBreadcrumbItem = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isParent: isParent, active: active, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_zek046": (0, (0, parcelRequire("lD23V")).default)(__cmplp.active ? `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N400})` : `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N200})`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                !!__cmplp.isParent && "_syaz1bu1",
                __cmplp.className
            ])
        });
    });
    const $c1bc24527d77cdc3$var$CommandChevronContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vwz4kb7n _syazjwct",
                __cmplp.className
            ])
        });
    });
    const $c1bc24527d77cdc3$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '24px',
        width: '24px'
    });
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("gGkxR", function(module, exports) {
    $parcel$export(module.exports, "TruncateWithTooltipOnActive", ()=>$e999625ec19f201d$export$4495aca3d261add0);
    var $5uXOq = parcelRequire("5uXOq");
    var $1I7E8;
    var $dC5iT;
    var $8CUq3;
    var $k5uoT;
    var $jgArx;
    var $k7xca;
    const $e999625ec19f201d$var$TooltipRenderer = ({ children: children, shouldShowTooltip: shouldShowTooltip })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: !!shouldShowTooltip,
            autoFocus: false,
            placement: "bottom-end",
            popupComponent: (0, (0, parcelRequire("jgArx")).PopupComponent),
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgArx")).TooltipContent), {
                    "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.tooltip-content"
                }, children),
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgArx")).TriggerComponent), {
                    "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.trigger-component",
                    ...triggerProps
                }),
            zIndex: (0, (0, parcelRequire("k5uoT")).layers).tooltip()
        });
    const $e999625ec19f201d$export$70f47de153e915ed = ()=>(0, $5uXOq.useRef)(null);
    const $e999625ec19f201d$export$4495aca3d261add0 = ({ children: children, isActive: isActive, customTooltip: customTooltip, showTooltip: showTooltip, preventTruncate: preventTruncate })=>{
        const containerRef = $e999625ec19f201d$export$70f47de153e915ed();
        const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, (0, parcelRequire("k7xca")).useTruncatedTooltip)({
            containerRef: containerRef,
            tooltipDelay: (0, $40fe2afec35c84b7$export$f9e3e7ede9ba929d)
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            ref: containerRef,
            xcss: [
                $e999625ec19f201d$var$tooltipContainerStyles,
                !preventTruncate && $e999625ec19f201d$var$truncateTooltipStyles
            ]
        }, children), isActive && (0, ($parcel$interopDefault($5uXOq))).createElement($e999625ec19f201d$var$TooltipRenderer, {
            shouldShowTooltip: showTooltip || shouldShowTruncatedTooltip
        }, showTooltip && customTooltip ? customTooltip : children));
    };
    const $e999625ec19f201d$var$tooltipContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative',
        flexGrow: 1,
        textTransform: 'none'
    });
    const $e999625ec19f201d$var$truncateTooltipStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
});
parcelRegister("jgArx", function(module, exports) {
    $parcel$export(module.exports, "TooltipComponent", ()=>$3c6ba86682bb18eb$export$e18e2f8e82cdc428);
    $parcel$export(module.exports, "TriggerComponent", ()=>$3c6ba86682bb18eb$export$534fc570264a52a4);
    $parcel$export(module.exports, "TooltipTrigger", ()=>$3c6ba86682bb18eb$export$8c610744efcf8a1d);
    $parcel$export(module.exports, "PopupComponent", ()=>$3c6ba86682bb18eb$export$9fac2d040f3ed438);
    $parcel$export(module.exports, "TruncateWithTooltipContainer", ()=>$3c6ba86682bb18eb$export$8cae238d61c8405a);
    $parcel$export(module.exports, "TooltipContent", ()=>$3c6ba86682bb18eb$export$e9003e2be37ec060);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $btzsC;
    var $koVbs;
    var $6nFD4;
    const $3c6ba86682bb18eb$export$e18e2f8e82cdc428 = (0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$var$StyledTooltipPrimitive, {
            ...props,
            ref: ref
        }));
    const $3c6ba86682bb18eb$export$534fc570264a52a4 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$export$8c610744efcf8a1d, {
            ...props,
            role: "button",
            ref: ref,
            "aria-label": formatMessage((0, (0, parcelRequire("6nFD4")).messages).tooltipTriggerAriaLabel)
        });
    });
    const $3c6ba86682bb18eb$export$9fac2d040f3ed438 = (0, $5uXOq.forwardRef)(({ children: children, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$var$StyledPopupPrimitive, {
            ...props,
            ref: ref
        }, children));
    const $3c6ba86682bb18eb$var$StyledTooltipPrimitive = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("btzsC")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1pbydx66 _1bsbp3fh _1yt41ppf _bfhk1j9a _16qsacve",
                __cmplp.className
            ])
        });
    });
    const $3c6ba86682bb18eb$var$StyledPopupPrimitive = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1pbydx66 _1bsbp3fh _1yt41ppf _bfhk1j9a _16qsacve",
                __cmplp.className
            ])
        });
    });
    const $3c6ba86682bb18eb$export$8cae238d61c8405a = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1p1dglyw",
                __cmplp.className
            ])
        });
    });
    const $3c6ba86682bb18eb$export$e9003e2be37ec060 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1jfi _11c8qk37",
                __cmplp.className
            ])
        });
    });
    const $3c6ba86682bb18eb$export$8c610744efcf8a1d = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6nFD4", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$87d1d47436abe24f$export$defe85febe8b728c);
    var $7VHMR;
    const $87d1d47436abe24f$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        tooltipTriggerAriaLabel: {
            "id": "command-palette.common.truncate-with-tooltip.components.tooltip-trigger-aria-label",
            "defaultMessage": "Command palette tool tip"
        }
    });
});
const $40fe2afec35c84b7$export$f9e3e7ede9ba929d = 400;
parcelRegister("k7xca", function(module, exports) {
    $parcel$export(module.exports, "useTruncatedTooltip", ()=>$ad951546dfa9fa2c$export$94b118b3187f12c);
    var $5uXOq = parcelRequire("5uXOq");
    var $gM5ou;
    const $ad951546dfa9fa2c$export$22c0312879c61300 = ()=>(0, $5uXOq.useState)(false);
    const $ad951546dfa9fa2c$export$1ac6e474a0163418 = ()=>(0, $5uXOq.useState)(false);
    const $ad951546dfa9fa2c$export$94b118b3187f12c = ({ containerRef: containerRef, tooltipDelay: tooltipDelay })=>{
        const [shouldShowTruncatedTooltip, setShouldShowTruncatedTooltip] = $ad951546dfa9fa2c$export$22c0312879c61300();
        const [isTruncated, setIsTruncated] = $ad951546dfa9fa2c$export$1ac6e474a0163418();
        const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, (0, parcelRequire("gM5ou")).useSetTimeoutAutoClear)();
        const setTimeoutFunc = setTimeoutAutoClear;
        (0, $5uXOq.useEffect)(()=>{
            const container = containerRef.current;
            if (!container) return;
            if (container.offsetWidth < container.scrollWidth) setIsTruncated(true);
            else setIsTruncated(false);
        }, [
            setIsTruncated,
            containerRef
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isTruncated && tooltipDelay === 0) {
                setShouldShowTruncatedTooltip(true);
                return ()=>{};
            }
            if (isTruncated && tooltipDelay > 0) {
                setTimeoutFunc(()=>setShouldShowTruncatedTooltip(true), tooltipDelay);
                return ()=>{};
            }
            setShouldShowTruncatedTooltip(false);
            return ()=>{};
        }, [
            isTruncated,
            setShouldShowTruncatedTooltip,
            tooltipDelay,
            setTimeoutFunc
        ]);
        return {
            shouldShowTruncatedTooltip: shouldShowTruncatedTooltip
        };
    };
});
const $c5fb72cffbe58dfe$export$1858c2a91b8b53ba = 'command-palette.ui.modal.body.command-name-container';
const $c5fb72cffbe58dfe$export$5e3a644e2bbe06f3 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-container';
const $c5fb72cffbe58dfe$export$fb5462105b23e3e5 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-item';
const $c5fb72cffbe58dfe$export$4675b4d60d9881d4 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.separator';
parcelRegister("3sBlN", function(module, exports) {
    $parcel$export(module.exports, "RightContent", ()=>$a83ca30f957fd273$export$11dbab4b39f15d6b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $h1toL;
    var $koVbs;
    var $gM5ou;
    var $iLhkq;
    var $dSJBv;
    var $kbnU6;
    var $lHtdH;
    const $a83ca30f957fd273$export$11dbab4b39f15d6b = ({ command: command, isActive: isActive, isFirstCommand: isFirstCommand = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const transitionStep = (0, (0, parcelRequire("lHtdH")).useHoverTransitionStep)(command, isActive, isFirstCommand);
        const commandHasChildren = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("gM5ou")).hasChildren)(command), [
            command
        ]);
        const shouldRenderRightContent = commandHasChildren || !!command.shortcut;
        if (!shouldRenderRightContent) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$RightContentWrapper, null, commandHasChildren && (0, ($parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$CommandRightChevronContainer, {
            "data-testid": (0, $0296d551a7f83620$export$e3e144c17be58a44),
            transitionStep: transitionStep
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("h1toL"))))), {
            label: formatMessage((0, (0, parcelRequire("iLhkq")).messages).rightChevronLabel)
        })), !!command.shortcut && (0, ($parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$ShortcutContainer, {
            "data-testid": (0, $0296d551a7f83620$export$f3036e9d26f81cd9),
            shouldHaveTransition: commandHasChildren,
            transitionStep: transitionStep
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dSJBv")).Shortcuts), {
            shortcut: command.shortcut
        })));
    };
    const $a83ca30f957fd273$var$animationFadeIn = null;
    const $a83ca30f957fd273$var$animationFadeOut = null;
    const $a83ca30f957fd273$var$RightContentWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1e0c11p5 _18u01b66 _syaz1a45",
                __cmplp.className
            ])
        });
    });
    const $a83ca30f957fd273$var$CommandRightChevronContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { transitionStep: transitionStep, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ii7kb7n _yyhykb7n _4cvr1h6o _1e0c1txw _1bsb1tcg _4t3i1tcg _vwz41tcg _5sag1ttt _1pgl1ytf _1o51q7pw _tzy4idpf _syazbkuv",
                __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING && "",
                __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING && "_j7hq1wwu",
                __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
                __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1sbx",
                (__cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4kb7n",
                __cmplp.className
            ])
        });
    });
    const $a83ca30f957fd273$var$ShortcutContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { shouldHaveTransition: shouldHaveTransition, transitionStep: transitionStep, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ii7kb7n _yyhykb7n _5sag1ttt _1pgl1ytf _1o51q7pw _1e0c1txw _1bahesu3",
                __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
                __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1wwu",
                __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING && "",
                __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING && "_j7hq1sbx",
                (__cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4idpf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("h1toL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
    function $c6495598d3d7027d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>$c6495598d3d7027d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
        }, props, {
            newIcon: $c6495598d3d7027d$var$_chevronRight.default,
            iconType: "utility"
        }));
    $c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
    var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;
});
const $0296d551a7f83620$export$f3036e9d26f81cd9 = 'command-palette.ui.modal.body.command-shortcut-container';
const $0296d551a7f83620$export$e3e144c17be58a44 = 'command-palette.ui.modal.body.command-chevron-container';
const $0296d551a7f83620$export$e792b5b2b6c9ee7 = 'command-palette.ui.modal.body.command-right-icon-container';
parcelRegister("iLhkq", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$bf35cee6e1d1204b$export$defe85febe8b728c);
    var $7VHMR;
    const $bf35cee6e1d1204b$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rightChevronLabel: {
            "id": "command-palette.common.components.command-row.right-content.right-chevron-label",
            "defaultMessage": "Command with children icon"
        }
    });
});
parcelRegister("dSJBv", function(module, exports) {
    $parcel$export(module.exports, "Shortcuts", ()=>$57e6d30b2626ce39$export$b326d77e4b8b7664);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $koVbs;
    var $bcTvL;
    var $gM5ou;
    var $dzeHJ;
    var $esPgL;
    const $57e6d30b2626ce39$var$KeyElement = ({ shortcut: shortcut })=>(0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$export$cde89099db64abe3, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dzeHJ")).FilledLozenge), {
            "data-testid": (0, $5ecbf01f9da59a15$export$cd62afa4691c297)
        }, shortcut));
    const $57e6d30b2626ce39$var$DivisorElement = ({ divisor: divisor })=>(0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$ShortcutDivider, {
            "data-testid": (0, $5ecbf01f9da59a15$export$e06ad7c09a29974b)
        }, divisor);
    const $57e6d30b2626ce39$var$parseShortcut = (shortcut, replacers, acc = [], types = [])=>{
        const replacer = replacers.shift();
        if (!replacer) {
            acc.push({
                type: (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).KEY,
                key: shortcut
            });
            types.push((0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).KEY);
            return [
                acc,
                types
            ];
        }
        shortcut.split(replacer.char).forEach((str, index, self)=>{
            $57e6d30b2626ce39$var$parseShortcut(str, replacers.slice(0), acc, types);
            if (index < self.length - 1) {
                acc.push({
                    type: replacer.replacement
                });
                types.push(replacer.replacement);
            }
        });
        return [
            acc,
            types
        ];
    };
    const $57e6d30b2626ce39$export$cfaeb054b183bb20 = ()=>(0, (0, parcelRequire("koVbs")).default)();
    const $57e6d30b2626ce39$export$b326d77e4b8b7664 = ({ shortcut: shortcut })=>{
        const { formatMessage: formatMessage } = $57e6d30b2626ce39$export$cfaeb054b183bb20();
        const [shortcuts, types] = (0, $5uXOq.useMemo)(()=>$57e6d30b2626ce39$var$parseShortcut(shortcut, (0, (0, parcelRequire("gM5ou")).getShortcutSpecialCharacters)()), [
            shortcut
        ]);
        const basicShortcutMessage = (0, $5uXOq.useMemo)(()=>{
            if (types.length === 3) {
                if (types[0] === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).KEY && types[2] === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).KEY) {
                    if (types[1] === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).THEN) return (0, (0, parcelRequire("esPgL")).messages).shortcutThen;
                    if (types[1] === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).OR) return (0, (0, parcelRequire("esPgL")).messages).shortcutOr;
                    if (types[1] === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).PLUS) return (0, (0, parcelRequire("esPgL")).messages).shortcutPlus;
                }
            }
            return null;
        }, [
            types
        ]);
        const formatTypeToMessage = (0, $5uXOq.useCallback)((type)=>{
            switch(type){
                case (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).THEN:
                    return formatMessage((0, (0, parcelRequire("esPgL")).messages).divisorThen);
                case (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).OR:
                    return formatMessage((0, (0, parcelRequire("esPgL")).messages).divisorOr);
                default:
                    return formatMessage((0, (0, parcelRequire("esPgL")).messages).divisorPlus);
            }
        }, [
            formatMessage
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$ShortcutContainer, {
            "data-testid": (0, $5ecbf01f9da59a15$export$ec8260df4f23714c),
            "aria-hidden": true
        }, basicShortcutMessage ? formatMessage(basicShortcutMessage, {
            shortcutA: (0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
                shortcut: shortcuts[0].key
            }),
            shortcutB: (0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
                shortcut: shortcuts[2].key
            }),
            divisor: (chunk)=>(0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$DivisorElement, {
                    divisor: chunk
                })
        }) : shortcuts.map((obj, index)=>{
            if (obj.type === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).KEY) return (0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
                key: index,
                shortcut: obj.key
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$DivisorElement, {
                key: index,
                divisor: formatTypeToMessage(obj.type)
            });
        }));
    };
    const $57e6d30b2626ce39$var$ShortcutDivider = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8otz2",
                __cmplp.className
            ])
        });
    });
    const $57e6d30b2626ce39$var$ShortcutContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlidpf _1o9zkb7n _1bah1h6o _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $57e6d30b2626ce39$export$cde89099db64abe3 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o",
                __cmplp.className
            ])
        });
    });
});
const $5ecbf01f9da59a15$export$cd62afa4691c297 = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-icon';
const $5ecbf01f9da59a15$export$e06ad7c09a29974b = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-divider';
const $5ecbf01f9da59a15$export$ec8260df4f23714c = 'command-palette.ui.modal.modal-content.body.command-row.shortcuts.shortcut-container';
parcelRegister("esPgL", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$4f430d579edd6c91$export$defe85febe8b728c);
    var $7VHMR;
    const $4f430d579edd6c91$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        shortcutThen: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-then",
            "defaultMessage": "{shortcutA} <divisor>then</divisor> {shortcutB}"
        },
        shortcutOr: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-or",
            "defaultMessage": "{shortcutA} <divisor>or</divisor> {shortcutB}"
        },
        shortcutPlus: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-plus",
            "defaultMessage": "{shortcutA} <divisor>+</divisor> {shortcutB}"
        },
        divisorThen: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-then",
            "defaultMessage": "then"
        },
        divisorOr: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-or",
            "defaultMessage": "or"
        },
        divisorPlus: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-plus",
            "defaultMessage": "+"
        }
    });
});
parcelRegister("kbnU6", function(module, exports) {
    $parcel$export(module.exports, "TRANSITION_STEP", ()=>$d865f5b0afeb3acd$export$42d8d7c94c5a11e9);
    $parcel$export(module.exports, "TRANSITION_INITIAL_DELAY_TIME_MS", ()=>$d865f5b0afeb3acd$export$82cfc253a6c33f59);
    $parcel$export(module.exports, "TRANSITION_HOVER_DELAY_TIME_MS", ()=>$d865f5b0afeb3acd$export$e092796a9af3633b);
    $parcel$export(module.exports, "TRANSITION_DURATION_MS", ()=>$d865f5b0afeb3acd$export$1cad4f611a1c0229);
    var $d865f5b0afeb3acd$export$42d8d7c94c5a11e9;
    (function(TRANSITION_STEP) {
        TRANSITION_STEP["INITIAL"] = "initial";
        TRANSITION_STEP["DELAYING"] = "delaying";
        TRANSITION_STEP["TRANSITIONING"] = "transitioning";
        TRANSITION_STEP["FINISHED"] = "finished";
        TRANSITION_STEP["DELAYING_FADE_OUT"] = "delaying-fade-out";
        TRANSITION_STEP["TRANSITIONING_FADE_OUT"] = "transitioning-fade-out";
    })($d865f5b0afeb3acd$export$42d8d7c94c5a11e9 || ($d865f5b0afeb3acd$export$42d8d7c94c5a11e9 = {}));
    const $d865f5b0afeb3acd$export$82cfc253a6c33f59 = 600;
    const $d865f5b0afeb3acd$export$e092796a9af3633b = 300;
    const $d865f5b0afeb3acd$export$1cad4f611a1c0229 = 350;
});
parcelRegister("lHtdH", function(module, exports) {
    $parcel$export(module.exports, "useHoverTransitionStep", ()=>$9c0e762a7fdf0cdc$export$eefd045a02bab4c6);
    var $5uXOq = parcelRequire("5uXOq");
    var $dWt6p;
    var $jcw0u;
    var $gM5ou;
    var $kbnU6;
    const $9c0e762a7fdf0cdc$export$eefd045a02bab4c6 = (command, isActive, isFirstCommand)=>{
        const [hasTransitionedFirstCommand, setHasTransitionedFirstCommand] = (0, $5uXOq.useState)(false);
        const [transitionStep, setTransitionStep] = (0, $5uXOq.useState)((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL);
        const timerRef = (0, $5uXOq.useRef)(null);
        const isReducedMotion = (0, (0, parcelRequire("dWt6p")).useIsReducedMotion)();
        const commandHasChildren = (0, (0, parcelRequire("gM5ou")).hasChildren)(command);
        (0, $5uXOq.useEffect)(()=>{
            setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL);
            if (timerRef.current) clearTimeout(timerRef.current);
        }, [
            command
        ]);
        const startTimerForNextStep = (nextStep, durationMs)=>{
            timerRef.current = setTimeout(()=>{
                setTransitionStep(nextStep);
                timerRef.current = null;
            }, durationMs);
        };
        const handleReducedMotionTransition = (0, $5uXOq.useCallback)(()=>{
            if (isActive) setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).FINISHED);
            else setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL);
        }, [
            isActive
        ]);
        const handleWithMotionTransition = (0, $5uXOq.useCallback)(()=>{
            switch(transitionStep){
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL:
                    if (isActive) {
                        setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING);
                        startTimerForNextStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING, isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand ? (0, (0, parcelRequire("kbnU6")).TRANSITION_INITIAL_DELAY_TIME_MS) : (0, (0, parcelRequire("kbnU6")).TRANSITION_HOVER_DELAY_TIME_MS));
                    }
                    break;
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING:
                    if (!isActive) {
                        timerRef.current && clearTimeout(timerRef.current);
                        timerRef.current = null;
                        setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL);
                    }
                    break;
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING:
                    if (isActive) {
                        if (isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand) setHasTransitionedFirstCommand(true);
                        if (!timerRef.current) startTimerForNextStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).FINISHED, (0, (0, parcelRequire("kbnU6")).TRANSITION_DURATION_MS));
                    }
                    break;
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).FINISHED:
                    if (!isActive) setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING_FADE_OUT);
                    break;
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING_FADE_OUT:
                    if (!timerRef.current) startTimerForNextStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT, (0, (0, parcelRequire("kbnU6")).TRANSITION_HOVER_DELAY_TIME_MS));
                    break;
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT:
                    if (!timerRef.current) startTimerForNextStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL, (0, (0, parcelRequire("kbnU6")).TRANSITION_DURATION_MS));
                    break;
                default:
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: new Error('Invalid transition step for command'),
                        meta: {
                            id: 'useTransitionStep',
                            packageName: 'jiraCommandPalette',
                            teamName: 'deliveroo'
                        }
                    });
            }
        }, [
            command.shortcut,
            hasTransitionedFirstCommand,
            isActive,
            isFirstCommand,
            transitionStep
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (commandHasChildren) {
                if (isReducedMotion) handleReducedMotionTransition();
                else handleWithMotionTransition();
            }
        }, [
            commandHasChildren,
            isReducedMotion,
            handleReducedMotionTransition,
            handleWithMotionTransition
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isFirstCommand) setHasTransitionedFirstCommand(false);
        }, [
            isFirstCommand
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                if (timerRef.current) clearTimeout(timerRef.current);
            }, []);
        return transitionStep;
    };
});
parcelRegister("5aF2z", function(module, exports) {
    $parcel$export(module.exports, "GROUP_TEST_ID", ()=>$7ecce3582144481d$export$d83f892940e54128);
    $parcel$export(module.exports, "NO_RESULTS_TEST_ID", ()=>$7ecce3582144481d$export$bf182a53106ca02e);
    $parcel$export(module.exports, "SCROLL_DIRECTION", ()=>$7ecce3582144481d$export$a6d65a8fb7b912d6);
    const $7ecce3582144481d$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
    const $7ecce3582144481d$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
    const $7ecce3582144481d$export$d83f892940e54128 = 'command-palette.ui.modal.body.group-container';
    const $7ecce3582144481d$export$707f57180c76458e = 'command-palette.ui.modal.body.spinner-container';
    const $7ecce3582144481d$export$bf182a53106ca02e = 'command-palette.ui.modal.body.no-results-container';
    var $7ecce3582144481d$export$a6d65a8fb7b912d6;
    (function(SCROLL_DIRECTION) {
        SCROLL_DIRECTION["START"] = "start";
        SCROLL_DIRECTION["END"] = "end";
    })($7ecce3582144481d$export$a6d65a8fb7b912d6 || ($7ecce3582144481d$export$a6d65a8fb7b912d6 = {}));
});
parcelRegister("64ZBB", function(module, exports) {
    $parcel$export(module.exports, "isElementVisibleInContainer", ()=>$6b9215d3fa38a855$export$b9dc8b6556026098);
    $parcel$export(module.exports, "getScrollToIndex", ()=>$6b9215d3fa38a855$export$56068eb4c4e3a63c);
    $parcel$export(module.exports, "scrollResultIntoView", ()=>$6b9215d3fa38a855$export$6be8a7238febd54f);
    $parcel$export(module.exports, "scrollResultIntoViewOld", ()=>$6b9215d3fa38a855$export$5ebacb7632dd32c7);
    var $gM5ou;
    var $5aF2z;
    const $6b9215d3fa38a855$export$b9dc8b6556026098 = (element, container)=>{
        const modalBodyRect = container.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();
        return elementRect.top >= modalBodyRect.top && elementRect.bottom <= modalBodyRect.bottom;
    };
    const $6b9215d3fa38a855$export$56068eb4c4e3a63c = (results, newActiveIndex, scrollTo)=>{
        const commandResultIndex = results.findIndex((result)=>!result.isGroup && result.index === newActiveIndex);
        if (scrollTo === (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).START && commandResultIndex > 0) {
            const prevActiveCommandIndex = results.findIndex((result, index)=>index < commandResultIndex && !result.isGroup && (0, (0, parcelRequire("gM5ou")).hasAction)(result.command));
            if (prevActiveCommandIndex === -1) return 0;
        }
        if (scrollTo === (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).END) {
            const afterActiveCommandIndex = results.findIndex((result, index)=>index > commandResultIndex && !result.isGroup && (0, (0, parcelRequire("gM5ou")).hasAction)(result.command));
            if (afterActiveCommandIndex === -1) return results.length - 1;
            return commandResultIndex;
        }
        const isCommandAfterGroupHeading = commandResultIndex > 0 && results[commandResultIndex - 1].isGroup;
        return isCommandAfterGroupHeading ? commandResultIndex - 1 : commandResultIndex;
    };
    const $6b9215d3fa38a855$export$6be8a7238febd54f = ({ target: target, direction: direction, scrollContainer: scrollContainer })=>{
        const targetRect = target.getBoundingClientRect();
        const containerRect = scrollContainer.getBoundingClientRect();
        const gapScroll = 4;
        if (direction === (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).END) {
            const commandPosition = targetRect.bottom - containerRect.top;
            const amountToScroll = commandPosition - containerRect.height;
            const pos = amountToScroll + gapScroll + scrollContainer.scrollTop;
            scrollContainer.scrollTo({
                top: pos
            });
        } else {
            const commandPosition = containerRect.top - targetRect.top;
            const amountToScroll = scrollContainer.scrollTop - commandPosition;
            const pos = amountToScroll - gapScroll;
            scrollContainer.scrollTo({
                top: pos
            });
        }
    };
    const $6b9215d3fa38a855$export$5ebacb7632dd32c7 = (scrollToResult, scrollTo)=>{
        if (!scrollToResult?.parentElement) return;
        const parent = scrollToResult.parentElement;
        const elemRect = scrollToResult.getBoundingClientRect();
        const parentRect = parent.getBoundingClientRect();
        const gapScroll = 4;
        if (scrollTo === (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).END) {
            const commandPosition = elemRect.bottom - parentRect.top;
            const amountToScroll = commandPosition - parentRect.height;
            const pos = amountToScroll + gapScroll + parent.scrollTop;
            scrollToResult.parentElement.scrollTo({
                top: pos
            });
        } else {
            const commandPosition = parentRect.top - elemRect.top;
            const amountToScroll = parent.scrollTop - commandPosition;
            const pos = amountToScroll - gapScroll;
            scrollToResult.parentElement.scrollTo({
                top: pos
            });
        }
    };
});
parcelRegister("dE25F", function(module, exports) {
    $parcel$export(module.exports, "Footer", ()=>$842574a5e4b1a419$export$a06f1c675e846f6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $842574a5e4b1a419$export$a06f1c675e846f6f = ({ defaultFooterContent: defaultFooterContent, children: children })=>{
        const footerChildren = children || defaultFooterContent;
        if (!footerChildren) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($842574a5e4b1a419$var$ModalFooter, {
            "data-testid": (0, $8289a08a5c530859$export$aca3e1b45b29f2bb)
        }, footerChildren);
    };
    const $842574a5e4b1a419$var$ModalFooter = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_mrkb1kw7 _1o0z1kw7 _1yt49l6b _x3doh6cr",
                __cmplp.className
            ])
        });
    });
});
const $8289a08a5c530859$export$aca3e1b45b29f2bb = 'command-palette.ui.modal.footer.footer';
parcelRegister("d4iCz", function(module, exports) {
    $parcel$export(module.exports, "Header", ()=>$82822f3e363fec07$export$8b251419efc915eb);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    const $82822f3e363fec07$export$8b251419efc915eb = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $82822f3e363fec07$var$headerStyles,
            testId: (0, $cd6716f1a0c7ec9f$export$bf5b960a2e79e6cf)
        }, children);
    const $82822f3e363fec07$var$headerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit',
        padding: 'space.200',
        borderBottom: `solid 1px ${`var(--ds-border, ${(0, $829f609a65d26a98$exports).N40})`}`
    });
});
const $cd6716f1a0c7ec9f$export$bf5b960a2e79e6cf = 'command-palette.ui.modal.header.modal-header';
parcelRegister("6Xy8w", function(module, exports) {
    $parcel$export(module.exports, "useDebouncedLoadChildren", ()=>$d4ce5e5db4831205$export$d38ddfbd8b9028f);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $bcTvL;
    var $d8lE2;
    const $d4ce5e5db4831205$export$d38ddfbd8b9028f = (callback)=>{
        const [{ search: search }, { setLoadingList: setLoadingList }] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteSearch)();
        const loadChildCommands = (0, $5uXOq.useCallback)(async (searchTerm, obj)=>{
            await callback(searchTerm, obj);
            if (!obj.isMounted) return;
            setLoadingList(false);
        }, [
            callback,
            setLoadingList
        ]);
        const executeDebouncer = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($lFKmC)))(loadChildCommands, (0, (0, parcelRequire("bcTvL")).COMMAND_PALETTE_DEBOUNCE_DEFAULT)), [
            loadChildCommands
        ]);
        (0, $5uXOq.useEffect)(()=>()=>executeDebouncer?.cancel?.(), [
            executeDebouncer
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const obj = {
                isMounted: true
            };
            setLoadingList(true);
            executeDebouncer(search, obj);
            return ()=>{
                obj.isMounted = false;
            };
        }, [
            search,
            executeDebouncer,
            setLoadingList
        ]);
    };
});
parcelRegister("1qxNN", function(module, exports) {
    $parcel$export(module.exports, "useQuickSearchWithRecentCache", ()=>$ebab1b38e2fea9c7$export$7eb3d4d963c0f46c);
    var $5uXOq = parcelRequire("5uXOq");
    var $d8lE2;
    var $8zOmE;
    var $2NMNM;
    var $lQmpR;
    const $ebab1b38e2fea9c7$export$ca7c3b177540050a = ()=>{
        const recentCacheRef = (0, $5uXOq.useRef)();
        const setRecentCache = (0, $5uXOq.useCallback)((cache)=>{
            recentCacheRef.current = cache;
        }, [
            recentCacheRef
        ]);
        return [
            recentCacheRef,
            setRecentCache
        ];
    };
    const $ebab1b38e2fea9c7$export$7eb3d4d963c0f46c = ()=>{
        const [{ isOpen: isOpen }] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteIsOpen)();
        const [recentCache, setRecentCache] = $ebab1b38e2fea9c7$export$ca7c3b177540050a();
        const { fetch: fetch } = (0, (0, parcelRequire("lQmpR")).useQuickSearch)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (Boolean(recentCache.current) && !isOpen) setRecentCache(undefined);
        }, [
            isOpen,
            recentCache,
            setRecentCache
        ]);
        const fetchData = (0, $5uXOq.useCallback)(async (searchString, sessionId, signal)=>{
            const start = new Date();
            const apiCall = fetch(searchString, sessionId, signal);
            const result = await apiCall;
            const end = new Date();
            const duration = end.getTime() - start.getTime();
            if (searchString?.length) (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(createAnalyticsEvent({}), 'searchRequest completed', {
                postQueryRequestDurationMs: duration
            });
            else {
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(createAnalyticsEvent({}), 'recentRequest completed', {
                    preQueryRequestDurationMs: duration
                });
                setRecentCache(apiCall);
            }
            return result;
        }, [
            createAnalyticsEvent,
            fetch,
            setRecentCache
        ]);
        const getResponse = (0, $5uXOq.useCallback)(async (searchString, sessionId, signal)=>{
            if (searchString && searchString.length > 0) {
                const result = await fetchData(searchString, sessionId, signal);
                return {
                    result: result,
                    isCache: false
                };
            }
            if (recentCache.current) try {
                await recentCache.current;
            } catch (err) {
                const apiCall = fetchData(searchString, sessionId, signal);
                return {
                    result: await apiCall,
                    isCache: false
                };
            }
            else {
                const apiCall = fetchData(searchString, sessionId, signal);
                return {
                    result: await apiCall,
                    isCache: false
                };
            }
            return {
                result: await recentCache.current,
                isCache: true
            };
        }, [
            recentCache,
            fetchData
        ]);
        return {
            fetch: getResponse
        };
    };
});
parcelRegister("lQmpR", function(module, exports) {
    $parcel$export(module.exports, "useQuickSearch", ()=>$ea71281883388db5$export$8ad8ebb2d2ffa47);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $eusud;
    var $9OXo1;
    var $dmf5R;
    const $ea71281883388db5$var$EXPERIENCE = 'command-palette-jira-integration';
    const $ea71281883388db5$var$LIMIT = Math.max((0, (0, parcelRequire("dmf5R")).ISSUE_LIMIT), (0, (0, parcelRequire("dmf5R")).PROJECT_LIMIT), (0, (0, parcelRequire("dmf5R")).BOARD_LIMIT), (0, (0, parcelRequire("dmf5R")).FILTER_LIMIT), (0, (0, parcelRequire("dmf5R")).PLAN_LIMIT)) + 1;
    const $ea71281883388db5$export$8ad8ebb2d2ffa47 = ()=>{
        const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const fetch = (0, $5uXOq.useCallback)(async (query, sessionId, signal)=>{
            try {
                const data = await (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/xpsearch-aggregator/quicksearch/v1', {
                    body: JSON.stringify({
                        cloudId: cloudId,
                        scopes: [
                            'jira.issue',
                            'jira.board',
                            'jira.project',
                            'jira.filter',
                            'jira.plan'
                        ],
                        query: query,
                        experience: $ea71281883388db5$var$EXPERIENCE,
                        searchSession: {
                            sessionId: sessionId,
                            referrerId: null
                        },
                        limit: $ea71281883388db5$var$LIMIT
                    }),
                    signal: signal
                });
                return data;
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error instanceof Error ? error : new Error('Error not identified'),
                    meta: {
                        id: 'fetchRecentlyViewedIssuesService',
                        packageName: 'jiraCommandPaletteQuickSearch',
                        teamName: 'deliveroo'
                    }
                });
                throw error;
            }
        }, [
            cloudId
        ]);
        return {
            fetch: fetch
        };
    };
});
parcelRegister("dmf5R", function(module, exports) {
    $parcel$export(module.exports, "QUICK_SEARCH_PRIORITY", ()=>$4f39564697687816$export$ce7c8c2e20fb73ca);
    $parcel$export(module.exports, "ISSUE_LIMIT", ()=>$4f39564697687816$export$dcc4c3a6f9b2e0aa);
    $parcel$export(module.exports, "PROJECT_LIMIT", ()=>$4f39564697687816$export$8000560255015036);
    $parcel$export(module.exports, "BOARD_LIMIT", ()=>$4f39564697687816$export$2987f3ac7bc1c1c3);
    $parcel$export(module.exports, "FILTER_LIMIT", ()=>$4f39564697687816$export$14ceffb568197d5a);
    $parcel$export(module.exports, "PLAN_LIMIT", ()=>$4f39564697687816$export$654fbdaf884d026c);
    var $4f39564697687816$export$ce7c8c2e20fb73ca;
    (function(QUICK_SEARCH_PRIORITY) {
        QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["ISSUES"] = 0] = "ISSUES";
        QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["PROJECTS"] = 1] = "PROJECTS";
        QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["BOARDS"] = 2] = "BOARDS";
        QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["FILTERS"] = 3] = "FILTERS";
        QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["PLANS"] = 4] = "PLANS";
        QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["RECOMMENDED"] = 5] = "RECOMMENDED";
    })($4f39564697687816$export$ce7c8c2e20fb73ca || ($4f39564697687816$export$ce7c8c2e20fb73ca = {}));
    const $4f39564697687816$export$dcc4c3a6f9b2e0aa = 5;
    const $4f39564697687816$export$8000560255015036 = 3;
    const $4f39564697687816$export$2987f3ac7bc1c1c3 = 3;
    const $4f39564697687816$export$14ceffb568197d5a = 3;
    const $4f39564697687816$export$654fbdaf884d026c = 3;
});
parcelRegister("b3BGu", function(module, exports) {
    $parcel$export(module.exports, "useGetRecentResults", ()=>$9775be8c5f520569$export$232194057b4317a2);
    var $5uXOq = parcelRequire("5uXOq");
    var $gM5ou;
    var $h9iZl;
    var $8zOmE;
    var $2NMNM;
    var $JKfGz;
    var $5zDBm;
    var $hX4Eo;
    var $c2I39;
    var $bsL38;
    var $33VxI;
    var $5OaBm;
    var $3eTqY;
    var $2ZZwV;
    const $9775be8c5f520569$export$232194057b4317a2 = ()=>{
        const { getChildResult: getRecentBoardsChildResult } = (0, (0, parcelRequire("bsL38")).useGetRecentBoardsChildResult)();
        const { getChildResult: getRecentIssuesChildResult } = (0, (0, parcelRequire("5OaBm")).useGetRecentIssuesChildResult)();
        const { getChildResult: getRecentProjectsChildResult } = (0, (0, parcelRequire("2ZZwV")).useGetRecentProjectsChildResult)();
        const { getChildResult: getRecentFiltersChildResult } = (0, (0, parcelRequire("33VxI")).useGetRecentFiltersChildResult)();
        const { getChildResult: getRecentPlansChildResult } = (0, (0, parcelRequire("3eTqY")).useGetRecentPlansChildResult)();
        const { getChildResult: getErrorChildResult } = (0, (0, parcelRequire("JKfGz")).useGetErrorChildResult)();
        const { getChildResult: getRecommendedChildResult } = (0, (0, parcelRequire("5zDBm")).useGetRecommendedChildResult)();
        const [hasEditOrViewPermissions] = (0, (0, parcelRequire("h9iZl")).useNavigationViewPlansPermission)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, (0, parcelRequire("hX4Eo")).useSetTimeoutAutoClear)();
        const setTimeoutFunc = setTimeoutAutoClear;
        const getRecentResults = (0, $5uXOq.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
            setTimeoutFunc(()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'searchResults shown', 'preQuerySearchResults', {
                    ...(0, (0, parcelRequire("c2I39")).transformResultsForAnalytics)(quickSearchResponseData, true)
                });
            }, 0);
            return (0, (0, parcelRequire("gM5ou")).mergeChildResults)([
                getErrorChildResult({
                    search: search,
                    quickSearchResponseData: quickSearchResponseData,
                    error: error
                }),
                getRecommendedChildResult({
                    search: search,
                    quickSearchResponseData: quickSearchResponseData,
                    error: error
                }),
                getRecentIssuesChildResult({
                    search: search,
                    quickSearchResponseData: quickSearchResponseData,
                    error: error
                }),
                getRecentProjectsChildResult({
                    search: search,
                    quickSearchResponseData: quickSearchResponseData,
                    error: error
                }),
                getRecentBoardsChildResult({
                    search: search,
                    quickSearchResponseData: quickSearchResponseData,
                    error: error
                }),
                getRecentFiltersChildResult({
                    search: search,
                    quickSearchResponseData: quickSearchResponseData,
                    error: error
                }),
                ...hasEditOrViewPermissions ? [
                    getRecentPlansChildResult({
                        search: search,
                        quickSearchResponseData: quickSearchResponseData,
                        error: error
                    })
                ] : []
            ]);
        }, [
            createAnalyticsEvent,
            getErrorChildResult,
            getRecommendedChildResult,
            getRecentIssuesChildResult,
            getRecentProjectsChildResult,
            getRecentBoardsChildResult,
            getRecentFiltersChildResult,
            hasEditOrViewPermissions,
            getRecentPlansChildResult,
            setTimeoutFunc
        ]);
        return getRecentResults;
    };
});
parcelRegister("h9iZl", function(module, exports) {
    $parcel$export(module.exports, "navigationPlansVisibilityResource", ()=>$66eb980ebca35ddf$export$fa475a9581133779);
    $parcel$export(module.exports, "useNavigationPlansVisibility", ()=>$66eb980ebca35ddf$export$4524245d4e74edb2);
    $parcel$export(module.exports, "useNavigationViewPlansPermission", ()=>$66eb980ebca35ddf$export$98eef08fd4586a4);
    $parcel$export(module.exports, "useNavigationEditPlansPermission", ()=>$66eb980ebca35ddf$export$525db876ed776e0d);
    $parcel$export(module.exports, "useIsAdvancedRoadmapsTrial", ()=>$66eb980ebca35ddf$export$54805a2120a31ad0);
    var $dJl1T;
    var $7f4tk;
    var $2M1hQ;
    var $2YP9W;
    const $66eb980ebca35ddf$export$fa475a9581133779 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: (0, $94526093207618a3$export$9260ddb6dfeafd7b),
        getKey: ()=>'state',
        getData: async (_, { tenantContext: tenantContext })=>{
            try {
                if (tenantContext.isAnonymous) return false;
                const response = await (0, (0, parcelRequire("7f4tk")).default)(`${tenantContext.baseUrl}/rest/jpo/1.0/navigation/simple`);
                return response;
            } catch (error) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData((0, $94526093207618a3$export$87d0ca22edb7493a), 'Error while fetching plans visibility', error);
            }
            return false;
        },
        maxAge: Infinity
    });
    const $66eb980ebca35ddf$export$4524245d4e74edb2 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)($66eb980ebca35ddf$export$fa475a9581133779);
        let isVisible = false;
        if (!error && !loading && data !== null && typeof data === 'object') isVisible = data.isVisible;
        return [
            isVisible
        ];
    };
    const $66eb980ebca35ddf$export$98eef08fd4586a4 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)($66eb980ebca35ddf$export$fa475a9581133779);
        let hasEditOrViewPermissions = false;
        if (!error && !loading && data !== null && typeof data === 'object') hasEditOrViewPermissions = data.hasEditOrViewPermissions;
        return [
            hasEditOrViewPermissions
        ];
    };
    const $66eb980ebca35ddf$export$525db876ed776e0d = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)($66eb980ebca35ddf$export$fa475a9581133779);
        let canEditPlans = false;
        if (!error && !loading && data !== null && typeof data === 'object') canEditPlans = data.hasEditPermissions || false;
        return canEditPlans;
    };
    const $66eb980ebca35ddf$export$54805a2120a31ad0 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)($66eb980ebca35ddf$export$fa475a9581133779);
        let isAdvancedRoadmapsTrial = false;
        if (!error && !loading && data !== null && typeof data === 'object') isAdvancedRoadmapsTrial = data.isAdvancedRoadmapsTrial || false;
        return isAdvancedRoadmapsTrial;
    };
});
const $94526093207618a3$export$9260ddb6dfeafd7b = 'NAVIGATION_PLANS_VISIBILITY';
const $94526093207618a3$export$87d0ca22edb7493a = 'portfolio.services.plan-item-visibility';
parcelRegister("JKfGz", function(module, exports) {
    $parcel$export(module.exports, "useGetErrorChildResult", ()=>$f1d1fc49f867d81f$export$3aefd3a8866c4c01);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $koVbs;
    var $kjpLE;
    var $bgCj3;
    var $3MOkj;
    var $7mCsh;
    const $f1d1fc49f867d81f$export$3aefd3a8866c4c01 = ()=>{
        const { formatMessage: formatMessage, formatList: formatList } = (0, (0, parcelRequire("koVbs")).default)();
        const getChildResult = (0, $5uXOq.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
            const commands = [];
            const sections = {};
            const isSearching = Boolean(search);
            const issueScope = (0, (0, parcelRequire("bgCj3")).getQuickSearchIssueScope)(quickSearchResponseData);
            const projectScope = (0, (0, parcelRequire("bgCj3")).getQuickSearchProjectScope)(quickSearchResponseData);
            const boardScope = (0, (0, parcelRequire("bgCj3")).getQuickSearchBoardScope)(quickSearchResponseData);
            const filterScope = (0, (0, parcelRequire("bgCj3")).getQuickSearchFilterScope)(quickSearchResponseData);
            const planScope = (0, (0, parcelRequire("bgCj3")).getQuickSearchPlanScope)(quickSearchResponseData);
            const errorScopes = [
                issueScope?.error ? formatMessage((0, (0, parcelRequire("3MOkj")).messages).issues) : undefined,
                projectScope?.error ? formatMessage((0, (0, parcelRequire("3MOkj")).messages).projects) : undefined,
                boardScope?.error ? formatMessage((0, (0, parcelRequire("3MOkj")).messages).boards) : undefined,
                filterScope?.error ? formatMessage((0, (0, parcelRequire("3MOkj")).messages).filters) : undefined,
                planScope?.error ? formatMessage((0, (0, parcelRequire("3MOkj")).messages).plans) : undefined
            ];
            const errors = errorScopes.filter(Boolean);
            if (error || errorScopes.length === errors.length) {
                const message = formatMessage(isSearching ? (0, (0, parcelRequire("3MOkj")).messages).searchFullError : (0, (0, parcelRequire("3MOkj")).messages).recentFullError);
                commands.push({
                    id: 'full-error',
                    name: message,
                    components: {
                        Name: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($f1d1fc49f867d81f$var$CommandErrorWrapper, {
                                "data-testid": (0, $eb8f9bab396c63a1$export$1a00547d03f724bf)
                            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kjpLE")).FullWidthText), null, message))
                    },
                    keywords: search
                });
                return {
                    sections: sections,
                    commands: commands
                };
            }
            if (errors.length) {
                const formattedErrors = formatList(errors, {
                    style: 'long',
                    type: 'conjunction'
                });
                const message = isSearching ? formatMessage((0, (0, parcelRequire("3MOkj")).messages).searchPartialError, {
                    errorList: formattedErrors
                }) : formatMessage((0, (0, parcelRequire("3MOkj")).messages).recentPartialError, {
                    errorList: formattedErrors
                });
                commands.push({
                    id: 'partial-error',
                    name: formatMessage((0, (0, parcelRequire("3MOkj")).messages).searchFullError),
                    components: {
                        Name: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($f1d1fc49f867d81f$var$CommandErrorWrapper, {
                                "data-testid": (0, $eb8f9bab396c63a1$export$18ff005171e98b96)
                            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kjpLE")).FullWidthText), null, message))
                    },
                    keywords: search
                });
                return {
                    sections: sections,
                    commands: commands
                };
            }
            const noSearchResults = !issueScope?.results?.length && !projectScope?.results?.length && !boardScope?.results?.length && !filterScope?.results?.length && !planScope?.results?.length;
            if (noSearchResults) {
                if (isSearching) commands.push({
                    id: 'no-search-results',
                    name: formatMessage((0, (0, parcelRequire("3MOkj")).messages).searchFullError),
                    keywords: search,
                    components: {
                        Name: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($f1d1fc49f867d81f$var$CommandErrorWrapper, {
                                "data-testid": (0, $eb8f9bab396c63a1$export$92b3b15780115417)
                            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kjpLE")).FullWidthText), null, formatMessage((0, (0, parcelRequire("3MOkj")).messages).searchNoResults)))
                    }
                });
                else {
                    const message = formatMessage((0, (0, parcelRequire("3MOkj")).messages).noRecentResults);
                    commands.push({
                        id: 'no-recent-results',
                        name: message,
                        keywords: search,
                        components: {
                            Name: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($f1d1fc49f867d81f$var$CommandErrorWrapper, {
                                    "data-testid": (0, $eb8f9bab396c63a1$export$b42da4a04bacaf8c)
                                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7mCsh")).NoRecentResults), {
                                    message: message
                                }))
                        }
                    });
                }
                return {
                    sections: sections,
                    commands: commands
                };
            }
            return {
                sections: sections,
                commands: commands
            };
        }, [
            formatList,
            formatMessage
        ]);
        return {
            getChildResult: getChildResult
        };
    };
    const $f1d1fc49f867d81f$var$CommandErrorWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0qpxbi _n3tdu2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kjpLE", function(module, exports) {
    $parcel$export(module.exports, "FullWidthText", ()=>$c8be77c5d60194e1$export$379b1877ecebef1d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $c8be77c5d60194e1$export$379b1877ecebef1d = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _y3gn1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bgCj3", function(module, exports) {
    $parcel$export(module.exports, "transformQuickSearchIssueResultToIssue", ()=>$bd830de5da878c68$export$58562759d0785ec6);
    $parcel$export(module.exports, "getQuickSearchIssueScope", ()=>$bd830de5da878c68$export$d7d3d79bf2e09f24);
    $parcel$export(module.exports, "transformQuickSearchBoardResultToBoard", ()=>$bd830de5da878c68$export$b8b15ec40fa1a48c);
    $parcel$export(module.exports, "getQuickSearchBoardScope", ()=>$bd830de5da878c68$export$53119668e12df12a);
    $parcel$export(module.exports, "getQuickSearchProjectScope", ()=>$bd830de5da878c68$export$a63a1be38234a3e5);
    $parcel$export(module.exports, "transformQuickSearchProjectResultToProject", ()=>$bd830de5da878c68$export$f2d81fcd7b29a3fa);
    $parcel$export(module.exports, "getQuickSearchFilterScope", ()=>$bd830de5da878c68$export$9fa79248b92c9eb7);
    $parcel$export(module.exports, "transformQuickSearchFilterResultToFilter", ()=>$bd830de5da878c68$export$ff1365615bf8816a);
    $parcel$export(module.exports, "getQuickSearchPlanScope", ()=>$bd830de5da878c68$export$ee6c69e884c0330);
    $parcel$export(module.exports, "transformQuickSearchPlanResultToPlan", ()=>$bd830de5da878c68$export$8033b8f463ee000a);
    const $bd830de5da878c68$export$58562759d0785ec6 = (issue)=>({
            issueId: issue.id,
            summary: issue.name,
            url: issue.url,
            issueKey: issue.attributes.key,
            avatar: issue.attributes.avatar,
            projectName: issue.attributes.container.title,
            projectId: issue.attributes.containerId,
            issueTypeName: issue.attributes.issueTypeName
        });
    const $bd830de5da878c68$export$d7d3d79bf2e09f24 = (results)=>{
        const issueResults = results?.scopes?.find((scope)=>scope.id === 'jira.issue');
        if (issueResults) return issueResults;
        return undefined;
    };
    const $bd830de5da878c68$export$b8b15ec40fa1a48c = (board)=>({
            id: board.id,
            url: board.url,
            name: board.name,
            containerId: board.attributes.containerId,
            containerName: board.attributes.containerName,
            isFavourite: board.attributes.isFavourite
        });
    const $bd830de5da878c68$export$53119668e12df12a = (results)=>{
        const boardResults = results?.scopes?.find((scope)=>scope.id === 'jira.board');
        if (boardResults) return boardResults;
        return undefined;
    };
    const $bd830de5da878c68$export$a63a1be38234a3e5 = (results)=>{
        const issueResults = results?.scopes?.find((scope)=>scope.id === 'jira.project');
        if (issueResults) return issueResults;
        return undefined;
    };
    const $bd830de5da878c68$export$f2d81fcd7b29a3fa = (project)=>({
            projectId: project.id,
            name: project.name,
            url: project.url,
            avatar: project.attributes.avatar,
            canView: project.attributes.canView,
            isFavourite: project.attributes.isFavourite,
            projectKey: project.attributes.projectKey,
            projectType: project.attributes.projectType,
            simplified: project.attributes.simplified
        });
    const $bd830de5da878c68$export$9fa79248b92c9eb7 = (results)=>{
        const filterResults = results?.scopes?.find((scope)=>scope.id === 'jira.filter');
        if (filterResults) return filterResults;
        return undefined;
    };
    const $bd830de5da878c68$export$ff1365615bf8816a = (filter)=>({
            id: filter.id,
            name: filter.name,
            url: filter.url
        });
    const $bd830de5da878c68$export$ee6c69e884c0330 = (results)=>{
        const planResults = results?.scopes?.find((scope)=>scope.id === 'jira.plan');
        if (planResults) return planResults;
        return undefined;
    };
    const $bd830de5da878c68$export$8033b8f463ee000a = (plan)=>({
            id: plan.id,
            name: plan.name,
            url: plan.url
        });
});
const $eb8f9bab396c63a1$export$1a00547d03f724bf = 'command-palette.ui.modal.modal-dialog';
const $eb8f9bab396c63a1$export$18ff005171e98b96 = 'command-palette.ui.modal.modal-dialog';
const $eb8f9bab396c63a1$export$92b3b15780115417 = 'command-palette.ui.modal.modal-dialog';
const $eb8f9bab396c63a1$export$b42da4a04bacaf8c = 'no-recent-results';
parcelRegister("3MOkj", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$8949dd27841de0ba$export$defe85febe8b728c);
    var $7VHMR;
    const $8949dd27841de0ba$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noRecentResults: {
            "id": "command-palette-quick-search.common.error.no-recent-results",
            "defaultMessage": "Things in Jira that you\u2019ve recently viewed will appear here."
        },
        recentFullError: {
            "id": "command-palette-quick-search.common.error.recent-full-error",
            "defaultMessage": "We\u2019re having trouble loading recently viewed issues. Try again in a few moments."
        },
        searchFullError: {
            "id": "command-palette-quick-search.common.error.search-full-error",
            "defaultMessage": "We\u2019re not sure what went wrong. Try again in a few moments."
        },
        searchNoResults: {
            "id": "command-palette-quick-search.common.error.search-no-results",
            "defaultMessage": "No issue, project, board, plan, or filter matches your search"
        },
        searchIssueError: {
            "id": "command-palette-quick-search.common.error.search-issue-error",
            "defaultMessage": "We\u2019re having trouble searching issues. You can try again in a few moments."
        },
        recentPartialError: {
            "id": "command-palette-quick-search.common.error.recent-partial-error",
            "defaultMessage": "We are having trouble loading {errorList} from your recently viewed items. Try again in a few moments."
        },
        searchPartialError: {
            "id": "command-palette-quick-search.common.error.search-partial-error",
            "defaultMessage": "We are having trouble searching {errorList}. Try again in a few moments."
        },
        issues: {
            "id": "command-palette-quick-search.common.error.issues",
            "defaultMessage": "issues"
        },
        projects: {
            "id": "command-palette-quick-search.common.error.projects",
            "defaultMessage": "projects"
        },
        boards: {
            "id": "command-palette-quick-search.common.error.boards",
            "defaultMessage": "boards"
        },
        filters: {
            "id": "command-palette-quick-search.common.error.filters",
            "defaultMessage": "filters"
        },
        plans: {
            "id": "command-palette-quick-search.common.error.plans",
            "defaultMessage": "plans"
        }
    });
});
parcelRegister("7mCsh", function(module, exports) {
    $parcel$export(module.exports, "NoRecentResults", ()=>$58efa10eb1db047e$export$6a5306d6ad19b06d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dC5iT;
    var $luBm6;
    var $80P9l;
    var $kjpLE;
    const $58efa10eb1db047e$export$6a5306d6ad19b06d = ({ message: message })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kjpLE")).FullWidthText), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.050"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($58efa10eb1db047e$var$ImageWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("80P9l")).default), {
            alt: "",
            fill: true
        })), message)));
    const $58efa10eb1db047e$var$ImageWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3ioahv _kqswh2mm",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("80P9l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6043373c6b544137$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "srcLight", ()=>($parcel$interopDefault((parcelRequire("cXdza")))));
    $parcel$export(module.exports, "srcDark", ()=>($parcel$interopDefault((parcelRequire("cXdza")))));
    var $dCLgq;
    var $cXdza = parcelRequire("cXdza");
    const $6043373c6b544137$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($cXdza)),
        srcDark: ($parcel$interopDefault($cXdza))
    });
    var $6043373c6b544137$export$2e2bcd8739ae039 = $6043373c6b544137$var$Illustration;
    const $6043373c6b544137$export$a179c88182cb9d56 = [
        0,
        0,
        95,
        89
    ];
});
parcelRegister("cXdza", function(module, exports) {
    module.exports = new URL("magic-search.dbdce574.svg", import.meta.url).toString();
});
parcelRegister("5zDBm", function(module, exports) {
    $parcel$export(module.exports, "useGetRecommendedChildResult", ()=>$6bd8e7b697bad55c$export$d7d3564e5e2691ad);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dmf5R;
    var $bgCj3;
    var $73ZzY;
    var $e5idJ;
    var $bGpCi;
    const $6bd8e7b697bad55c$var$SECTION_ID = 'recommended';
    const $6bd8e7b697bad55c$export$d7d3564e5e2691ad = ()=>{
        const { getViewAllCommand: getViewAllCommand } = (0, (0, parcelRequire("73ZzY")).useGetViewAllCommand)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getChildResult = (0, $5uXOq.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
            const isSearching = Boolean(search);
            const sections = {
                [$6bd8e7b697bad55c$var$SECTION_ID]: {
                    name: formatMessage((0, (0, parcelRequire("bGpCi")).messages).recommendedSection),
                    priority: (0, (0, parcelRequire("dmf5R")).QUICK_SEARCH_PRIORITY).RECOMMENDED
                }
            };
            const commands = [];
            const issueScope = (0, (0, parcelRequire("bgCj3")).getQuickSearchIssueScope)(quickSearchResponseData);
            const projectScope = (0, (0, parcelRequire("bgCj3")).getQuickSearchProjectScope)(quickSearchResponseData);
            const boardScope = (0, (0, parcelRequire("bgCj3")).getQuickSearchBoardScope)(quickSearchResponseData);
            const filterScope = (0, (0, parcelRequire("bgCj3")).getQuickSearchFilterScope)(quickSearchResponseData);
            const planScope = (0, (0, parcelRequire("bgCj3")).getQuickSearchPlanScope)(quickSearchResponseData);
            const showRecommended = (scope)=>!scope || scope.error || error || isSearching && !scope?.results?.length;
            if (showRecommended(issueScope)) commands.push(getViewAllCommand({
                id: 'recommended-issues',
                section: $6bd8e7b697bad55c$var$SECTION_ID,
                name: formatMessage((0, (0, parcelRequire("bGpCi")).messages).viewAllIssues),
                keywords: search,
                isRecommended: true,
                url: (0, (0, parcelRequire("e5idJ")).getViewAllUrl)((0, (0, parcelRequire("e5idJ")).ViewAllType).ISSUE),
                priority: (0, (0, parcelRequire("dmf5R")).QUICK_SEARCH_PRIORITY).ISSUES,
                analyticsPayload: {
                    action: 'viewAllIssues'
                }
            }));
            if (showRecommended(boardScope)) commands.push(getViewAllCommand({
                id: 'recommended-boards',
                section: $6bd8e7b697bad55c$var$SECTION_ID,
                name: formatMessage((0, (0, parcelRequire("bGpCi")).messages).viewAllBoards),
                keywords: search,
                isRecommended: true,
                url: (0, (0, parcelRequire("e5idJ")).getViewAllUrl)((0, (0, parcelRequire("e5idJ")).ViewAllType).BOARD),
                priority: (0, (0, parcelRequire("dmf5R")).QUICK_SEARCH_PRIORITY).BOARDS,
                analyticsPayload: {
                    action: 'viewAllBoards'
                }
            }));
            if (showRecommended(projectScope)) commands.push(getViewAllCommand({
                id: 'recommended-projects',
                section: $6bd8e7b697bad55c$var$SECTION_ID,
                name: formatMessage((0, (0, parcelRequire("bGpCi")).messages).viewAllProjects),
                keywords: search,
                isRecommended: true,
                url: (0, (0, parcelRequire("e5idJ")).getViewAllUrl)((0, (0, parcelRequire("e5idJ")).ViewAllType).PROJECT),
                priority: (0, (0, parcelRequire("dmf5R")).QUICK_SEARCH_PRIORITY).PROJECTS,
                analyticsPayload: {
                    action: 'viewAllProjects'
                }
            }));
            if (showRecommended(filterScope)) commands.push(getViewAllCommand({
                id: 'recommended-filters',
                section: $6bd8e7b697bad55c$var$SECTION_ID,
                name: formatMessage((0, (0, parcelRequire("bGpCi")).messages).viewAllFilters),
                keywords: search,
                isRecommended: true,
                url: (0, (0, parcelRequire("e5idJ")).getViewAllUrl)((0, (0, parcelRequire("e5idJ")).ViewAllType).FILTER),
                priority: (0, (0, parcelRequire("dmf5R")).QUICK_SEARCH_PRIORITY).FILTERS,
                analyticsPayload: {
                    action: 'viewAllFilters'
                }
            }));
            if (showRecommended(planScope)) commands.push(getViewAllCommand({
                id: 'recommended-plans',
                section: $6bd8e7b697bad55c$var$SECTION_ID,
                name: formatMessage((0, (0, parcelRequire("bGpCi")).messages).viewAllPlans),
                keywords: search,
                isRecommended: true,
                url: (0, (0, parcelRequire("e5idJ")).getViewAllUrl)((0, (0, parcelRequire("e5idJ")).ViewAllType).PLAN),
                priority: (0, (0, parcelRequire("dmf5R")).QUICK_SEARCH_PRIORITY).PLANS,
                analyticsPayload: {
                    action: 'viewAllPlans'
                }
            }));
            return {
                sections: sections,
                commands: commands
            };
        }, [
            formatMessage,
            getViewAllCommand
        ]);
        return {
            getChildResult: getChildResult
        };
    };
});
parcelRegister("73ZzY", function(module, exports) {
    $parcel$export(module.exports, "useGetViewAllCommand", ()=>$6cf89e2618cdefcd$export$fc2d112e790e7f2a);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lotJ5;
    var $4l54H;
    const $6cf89e2618cdefcd$export$fc2d112e790e7f2a = ()=>{
        const { transformNavigationCommand: transformNavigationCommand } = (0, (0, parcelRequire("4l54H")).useTransformNavigationCommands)();
        const getViewAllCommand = (0, $5uXOq.useCallback)(({ name: name, url: url, isRecommended: isRecommended = false, analyticsPayload: analyticsPayload = {}, ...rest })=>transformNavigationCommand({
                name: name,
                components: {
                    Name: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($6cf89e2618cdefcd$var$RenderNameWrapper, {
                            "data-testid": "command-palette-quick-search.common.ui.view-all.render-name-wrapper",
                            isRecommended: isRecommended
                        }, name),
                    LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lotJ5"))))), {
                            label: "",
                            color: "currentColor"
                        })
                },
                analytics: {
                    action: 'quickSearchViewAll',
                    ...analyticsPayload
                },
                ...rest
            }, {
                path: url
            }), [
            transformNavigationCommand
        ]);
        return {
            getViewAllCommand: getViewAllCommand
        };
    };
    const $6cf89e2618cdefcd$var$RenderNameWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isRecommended: isRecommended, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                !__cmplp.isRecommended && "_syaz1e6v",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("lotJ5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f932e5e315a81e72$var$_react = $f932e5e315a81e72$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $f932e5e315a81e72$var$_arrowRight = $f932e5e315a81e72$var$_interopRequireDefault((parcelRequire("bCETl")));
    var $f932e5e315a81e72$var$_arrowRight2 = $f932e5e315a81e72$var$_interopRequireDefault((parcelRequire("8RBk4")));
    function $f932e5e315a81e72$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f932e5e315a81e72$var$ArrowRightIcon = (props)=>$f932e5e315a81e72$var$_react.default.createElement($f932e5e315a81e72$var$_arrowRight.default, Object.assign({
            LEGACY_fallbackIcon: $f932e5e315a81e72$var$_arrowRight2.default
        }, props));
    $f932e5e315a81e72$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
    var $f932e5e315a81e72$var$_default = module.exports.default = $f932e5e315a81e72$var$ArrowRightIcon;
});
parcelRegister("bCETl", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8762f68d47646053$var$_react = $8762f68d47646053$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8762f68d47646053$var$_UNSAFE_baseNew = $8762f68d47646053$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $8762f68d47646053$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8762f68d47646053$var$ArrowRightIcon = (props)=>$8762f68d47646053$var$_react.default.createElement($8762f68d47646053$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m6.25 2 4 4-4 4M1 6h8.75"/>`,
            type: 'utility'
        }, props));
    $8762f68d47646053$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $8762f68d47646053$var$_default = module.exports.default = $8762f68d47646053$var$ArrowRightIcon;
});
parcelRegister("8RBk4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6740397d4ba98b13$var$_react = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $6740397d4ba98b13$var$_arrowRight = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("h1TKi")));
    function $6740397d4ba98b13$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6740397d4ba98b13$var$ArrowRightIcon = (props)=>$6740397d4ba98b13$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
        }, props, {
            newIcon: $6740397d4ba98b13$var$_arrowRight.default
        }));
    $6740397d4ba98b13$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $6740397d4ba98b13$var$_default = module.exports.default = $6740397d4ba98b13$var$ArrowRightIcon;
});
parcelRegister("h1TKi", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c65dc59efb96b35a$var$_UNSAFE_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>$c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
        }, props));
    $c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;
});
parcelRegister("4l54H", function(module, exports) {
    $parcel$export(module.exports, "useTransformNavigationCommands", ()=>$586d7e6f1a99cb44$export$5b108cd54c923a60);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $7paD5;
    var $kgoHi;
    var $8CUq3;
    var $jh7L9;
    var $jiSaf;
    var $gM5ou;
    var $d8lE2;
    var $2f2jJ;
    var $4R6GH;
    var $8zOmE;
    var $dCm1o;
    var $doZTA;
    var $8btEA;
    var $3XsL2;
    var $d10H0;
    var $dmcoI;
    const $586d7e6f1a99cb44$export$5b108cd54c923a60 = ()=>{
        const [{ location: { pathname: pathname } }, { push: push, pushTo: pushTo }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { getAnalyticsAttributes: getAnalyticsAttributes } = (0, (0, parcelRequire("d8lE2")).useActionsCommandPalette)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const openNewTab = (0, $5uXOq.useCallback)((link, openBackground)=>{
            const url = typeof link === 'string' ? link : link.path;
            const newTab = window.open(url, '_blank');
            if (openBackground) {
                newTab?.blur();
                window.focus();
            }
            return newTab;
        }, []);
        const openSameTab = (0, $5uXOq.useCallback)((link)=>{
            if (typeof link === 'string') return push(link);
            return pushTo(link);
        }, [
            push,
            pushTo
        ]);
        const renderCommand = (0, $5uXOq.useCallback)((props, path, shouldAlwaysOpenNewTab)=>{
            const { onClick: onClick, ...rest } = props;
            const { command: command } = rest;
            const handleClick = (event)=>{
                const wasSecondaryTriggered = (0, (0, parcelRequire("gM5ou")).isSecondaryTrigger)(event);
                if (!wasSecondaryTriggered) {
                    onClick?.(event);
                    event.preventDefault();
                    return;
                }
                const analytics = getAnalyticsAttributes(command, 'mouse', wasSecondaryTriggered, props?.analyticsAttributes);
                const eventAnalytics = createAnalyticsEvent({});
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(eventAnalytics, 'commandPalette navigation', analytics);
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(eventAnalytics, 'commandPalette secondaryAction', {
                    ...analytics,
                    keyPressed: (0, (0, parcelRequire("2f2jJ")).isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                    secondaryAction: 'openNewTab'
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(eventAnalytics, 'commandPalette taskSucceeded', analytics);
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3XsL2")).NavigationLink), {
                to: path,
                onClick: handleClick,
                ...shouldAlwaysOpenNewTab && {
                    target: '_blank'
                },
                "data-testid": (0, $2ea3babd020e8e8a$export$8db96ea7b6a4cbab),
                ...(0, (0, parcelRequire("4R6GH")).fg)('compal_listbox_to_menu') ? {} : {
                    tabIndex: -1
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jiSaf")).components).CommandRow, rest));
        }, [
            createAnalyticsEvent,
            getAnalyticsAttributes
        ]);
        const transformNavigationCommand = (0, $5uXOq.useCallback)((command, { path: path, shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab })=>({
                ...command,
                components: {
                    ...command.components,
                    Name: (base)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8btEA")).NameContainer), null, command.components?.Name ? (0, ($parcel$interopDefault($5uXOq))).createElement(command.components.Name, base) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, command.name), !!shouldAlwaysOpenNewTab && (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                            testId: (0, $2ea3babd020e8e8a$export$99957d8f5f113509),
                            justifyContent: "center",
                            alignItems: "center",
                            xcss: $586d7e6f1a99cb44$var$iconWrapperStyles
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7paD5"))))), {
                            label: "",
                            color: "currentColor"
                        })), !!shouldAlwaysOpenNewTab && !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8btEA")).IconContainer), {
                            "data-testid": (0, $2ea3babd020e8e8a$export$99957d8f5f113509)
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7paD5"))))), {
                            label: "",
                            color: "currentColor"
                        }))),
                    CommandRow: (base)=>renderCommand(base, path, shouldAlwaysOpenNewTab),
                    Footer: (0, (0, parcelRequire("d10H0")).NewTabHintMessage)
                },
                primaryAction: {
                    type: (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM,
                    perform: ()=>shouldAlwaysOpenNewTab ? openNewTab(path) : openSameTab(path)
                },
                secondaryAction: {
                    type: (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM,
                    perform: ()=>openNewTab(path, true),
                    preventModalClose: true,
                    analyticsArgs: {
                        secondaryAction: 'openNewTab'
                    }
                }
            }), [
            openNewTab,
            openSameTab,
            renderCommand
        ]);
        const shouldShowCommand = (0, $5uXOq.useCallback)((hideCommandPath)=>!(0, (0, parcelRequire("dmcoI")).isCurrentPage)(hideCommandPath, pathname), [
            pathname
        ]);
        const hideAndTransformNavigationCommand = (0, $5uXOq.useCallback)((commandToTransform)=>{
            const { path: path, hideCommandPath: hideCommandPath, shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab, command: command } = commandToTransform;
            let hidePath = typeof path === 'string' ? path : path.path;
            if (hideCommandPath) hidePath = hideCommandPath;
            if (!shouldShowCommand(hidePath)) return undefined;
            return transformNavigationCommand(command, {
                path: path,
                shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab
            });
        }, [
            shouldShowCommand,
            transformNavigationCommand
        ]);
        const hideAndTransformNavigationCommands = (0, $5uXOq.useCallback)((commands)=>{
            const filteredCommands = [];
            commands.forEach((commandToTransform)=>{
                const transformedCommand = hideAndTransformNavigationCommand(commandToTransform);
                if (transformedCommand) filteredCommands.push(transformedCommand);
            });
            return filteredCommands;
        }, [
            hideAndTransformNavigationCommand
        ]);
        return {
            shouldShowCommand: shouldShowCommand,
            hideAndTransformNavigationCommand: hideAndTransformNavigationCommand,
            hideAndTransformNavigationCommands: hideAndTransformNavigationCommands,
            transformNavigationCommand: transformNavigationCommand
        };
    };
    const $586d7e6f1a99cb44$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '24px',
        width: '24px',
        marginLeft: 'space.075'
    });
});
parcelRegister("8btEA", function(module, exports) {
    $parcel$export(module.exports, "NameContainer", ()=>$ddea451afbf29ad2$export$817b6bdd5f45c94b);
    $parcel$export(module.exports, "IconContainer", ()=>$ddea451afbf29ad2$export$8f314e512d92575f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $ddea451afbf29ad2$export$817b6bdd5f45c94b = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _2lx2vrvc _1nmz1hna _slp31hna",
                __cmplp.className
            ])
        });
    });
    const $ddea451afbf29ad2$export$8f314e512d92575f = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _18u012x7 _1bsb1tcg _4t3i1tcg _vwz41tcg _1f027vkz _nbgx7vkz",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3XsL2", function(module, exports) {
    $parcel$export(module.exports, "NavigationLink", ()=>$fdfd62bd57e7226d$export$721ee963a67379f1);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $hDzhb;
    const $fdfd62bd57e7226d$export$721ee963a67379f1 = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("hDzhb")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("d10H0", function(module, exports) {
    $parcel$export(module.exports, "NewTabHintMessage", ()=>$9f2aa76d6a204b23$export$54561b2030abf061);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $jiSaf;
    var $dzeHJ;
    var $2f2jJ;
    var $koVbs;
    var $kdbk3;
    const $9f2aa76d6a204b23$export$54561b2030abf061 = ({ defaultFooterContent: defaultFooterContent })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jiSaf")).components).Footer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$FooterContentContainer, {
            "data-testid": "command-palette-common.common.ui.new-tab-hint-message"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, defaultFooterContent), (0, ($parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$HintMessageWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$MessageWrapper, null, formatMessage((0, (0, parcelRequire("kdbk3")).messages).openInANewTab)), (0, (0, parcelRequire("2f2jJ")).isMacOs)() ? (0, ($parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$MacLozenge, null, (0, ($parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$MacTextOffset, null, "\u2318")) : (0, ($parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$WindowsLozenge, null, "Ctrl"), (0, ($parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$EnterLozenge, null, (0, ($parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$EnterIconSVG, null)))));
    };
    const $9f2aa76d6a204b23$var$EnterIconSVG = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "13",
            height: "8",
            viewBox: "0 0 13 8",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M11.055 1.055V3.055H2.275L4.195 1.135C4.455 0.875 4.455 0.455 4.195 0.195C3.935 -0.065 3.515 -0.065 3.255 0.195L0.195 3.255C-0.065 3.515 -0.065 3.935 0.195 4.195L3.255 7.255C3.515 7.515 3.935 7.515 4.195 7.255C4.455 6.995 4.455 6.575 4.195 6.315L2.275 4.38833H11.7217C12.0883 4.38833 12.3883 4.08833 12.3883 3.72167V1.055C12.3883 0.688333 12.0883 0.388333 11.7217 0.388333C11.355 0.388333 11.055 0.688333 11.055 1.055Z",
            fill: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N600})`
        }));
    const $9f2aa76d6a204b23$var$FooterContentContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1yb4",
                __cmplp.className
            ])
        });
    });
    const $9f2aa76d6a204b23$var$HintMessageWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1y6m _syazc8hx _u5f312x7",
                __cmplp.className
            ])
        });
    });
    const $9f2aa76d6a204b23$var$MacLozenge = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("dzeHJ")).OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0v77o _k48p1nn1 _1wybf6fq _vwz47vkz _syazc8hx",
                __cmplp.className
            ])
        });
    });
    const $9f2aa76d6a204b23$var$MacTextOffset = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_t9ec170z",
                __cmplp.className
            ])
        });
    });
    const $9f2aa76d6a204b23$var$WindowsLozenge = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("dzeHJ")).OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1qjk _k48p1nn1 _1p1d1dk0 _syazc8hx",
                __cmplp.className
            ])
        });
    });
    const $9f2aa76d6a204b23$var$EnterLozenge = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("dzeHJ")).OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0v77o",
                __cmplp.className
            ])
        });
    });
    const $9f2aa76d6a204b23$var$MessageWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c8qk37 _2hwxv77o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kdbk3", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$29cc514acfa3bb8e$export$defe85febe8b728c);
    var $7VHMR;
    const $29cc514acfa3bb8e$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        openInANewTab: {
            "id": "command-palette-common.common.new-tab-hint-message.open-in-a-new-tab",
            "defaultMessage": "Open in a new tab"
        }
    });
});
parcelRegister("dmcoI", function(module, exports) {
    $parcel$export(module.exports, "isCurrentPage", ()=>$b6be5b0653c72ae5$export$d4781f4a7d66b55c);
    const $b6be5b0653c72ae5$export$d4781f4a7d66b55c = (hideCommandPath, pathname)=>{
        const currentPathnameWithoutTrailingSlash = pathname.replace(/\/$/, '');
        const hideCommandPathWithoutTrailingSlash = hideCommandPath?.replace(/\/$/, '');
        return hideCommandPathWithoutTrailingSlash === currentPathnameWithoutTrailingSlash;
    };
});
const $2ea3babd020e8e8a$export$99957d8f5f113509 = 'command-palette-common.controllers.transform-navigation-commands.icon-container';
const $2ea3babd020e8e8a$export$8db96ea7b6a4cbab = 'command-palette-common.controllers.transform-navigation-commands.navigation-link';
parcelRegister("e5idJ", function(module, exports) {
    $parcel$export(module.exports, "ViewAllType", ()=>$1ebb3b4e78014f2d$export$701f40362530db8b);
    $parcel$export(module.exports, "getViewAllUrl", ()=>$1ebb3b4e78014f2d$export$96e8b39eed587a1e);
    var $1ebb3b4e78014f2d$export$701f40362530db8b;
    (function(ViewAllType) {
        ViewAllType["PROJECT"] = "project";
        ViewAllType["ISSUE"] = "issue";
        ViewAllType["BOARD"] = "board";
        ViewAllType["FILTER"] = "filter";
        ViewAllType["PLAN"] = "plan";
    })($1ebb3b4e78014f2d$export$701f40362530db8b || ($1ebb3b4e78014f2d$export$701f40362530db8b = {}));
    const $1ebb3b4e78014f2d$export$96e8b39eed587a1e = (type, search)=>{
        switch(type){
            case "issue":
                return `/jira/search${search ? `?searchString=${search}` : ''}`;
            case "board":
                return `/jira/boards${search ? `?contains=${search}` : ''}`;
            case "project":
                return `/jira/projects${search ? `?keyword=${search}` : ''}`;
            case "filter":
                return `/jira/filters${search ? `?name=${search}` : ''}`;
            case "plan":
                return `/jira/plans${search ? `?name=${search}` : ''}`;
            default:
                return undefined;
        }
    };
});
parcelRegister("bGpCi", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$d964339cd9d84bf9$export$defe85febe8b728c);
    var $7VHMR;
    const $d964339cd9d84bf9$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        recommendedSection: {
            "id": "command-palette-quick-search.common.recommended.recommended-section",
            "defaultMessage": "Recommended"
        },
        viewAllIssues: {
            "id": "command-palette-quick-search.common.recommended.view-all-issues",
            "defaultMessage": "View all issues"
        },
        viewAllProjects: {
            "id": "command-palette-quick-search.common.recommended.view-all-projects",
            "defaultMessage": "View all projects"
        },
        viewAllBoards: {
            "id": "command-palette-quick-search.common.recommended.view-all-boards",
            "defaultMessage": "View all boards"
        },
        viewAllFilters: {
            "id": "command-palette-quick-search.common.recommended.view-all-filters",
            "defaultMessage": "View all filters"
        },
        viewAllPlans: {
            "id": "command-palette-quick-search.common.recommended.view-all-plans",
            "defaultMessage": "View all plans"
        }
    });
});
parcelRegister("hX4Eo", function(module, exports) {
    $parcel$export(module.exports, "useSetTimeoutAutoClear", ()=>$4cb9c5b6b4b17493$export$c3d20e8c1e93a572);
    var $5uXOq = parcelRequire("5uXOq");
    const $4cb9c5b6b4b17493$export$c3d20e8c1e93a572 = ()=>{
        const timeoutRef = (0, $5uXOq.useRef)();
        (0, $5uXOq.useEffect)(()=>()=>{
                if (timeoutRef.current) clearTimeout(timeoutRef.current);
            }, []);
        const setTimeoutAutoClear = (0, $5uXOq.useCallback)((...args)=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(...args);
        }, []);
        return {
            setTimeoutAutoClear: setTimeoutAutoClear
        };
    };
});
parcelRegister("bsL38", function(module, exports) {
    $parcel$export(module.exports, "useGetRecentBoardsChildResult", ()=>$a9075714ae8a3438$export$67be4cf74634869c);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $flylh;
    var $dmf5R;
    var $3gYvd;
    const $a9075714ae8a3438$export$67be4cf74634869c = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { getQuickSearchBoardCommands: getQuickSearchBoardCommands } = (0, (0, parcelRequire("flylh")).useGetQuickSearchBoardCommands)({
            section: (0, $491877a74099feb6$export$501955bd67991a25),
            showViewAll: false
        });
        const getChildResult = (0, $5uXOq.useCallback)((props)=>{
            const sections = {
                [(0, $491877a74099feb6$export$501955bd67991a25)]: {
                    id: (0, $491877a74099feb6$export$501955bd67991a25),
                    name: formatMessage((0, (0, parcelRequire("3gYvd")).messages).recentlyViewedBoards),
                    priority: (0, (0, parcelRequire("dmf5R")).QUICK_SEARCH_PRIORITY).BOARDS
                }
            };
            const commands = getQuickSearchBoardCommands(props);
            return {
                sections: sections,
                commands: commands
            };
        }, [
            formatMessage,
            getQuickSearchBoardCommands
        ]);
        return {
            getChildResult: getChildResult
        };
    };
});
parcelRegister("flylh", function(module, exports) {
    $parcel$export(module.exports, "useGetQuickSearchBoardCommands", ()=>$d88b5469edac1ca6$export$3036f58f7b6b3d11);
    var $5uXOq = parcelRequire("5uXOq");
    var $di77o;
    var $koVbs;
    var $dmf5R;
    var $9ReLB;
    var $bgCj3;
    var $73ZzY;
    var $e5idJ;
    const $d88b5469edac1ca6$export$3036f58f7b6b3d11 = ({ section: section, showViewAll: showViewAll })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { getBoardCommand: getBoardCommand } = (0, (0, parcelRequire("di77o")).useGetBoardCommand)();
        const { getViewAllCommand: getViewAllCommand } = (0, (0, parcelRequire("73ZzY")).useGetViewAllCommand)();
        const getQuickSearchBoardCommands = (0, $5uXOq.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
            const boardScope = (0, (0, parcelRequire("bgCj3")).getQuickSearchBoardScope)(quickSearchResponseData);
            if (!boardScope || error || boardScope?.error || boardScope?.results?.length === 0) return [];
            const commands = boardScope.results.slice(0, (0, (0, parcelRequire("dmf5R")).BOARD_LIMIT)).map((board)=>getBoardCommand({
                    board: (0, (0, parcelRequire("bgCj3")).transformQuickSearchBoardResultToBoard)(board),
                    keywords: search,
                    section: section,
                    analytics: {
                        isSearchResult: true
                    }
                }));
            if (!showViewAll || boardScope.results.length <= (0, (0, parcelRequire("dmf5R")).BOARD_LIMIT)) return commands;
            const viewAllCommand = getViewAllCommand({
                id: 'view-all-boards',
                keywords: search,
                section: section,
                name: formatMessage((0, (0, parcelRequire("9ReLB")).messages).viewAllResults),
                url: (0, (0, parcelRequire("e5idJ")).getViewAllUrl)((0, (0, parcelRequire("e5idJ")).ViewAllType).BOARD, search),
                analyticsPayload: {
                    action: 'viewAllBoards',
                    size: boardScope.size
                }
            });
            return commands.concat([
                viewAllCommand
            ]);
        }, [
            formatMessage,
            getBoardCommand,
            getViewAllCommand,
            section,
            showViewAll
        ]);
        return {
            getQuickSearchBoardCommands: getQuickSearchBoardCommands
        };
    };
});
parcelRegister("di77o", function(module, exports) {
    $parcel$export(module.exports, "useGetBoardCommand", ()=>$c14ac5929a67ca09$export$a607cbe1c4fa60ee);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dME4E;
    var $4l54H;
    const $c14ac5929a67ca09$export$a607cbe1c4fa60ee = ()=>{
        const { transformNavigationCommand: transformNavigationCommand } = (0, (0, parcelRequire("4l54H")).useTransformNavigationCommands)();
        const renderBoardName = (0, $5uXOq.useCallback)((name, containerName, isActive)=>(0, ($parcel$interopDefault($5uXOq))).createElement($c14ac5929a67ca09$var$BoardNameContainer, {
                "data-testid": "command-palette-common.common.ui.command.board.board-name-container"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($c14ac5929a67ca09$var$BoardNameText, null, name), containerName && (0, ($parcel$interopDefault($5uXOq))).createElement($c14ac5929a67ca09$export$17e73069b4d98f65, {
                active: isActive
            }, containerName)), []);
        const getBoardCommand = (0, $5uXOq.useCallback)(({ board: board, keywords: keywords, section: section, analytics: analytics, ...rest })=>{
            const { id: id, url: url, name: name, containerId: containerId = 'UNAVAILABLE', containerName: containerName } = board;
            return transformNavigationCommand({
                id: `board-${id}`,
                section: section,
                name: name,
                keywords: keywords,
                components: {
                    Name: ({ isActive: isActive })=>renderBoardName(name, containerName, isActive),
                    LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dME4E"))))), {
                            label: "",
                            color: "currentColor"
                        })
                },
                analytics: {
                    action: 'boardViewed',
                    boardId: id,
                    boardContainerId: containerId || '',
                    metadata: {
                        contentId: id,
                        containerId: containerId,
                        contentType: 'board'
                    },
                    ...analytics
                },
                ...rest
            }, {
                path: url
            });
        }, [
            renderBoardName,
            transformNavigationCommand
        ]);
        return {
            getBoardCommand: getBoardCommand
        };
    };
    const $c14ac5929a67ca09$var$BoardNameContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _zulp12x7",
                __cmplp.className
            ])
        });
    });
    const $c14ac5929a67ca09$var$BoardNameText = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81oud _vwz41kw7",
                __cmplp.className
            ])
        });
    });
    const $c14ac5929a67ca09$export$17e73069b4d98f65 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { active: active, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81vlj _vwz41kw7",
                __cmplp.active ? "_syaz1a45" : "_syaz1wmz",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dME4E", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a08ed7e863649bfd$var$_react = $a08ed7e863649bfd$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a08ed7e863649bfd$var$_board = $a08ed7e863649bfd$var$_interopRequireDefault((parcelRequire("8EsNC")));
    var $a08ed7e863649bfd$var$_board2 = $a08ed7e863649bfd$var$_interopRequireDefault((parcelRequire("v8Zna")));
    function $a08ed7e863649bfd$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a08ed7e863649bfd$var$BoardIcon = (props)=>$a08ed7e863649bfd$var$_react.default.createElement($a08ed7e863649bfd$var$_board.default, Object.assign({
            LEGACY_fallbackIcon: $a08ed7e863649bfd$var$_board2.default
        }, props));
    $a08ed7e863649bfd$var$BoardIcon.Name = 'BoardIconMigration';
    var $a08ed7e863649bfd$var$_default = module.exports.default = $a08ed7e863649bfd$var$BoardIcon;
});
parcelRegister("8EsNC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $64c8661ab6d81803$var$_react = $64c8661ab6d81803$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $64c8661ab6d81803$var$_UNSAFE_baseNew = $64c8661ab6d81803$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $64c8661ab6d81803$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $64c8661ab6d81803$var$BoardIcon = (props)=>$64c8661ab6d81803$var$_react.default.createElement($64c8661ab6d81803$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M5.583 2.75H2C1.31 2.75.75 3.31.75 4v8c0 .69.56 1.25 1.25 1.25h3.583m0-10.5v10.5m0-10.5h4.834m-4.834 10.5h4.834m0-10.5H14c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25h-3.583m0-10.5v10.5"/>`
        }, props));
    $64c8661ab6d81803$var$BoardIcon.displayName = 'BoardIcon';
    var $64c8661ab6d81803$var$_default = module.exports.default = $64c8661ab6d81803$var$BoardIcon;
});
parcelRegister("v8Zna", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $05d9de5ec3a4369b$var$_react = $05d9de5ec3a4369b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $05d9de5ec3a4369b$var$_board = $05d9de5ec3a4369b$var$_interopRequireDefault((parcelRequire("8EsNC")));
    function $05d9de5ec3a4369b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $05d9de5ec3a4369b$var$BoardIcon = (props)=>$05d9de5ec3a4369b$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M8 6v12h2V6zm6 0v12h2V6z"/></g></svg>`
        }, props, {
            newIcon: $05d9de5ec3a4369b$var$_board.default
        }));
    $05d9de5ec3a4369b$var$BoardIcon.displayName = 'BoardIcon';
    var $05d9de5ec3a4369b$var$_default = module.exports.default = $05d9de5ec3a4369b$var$BoardIcon;
});
parcelRegister("9ReLB", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$d239df1fde27f18a$export$defe85febe8b728c);
    var $7VHMR;
    const $d239df1fde27f18a$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        viewAllResults: {
            "id": "command-palette-quick-search.common.view-all-results",
            "defaultMessage": "View all results"
        }
    });
});
const $491877a74099feb6$export$501955bd67991a25 = 'jira.board';
parcelRegister("3gYvd", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$1094b8458a2f11d3$export$defe85febe8b728c);
    var $7VHMR;
    const $1094b8458a2f11d3$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        recentlyViewedBoards: {
            "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.boards.recently-viewed-boards",
            "defaultMessage": "Recently Viewed Boards"
        }
    });
});
parcelRegister("33VxI", function(module, exports) {
    $parcel$export(module.exports, "useGetRecentFiltersChildResult", ()=>$4c2e1610d33be477$export$abc1122ece543f47);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dmf5R;
    var $8kcFW;
    var $5fcJA;
    const $4c2e1610d33be477$export$abc1122ece543f47 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { getQuickSearchFilterCommands: getQuickSearchFilterCommands } = (0, (0, parcelRequire("8kcFW")).useGetQuickSearchFilterCommands)({
            section: (0, $1eff0899f1ee36bd$export$501955bd67991a25),
            showViewAll: false
        });
        const getChildResult = (0, $5uXOq.useCallback)((props)=>{
            const sections = {
                [(0, $1eff0899f1ee36bd$export$501955bd67991a25)]: {
                    id: (0, $1eff0899f1ee36bd$export$501955bd67991a25),
                    name: formatMessage((0, (0, parcelRequire("5fcJA")).messages).recentlyViewedFilters),
                    priority: (0, (0, parcelRequire("dmf5R")).QUICK_SEARCH_PRIORITY).FILTERS
                }
            };
            const commands = getQuickSearchFilterCommands(props);
            return {
                sections: sections,
                commands: commands
            };
        }, [
            formatMessage,
            getQuickSearchFilterCommands
        ]);
        return {
            getChildResult: getChildResult
        };
    };
});
parcelRegister("8kcFW", function(module, exports) {
    $parcel$export(module.exports, "useGetQuickSearchFilterCommands", ()=>$aa6c7064981ac871$export$b31b2989a89c872e);
    var $5uXOq = parcelRequire("5uXOq");
    var $eat75;
    var $koVbs;
    var $dmf5R;
    var $9ReLB;
    var $bgCj3;
    var $73ZzY;
    var $e5idJ;
    const $aa6c7064981ac871$export$b31b2989a89c872e = ({ section: section, showViewAll: showViewAll })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { getFilterCommand: getFilterCommand } = (0, (0, parcelRequire("eat75")).useGetFilterCommand)();
        const { getViewAllCommand: getViewAllCommand } = (0, (0, parcelRequire("73ZzY")).useGetViewAllCommand)();
        const getQuickSearchFilterCommands = (0, $5uXOq.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
            const filterScope = (0, (0, parcelRequire("bgCj3")).getQuickSearchFilterScope)(quickSearchResponseData);
            if (!filterScope || error || filterScope?.error || filterScope?.results?.length === 0) return [];
            const commands = filterScope.results.slice(0, (0, (0, parcelRequire("dmf5R")).FILTER_LIMIT)).map((filter)=>getFilterCommand({
                    filter: (0, (0, parcelRequire("bgCj3")).transformQuickSearchFilterResultToFilter)(filter),
                    keywords: search,
                    section: section,
                    analytics: {
                        isSearchResult: true
                    }
                }));
            if (!showViewAll || filterScope.results.length <= (0, (0, parcelRequire("dmf5R")).FILTER_LIMIT)) return commands;
            const viewAllCommand = getViewAllCommand({
                id: 'view-all-filters',
                keywords: search,
                section: section,
                name: formatMessage((0, (0, parcelRequire("9ReLB")).messages).viewAllResults),
                url: (0, (0, parcelRequire("e5idJ")).getViewAllUrl)((0, (0, parcelRequire("e5idJ")).ViewAllType).FILTER, search),
                analyticsPayload: {
                    action: 'viewAllFilters',
                    size: filterScope.size
                }
            });
            return commands.concat([
                viewAllCommand
            ]);
        }, [
            formatMessage,
            getFilterCommand,
            getViewAllCommand,
            section,
            showViewAll
        ]);
        return {
            getQuickSearchFilterCommands: getQuickSearchFilterCommands
        };
    };
});
parcelRegister("eat75", function(module, exports) {
    $parcel$export(module.exports, "useGetFilterCommand", ()=>$77b1b9a822ca07f1$export$c074d91a3a335ecb);
    var $5uXOq = parcelRequire("5uXOq");
    var $2o8gl;
    var $4l54H;
    const $77b1b9a822ca07f1$export$c074d91a3a335ecb = ()=>{
        const { transformNavigationCommand: transformNavigationCommand } = (0, (0, parcelRequire("4l54H")).useTransformNavigationCommands)();
        const getFilterCommand = (0, $5uXOq.useCallback)(({ filter: filter, section: section, analytics: analytics, ...rest })=>{
            const { id: id, url: url, name: name } = filter;
            return transformNavigationCommand({
                id: `filter-${id}`,
                section: section,
                name: name,
                components: {
                    LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2o8gl"))))), {
                            label: "",
                            color: "currentColor"
                        })
                },
                analytics: {
                    action: 'filterViewed',
                    filterId: id,
                    metadata: {
                        contentId: id,
                        containerId: 'UNAVAILABLE',
                        contentType: 'filter'
                    },
                    ...analytics
                },
                ...rest
            }, {
                path: url
            });
        }, [
            transformNavigationCommand
        ]);
        return {
            getFilterCommand: getFilterCommand
        };
    };
});
parcelRegister("2o8gl", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1bd43b75b5db29b6$var$_react = $1bd43b75b5db29b6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $1bd43b75b5db29b6$var$_filter = $1bd43b75b5db29b6$var$_interopRequireDefault((parcelRequire("jX361")));
    var $1bd43b75b5db29b6$var$_filter2 = $1bd43b75b5db29b6$var$_interopRequireDefault((parcelRequire("bTqXB")));
    function $1bd43b75b5db29b6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1bd43b75b5db29b6$var$FilterIcon = (props)=>$1bd43b75b5db29b6$var$_react.default.createElement($1bd43b75b5db29b6$var$_filter.default, Object.assign({
            LEGACY_fallbackIcon: $1bd43b75b5db29b6$var$_filter2.default
        }, props));
    $1bd43b75b5db29b6$var$FilterIcon.Name = 'FilterIconMigration';
    var $1bd43b75b5db29b6$var$_default = module.exports.default = $1bd43b75b5db29b6$var$FilterIcon;
});
const $1eff0899f1ee36bd$export$501955bd67991a25 = 'jira.filter';
parcelRegister("5fcJA", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$b7976029a21f4058$export$defe85febe8b728c);
    var $7VHMR;
    const $b7976029a21f4058$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        recentlyViewedFilters: {
            "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.filters.recently-viewed-filters",
            "defaultMessage": "Recently Viewed Filters"
        }
    });
});
parcelRegister("5OaBm", function(module, exports) {
    $parcel$export(module.exports, "useGetRecentIssuesChildResult", ()=>$f6932e48ac759e7c$export$e5366d4438f3f848);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dmf5R;
    var $hzB87;
    var $bBHcB;
    const $f6932e48ac759e7c$var$SECTION_ID = 'jira.issue';
    const $f6932e48ac759e7c$export$e5366d4438f3f848 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { getQuickSearchIssueCommands: getQuickSearchIssueCommands } = (0, (0, parcelRequire("hzB87")).useGetQuickSearchIssueCommands)({
            section: $f6932e48ac759e7c$var$SECTION_ID,
            errorMessage: formatMessage((0, (0, parcelRequire("bBHcB")).messages).issueError),
            showViewAll: false
        });
        const getChildResult = (0, $5uXOq.useCallback)((props)=>{
            const sections = {
                [$f6932e48ac759e7c$var$SECTION_ID]: {
                    id: $f6932e48ac759e7c$var$SECTION_ID,
                    name: formatMessage((0, (0, parcelRequire("bBHcB")).messages).recentlyViewedIssues),
                    priority: (0, (0, parcelRequire("dmf5R")).QUICK_SEARCH_PRIORITY).ISSUES
                }
            };
            const commands = getQuickSearchIssueCommands(props);
            return {
                sections: sections,
                commands: commands
            };
        }, [
            formatMessage,
            getQuickSearchIssueCommands
        ]);
        return {
            getChildResult: getChildResult
        };
    };
});
parcelRegister("hzB87", function(module, exports) {
    $parcel$export(module.exports, "useGetQuickSearchIssueCommands", ()=>$ccaee2400f4c17a8$export$e3611b615ec843dc);
    var $5uXOq = parcelRequire("5uXOq");
    var $5WKxV;
    var $koVbs;
    var $dmf5R;
    var $9ReLB;
    var $bgCj3;
    var $73ZzY;
    var $e5idJ;
    const $ccaee2400f4c17a8$export$e3611b615ec843dc = ({ section: section, showViewAll: showViewAll })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { getIssueCommand: getIssueCommand } = (0, (0, parcelRequire("5WKxV")).useGetIssueCommand)();
        const { getViewAllCommand: getViewAllCommand } = (0, (0, parcelRequire("73ZzY")).useGetViewAllCommand)();
        const getQuickSearchIssueCommands = (0, $5uXOq.useCallback)(({ error: error, search: search, quickSearchResponseData: quickSearchResponseData })=>{
            const issueScope = (0, (0, parcelRequire("bgCj3")).getQuickSearchIssueScope)(quickSearchResponseData);
            if (!issueScope || error || issueScope?.error || issueScope?.results?.length === 0) return [];
            const commands = issueScope.results.slice(0, (0, (0, parcelRequire("dmf5R")).ISSUE_LIMIT)).map((issue)=>{
                const command = getIssueCommand({
                    issue: (0, (0, parcelRequire("bgCj3")).transformQuickSearchIssueResultToIssue)(issue),
                    keywords: search,
                    section: section,
                    analytics: {
                        isSearchResult: true
                    }
                });
                return command;
            });
            if (!showViewAll || issueScope.results.length <= (0, (0, parcelRequire("dmf5R")).ISSUE_LIMIT)) return commands;
            const viewAllCommand = getViewAllCommand({
                id: 'view-all-issues',
                keywords: search,
                section: section,
                name: formatMessage((0, (0, parcelRequire("9ReLB")).messages).viewAllResults),
                url: (0, (0, parcelRequire("e5idJ")).getViewAllUrl)((0, (0, parcelRequire("e5idJ")).ViewAllType).ISSUE, search),
                analyticsPayload: {
                    action: 'viewAllIssues',
                    size: issueScope.size
                }
            });
            return commands.concat([
                viewAllCommand
            ]);
        }, [
            formatMessage,
            getIssueCommand,
            getViewAllCommand,
            section,
            showViewAll
        ]);
        return {
            getQuickSearchIssueCommands: getQuickSearchIssueCommands
        };
    };
});
parcelRegister("5WKxV", function(module, exports) {
    $parcel$export(module.exports, "useGetIssueCommand", ()=>$a622cdc1edfd2034$export$98868e4240dcd14d);
    var $5uXOq = parcelRequire("5uXOq");
    var $4l54H;
    var $eMpK2;
    var $e0tx8;
    const $a622cdc1edfd2034$export$98868e4240dcd14d = ()=>{
        const { transformNavigationCommand: transformNavigationCommand } = (0, (0, parcelRequire("4l54H")).useTransformNavigationCommands)();
        const getIssueCommand = (0, $5uXOq.useCallback)(({ issue: issue, keywords: keywords, section: section, analytics: analytics, ...rest })=>{
            const { issueId: issueId, summary: summary, issueKey: issueKey, projectId: projectId = 'UNAVAILABLE' } = issue;
            return transformNavigationCommand({
                id: `issue-${issueId}`,
                section: section,
                keywords: keywords,
                name: `${issueKey} ${summary}`,
                components: {
                    Name: ({ isActive: isActive })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0tx8")).IssueView), {
                            issue: issue,
                            isActive: isActive
                        }),
                    LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eMpK2")).IssueLeftIcon), {
                            iconUrl: issue.avatar?.url,
                            issueTypeName: issue.issueTypeName
                        })
                },
                analytics: {
                    action: 'issueViewed',
                    issueId: issueId,
                    metadata: {
                        contentId: issueId,
                        containerId: projectId,
                        contentType: 'issue'
                    },
                    ...analytics
                },
                ...rest
            }, {
                path: `/browse/${issueKey}`
            });
        }, [
            transformNavigationCommand
        ]);
        return {
            getIssueCommand: getIssueCommand
        };
    };
});
parcelRegister("eMpK2", function(module, exports) {
    $parcel$export(module.exports, "IssueLeftIcon", ()=>$f381ae85157eafc9$export$b1b562672a76ad84);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dXXlv;
    const $f381ae85157eafc9$export$b1b562672a76ad84 = ({ iconUrl: iconUrl, issueTypeName: issueTypeName })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: iconUrl,
            alt: formatMessage((0, (0, parcelRequire("dXXlv")).messages).issueIconAltText, {
                issueTypeName: issueTypeName
            }),
            height: "16"
        });
    };
});
parcelRegister("dXXlv", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$91c46772185cf0df$export$defe85febe8b728c);
    var $7VHMR;
    const $91c46772185cf0df$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueIconAltText: {
            "id": "command-palette-common.common.command.issue.issue-left-icon.issue-icon-alt-text",
            "defaultMessage": "Icon for the issue type {issueTypeName}"
        }
    });
});
parcelRegister("e0tx8", function(module, exports) {
    $parcel$export(module.exports, "IssueView", ()=>$d9e23d5c9ad5ce0a$export$5aebed4b5cba826a);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lj8SI;
    var $dC5iT;
    var $8CUq3;
    var $gGkxR;
    const $d9e23d5c9ad5ce0a$export$995d7ae0c0293bac = {
        1: 'default',
        2: 'default',
        3: 'success',
        4: 'inprogress'
    };
    const $d9e23d5c9ad5ce0a$export$5aebed4b5cba826a = ({ issue: { issueKey: issueKey, summary: summary, projectName: projectName, status: status }, isActive: isActive })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d9e23d5c9ad5ce0a$var$searchResultContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d9e23d5c9ad5ce0a$var$TopContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gGkxR")).TruncateWithTooltipOnActive), {
            isActive: !!isActive
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d9e23d5c9ad5ce0a$var$IssueKey, null, issueKey), (0, ($parcel$interopDefault($5uXOq))).createElement($d9e23d5c9ad5ce0a$var$IssueSummary, {
            active: isActive
        }, summary))), (status || projectName) && (0, ($parcel$interopDefault($5uXOq))).createElement($d9e23d5c9ad5ce0a$var$BottomContainer, null, status ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d9e23d5c9ad5ce0a$var$statusStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: $d9e23d5c9ad5ce0a$export$995d7ae0c0293bac[status.statusCategoryId],
            maxWidth: 236
        }, status.statusName)) : null, (0, ($parcel$interopDefault($5uXOq))).createElement($d9e23d5c9ad5ce0a$var$ProjectName, {
            active: isActive
        }, projectName)));
    const $d9e23d5c9ad5ce0a$var$searchResultContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%'
    });
    const $d9e23d5c9ad5ce0a$var$TopContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vwz41tcg _slp31hna _1nmz1hna",
                __cmplp.className
            ])
        });
    });
    const $d9e23d5c9ad5ce0a$var$IssueKey = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1a45 _2hwx12x7 _1e0c1nu9",
                __cmplp.className
            ])
        });
    });
    const $d9e23d5c9ad5ce0a$var$IssueSummary = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { active: active, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1nu9",
                __cmplp.active ? "_syazaj1x" : "_syaz1a45",
                __cmplp.className
            ])
        });
    });
    const $d9e23d5c9ad5ce0a$var$BottomContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _19pkv77o _syaz1a45 _11c8qk37 _vwz41kw7",
                __cmplp.className
            ])
        });
    });
    const $d9e23d5c9ad5ce0a$var$statusStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.150'
    });
    const $d9e23d5c9ad5ce0a$var$ProjectName = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { active: active, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_o5721q9c _1reo15vq _18m915vq _1bto1l2s _p12fuuw1 _vwz4gktf",
                __cmplp.active ? "_syaz1a45" : "_syaz1wmz",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bBHcB", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$2fd7492046662c20$export$defe85febe8b728c);
    var $7VHMR;
    const $2fd7492046662c20$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        recentlyViewedIssues: {
            "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.issues.recently-viewed-issues",
            "defaultMessage": "Recently Viewed Issues"
        },
        issueError: {
            "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.issues.issue-error",
            "defaultMessage": "We're having trouble loading recently viewed issues. Try again in a few moments."
        }
    });
});
parcelRegister("3eTqY", function(module, exports) {
    $parcel$export(module.exports, "useGetRecentPlansChildResult", ()=>$b7d349acd9c3db6d$export$ec02659dcd249bd6);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dmf5R;
    var $9NCxG;
    var $gIysK;
    const $b7d349acd9c3db6d$export$ec02659dcd249bd6 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { getQuickSearchPlanCommands: getQuickSearchPlanCommands } = (0, (0, parcelRequire("9NCxG")).useGetQuickSearchPlanCommands)({
            section: (0, $96f4cd972101fda7$export$501955bd67991a25),
            showViewAll: false
        });
        const getChildResult = (0, $5uXOq.useCallback)((props)=>{
            const sections = {
                [(0, $96f4cd972101fda7$export$501955bd67991a25)]: {
                    id: (0, $96f4cd972101fda7$export$501955bd67991a25),
                    name: formatMessage((0, (0, parcelRequire("gIysK")).messages).recentlyViewedPlans),
                    priority: (0, (0, parcelRequire("dmf5R")).QUICK_SEARCH_PRIORITY).PLANS
                }
            };
            const commands = getQuickSearchPlanCommands(props);
            return {
                sections: sections,
                commands: commands
            };
        }, [
            formatMessage,
            getQuickSearchPlanCommands
        ]);
        return {
            getChildResult: getChildResult
        };
    };
});
parcelRegister("9NCxG", function(module, exports) {
    $parcel$export(module.exports, "useGetQuickSearchPlanCommands", ()=>$d40be781b173125f$export$668213efda00d797);
    var $5uXOq = parcelRequire("5uXOq");
    var $cPSNS;
    var $koVbs;
    var $dmf5R;
    var $9ReLB;
    var $bgCj3;
    var $73ZzY;
    var $e5idJ;
    const $d40be781b173125f$export$668213efda00d797 = ({ section: section, showViewAll: showViewAll })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { getPlanCommand: getPlanCommand } = (0, (0, parcelRequire("cPSNS")).useGetPlanCommand)();
        const { getViewAllCommand: getViewAllCommand } = (0, (0, parcelRequire("73ZzY")).useGetViewAllCommand)();
        const getQuickSearchPlanCommands = (0, $5uXOq.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
            const planScope = (0, (0, parcelRequire("bgCj3")).getQuickSearchPlanScope)(quickSearchResponseData);
            if (!planScope || error || planScope?.error || planScope?.results?.length === 0) return [];
            const commands = planScope.results.slice(0, (0, (0, parcelRequire("dmf5R")).PLAN_LIMIT)).map((plan)=>getPlanCommand({
                    plan: (0, (0, parcelRequire("bgCj3")).transformQuickSearchPlanResultToPlan)(plan),
                    keywords: search,
                    section: section,
                    analytics: {
                        isSearchResult: true
                    }
                }));
            if (!showViewAll || planScope.results.length <= (0, (0, parcelRequire("dmf5R")).PLAN_LIMIT)) return commands;
            const viewAllCommand = getViewAllCommand({
                id: 'view-all-plans',
                keywords: search,
                section: section,
                name: formatMessage((0, (0, parcelRequire("9ReLB")).messages).viewAllResults),
                url: (0, (0, parcelRequire("e5idJ")).getViewAllUrl)((0, (0, parcelRequire("e5idJ")).ViewAllType).PLAN, search),
                analyticsPayload: {
                    action: 'viewAllPlans',
                    size: planScope.size
                }
            });
            return commands.concat([
                viewAllCommand
            ]);
        }, [
            formatMessage,
            getPlanCommand,
            getViewAllCommand,
            section,
            showViewAll
        ]);
        return {
            getQuickSearchPlanCommands: getQuickSearchPlanCommands
        };
    };
});
parcelRegister("cPSNS", function(module, exports) {
    $parcel$export(module.exports, "useGetPlanCommand", ()=>$3e2bb83f72c97086$export$69408f6c87099775);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $4l54H;
    const $3e2bb83f72c97086$export$69408f6c87099775 = ()=>{
        const { transformNavigationCommand: transformNavigationCommand } = (0, (0, parcelRequire("4l54H")).useTransformNavigationCommands)();
        const getPlanCommand = (0, $5uXOq.useCallback)(({ plan: plan, section: section, analytics: analytics, ...rest })=>{
            const { id: id, url: url, name: name } = plan;
            return transformNavigationCommand({
                id: `plan-${id}`,
                section: section,
                name: name,
                components: {
                    LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($3e2bb83f72c97086$export$3eeaa2f0a53409a2, null)
                },
                analytics: {
                    action: 'planViewed',
                    planId: id,
                    metadata: {
                        contentId: id,
                        containerId: 'UNAVAILABLE',
                        contentType: 'plan'
                    },
                    ...analytics
                },
                ...rest
            }, {
                path: url
            });
        }, [
            transformNavigationCommand
        ]);
        return {
            getPlanCommand: getPlanCommand
        };
    };
    const $3e2bb83f72c97086$export$3eeaa2f0a53409a2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($3e2bb83f72c97086$var$PlanLeftIconContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M6.44455 5.66667C6.015 5.66667 5.66677 6.01489 5.66677 6.44444C5.66677 6.874 6.015 7.22222 6.44455 7.22222H9.55566C9.98522 7.22222 10.3334 6.874 10.3334 6.44444C10.3334 6.01489 9.98522 5.66667 9.55566 5.66667H6.44455Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M6.44455 8.77778C6.44455 8.34822 6.79278 8 7.22233 8H10.3334C10.763 8 11.1112 8.34822 11.1112 8.77778C11.1112 9.20733 10.763 9.55556 10.3334 9.55556H7.22233C6.79278 9.55556 6.44455 9.20733 6.44455 8.77778Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M6.44455 10.3333C6.015 10.3333 5.66677 10.6816 5.66677 11.1111C5.66677 11.5407 6.015 11.8889 6.44455 11.8889H8.00011C8.42966 11.8889 8.77789 11.5407 8.77789 11.1111C8.77789 10.6816 8.42966 10.3333 8.00011 10.3333H6.44455Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.889 2.55556C4.889 1.69645 5.58544 1 6.44455 1H9.55566C10.4148 1 11.1112 1.69645 11.1112 2.55556H11.889C12.7481 2.55556 13.4446 3.252 13.4446 4.11111V13.4444C13.4446 14.3036 12.7481 15 11.889 15H4.11122C3.25211 15 2.55566 14.3036 2.55566 13.4444V4.11111C2.55566 3.252 3.25211 2.55556 4.11122 2.55556H4.889ZM9.55566 4.88889C10.1314 4.88889 10.6342 4.57607 10.9031 4.11111H11.889V13.4444H4.11122L4.11122 4.11111H5.0971C5.36607 4.57607 5.86878 4.88889 6.44455 4.88889H9.55566ZM9.55566 2.55556H6.44455V3.33333H9.55566V2.55556Z"
        })));
    const $3e2bb83f72c97086$var$PlanLeftIconContainer = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vwz4kb7n _13ti15vq _15jv15vq _n0baglyw _1m8i1osq _1azq1osq _11d61r31 _11ssyfq0",
                __cmplp.className
            ])
        });
    });
});
const $96f4cd972101fda7$export$501955bd67991a25 = 'jira.plan';
parcelRegister("gIysK", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$fb619441bb92994c$export$defe85febe8b728c);
    var $7VHMR;
    const $fb619441bb92994c$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        recentlyViewedPlans: {
            "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.plans.recently-viewed-plans",
            "defaultMessage": "Recently Viewed Plans"
        }
    });
});
parcelRegister("2ZZwV", function(module, exports) {
    $parcel$export(module.exports, "useGetRecentProjectsChildResult", ()=>$b4417f6a7643e6c0$export$1f6a5212707c0c74);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dmf5R;
    var $i1jRv;
    var $6SKj1;
    const $b4417f6a7643e6c0$var$SECTION_ID = 'jira.project';
    const $b4417f6a7643e6c0$export$1f6a5212707c0c74 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { getQuickSearchProjectCommands: getQuickSearchProjectCommands } = (0, (0, parcelRequire("i1jRv")).useGetQuickSearchProjectCommands)({
            section: $b4417f6a7643e6c0$var$SECTION_ID,
            showViewAll: false
        });
        const getChildResult = (0, $5uXOq.useCallback)((props)=>{
            const sections = {
                [$b4417f6a7643e6c0$var$SECTION_ID]: {
                    id: $b4417f6a7643e6c0$var$SECTION_ID,
                    name: formatMessage((0, (0, parcelRequire("6SKj1")).messages).recentlyViewedProjects),
                    priority: (0, (0, parcelRequire("dmf5R")).QUICK_SEARCH_PRIORITY).PROJECTS
                }
            };
            const commands = getQuickSearchProjectCommands(props);
            return {
                sections: sections,
                commands: commands
            };
        }, [
            formatMessage,
            getQuickSearchProjectCommands
        ]);
        return {
            getChildResult: getChildResult
        };
    };
});
parcelRegister("i1jRv", function(module, exports) {
    $parcel$export(module.exports, "useGetQuickSearchProjectCommands", ()=>$662434420534e753$export$d434736854ef42ec);
    var $5uXOq = parcelRequire("5uXOq");
    var $aZ12W;
    var $koVbs;
    var $dmf5R;
    var $9ReLB;
    var $bgCj3;
    var $73ZzY;
    var $e5idJ;
    const $662434420534e753$export$d434736854ef42ec = ({ section: section, showViewAll: showViewAll })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { getProjectCommand: getProjectCommand } = (0, (0, parcelRequire("aZ12W")).useGetProjectCommand)();
        const { getViewAllCommand: getViewAllCommand } = (0, (0, parcelRequire("73ZzY")).useGetViewAllCommand)();
        const getQuickSearchProjectCommands = (0, $5uXOq.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
            const projectScope = (0, (0, parcelRequire("bgCj3")).getQuickSearchProjectScope)(quickSearchResponseData);
            if (!projectScope || error || projectScope?.error || projectScope?.results?.length === 0) return [];
            const commands = projectScope.results.slice(0, (0, (0, parcelRequire("dmf5R")).PROJECT_LIMIT)).map((project)=>getProjectCommand({
                    project: (0, (0, parcelRequire("bgCj3")).transformQuickSearchProjectResultToProject)(project),
                    keywords: search,
                    section: section,
                    analytics: {
                        isSearchResult: true
                    }
                })).filter((project)=>project);
            if (!showViewAll || projectScope.results.length <= (0, (0, parcelRequire("dmf5R")).PROJECT_LIMIT)) return commands;
            const viewAllCommand = getViewAllCommand({
                id: 'view-all-projects',
                keywords: search,
                section: section,
                name: formatMessage((0, (0, parcelRequire("9ReLB")).messages).viewAllResults),
                url: (0, (0, parcelRequire("e5idJ")).getViewAllUrl)((0, (0, parcelRequire("e5idJ")).ViewAllType).PROJECT, search),
                analyticsPayload: {
                    action: 'viewAllProjects',
                    size: projectScope.size
                }
            });
            return commands.concat([
                viewAllCommand
            ]);
        }, [
            formatMessage,
            getProjectCommand,
            getViewAllCommand,
            section,
            showViewAll
        ]);
        return {
            getQuickSearchProjectCommands: getQuickSearchProjectCommands
        };
    };
});
parcelRegister("aZ12W", function(module, exports) {
    $parcel$export(module.exports, "useGetProjectCommand", ()=>$63b43d5e6f1b8813$export$ea003d923e77b495);
    var $5uXOq = parcelRequire("5uXOq");
    var $4l54H;
    var $f8hy9;
    const $63b43d5e6f1b8813$export$ea003d923e77b495 = ()=>{
        const { transformNavigationCommand: transformNavigationCommand } = (0, (0, parcelRequire("4l54H")).useTransformNavigationCommands)();
        const getProjectCommand = (0, $5uXOq.useCallback)(({ project: project, keywords: keywords, section: section, analytics: analytics, ...rest })=>{
            const { projectId: projectId, name: name, url: url, avatar: avatar, canView: canView } = project;
            if (!canView) return null;
            return transformNavigationCommand({
                id: `project-${projectId}`,
                section: section,
                keywords: keywords,
                name: name,
                components: {
                    LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f8hy9")).ProjectLeftIcon), {
                            url: avatar.url,
                            name: name
                        })
                },
                analytics: {
                    action: 'projectViewed',
                    projectId: projectId,
                    metadata: {
                        contentId: projectId,
                        containerId: 'UNAVAILABLE',
                        contentType: 'project'
                    },
                    ...analytics
                },
                ...rest
            }, {
                path: url
            });
        }, [
            transformNavigationCommand
        ]);
        return {
            getProjectCommand: getProjectCommand
        };
    };
});
parcelRegister("f8hy9", function(module, exports) {
    $parcel$export(module.exports, "ProjectLeftIcon", ()=>$242c5c58946a0dbd$export$423e89389ac007b0);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $gxhFd;
    const $242c5c58946a0dbd$export$423e89389ac007b0 = ({ url: url, name: name })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: url,
            alt: formatMessage((0, (0, parcelRequire("gxhFd")).messages).issueIconAltText, {
                name: name
            }),
            height: "16"
        });
    };
});
parcelRegister("gxhFd", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$41c7d31c0e7473b6$export$defe85febe8b728c);
    var $7VHMR;
    const $41c7d31c0e7473b6$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueIconAltText: {
            "id": "command-palette-common.common.command.project.project-left-icon.issue-icon-alt-text",
            "defaultMessage": "Icon for the project {name}"
        }
    });
});
parcelRegister("6SKj1", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$879dfa2560394919$export$defe85febe8b728c);
    var $7VHMR;
    const $879dfa2560394919$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        recentlyViewedProjects: {
            "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.projects.recently-viewed-projects",
            "defaultMessage": "Recently Viewed Projects"
        }
    });
});
parcelRegister("5mZMv", function(module, exports) {
    $parcel$export(module.exports, "useGetSearchResults", ()=>$833c50f0d3c45952$export$bca2834c2ecfc5f9);
    var $5uXOq = parcelRequire("5uXOq");
    var $gM5ou;
    var $h9iZl;
    var $8zOmE;
    var $2NMNM;
    var $JKfGz;
    var $5zDBm;
    var $hX4Eo;
    var $c2I39;
    var $lLiuT;
    var $gaogX;
    var $9Jgrf;
    var $1WvJs;
    var $c2RuO;
    const $833c50f0d3c45952$export$bca2834c2ecfc5f9 = ()=>{
        const { getChildResult: getErrorChildResult } = (0, (0, parcelRequire("JKfGz")).useGetErrorChildResult)();
        const { getChildResult: getRecommendedChildResult } = (0, (0, parcelRequire("5zDBm")).useGetRecommendedChildResult)();
        const { getChildResult: getSearchIssuesChildResult } = (0, (0, parcelRequire("9Jgrf")).useGetSearchIssuesChildResult)();
        const { getChildResult: getSearchProjectsChildResult } = (0, (0, parcelRequire("c2RuO")).useGetSearchProjectsChildResult)();
        const { getChildResult: getSearchBoardsChildResult } = (0, (0, parcelRequire("lLiuT")).useGetSearchBoardsChildResult)();
        const { getChildResult: getSearchFiltersChildResult } = (0, (0, parcelRequire("gaogX")).useGetSearchFiltersChildResult)();
        const { getChildResult: getSearchPlansChildResult } = (0, (0, parcelRequire("1WvJs")).useGetSearchPlansChildResult)();
        const [hasEditOrViewPermissions] = (0, (0, parcelRequire("h9iZl")).useNavigationViewPlansPermission)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, (0, parcelRequire("hX4Eo")).useSetTimeoutAutoClear)();
        const setTimeoutFunc = setTimeoutAutoClear;
        const getSearchResults = (0, $5uXOq.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
            setTimeoutFunc(()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'searchResults shown', 'postQuerySearchResults', {
                    ...(0, (0, parcelRequire("c2I39")).transformResultsForAnalytics)(quickSearchResponseData, false)
                });
            }, 0);
            return (0, (0, parcelRequire("gM5ou")).mergeChildResults)([
                getErrorChildResult({
                    search: search,
                    quickSearchResponseData: quickSearchResponseData,
                    error: error
                }),
                getRecommendedChildResult({
                    search: search,
                    quickSearchResponseData: quickSearchResponseData,
                    error: error
                }),
                getSearchIssuesChildResult({
                    search: search,
                    quickSearchResponseData: quickSearchResponseData,
                    error: error
                }),
                getSearchProjectsChildResult({
                    search: search,
                    quickSearchResponseData: quickSearchResponseData,
                    error: error
                }),
                getSearchBoardsChildResult({
                    search: search,
                    quickSearchResponseData: quickSearchResponseData,
                    error: error
                }),
                getSearchFiltersChildResult({
                    search: search,
                    quickSearchResponseData: quickSearchResponseData,
                    error: error
                }),
                ...hasEditOrViewPermissions ? [
                    getSearchPlansChildResult({
                        search: search,
                        quickSearchResponseData: quickSearchResponseData,
                        error: error
                    })
                ] : []
            ]);
        }, [
            createAnalyticsEvent,
            getErrorChildResult,
            getRecommendedChildResult,
            getSearchBoardsChildResult,
            getSearchFiltersChildResult,
            getSearchIssuesChildResult,
            getSearchPlansChildResult,
            getSearchProjectsChildResult,
            hasEditOrViewPermissions,
            setTimeoutFunc
        ]);
        return getSearchResults;
    };
});
parcelRegister("lLiuT", function(module, exports) {
    $parcel$export(module.exports, "useGetSearchBoardsChildResult", ()=>$88c4ff99e9f621dc$export$894d6ed9a271a485);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $flylh;
    var $dmf5R;
    var $be7GP;
    const $88c4ff99e9f621dc$export$894d6ed9a271a485 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { getQuickSearchBoardCommands: getQuickSearchBoardCommands } = (0, (0, parcelRequire("flylh")).useGetQuickSearchBoardCommands)({
            section: (0, $9db33864c3ec79d1$export$501955bd67991a25),
            showViewAll: true
        });
        const getChildResult = (0, $5uXOq.useCallback)((props)=>{
            const sections = {
                [(0, $9db33864c3ec79d1$export$501955bd67991a25)]: {
                    id: (0, $9db33864c3ec79d1$export$501955bd67991a25),
                    name: formatMessage((0, (0, parcelRequire("be7GP")).messages).boards),
                    priority: (0, (0, parcelRequire("dmf5R")).QUICK_SEARCH_PRIORITY).BOARDS
                }
            };
            const commands = getQuickSearchBoardCommands(props);
            return {
                sections: sections,
                commands: commands
            };
        }, [
            formatMessage,
            getQuickSearchBoardCommands
        ]);
        return {
            getChildResult: getChildResult
        };
    };
});
const $9db33864c3ec79d1$export$501955bd67991a25 = 'jira.board';
parcelRegister("be7GP", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$aa2de8cb98997fdf$export$defe85febe8b728c);
    var $7VHMR;
    const $aa2de8cb98997fdf$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        boards: {
            "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.boards.boards",
            "defaultMessage": "Boards"
        }
    });
});
parcelRegister("gaogX", function(module, exports) {
    $parcel$export(module.exports, "useGetSearchFiltersChildResult", ()=>$b64025b277191be0$export$679a1b8aea427942);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dmf5R;
    var $8kcFW;
    var $4gL65;
    const $b64025b277191be0$export$679a1b8aea427942 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { getQuickSearchFilterCommands: getQuickSearchFilterCommands } = (0, (0, parcelRequire("8kcFW")).useGetQuickSearchFilterCommands)({
            section: (0, $c830d1fbcd93a1f4$export$501955bd67991a25),
            showViewAll: true
        });
        const getChildResult = (0, $5uXOq.useCallback)((props)=>{
            const sections = {
                [(0, $c830d1fbcd93a1f4$export$501955bd67991a25)]: {
                    id: (0, $c830d1fbcd93a1f4$export$501955bd67991a25),
                    name: formatMessage((0, (0, parcelRequire("4gL65")).messages).filters),
                    priority: (0, (0, parcelRequire("dmf5R")).QUICK_SEARCH_PRIORITY).FILTERS
                }
            };
            const commands = getQuickSearchFilterCommands(props);
            return {
                sections: sections,
                commands: commands
            };
        }, [
            formatMessage,
            getQuickSearchFilterCommands
        ]);
        return {
            getChildResult: getChildResult
        };
    };
});
const $c830d1fbcd93a1f4$export$501955bd67991a25 = 'jira.filter';
parcelRegister("4gL65", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$3b03efab368f8867$export$defe85febe8b728c);
    var $7VHMR;
    const $3b03efab368f8867$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        filters: {
            "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.filters.filters",
            "defaultMessage": "Filters"
        }
    });
});
parcelRegister("9Jgrf", function(module, exports) {
    $parcel$export(module.exports, "useGetSearchIssuesChildResult", ()=>$9793044f8c06d022$export$87713fad27eebcf1);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dmf5R;
    var $hzB87;
    var $1URUx;
    const $9793044f8c06d022$var$SECTION_ID = 'jira.issue';
    const $9793044f8c06d022$export$87713fad27eebcf1 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { getQuickSearchIssueCommands: getQuickSearchIssueCommands } = (0, (0, parcelRequire("hzB87")).useGetQuickSearchIssueCommands)({
            section: $9793044f8c06d022$var$SECTION_ID,
            errorMessage: formatMessage((0, (0, parcelRequire("1URUx")).messages).issueError),
            showViewAll: true
        });
        const getChildResult = (0, $5uXOq.useCallback)((props)=>{
            const sections = {
                [$9793044f8c06d022$var$SECTION_ID]: {
                    id: $9793044f8c06d022$var$SECTION_ID,
                    name: formatMessage((0, (0, parcelRequire("1URUx")).messages).issues),
                    priority: (0, (0, parcelRequire("dmf5R")).QUICK_SEARCH_PRIORITY).ISSUES
                }
            };
            const commands = getQuickSearchIssueCommands(props);
            return {
                sections: sections,
                commands: commands
            };
        }, [
            formatMessage,
            getQuickSearchIssueCommands
        ]);
        return {
            getChildResult: getChildResult
        };
    };
});
parcelRegister("1URUx", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$47497f421fc59186$export$defe85febe8b728c);
    var $7VHMR;
    const $47497f421fc59186$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueError: {
            "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.issues.issue-error",
            "defaultMessage": "We\u2019re having trouble searching issues. You can try again in a few moments."
        },
        issues: {
            "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.issues.issues",
            "defaultMessage": "Issues"
        }
    });
});
parcelRegister("1WvJs", function(module, exports) {
    $parcel$export(module.exports, "useGetSearchPlansChildResult", ()=>$e32d9815c94026cd$export$fc9d0a774ff010f1);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dmf5R;
    var $9NCxG;
    var $d0qEo;
    const $e32d9815c94026cd$export$fc9d0a774ff010f1 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { getQuickSearchPlanCommands: getQuickSearchPlanCommands } = (0, (0, parcelRequire("9NCxG")).useGetQuickSearchPlanCommands)({
            section: (0, $fa2f1ec5e9dfa50d$export$501955bd67991a25),
            showViewAll: true
        });
        const getChildResult = (0, $5uXOq.useCallback)((props)=>{
            const sections = {
                [(0, $fa2f1ec5e9dfa50d$export$501955bd67991a25)]: {
                    id: (0, $fa2f1ec5e9dfa50d$export$501955bd67991a25),
                    name: formatMessage((0, (0, parcelRequire("d0qEo")).messages).plans),
                    priority: (0, (0, parcelRequire("dmf5R")).QUICK_SEARCH_PRIORITY).PLANS
                }
            };
            const commands = getQuickSearchPlanCommands(props);
            return {
                sections: sections,
                commands: commands
            };
        }, [
            formatMessage,
            getQuickSearchPlanCommands
        ]);
        return {
            getChildResult: getChildResult
        };
    };
});
const $fa2f1ec5e9dfa50d$export$501955bd67991a25 = 'jira.plan';
parcelRegister("d0qEo", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$9f7215f09d1073bd$export$defe85febe8b728c);
    var $7VHMR;
    const $9f7215f09d1073bd$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        plans: {
            "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.plans.plans",
            "defaultMessage": "Plans"
        }
    });
});
parcelRegister("c2RuO", function(module, exports) {
    $parcel$export(module.exports, "useGetSearchProjectsChildResult", ()=>$703c5598a8fdd0ed$export$e18d773eb3827574);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dmf5R;
    var $i1jRv;
    var $lJcHJ;
    const $703c5598a8fdd0ed$var$SECTION_ID = 'jira.project';
    const $703c5598a8fdd0ed$export$e18d773eb3827574 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { getQuickSearchProjectCommands: getQuickSearchProjectCommands } = (0, (0, parcelRequire("i1jRv")).useGetQuickSearchProjectCommands)({
            section: $703c5598a8fdd0ed$var$SECTION_ID,
            showViewAll: true
        });
        const getChildResult = (0, $5uXOq.useCallback)((props)=>{
            const sections = {
                [$703c5598a8fdd0ed$var$SECTION_ID]: {
                    id: $703c5598a8fdd0ed$var$SECTION_ID,
                    name: formatMessage((0, (0, parcelRequire("lJcHJ")).messages).projects),
                    priority: (0, (0, parcelRequire("dmf5R")).QUICK_SEARCH_PRIORITY).PROJECTS
                }
            };
            const commands = getQuickSearchProjectCommands(props);
            return {
                sections: sections,
                commands: commands
            };
        }, [
            formatMessage,
            getQuickSearchProjectCommands
        ]);
        return {
            getChildResult: getChildResult
        };
    };
});
parcelRegister("lJcHJ", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$8373ba575134fc5e$export$defe85febe8b728c);
    var $7VHMR;
    const $8373ba575134fc5e$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projects: {
            "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.projects.projects",
            "defaultMessage": "Projects"
        }
    });
});
parcelRegister("cy1Ju", function(module, exports) {
    $parcel$export(module.exports, "QuickSearchChildWrapper", ()=>$155f5b8355a77d5d$export$85ee85d7d315a747);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjt52;
    var $18wuq;
    var $bFaKi;
    const $155f5b8355a77d5d$export$85ee85d7d315a747 = ({ children: children })=>{
        const [attributes, { reset: reset }] = (0, (0, parcelRequire("gjt52")).useQuickSearchAnalyticsAttributes)();
        (0, $5uXOq.useEffect)(()=>{
            reset();
            return ()=>{
                reset();
            };
        }, [
            reset
        ]);
        const shouldFireScreenAnalytics = attributes.queryVersion >= 0;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("18wuq")).QuickSearchWrapper), null, shouldFireScreenAnalytics && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bFaKi")).QuickSearchFireScreenAnalytics), null), children);
    };
});
parcelRegister("18wuq", function(module, exports) {
    $parcel$export(module.exports, "QuickSearchWrapper", ()=>$c5eeb66c5ad1d34b$export$2398c0852f2402a1);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $iXVV6;
    var $gjt52;
    const $c5eeb66c5ad1d34b$export$2398c0852f2402a1 = ({ children: children })=>{
        const [attributes] = (0, (0, parcelRequire("gjt52")).useQuickSearchAnalyticsAttributes)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            packageName: "jiraCommandPaletteQuickSearch",
            id: "quick-search",
            teamName: "deliveroo"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            attributes: attributes
        }, children));
    };
});
parcelRegister("bFaKi", function(module, exports) {
    $parcel$export(module.exports, "QuickSearchFireScreenAnalytics", ()=>$9c588ae7c7c47ec2$export$7b8039e0ef5a7b1b);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXVV6;
    var $5oFIy;
    var $gjt52;
    const $9c588ae7c7c47ec2$export$7b8039e0ef5a7b1b = ()=>{
        const [{ query: query }] = (0, (0, parcelRequire("gjt52")).useQuickSearchAnalytics)();
        const isSearch = (0, $5uXOq.useMemo)(()=>Boolean(query?.length), [
            query
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: isSearch ? 'searchCommandPalettePostQuery' : 'searchCommandPalettePreQuery',
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null));
    };
});
parcelRegister("h2Vnd", function(module, exports) {
    $parcel$export(module.exports, "useCommandPaletteRegistry", ()=>$8a5112967b14f6b6$export$843ca10488699b0c);
    var $5uXOq = parcelRequire("5uXOq");
    var $d8lE2;
    var $1Kt4o;
    const $8a5112967b14f6b6$export$843ca10488699b0c = ()=>{
        const { setRegistry: setRegistry } = (0, (0, parcelRequire("d8lE2")).useActionsCommandPalette)();
        (0, $5uXOq.useState)(()=>{
            setRegistry((0, (0, parcelRequire("1Kt4o")).COMMAND_PALETTE_REGISTRY));
        });
    };
});
parcelRegister("1Kt4o", function(module, exports) {
    $parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", ()=>$3add01bee0e3b846$export$689de18177335e39);
    $parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", ()=>$3add01bee0e3b846$export$96f61eb1261e42c3);
    const $3add01bee0e3b846$export$689de18177335e39 = {
        ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
        ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
        CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
        COPY_URL: 'COPY_URL',
        DESCRIPTION: 'DESCRIPTION',
        ISSUE_ACTIONS: 'ISSUE_ACTIONS',
        ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
        ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
        ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
        LOG_WORK: 'LOG_WORK',
        NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
        PARENT: 'PARENT',
        PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
        QUICK_ADD: 'QUICK_ADD',
        QUICK_SEARCH: 'QUICK_SEARCH',
        SHORTCUTS: 'SHORTCUTS',
        STATUS: 'STATUS',
        STORY_POINTS: 'STORY_POINTS',
        TEST: 'TEST',
        THEME_MODE: 'THEME_MODE'
    };
    const $3add01bee0e3b846$var$teams = {
        Deliveroo: 'Deliveroo'
    };
    const $3add01bee0e3b846$export$96f61eb1261e42c3 = {
        ADMIN_NAVIGATION: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ADMIN_NAVIGATION,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        CHECK_NOTIFICATIONS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.CHECK_NOTIFICATIONS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        COPY_URL: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.COPY_URL,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        DESCRIPTION: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.DESCRIPTION,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        ISSUE_ACTIONS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_ACTIONS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        ISSUE_FIELD_ASSIGN: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        ISSUE_HEADER_ACTIONS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        ISSUE_SUB_HEADER_ACTIONS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        LOG_WORK: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.LOG_WORK,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        NAVIGATION_COMMANDS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.NAVIGATION_COMMANDS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        PARENT: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.PARENT,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        PROJECT_NAVIGATION: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.PROJECT_NAVIGATION,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        QUICK_ADD: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_ADD,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        QUICK_SEARCH: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_SEARCH,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        SHORTCUTS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.SHORTCUTS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        STATUS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.STATUS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        STORY_POINTS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.STORY_POINTS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        THEME_MODE: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.THEME_MODE,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        }
    };
});
parcelRegister("bbRjE", function(module, exports) {
    $parcel$export(module.exports, "CommandPaletteModal", ()=>$5656caada5aa2e19$export$9b347310d90ce55);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $1R1Ge;
    var $i8Qvm;
    var $eTXmK;
    var $koVbs;
    var $bcTvL;
    var $d8lE2;
    var $7idav;
    var $9gmuM;
    var $aV3mV;
    const $5656caada5aa2e19$export$9b347310d90ce55 = ({ defaultAriaLabel: defaultAriaLabel, defaultPlaceholder: defaultPlaceholder, defaultFooterContent: defaultFooterContent, onAnalytics: onAnalytics, onErrorAnalytics: onErrorAnalytics, defaultFallback: defaultFallback, rootFallback: rootFallback })=>{
        const [{ commandPaletteSessionId: commandPaletteSessionId, isOpen: isOpen, hasPopupOverlay: hasPopupOverlay }, { close: close, markAsLoaded: markAsLoaded, setAnalytics: setAnalytics }] = (0, (0, parcelRequire("d8lE2")).useCommandPalette)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        (0, $5uXOq.useEffect)(()=>{
            setAnalytics(onAnalytics, onErrorAnalytics);
        }, [
            onAnalytics,
            onErrorAnalytics,
            setAnalytics
        ]);
        const sendAnalyticsEvent = (0, $5uXOq.useCallback)((action)=>{
            const ev = createAnalyticsEvent({
                action: action,
                actionSubject: 'commandPalette'
            });
            if (onAnalytics) onAnalytics(ev, (0, (0, parcelRequire("bcTvL")).UI_EVENT_TYPE), {
                attributes: {
                    commandPaletteSessionId: commandPaletteSessionId
                }
            });
        }, [
            commandPaletteSessionId,
            createAnalyticsEvent,
            onAnalytics
        ]);
        const onEscPressed = (0, $5uXOq.useCallback)((event)=>{
            if (event.key === 'Escape' && isOpen) {
                event.preventDefault();
                event.stopPropagation();
                sendAnalyticsEvent('closed');
                (0, (0, parcelRequire("eTXmK")).default)('command-palette-closed');
                close();
            }
        }, [
            isOpen,
            sendAnalyticsEvent,
            close
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (hasPopupOverlay) return;
            document.addEventListener('keydown', onEscPressed, true);
            return ()=>{
                document.removeEventListener('keydown', onEscPressed, true);
            };
        }, [
            hasPopupOverlay,
            onEscPressed
        ]);
        (0, $5uXOq.useEffect)(()=>{
            markAsLoaded();
        }, [
            markAsLoaded
        ]);
        const onClose = (0, $5uXOq.useCallback)(()=>{
            sendAnalyticsEvent('closed');
            (0, (0, parcelRequire("eTXmK")).default)('command-palette-closed');
            close();
        }, [
            sendAnalyticsEvent,
            close
        ]);
        const onOpenComplete = (0, $5uXOq.useCallback)(()=>{
            sendAnalyticsEvent('viewed');
        }, [
            sendAnalyticsEvent
        ]);
        if (!isOpen) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            onClose: onClose,
            shouldCloseOnOverlayClick: true,
            shouldCloseOnEscapePress: true,
            autoFocus: false,
            testId: (0, $898ce3b7997b47d8$export$7622d28bacf170d1),
            onOpenComplete: onOpenComplete,
            width: 752,
            isBlanketHidden: true,
            label: formatMessage((0, (0, parcelRequire("7idav")).messages).modalLabel)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aV3mV")).ModalWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gmuM")).ModalContent), {
            defaultAriaLabel: defaultAriaLabel,
            defaultFallback: defaultFallback,
            rootFallback: rootFallback,
            defaultPlaceholder: defaultPlaceholder,
            defaultFooterContent: defaultFooterContent,
            onClose: onClose
        }))));
    };
});
const $898ce3b7997b47d8$export$7622d28bacf170d1 = 'command-palette.ui.modal.modal-dialog';
parcelRegister("7idav", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$df55570f72dcd4e3$export$defe85febe8b728c);
    var $7VHMR;
    const $df55570f72dcd4e3$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        modalLabel: {
            "id": "command-palette.modal.modal-label",
            "defaultMessage": "Command palette modal"
        }
    });
});
parcelRegister("9gmuM", function(module, exports) {
    $parcel$export(module.exports, "ModalContent", ()=>$a9a31ea88bba7cd5$export$6da19a24bf249f17);
    var $5uXOq = parcelRequire("5uXOq");
    var $l8ruj;
    var $dOktC;
    var $d8lE2;
    var $2c1yN;
    var $fChlq;
    var $bgJTS;
    var $eNg6o;
    var $3OYpW;
    var $2mlNs;
    var $5c7Xb;
    var $5nIJM;
    const $a9a31ea88bba7cd5$export$6da19a24bf249f17 = ({ defaultAriaLabel: defaultAriaLabel, defaultFallback: defaultFallback, rootFallback: rootFallback, defaultPlaceholder: defaultPlaceholder, defaultFooterContent: defaultFooterContent, onClose: onClose })=>{
        const { total: total, fallback: fallback, results: results, renderAfterCommands: renderAfterCommands, activeCommand: activeCommand } = (0, (0, parcelRequire("2c1yN")).useMatches)({
            defaultFallback: defaultFallback,
            rootFallback: rootFallback
        });
        const [registryData] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteRegistryCurrentAttribution)();
        (0, (0, parcelRequire("bgJTS")).usePerformPendingCommandOnClose)();
        (0, (0, parcelRequire("fChlq")).usePerformMode)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5c7Xb")).default), {
            onClose: onClose,
            defaultAriaLabel: defaultAriaLabel,
            defaultPlaceholder: defaultPlaceholder,
            results: results,
            activeCommand: activeCommand
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "command-palette-body"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eNg6o")).CommandBodyErrorBoundary), {
            teamName: registryData?.registryData?.teamName || 'deliveroo',
            attributes: registryData?.analyticsAttributes,
            fallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dOktC")).NoResultsContainer), {
                    "data-testid": (0, $621e16c24c54300b$export$3545956e927a0d0a)
                }, fallback?.onError?.renderLabel?.() || fallback?.onError?.label)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OYpW")).Body), {
            fallback: fallback,
            results: results,
            total: total,
            renderAfterCommands: renderAfterCommands
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5nIJM")).ScreenReaderContent), {
            activeCommand: activeCommand,
            results: results
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2mlNs")).Footer), {
            defaultFooterContent: defaultFooterContent,
            activeCommand: activeCommand
        }));
    };
});
parcelRegister("2c1yN", function(module, exports) {
    $parcel$export(module.exports, "useMatches", ()=>$7bee86b4b24e2871$export$2378eb7f5ff86053);
    var $5uXOq = parcelRequire("5uXOq");
    var $gM5ou;
    var $4DwnT;
    var $a2Y5o;
    var $d8lE2;
    var $ivHpc;
    var $4SX9W;
    var $cPq6h;
    const $7bee86b4b24e2871$export$2378eb7f5ff86053 = ({ defaultFallback: defaultFallback, rootFallback: rootFallback })=>{
        const [{ commands: commands, expandedCommand: expandedCommand, childResult: childResult, loadingList: loadingList, sections: sections, fallbackOverride: fallbackOverride }] = (0, (0, parcelRequire("d8lE2")).useCommandPalette)();
        const [search] = (0, (0, parcelRequire("ivHpc")).useCommandPaletteSearchDebounced)();
        const hasLoadChildren = (0, (0, parcelRequire("gM5ou")).hasChildren)(expandedCommand);
        const selectedCommands = (0, $5uXOq.useMemo)(()=>hasLoadChildren ? childResult?.commands || [] : commands, [
            hasLoadChildren,
            childResult?.commands,
            commands
        ]);
        const selectedSections = (0, $5uXOq.useMemo)(()=>hasLoadChildren ? childResult?.sections : (0, (0, parcelRequire("gM5ou")).mergeSections)(sections), [
            hasLoadChildren,
            childResult?.sections,
            sections
        ]);
        const filterCommandsOverride = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("4DwnT")).getActiveCommandList)(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.filterAndSortOverrideFn, [
            expandedCommand
        ]);
        const flattenedResults = (0, (0, parcelRequire("cPq6h")).useSortAndFilter)(search, selectedCommands, selectedSections, filterCommandsOverride);
        const fallback = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("4SX9W")).getFallback)({
                rootFallback: rootFallback,
                defaultFallback: defaultFallback,
                expandedCommand: expandedCommand,
                noResults: Boolean(flattenedResults.results.length === 0 && !loadingList),
                fallbackOverride: fallbackOverride
            }), [
            defaultFallback,
            expandedCommand,
            fallbackOverride,
            flattenedResults.results.length,
            loadingList,
            rootFallback
        ]);
        return (0, $5uXOq.useMemo)(()=>{
            if ((0, (0, parcelRequire("4DwnT")).getActiveCommandList)(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.shouldShowNoCommandsWhileLoading && loadingList) return {
                results: [],
                total: 0
            };
            const fallbackCommandResult = (0, (0, parcelRequire("a2Y5o")).getFallbackCommandResult)(fallback);
            if (fallbackCommandResult) return fallbackCommandResult;
            return {
                ...flattenedResults,
                fallback: fallback
            };
        }, [
            expandedCommand,
            fallback,
            flattenedResults,
            loadingList
        ]);
    };
});
parcelRegister("a2Y5o", function(module, exports) {
    $parcel$export(module.exports, "getFallbackCommandResult", ()=>$71360b39d14851cd$export$f6daf99735e387a3);
    const $71360b39d14851cd$export$f6daf99735e387a3 = (fallback)=>{
        if (!fallback || !fallback?.onNoResults?.fallbackCommand) return undefined;
        const { fallbackCommand: fallbackCommand, fallbackSection: fallbackSection } = fallback.onNoResults;
        const section = fallbackSection;
        const fallbackCommandHeader = fallbackCommand && section ? {
            ...section.renderName ? {
                renderGroup: section.renderName
            } : {
                group: section.name
            },
            isGroup: true
        } : undefined;
        return {
            results: [
                fallbackCommandHeader,
                {
                    command: fallbackCommand,
                    active: true,
                    index: 0
                }
            ].filter(Boolean),
            total: 1,
            activeCommand: fallbackCommand,
            fallback: fallback
        };
    };
});
parcelRegister("ivHpc", function(module, exports) {
    $parcel$export(module.exports, "useCommandPaletteSearchDebounced", ()=>$2636035def55b2ae$export$f36a4bb9041c3f69);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $bcTvL;
    var $d8lE2;
    const $2636035def55b2ae$export$f36a4bb9041c3f69 = (debounceTime = (0, (0, parcelRequire("bcTvL")).COMMAND_PALETTE_DEBOUNCE_DEFAULT))=>{
        const [{ search: search }, { handleSearch: handleSearch }] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteSearch)();
        const [debouncedSearch, setDebouncedSearch] = (0, $5uXOq.useState)(search);
        const debouncedSetSearch = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($lFKmC)))(setDebouncedSearch, debounceTime), [
            debounceTime
        ]);
        (0, $5uXOq.useEffect)(()=>{
            debouncedSetSearch(search);
        }, [
            debouncedSetSearch,
            search
        ]);
        (0, $5uXOq.useEffect)(()=>()=>debouncedSetSearch.cancel(), [
            debouncedSetSearch
        ]);
        const setSearch = (0, $5uXOq.useCallback)((newSearch)=>{
            debouncedSetSearch.cancel();
            handleSearch(newSearch);
            setDebouncedSearch(newSearch);
        }, [
            debouncedSetSearch,
            handleSearch
        ]);
        return (0, $5uXOq.useMemo)(()=>[
                debouncedSearch,
                setSearch
            ], [
            debouncedSearch,
            setSearch
        ]);
    };
});
parcelRegister("4SX9W", function(module, exports) {
    $parcel$export(module.exports, "getFallback", ()=>$616b5b5588a59ff4$export$ad095be9c56d0fc8);
    var $4DwnT;
    const $616b5b5588a59ff4$export$ad095be9c56d0fc8 = ({ defaultFallback: defaultFallback, rootFallback: rootFallback, expandedCommand: expandedCommand, noResults: noResults, fallbackOverride: fallbackOverride })=>{
        const rootNoResultsFallback = rootFallback ? {
            onNoResults: rootFallback
        } : undefined;
        if (fallbackOverride) return {
            ...rootNoResultsFallback,
            ...fallbackOverride,
            ...!noResults && {
                onNoResults: undefined
            }
        };
        const wasSecondaryTriggered = expandedCommand?.wasSecondaryTriggered;
        const activeCommandList = (0, (0, parcelRequire("4DwnT")).getActiveCommandList)(expandedCommand, wasSecondaryTriggered);
        const commandFallback = activeCommandList?.fallback;
        if (!defaultFallback && !commandFallback && !rootNoResultsFallback) return undefined;
        return {
            ...rootNoResultsFallback,
            ...expandedCommand ? defaultFallback : {},
            ...commandFallback,
            ...!noResults && {
                onNoResults: undefined
            }
        };
    };
});
parcelRegister("cPq6h", function(module, exports) {
    $parcel$export(module.exports, "useSortAndFilter", ()=>$9cd78317b9fc124c$export$329b92741e754bfe);
    var $5uXOq = parcelRequire("5uXOq");
    var $l87OC;
    var $fVoBn;
    var $d8lE2;
    var $aRVi7;
    var $16iJP;
    var $6dRZA;
    var $Nytob;
    const $9cd78317b9fc124c$export$329b92741e754bfe = (search, selectedCommands, selectedSections, filterCommandsOverride)=>{
        const queryKeywordCount = (0, $5uXOq.useMemo)(()=>search.trim().split(' ').filter(Boolean).length, [
            search
        ]);
        const searchableCommands = (0, (0, parcelRequire("6dRZA")).useSearchableCommands)(selectedCommands);
        const [{ activeIndex: activeIndex }] = (0, (0, parcelRequire("d8lE2")).useCommandPalette)();
        const fuse = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("16iJP")).createFuseFromCommands)(searchableCommands, queryKeywordCount), [
            searchableCommands,
            queryKeywordCount
        ]);
        const sortedAndFilteredCommands = (0, $5uXOq.useMemo)(()=>{
            if (filterCommandsOverride) return filterCommandsOverride(search, selectedCommands, selectedSections);
            let filteredCommands;
            if (!search.trim().toLowerCase().length) filteredCommands = selectedCommands.map((command)=>({
                    ...command,
                    searchRelevancyScore: 1
                }));
            else {
                const fuseResults = (0, (0, parcelRequire("16iJP")).searchFuseIndex)(fuse, search);
                filteredCommands = (0, (0, parcelRequire("aRVi7")).filterCommandsFromSearch)(search, fuseResults, searchableCommands);
            }
            return (0, (0, parcelRequire("Nytob")).sortCommands)(filteredCommands, selectedSections);
        }, [
            filterCommandsOverride,
            fuse,
            search,
            searchableCommands,
            selectedCommands,
            selectedSections
        ]);
        const groupedCommands = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("fVoBn")).getGroupedCommands)(sortedAndFilteredCommands, selectedSections), [
            selectedSections,
            sortedAndFilteredCommands
        ]);
        const commandMatches = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("l87OC")).getFlattenedResults)(groupedCommands, activeIndex), [
            groupedCommands,
            activeIndex
        ]);
        return commandMatches;
    };
});
parcelRegister("l87OC", function(module, exports) {
    $parcel$export(module.exports, "getFlattenedResults", ()=>$a244ed78c982107b$export$2915eee4e3cdb2f0);
    const $a244ed78c982107b$export$2915eee4e3cdb2f0 = (groupedCommands, activeIndex)=>{
        const ungroupedCommands = groupedCommands.ungrouped.slice(0);
        let results = ungroupedCommands;
        const sortedGroups = Object.values(groupedCommands.grouped);
        sortedGroups.forEach(({ id: id, group: group, renderGroup: renderGroup, commands: groupCommands })=>{
            results = results.concat({
                ...renderGroup ? {
                    renderGroup: renderGroup
                } : {
                    group: group
                },
                isGroup: true,
                id: id
            }, groupCommands);
        });
        const hasAction = (listed)=>Boolean(listed.command.primaryAction || listed.command.secondaryAction);
        let index = 0;
        let totalActionableCommands = 0;
        let activeCommand;
        let sectionIndex = -1;
        let indexWithinSection = 0;
        let sectionId;
        results = results.map((result)=>{
            if (result.isGroup) {
                const newResult = result;
                indexWithinSection = 0;
                sectionIndex += 1;
                newResult.index = sectionIndex;
                sectionId = result.id;
            }
            if (!result.isGroup) {
                const newResult = result;
                if (hasAction(result)) {
                    newResult.index = index;
                    index += 1;
                    totalActionableCommands += 1;
                    newResult.active = activeIndex === result.index;
                }
                newResult.indexWithinSection = indexWithinSection;
                newResult.sectionIndex = sectionIndex;
                newResult.sectionId = sectionId;
                indexWithinSection += 1;
                if (newResult.active) activeCommand = newResult.command;
                return newResult;
            }
            return result;
        });
        return {
            results: results,
            total: totalActionableCommands,
            activeCommand: activeCommand
        };
    };
});
parcelRegister("fVoBn", function(module, exports) {
    $parcel$export(module.exports, "getGroupedCommands", ()=>$691c7859c3b26655$export$30f49bc6f46f80dd);
    const $691c7859c3b26655$export$30f49bc6f46f80dd = (commands, sections)=>commands.reduce((acc, command)=>{
            const listedCommand = {
                command: command
            };
            const createGroup = (id, section)=>{
                if (!acc.grouped.some((group)=>group.id === id)) acc.grouped.push({
                    ...section.renderName ? {
                        renderGroup: section.renderName
                    } : {
                        group: section.name
                    },
                    id: id,
                    priority: section.priority,
                    commands: []
                });
            };
            const addCommandGroup = (name, newCommand)=>{
                acc.grouped.find((group)=>group.id === name)?.commands.push(newCommand);
            };
            const section = !!command.section && sections?.[command.section];
            if (section) {
                const id = command.section;
                createGroup?.(id, section);
                addCommandGroup(id, listedCommand);
            } else acc.ungrouped.push(listedCommand);
            acc.length += 1;
            return acc;
        }, {
            grouped: [],
            ungrouped: [],
            length: 0
        });
});
parcelRegister("aRVi7", function(module, exports) {
    $parcel$export(module.exports, "filterCommandsFromSearch", ()=>$97a1382624453719$export$552543cdf42ae2bf);
    const $97a1382624453719$export$552543cdf42ae2bf = (search, fuseResults, commands)=>{
        const trimmedSearch = search.trim().toLowerCase();
        if (!trimmedSearch.length) return commands.map((command)=>({
                ...command,
                searchRelevancyScore: 1
            }));
        return commands.flatMap((command)=>{
            const fuseResult = fuseResults.find((result)=>result.item.id === command.id);
            if (fuseResult) return [
                {
                    ...command,
                    searchRelevancyScore: fuseResult.score
                }
            ];
            return [];
        });
    };
});
parcelRegister("16iJP", function(module, exports) {
    $parcel$export(module.exports, "createFuseFromCommands", ()=>$9b94410daf45f1f8$export$3047320e6ed5178f);
    $parcel$export(module.exports, "searchFuseIndex", ()=>$9b94410daf45f1f8$export$17e53d0bddbf4060);
    var $eqCsX;
    var $7WupW;
    const $9b94410daf45f1f8$export$dee16a5b7a115788 = (queryKeywordCount = 1)=>({
            ...(0, (0, parcelRequire("7WupW")).FUSE_SEARCH_OPTIONS),
            keys: (0, (0, parcelRequire("7WupW")).FUSE_SEARCH_OPTIONS).keys?.map((key)=>typeof key === 'object' && 'name' in key ? {
                    ...key,
                    weight: key.name === 'searchKeywordsArray' ? (key.weight ?? 1) / Math.max(queryKeywordCount, 1) : key.weight
                } : key)
        });
    const $9b94410daf45f1f8$export$3047320e6ed5178f = (allCommands, queryKeywordCount = 1)=>new (0, (0, parcelRequire("eqCsX")).default)(allCommands, $9b94410daf45f1f8$export$dee16a5b7a115788(queryKeywordCount));
    const $9b94410daf45f1f8$export$17e53d0bddbf4060 = (fuse, query)=>fuse.search({
            $or: [
                {
                    name: query
                },
                {
                    shortcut: query
                },
                {
                    sectionName: query
                },
                {
                    $or: query.split(' ').map((word)=>({
                            searchKeywordsArray: word
                        }))
                }
            ]
        });
});
parcelRegister("eqCsX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a81154f2549cb822$export$2e2bcd8739ae039);
    function $a81154f2549cb822$var$isArray(value) {
        return !Array.isArray ? $a81154f2549cb822$var$getTag(value) === '[object Array]' : Array.isArray(value);
    }
    const $a81154f2549cb822$var$INFINITY = 1 / 0;
    function $a81154f2549cb822$var$baseToString(value) {
        if (typeof value == 'string') return value;
        let result = value + '';
        return result == '0' && 1 / value == -$a81154f2549cb822$var$INFINITY ? '-0' : result;
    }
    function $a81154f2549cb822$var$toString(value) {
        return value == null ? '' : $a81154f2549cb822$var$baseToString(value);
    }
    function $a81154f2549cb822$var$isString(value) {
        return typeof value === 'string';
    }
    function $a81154f2549cb822$var$isNumber(value) {
        return typeof value === 'number';
    }
    function $a81154f2549cb822$var$isBoolean(value) {
        return value === true || value === false || $a81154f2549cb822$var$isObjectLike(value) && $a81154f2549cb822$var$getTag(value) == '[object Boolean]';
    }
    function $a81154f2549cb822$var$isObject(value) {
        return typeof value === 'object';
    }
    function $a81154f2549cb822$var$isObjectLike(value) {
        return $a81154f2549cb822$var$isObject(value) && value !== null;
    }
    function $a81154f2549cb822$var$isDefined(value) {
        return value !== undefined && value !== null;
    }
    function $a81154f2549cb822$var$isBlank(value) {
        return !value.trim().length;
    }
    function $a81154f2549cb822$var$getTag(value) {
        return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
    }
    const $a81154f2549cb822$var$EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
    const $a81154f2549cb822$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
    const $a81154f2549cb822$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
    const $a81154f2549cb822$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
    const $a81154f2549cb822$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
    const $a81154f2549cb822$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
    const $a81154f2549cb822$var$hasOwn = Object.prototype.hasOwnProperty;
    class $a81154f2549cb822$var$KeyStore {
        constructor(keys){
            this._keys = [];
            this._keyMap = {};
            let totalWeight = 0;
            keys.forEach((key)=>{
                let obj = $a81154f2549cb822$var$createKey(key);
                this._keys.push(obj);
                this._keyMap[obj.id] = obj;
                totalWeight += obj.weight;
            });
            this._keys.forEach((key)=>{
                key.weight /= totalWeight;
            });
        }
        get(keyId) {
            return this._keyMap[keyId];
        }
        keys() {
            return this._keys;
        }
        toJSON() {
            return JSON.stringify(this._keys);
        }
    }
    function $a81154f2549cb822$var$createKey(key) {
        let path = null;
        let id = null;
        let src = null;
        let weight = 1;
        let getFn = null;
        if ($a81154f2549cb822$var$isString(key) || $a81154f2549cb822$var$isArray(key)) {
            src = key;
            path = $a81154f2549cb822$var$createKeyPath(key);
            id = $a81154f2549cb822$var$createKeyId(key);
        } else {
            if (!$a81154f2549cb822$var$hasOwn.call(key, 'name')) throw new Error($a81154f2549cb822$var$MISSING_KEY_PROPERTY('name'));
            const name = key.name;
            src = name;
            if ($a81154f2549cb822$var$hasOwn.call(key, 'weight')) {
                weight = key.weight;
                if (weight <= 0) throw new Error($a81154f2549cb822$var$INVALID_KEY_WEIGHT_VALUE(name));
            }
            path = $a81154f2549cb822$var$createKeyPath(name);
            id = $a81154f2549cb822$var$createKeyId(name);
            getFn = key.getFn;
        }
        return {
            path: path,
            id: id,
            weight: weight,
            src: src,
            getFn: getFn
        };
    }
    function $a81154f2549cb822$var$createKeyPath(key) {
        return $a81154f2549cb822$var$isArray(key) ? key : key.split('.');
    }
    function $a81154f2549cb822$var$createKeyId(key) {
        return $a81154f2549cb822$var$isArray(key) ? key.join('.') : key;
    }
    function $a81154f2549cb822$var$get(obj, path) {
        let list = [];
        let arr = false;
        const deepGet = (obj, path, index)=>{
            if (!$a81154f2549cb822$var$isDefined(obj)) return;
            if (!path[index]) list.push(obj);
            else {
                let key = path[index];
                const value = obj[key];
                if (!$a81154f2549cb822$var$isDefined(value)) return;
                if (index === path.length - 1 && ($a81154f2549cb822$var$isString(value) || $a81154f2549cb822$var$isNumber(value) || $a81154f2549cb822$var$isBoolean(value))) list.push($a81154f2549cb822$var$toString(value));
                else if ($a81154f2549cb822$var$isArray(value)) {
                    arr = true;
                    for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
                } else if (path.length) deepGet(value, path, index + 1);
            }
        };
        deepGet(obj, $a81154f2549cb822$var$isString(path) ? path.split('.') : path, 0);
        return arr ? list : list[0];
    }
    const $a81154f2549cb822$var$MatchOptions = {
        includeMatches: false,
        findAllMatches: false,
        minMatchCharLength: 1
    };
    const $a81154f2549cb822$var$BasicOptions = {
        isCaseSensitive: false,
        includeScore: false,
        keys: [],
        shouldSort: true,
        sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
    };
    const $a81154f2549cb822$var$FuzzyOptions = {
        location: 0,
        threshold: 0.6,
        distance: 100
    };
    const $a81154f2549cb822$var$AdvancedOptions = {
        useExtendedSearch: false,
        getFn: $a81154f2549cb822$var$get,
        ignoreLocation: false,
        ignoreFieldNorm: false,
        fieldNormWeight: 1
    };
    var $a81154f2549cb822$var$Config = {
        ...$a81154f2549cb822$var$BasicOptions,
        ...$a81154f2549cb822$var$MatchOptions,
        ...$a81154f2549cb822$var$FuzzyOptions,
        ...$a81154f2549cb822$var$AdvancedOptions
    };
    const $a81154f2549cb822$var$SPACE = /[^ ]+/g;
    function $a81154f2549cb822$var$norm(weight = 1, mantissa = 3) {
        const cache = new Map();
        const m = Math.pow(10, mantissa);
        return {
            get (value) {
                const numTokens = value.match($a81154f2549cb822$var$SPACE).length;
                if (cache.has(numTokens)) return cache.get(numTokens);
                const norm = 1 / Math.pow(numTokens, 0.5 * weight);
                const n = parseFloat(Math.round(norm * m) / m);
                cache.set(numTokens, n);
                return n;
            },
            clear () {
                cache.clear();
            }
        };
    }
    class $a81154f2549cb822$var$FuseIndex {
        constructor({ getFn: getFn = $a81154f2549cb822$var$Config.getFn, fieldNormWeight: fieldNormWeight = $a81154f2549cb822$var$Config.fieldNormWeight } = {}){
            this.norm = $a81154f2549cb822$var$norm(fieldNormWeight, 3);
            this.getFn = getFn;
            this.isCreated = false;
            this.setIndexRecords();
        }
        setSources(docs = []) {
            this.docs = docs;
        }
        setIndexRecords(records = []) {
            this.records = records;
        }
        setKeys(keys = []) {
            this.keys = keys;
            this._keysMap = {};
            keys.forEach((key, idx)=>{
                this._keysMap[key.id] = idx;
            });
        }
        create() {
            if (this.isCreated || !this.docs.length) return;
            this.isCreated = true;
            if ($a81154f2549cb822$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
                this._addString(doc, docIndex);
            });
            else this.docs.forEach((doc, docIndex)=>{
                this._addObject(doc, docIndex);
            });
            this.norm.clear();
        }
        add(doc) {
            const idx = this.size();
            if ($a81154f2549cb822$var$isString(doc)) this._addString(doc, idx);
            else this._addObject(doc, idx);
        }
        removeAt(idx) {
            this.records.splice(idx, 1);
            for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
        }
        getValueForItemAtKeyId(item, keyId) {
            return item[this._keysMap[keyId]];
        }
        size() {
            return this.records.length;
        }
        _addString(doc, docIndex) {
            if (!$a81154f2549cb822$var$isDefined(doc) || $a81154f2549cb822$var$isBlank(doc)) return;
            let record = {
                v: doc,
                i: docIndex,
                n: this.norm.get(doc)
            };
            this.records.push(record);
        }
        _addObject(doc, docIndex) {
            let record = {
                i: docIndex,
                $: {}
            };
            this.keys.forEach((key, keyIndex)=>{
                let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
                if (!$a81154f2549cb822$var$isDefined(value)) return;
                if ($a81154f2549cb822$var$isArray(value)) {
                    let subRecords = [];
                    const stack = [
                        {
                            nestedArrIndex: -1,
                            value: value
                        }
                    ];
                    while(stack.length){
                        const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                        if (!$a81154f2549cb822$var$isDefined(value)) continue;
                        if ($a81154f2549cb822$var$isString(value) && !$a81154f2549cb822$var$isBlank(value)) {
                            let subRecord = {
                                v: value,
                                i: nestedArrIndex,
                                n: this.norm.get(value)
                            };
                            subRecords.push(subRecord);
                        } else if ($a81154f2549cb822$var$isArray(value)) value.forEach((item, k)=>{
                            stack.push({
                                nestedArrIndex: k,
                                value: item
                            });
                        });
                    }
                    record.$[keyIndex] = subRecords;
                } else if ($a81154f2549cb822$var$isString(value) && !$a81154f2549cb822$var$isBlank(value)) {
                    let subRecord = {
                        v: value,
                        n: this.norm.get(value)
                    };
                    record.$[keyIndex] = subRecord;
                }
            });
            this.records.push(record);
        }
        toJSON() {
            return {
                keys: this.keys,
                records: this.records
            };
        }
    }
    function $a81154f2549cb822$var$createIndex(keys, docs, { getFn: getFn = $a81154f2549cb822$var$Config.getFn, fieldNormWeight: fieldNormWeight = $a81154f2549cb822$var$Config.fieldNormWeight } = {}) {
        const myIndex = new $a81154f2549cb822$var$FuseIndex({
            getFn: getFn,
            fieldNormWeight: fieldNormWeight
        });
        myIndex.setKeys(keys.map($a81154f2549cb822$var$createKey));
        myIndex.setSources(docs);
        myIndex.create();
        return myIndex;
    }
    function $a81154f2549cb822$var$parseIndex(data, { getFn: getFn = $a81154f2549cb822$var$Config.getFn, fieldNormWeight: fieldNormWeight = $a81154f2549cb822$var$Config.fieldNormWeight } = {}) {
        const { keys: keys, records: records } = data;
        const myIndex = new $a81154f2549cb822$var$FuseIndex({
            getFn: getFn,
            fieldNormWeight: fieldNormWeight
        });
        myIndex.setKeys(keys);
        myIndex.setIndexRecords(records);
        return myIndex;
    }
    function $a81154f2549cb822$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $a81154f2549cb822$var$Config.distance, ignoreLocation: ignoreLocation = $a81154f2549cb822$var$Config.ignoreLocation } = {}) {
        const accuracy = errors / pattern.length;
        if (ignoreLocation) return accuracy;
        const proximity = Math.abs(expectedLocation - currentLocation);
        if (!distance) return proximity ? 1.0 : accuracy;
        return accuracy + proximity / distance;
    }
    function $a81154f2549cb822$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $a81154f2549cb822$var$Config.minMatchCharLength) {
        let indices = [];
        let start = -1;
        let end = -1;
        let i = 0;
        for(let len = matchmask.length; i < len; i += 1){
            let match = matchmask[i];
            if (match && start === -1) start = i;
            else if (!match && start !== -1) {
                end = i - 1;
                if (end - start + 1 >= minMatchCharLength) indices.push([
                    start,
                    end
                ]);
                start = -1;
            }
        }
        if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
            start,
            i - 1
        ]);
        return indices;
    }
    const $a81154f2549cb822$var$MAX_BITS = 32;
    function $a81154f2549cb822$var$search(text, pattern, patternAlphabet, { location: location = $a81154f2549cb822$var$Config.location, distance: distance = $a81154f2549cb822$var$Config.distance, threshold: threshold = $a81154f2549cb822$var$Config.threshold, findAllMatches: findAllMatches = $a81154f2549cb822$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $a81154f2549cb822$var$Config.minMatchCharLength, includeMatches: includeMatches = $a81154f2549cb822$var$Config.includeMatches, ignoreLocation: ignoreLocation = $a81154f2549cb822$var$Config.ignoreLocation } = {}) {
        if (pattern.length > $a81154f2549cb822$var$MAX_BITS) throw new Error($a81154f2549cb822$var$PATTERN_LENGTH_TOO_LARGE($a81154f2549cb822$var$MAX_BITS));
        const patternLen = pattern.length;
        const textLen = text.length;
        const expectedLocation = Math.max(0, Math.min(location, textLen));
        let currentThreshold = threshold;
        let bestLocation = expectedLocation;
        const computeMatches = minMatchCharLength > 1 || includeMatches;
        const matchMask = computeMatches ? Array(textLen) : [];
        let index;
        while((index = text.indexOf(pattern, bestLocation)) > -1){
            let score = $a81154f2549cb822$var$computeScore$1(pattern, {
                currentLocation: index,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            currentThreshold = Math.min(score, currentThreshold);
            bestLocation = index + patternLen;
            if (computeMatches) {
                let i = 0;
                while(i < patternLen){
                    matchMask[index + i] = 1;
                    i += 1;
                }
            }
        }
        bestLocation = -1;
        let lastBitArr = [];
        let finalScore = 1;
        let binMax = patternLen + textLen;
        const mask = 1 << patternLen - 1;
        for(let i = 0; i < patternLen; i += 1){
            let binMin = 0;
            let binMid = binMax;
            while(binMin < binMid){
                const score = $a81154f2549cb822$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: expectedLocation + binMid,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                if (score <= currentThreshold) binMin = binMid;
                else binMax = binMid;
                binMid = Math.floor((binMax - binMin) / 2 + binMin);
            }
            binMax = binMid;
            let start = Math.max(1, expectedLocation - binMid + 1);
            let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
            let bitArr = Array(finish + 2);
            bitArr[finish + 1] = (1 << i) - 1;
            for(let j = finish; j >= start; j -= 1){
                let currentLocation = j - 1;
                let charMatch = patternAlphabet[text.charAt(currentLocation)];
                if (computeMatches) matchMask[currentLocation] = +!!charMatch;
                bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
                if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
                if (bitArr[j] & mask) {
                    finalScore = $a81154f2549cb822$var$computeScore$1(pattern, {
                        errors: i,
                        currentLocation: currentLocation,
                        expectedLocation: expectedLocation,
                        distance: distance,
                        ignoreLocation: ignoreLocation
                    });
                    if (finalScore <= currentThreshold) {
                        currentThreshold = finalScore;
                        bestLocation = currentLocation;
                        if (bestLocation <= expectedLocation) break;
                        start = Math.max(1, 2 * expectedLocation - bestLocation);
                    }
                }
            }
            const score = $a81154f2549cb822$var$computeScore$1(pattern, {
                errors: i + 1,
                currentLocation: expectedLocation,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score > currentThreshold) break;
            lastBitArr = bitArr;
        }
        const result = {
            isMatch: bestLocation >= 0,
            score: Math.max(0.001, finalScore)
        };
        if (computeMatches) {
            const indices = $a81154f2549cb822$var$convertMaskToIndices(matchMask, minMatchCharLength);
            if (!indices.length) result.isMatch = false;
            else if (includeMatches) result.indices = indices;
        }
        return result;
    }
    function $a81154f2549cb822$var$createPatternAlphabet(pattern) {
        let mask = {};
        for(let i = 0, len = pattern.length; i < len; i += 1){
            const char = pattern.charAt(i);
            mask[char] = (mask[char] || 0) | 1 << len - i - 1;
        }
        return mask;
    }
    class $a81154f2549cb822$var$BitapSearch {
        constructor(pattern, { location: location = $a81154f2549cb822$var$Config.location, threshold: threshold = $a81154f2549cb822$var$Config.threshold, distance: distance = $a81154f2549cb822$var$Config.distance, includeMatches: includeMatches = $a81154f2549cb822$var$Config.includeMatches, findAllMatches: findAllMatches = $a81154f2549cb822$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $a81154f2549cb822$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $a81154f2549cb822$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $a81154f2549cb822$var$Config.ignoreLocation } = {}){
            this.options = {
                location: location,
                threshold: threshold,
                distance: distance,
                includeMatches: includeMatches,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                isCaseSensitive: isCaseSensitive,
                ignoreLocation: ignoreLocation
            };
            this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
            this.chunks = [];
            if (!this.pattern.length) return;
            const addChunk = (pattern, startIndex)=>{
                this.chunks.push({
                    pattern: pattern,
                    alphabet: $a81154f2549cb822$var$createPatternAlphabet(pattern),
                    startIndex: startIndex
                });
            };
            const len = this.pattern.length;
            if (len > $a81154f2549cb822$var$MAX_BITS) {
                let i = 0;
                const remainder = len % $a81154f2549cb822$var$MAX_BITS;
                const end = len - remainder;
                while(i < end){
                    addChunk(this.pattern.substr(i, $a81154f2549cb822$var$MAX_BITS), i);
                    i += $a81154f2549cb822$var$MAX_BITS;
                }
                if (remainder) {
                    const startIndex = len - $a81154f2549cb822$var$MAX_BITS;
                    addChunk(this.pattern.substr(startIndex), startIndex);
                }
            } else addChunk(this.pattern, 0);
        }
        searchIn(text) {
            const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
            if (!isCaseSensitive) text = text.toLowerCase();
            if (this.pattern === text) {
                let result = {
                    isMatch: true,
                    score: 0
                };
                if (includeMatches) result.indices = [
                    [
                        0,
                        text.length - 1
                    ]
                ];
                return result;
            }
            const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
            let allIndices = [];
            let totalScore = 0;
            let hasMatches = false;
            this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
                const { isMatch: isMatch, score: score, indices: indices } = $a81154f2549cb822$var$search(text, pattern, alphabet, {
                    location: location + startIndex,
                    distance: distance,
                    threshold: threshold,
                    findAllMatches: findAllMatches,
                    minMatchCharLength: minMatchCharLength,
                    includeMatches: includeMatches,
                    ignoreLocation: ignoreLocation
                });
                if (isMatch) hasMatches = true;
                totalScore += score;
                if (isMatch && indices) allIndices = [
                    ...allIndices,
                    ...indices
                ];
            });
            let result = {
                isMatch: hasMatches,
                score: hasMatches ? totalScore / this.chunks.length : 1
            };
            if (hasMatches && includeMatches) result.indices = allIndices;
            return result;
        }
    }
    class $a81154f2549cb822$var$BaseMatch {
        constructor(pattern){
            this.pattern = pattern;
        }
        static isMultiMatch(pattern) {
            return $a81154f2549cb822$var$getMatch(pattern, this.multiRegex);
        }
        static isSingleMatch(pattern) {
            return $a81154f2549cb822$var$getMatch(pattern, this.singleRegex);
        }
        search() {}
    }
    function $a81154f2549cb822$var$getMatch(pattern, exp) {
        const matches = pattern.match(exp);
        return matches ? matches[1] : null;
    }
    class $a81154f2549cb822$var$ExactMatch extends $a81154f2549cb822$var$BaseMatch {
        constructor(pattern){
            super(pattern);
        }
        static get type() {
            return 'exact';
        }
        static get multiRegex() {
            return /^="(.*)"$/;
        }
        static get singleRegex() {
            return /^=(.*)$/;
        }
        search(text) {
            const isMatch = text === this.pattern;
            return {
                isMatch: isMatch,
                score: isMatch ? 0 : 1,
                indices: [
                    0,
                    this.pattern.length - 1
                ]
            };
        }
    }
    class $a81154f2549cb822$var$InverseExactMatch extends $a81154f2549cb822$var$BaseMatch {
        constructor(pattern){
            super(pattern);
        }
        static get type() {
            return 'inverse-exact';
        }
        static get multiRegex() {
            return /^!"(.*)"$/;
        }
        static get singleRegex() {
            return /^!(.*)$/;
        }
        search(text) {
            const index = text.indexOf(this.pattern);
            const isMatch = index === -1;
            return {
                isMatch: isMatch,
                score: isMatch ? 0 : 1,
                indices: [
                    0,
                    text.length - 1
                ]
            };
        }
    }
    class $a81154f2549cb822$var$PrefixExactMatch extends $a81154f2549cb822$var$BaseMatch {
        constructor(pattern){
            super(pattern);
        }
        static get type() {
            return 'prefix-exact';
        }
        static get multiRegex() {
            return /^\^"(.*)"$/;
        }
        static get singleRegex() {
            return /^\^(.*)$/;
        }
        search(text) {
            const isMatch = text.startsWith(this.pattern);
            return {
                isMatch: isMatch,
                score: isMatch ? 0 : 1,
                indices: [
                    0,
                    this.pattern.length - 1
                ]
            };
        }
    }
    class $a81154f2549cb822$var$InversePrefixExactMatch extends $a81154f2549cb822$var$BaseMatch {
        constructor(pattern){
            super(pattern);
        }
        static get type() {
            return 'inverse-prefix-exact';
        }
        static get multiRegex() {
            return /^!\^"(.*)"$/;
        }
        static get singleRegex() {
            return /^!\^(.*)$/;
        }
        search(text) {
            const isMatch = !text.startsWith(this.pattern);
            return {
                isMatch: isMatch,
                score: isMatch ? 0 : 1,
                indices: [
                    0,
                    text.length - 1
                ]
            };
        }
    }
    class $a81154f2549cb822$var$SuffixExactMatch extends $a81154f2549cb822$var$BaseMatch {
        constructor(pattern){
            super(pattern);
        }
        static get type() {
            return 'suffix-exact';
        }
        static get multiRegex() {
            return /^"(.*)"\$$/;
        }
        static get singleRegex() {
            return /^(.*)\$$/;
        }
        search(text) {
            const isMatch = text.endsWith(this.pattern);
            return {
                isMatch: isMatch,
                score: isMatch ? 0 : 1,
                indices: [
                    text.length - this.pattern.length,
                    text.length - 1
                ]
            };
        }
    }
    class $a81154f2549cb822$var$InverseSuffixExactMatch extends $a81154f2549cb822$var$BaseMatch {
        constructor(pattern){
            super(pattern);
        }
        static get type() {
            return 'inverse-suffix-exact';
        }
        static get multiRegex() {
            return /^!"(.*)"\$$/;
        }
        static get singleRegex() {
            return /^!(.*)\$$/;
        }
        search(text) {
            const isMatch = !text.endsWith(this.pattern);
            return {
                isMatch: isMatch,
                score: isMatch ? 0 : 1,
                indices: [
                    0,
                    text.length - 1
                ]
            };
        }
    }
    class $a81154f2549cb822$var$FuzzyMatch extends $a81154f2549cb822$var$BaseMatch {
        constructor(pattern, { location: location = $a81154f2549cb822$var$Config.location, threshold: threshold = $a81154f2549cb822$var$Config.threshold, distance: distance = $a81154f2549cb822$var$Config.distance, includeMatches: includeMatches = $a81154f2549cb822$var$Config.includeMatches, findAllMatches: findAllMatches = $a81154f2549cb822$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $a81154f2549cb822$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $a81154f2549cb822$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $a81154f2549cb822$var$Config.ignoreLocation } = {}){
            super(pattern);
            this._bitapSearch = new $a81154f2549cb822$var$BitapSearch(pattern, {
                location: location,
                threshold: threshold,
                distance: distance,
                includeMatches: includeMatches,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                isCaseSensitive: isCaseSensitive,
                ignoreLocation: ignoreLocation
            });
        }
        static get type() {
            return 'fuzzy';
        }
        static get multiRegex() {
            return /^"(.*)"$/;
        }
        static get singleRegex() {
            return /^(.*)$/;
        }
        search(text) {
            return this._bitapSearch.searchIn(text);
        }
    }
    class $a81154f2549cb822$var$IncludeMatch extends $a81154f2549cb822$var$BaseMatch {
        constructor(pattern){
            super(pattern);
        }
        static get type() {
            return 'include';
        }
        static get multiRegex() {
            return /^'"(.*)"$/;
        }
        static get singleRegex() {
            return /^'(.*)$/;
        }
        search(text) {
            let location = 0;
            let index;
            const indices = [];
            const patternLen = this.pattern.length;
            while((index = text.indexOf(this.pattern, location)) > -1){
                location = index + patternLen;
                indices.push([
                    index,
                    location - 1
                ]);
            }
            const isMatch = !!indices.length;
            return {
                isMatch: isMatch,
                score: isMatch ? 0 : 1,
                indices: indices
            };
        }
    }
    const $a81154f2549cb822$var$searchers = [
        $a81154f2549cb822$var$ExactMatch,
        $a81154f2549cb822$var$IncludeMatch,
        $a81154f2549cb822$var$PrefixExactMatch,
        $a81154f2549cb822$var$InversePrefixExactMatch,
        $a81154f2549cb822$var$InverseSuffixExactMatch,
        $a81154f2549cb822$var$SuffixExactMatch,
        $a81154f2549cb822$var$InverseExactMatch,
        $a81154f2549cb822$var$FuzzyMatch
    ];
    const $a81154f2549cb822$var$searchersLen = $a81154f2549cb822$var$searchers.length;
    const $a81154f2549cb822$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
    const $a81154f2549cb822$var$OR_TOKEN = '|';
    function $a81154f2549cb822$var$parseQuery(pattern, options = {}) {
        return pattern.split($a81154f2549cb822$var$OR_TOKEN).map((item)=>{
            let query = item.trim().split($a81154f2549cb822$var$SPACE_RE).filter((item)=>item && !!item.trim());
            let results = [];
            for(let i = 0, len = query.length; i < len; i += 1){
                const queryItem = query[i];
                let found = false;
                let idx = -1;
                while(!found && ++idx < $a81154f2549cb822$var$searchersLen){
                    const searcher = $a81154f2549cb822$var$searchers[idx];
                    let token = searcher.isMultiMatch(queryItem);
                    if (token) {
                        results.push(new searcher(token, options));
                        found = true;
                    }
                }
                if (found) continue;
                idx = -1;
                while(++idx < $a81154f2549cb822$var$searchersLen){
                    const searcher = $a81154f2549cb822$var$searchers[idx];
                    let token = searcher.isSingleMatch(queryItem);
                    if (token) {
                        results.push(new searcher(token, options));
                        break;
                    }
                }
            }
            return results;
        });
    }
    const $a81154f2549cb822$var$MultiMatchSet = new Set([
        $a81154f2549cb822$var$FuzzyMatch.type,
        $a81154f2549cb822$var$IncludeMatch.type
    ]);
    class $a81154f2549cb822$var$ExtendedSearch {
        constructor(pattern, { isCaseSensitive: isCaseSensitive = $a81154f2549cb822$var$Config.isCaseSensitive, includeMatches: includeMatches = $a81154f2549cb822$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $a81154f2549cb822$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $a81154f2549cb822$var$Config.ignoreLocation, findAllMatches: findAllMatches = $a81154f2549cb822$var$Config.findAllMatches, location: location = $a81154f2549cb822$var$Config.location, threshold: threshold = $a81154f2549cb822$var$Config.threshold, distance: distance = $a81154f2549cb822$var$Config.distance } = {}){
            this.query = null;
            this.options = {
                isCaseSensitive: isCaseSensitive,
                includeMatches: includeMatches,
                minMatchCharLength: minMatchCharLength,
                findAllMatches: findAllMatches,
                ignoreLocation: ignoreLocation,
                location: location,
                threshold: threshold,
                distance: distance
            };
            this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
            this.query = $a81154f2549cb822$var$parseQuery(this.pattern, this.options);
        }
        static condition(_, options) {
            return options.useExtendedSearch;
        }
        searchIn(text) {
            const query = this.query;
            if (!query) return {
                isMatch: false,
                score: 1
            };
            const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
            text = isCaseSensitive ? text : text.toLowerCase();
            let numMatches = 0;
            let allIndices = [];
            let totalScore = 0;
            for(let i = 0, qLen = query.length; i < qLen; i += 1){
                const searchers = query[i];
                allIndices.length = 0;
                numMatches = 0;
                for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                    const searcher = searchers[j];
                    const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                    if (isMatch) {
                        numMatches += 1;
                        totalScore += score;
                        if (includeMatches) {
                            const type = searcher.constructor.type;
                            if ($a81154f2549cb822$var$MultiMatchSet.has(type)) allIndices = [
                                ...allIndices,
                                ...indices
                            ];
                            else allIndices.push(indices);
                        }
                    } else {
                        totalScore = 0;
                        numMatches = 0;
                        allIndices.length = 0;
                        break;
                    }
                }
                if (numMatches) {
                    let result = {
                        isMatch: true,
                        score: totalScore / numMatches
                    };
                    if (includeMatches) result.indices = allIndices;
                    return result;
                }
            }
            return {
                isMatch: false,
                score: 1
            };
        }
    }
    const $a81154f2549cb822$var$registeredSearchers = [];
    function $a81154f2549cb822$var$register(...args) {
        $a81154f2549cb822$var$registeredSearchers.push(...args);
    }
    function $a81154f2549cb822$var$createSearcher(pattern, options) {
        for(let i = 0, len = $a81154f2549cb822$var$registeredSearchers.length; i < len; i += 1){
            let searcherClass = $a81154f2549cb822$var$registeredSearchers[i];
            if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
        }
        return new $a81154f2549cb822$var$BitapSearch(pattern, options);
    }
    const $a81154f2549cb822$var$LogicalOperator = {
        AND: '$and',
        OR: '$or'
    };
    const $a81154f2549cb822$var$KeyType = {
        PATH: '$path',
        PATTERN: '$val'
    };
    const $a81154f2549cb822$var$isExpression = (query)=>!!(query[$a81154f2549cb822$var$LogicalOperator.AND] || query[$a81154f2549cb822$var$LogicalOperator.OR]);
    const $a81154f2549cb822$var$isPath = (query)=>!!query[$a81154f2549cb822$var$KeyType.PATH];
    const $a81154f2549cb822$var$isLeaf = (query)=>!$a81154f2549cb822$var$isArray(query) && $a81154f2549cb822$var$isObject(query) && !$a81154f2549cb822$var$isExpression(query);
    const $a81154f2549cb822$var$convertToExplicit = (query)=>({
            [$a81154f2549cb822$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                    [key]: query[key]
                }))
        });
    function $a81154f2549cb822$var$parse(query, options, { auto: auto = true } = {}) {
        const next = (query)=>{
            let keys = Object.keys(query);
            const isQueryPath = $a81154f2549cb822$var$isPath(query);
            if (!isQueryPath && keys.length > 1 && !$a81154f2549cb822$var$isExpression(query)) return next($a81154f2549cb822$var$convertToExplicit(query));
            if ($a81154f2549cb822$var$isLeaf(query)) {
                const key = isQueryPath ? query[$a81154f2549cb822$var$KeyType.PATH] : keys[0];
                const pattern = isQueryPath ? query[$a81154f2549cb822$var$KeyType.PATTERN] : query[key];
                if (!$a81154f2549cb822$var$isString(pattern)) throw new Error($a81154f2549cb822$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
                const obj = {
                    keyId: $a81154f2549cb822$var$createKeyId(key),
                    pattern: pattern
                };
                if (auto) obj.searcher = $a81154f2549cb822$var$createSearcher(pattern, options);
                return obj;
            }
            let node = {
                children: [],
                operator: keys[0]
            };
            keys.forEach((key)=>{
                const value = query[key];
                if ($a81154f2549cb822$var$isArray(value)) value.forEach((item)=>{
                    node.children.push(next(item));
                });
            });
            return node;
        };
        if (!$a81154f2549cb822$var$isExpression(query)) query = $a81154f2549cb822$var$convertToExplicit(query);
        return next(query);
    }
    function $a81154f2549cb822$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $a81154f2549cb822$var$Config.ignoreFieldNorm }) {
        results.forEach((result)=>{
            let totalScore = 1;
            result.matches.forEach(({ key: key, norm: norm, score: score })=>{
                const weight = key ? key.weight : null;
                totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
            });
            result.score = totalScore;
        });
    }
    function $a81154f2549cb822$var$transformMatches(result, data) {
        const matches = result.matches;
        data.matches = [];
        if (!$a81154f2549cb822$var$isDefined(matches)) return;
        matches.forEach((match)=>{
            if (!$a81154f2549cb822$var$isDefined(match.indices) || !match.indices.length) return;
            const { indices: indices, value: value } = match;
            let obj = {
                indices: indices,
                value: value
            };
            if (match.key) obj.key = match.key.src;
            if (match.idx > -1) obj.refIndex = match.idx;
            data.matches.push(obj);
        });
    }
    function $a81154f2549cb822$var$transformScore(result, data) {
        data.score = result.score;
    }
    function $a81154f2549cb822$var$format(results, docs, { includeMatches: includeMatches = $a81154f2549cb822$var$Config.includeMatches, includeScore: includeScore = $a81154f2549cb822$var$Config.includeScore } = {}) {
        const transformers = [];
        if (includeMatches) transformers.push($a81154f2549cb822$var$transformMatches);
        if (includeScore) transformers.push($a81154f2549cb822$var$transformScore);
        return results.map((result)=>{
            const { idx: idx } = result;
            const data = {
                item: docs[idx],
                refIndex: idx
            };
            if (transformers.length) transformers.forEach((transformer)=>{
                transformer(result, data);
            });
            return data;
        });
    }
    class $a81154f2549cb822$export$2e2bcd8739ae039 {
        constructor(docs, options = {}, index){
            this.options = {
                ...$a81154f2549cb822$var$Config,
                ...options
            };
            this.options.useExtendedSearch;
            this._keyStore = new $a81154f2549cb822$var$KeyStore(this.options.keys);
            this.setCollection(docs, index);
        }
        setCollection(docs, index) {
            this._docs = docs;
            if (index && !(index instanceof $a81154f2549cb822$var$FuseIndex)) throw new Error($a81154f2549cb822$var$INCORRECT_INDEX_TYPE);
            this._myIndex = index || $a81154f2549cb822$var$createIndex(this.options.keys, this._docs, {
                getFn: this.options.getFn,
                fieldNormWeight: this.options.fieldNormWeight
            });
        }
        add(doc) {
            if (!$a81154f2549cb822$var$isDefined(doc)) return;
            this._docs.push(doc);
            this._myIndex.add(doc);
        }
        remove(predicate = ()=>false) {
            const results = [];
            for(let i = 0, len = this._docs.length; i < len; i += 1){
                const doc = this._docs[i];
                if (predicate(doc, i)) {
                    this.removeAt(i);
                    i -= 1;
                    len -= 1;
                    results.push(doc);
                }
            }
            return results;
        }
        removeAt(idx) {
            this._docs.splice(idx, 1);
            this._myIndex.removeAt(idx);
        }
        getIndex() {
            return this._myIndex;
        }
        search(query, { limit: limit = -1 } = {}) {
            const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
            let results = $a81154f2549cb822$var$isString(query) ? $a81154f2549cb822$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
            $a81154f2549cb822$var$computeScore(results, {
                ignoreFieldNorm: ignoreFieldNorm
            });
            if (shouldSort) results.sort(sortFn);
            if ($a81154f2549cb822$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
            return $a81154f2549cb822$var$format(results, this._docs, {
                includeMatches: includeMatches,
                includeScore: includeScore
            });
        }
        _searchStringList(query) {
            const searcher = $a81154f2549cb822$var$createSearcher(query, this.options);
            const { records: records } = this._myIndex;
            const results = [];
            records.forEach(({ v: text, i: idx, n: norm })=>{
                if (!$a81154f2549cb822$var$isDefined(text)) return;
                const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                if (isMatch) results.push({
                    item: text,
                    idx: idx,
                    matches: [
                        {
                            score: score,
                            value: text,
                            norm: norm,
                            indices: indices
                        }
                    ]
                });
            });
            return results;
        }
        _searchLogical(query) {
            const expression = $a81154f2549cb822$var$parse(query, this.options);
            const evaluate = (node, item, idx)=>{
                if (!node.children) {
                    const { keyId: keyId, searcher: searcher } = node;
                    const matches = this._findMatches({
                        key: this._keyStore.get(keyId),
                        value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                        searcher: searcher
                    });
                    if (matches && matches.length) return [
                        {
                            idx: idx,
                            item: item,
                            matches: matches
                        }
                    ];
                    return [];
                }
                const res = [];
                for(let i = 0, len = node.children.length; i < len; i += 1){
                    const child = node.children[i];
                    const result = evaluate(child, item, idx);
                    if (result.length) res.push(...result);
                    else if (node.operator === $a81154f2549cb822$var$LogicalOperator.AND) return [];
                }
                return res;
            };
            const records = this._myIndex.records;
            const resultMap = {};
            const results = [];
            records.forEach(({ $: item, i: idx })=>{
                if ($a81154f2549cb822$var$isDefined(item)) {
                    let expResults = evaluate(expression, item, idx);
                    if (expResults.length) {
                        if (!resultMap[idx]) {
                            resultMap[idx] = {
                                idx: idx,
                                item: item,
                                matches: []
                            };
                            results.push(resultMap[idx]);
                        }
                        expResults.forEach(({ matches: matches })=>{
                            resultMap[idx].matches.push(...matches);
                        });
                    }
                }
            });
            return results;
        }
        _searchObjectList(query) {
            const searcher = $a81154f2549cb822$var$createSearcher(query, this.options);
            const { keys: keys, records: records } = this._myIndex;
            const results = [];
            records.forEach(({ $: item, i: idx })=>{
                if (!$a81154f2549cb822$var$isDefined(item)) return;
                let matches = [];
                keys.forEach((key, keyIndex)=>{
                    matches.push(...this._findMatches({
                        key: key,
                        value: item[keyIndex],
                        searcher: searcher
                    }));
                });
                if (matches.length) results.push({
                    idx: idx,
                    item: item,
                    matches: matches
                });
            });
            return results;
        }
        _findMatches({ key: key, value: value, searcher: searcher }) {
            if (!$a81154f2549cb822$var$isDefined(value)) return [];
            let matches = [];
            if ($a81154f2549cb822$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
                if (!$a81154f2549cb822$var$isDefined(text)) return;
                const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                if (isMatch) matches.push({
                    score: score,
                    key: key,
                    value: text,
                    idx: idx,
                    norm: norm,
                    indices: indices
                });
            });
            else {
                const { v: text, n: norm } = value;
                const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                if (isMatch) matches.push({
                    score: score,
                    key: key,
                    value: text,
                    norm: norm,
                    indices: indices
                });
            }
            return matches;
        }
    }
    $a81154f2549cb822$export$2e2bcd8739ae039.version = '7.0.0';
    $a81154f2549cb822$export$2e2bcd8739ae039.createIndex = $a81154f2549cb822$var$createIndex;
    $a81154f2549cb822$export$2e2bcd8739ae039.parseIndex = $a81154f2549cb822$var$parseIndex;
    $a81154f2549cb822$export$2e2bcd8739ae039.config = $a81154f2549cb822$var$Config;
    $a81154f2549cb822$export$2e2bcd8739ae039.parseQuery = $a81154f2549cb822$var$parse;
    $a81154f2549cb822$var$register($a81154f2549cb822$var$ExtendedSearch);
});
parcelRegister("7WupW", function(module, exports) {
    $parcel$export(module.exports, "FUSE_SEARCH_OPTIONS", ()=>$38319215347bd0bc$export$833d69a1b36f826e);
    var $gM5ou;
    const $38319215347bd0bc$export$833d69a1b36f826e = {
        threshold: 0.3,
        keys: [
            {
                name: 'shortcut',
                getFn: (command)=>(0, (0, parcelRequire("gM5ou")).removeShortcutSpecialCharacters)(command.shortcut ?? ''),
                weight: Math.pow(2, 6)
            },
            {
                name: 'name',
                weight: Math.pow(2, 5)
            },
            {
                name: 'searchKeywordsArray',
                weight: Math.pow(2, 2)
            },
            {
                name: 'sectionName',
                weight: Math.pow(2, 1)
            }
        ],
        includeScore: true,
        shouldSort: false,
        distance: 1000,
        ignoreFieldNorm: true
    };
});
parcelRegister("6dRZA", function(module, exports) {
    $parcel$export(module.exports, "useSearchableCommands", ()=>$1c92e65a4091d3c6$export$9fc7cf5dc38ed809);
    var $5uXOq = parcelRequire("5uXOq");
    var $jh7L9;
    var $d8lE2;
    const $1c92e65a4091d3c6$var$getSearchableChildrenCommands = (action)=>{
        if (action?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST && action.commands !== undefined) return action.commands;
        return [];
    };
    const $1c92e65a4091d3c6$export$9fc7cf5dc38ed809 = (commands)=>{
        const [{ sections: sections }] = (0, (0, parcelRequire("d8lE2")).useCommandPalette)();
        return (0, $5uXOq.useMemo)(()=>$1c92e65a4091d3c6$export$529e2322cf5eecf3(commands, sections), [
            commands,
            sections
        ]);
    };
    const $1c92e65a4091d3c6$var$getSectionName = (command, sectionMap)=>{
        const sectionId = command.section ?? '';
        const section = sectionMap.get(sectionId);
        if (!section) return '';
        if (section.name) return section.name;
        const textContent = (elem)=>{
            if (!elem) return '';
            if (typeof elem === 'string') return elem;
            const children = elem.props && elem.props.children;
            return children instanceof Array ? children.map(textContent).join('') : textContent(children);
        };
        return textContent(section.renderName?.() ?? '');
    };
    const $1c92e65a4091d3c6$export$529e2322cf5eecf3 = (commands, sections)=>{
        const sectionMap = new Map(sections.flatMap((section)=>Object.entries(section)));
        const findCommands = (currentCommands, depth = 1)=>{
            const allCommands = [];
            const commandsToPrepare = currentCommands;
            commandsToPrepare.forEach((command)=>{
                allCommands.push({
                    ...command,
                    searchKeywordsArray: command.keywords?.split(' ') ?? [],
                    sectionName: $1c92e65a4091d3c6$var$getSectionName(command, sectionMap)
                });
                const searchableChildren = [];
                const searchablePrimaryChildren = $1c92e65a4091d3c6$var$getSearchableChildrenCommands(command.primaryAction);
                const searchableSecondaryChildren = $1c92e65a4091d3c6$var$getSearchableChildrenCommands(command.secondaryAction);
                if (depth < (0, $d867cba7ab775099$export$f1496885619d1f75) && searchablePrimaryChildren.length) searchableChildren.push(...findCommands(searchablePrimaryChildren, depth + 1));
                if (depth < (0, $d867cba7ab775099$export$f1496885619d1f75) && searchableSecondaryChildren.length) searchableChildren.push(...findCommands(searchableSecondaryChildren, depth + 1));
                searchableChildren.forEach((childCommand)=>{
                    const breadcrumb = [
                        command?.components?.Name || (()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, command.name))
                    ];
                    if (childCommand.breadcrumb?.length) breadcrumb.push(...childCommand.breadcrumb);
                    else breadcrumb.push(childCommand?.components?.Name || (()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, childCommand.name)));
                    const parentCommands = [
                        command
                    ];
                    if (childCommand.parentCommands?.length) parentCommands.push(...childCommand.parentCommands);
                    allCommands.push({
                        ...childCommand,
                        searchKeywordsArray: childCommand.keywords?.split(' ') ?? [],
                        section: command.section,
                        sectionName: $1c92e65a4091d3c6$var$getSectionName(command, sectionMap),
                        parentCommands: parentCommands,
                        breadcrumb: breadcrumb
                    });
                });
            });
            return allCommands;
        };
        return findCommands(commands);
    };
});
const $d867cba7ab775099$export$f1496885619d1f75 = 3;
parcelRegister("Nytob", function(module, exports) {
    $parcel$export(module.exports, "sortCommands", ()=>$19451497861c3205$export$e679a6aefb43ec97);
    const $19451497861c3205$var$getSectionOffset = (section)=>1 + (section.priority ?? 0) * (0, $6294646e4edfb139$export$af5cf775e0899047);
    const $19451497861c3205$export$e679a6aefb43ec97 = (commands, selectedSections)=>{
        const sortByPriority = (commandsToSort)=>commandsToSort.sort((a, b)=>(a.priority || 0) - (b.priority || 0));
        const sortedSections = Object.entries(selectedSections ?? {}).sort(([idA, valA], [idB, valB])=>{
            const aScore = Math.min(...commands.filter((command)=>command.section === idA).map((command)=>command.searchRelevancyScore ?? 1), 1) * $19451497861c3205$var$getSectionOffset(valA);
            const bScore = Math.min(...commands.filter((command)=>command.section === idB).map((command)=>command.searchRelevancyScore ?? 1), 1) * $19451497861c3205$var$getSectionOffset(valB);
            if (aScore !== bScore) return aScore - bScore;
            const priorityA = valA.priority || 0;
            const priorityB = valB.priority || 0;
            return priorityA - priorityB;
        });
        return sortByPriority(commands).sort((a, b)=>{
            if (a.section && !b.section) return 1;
            if (!a.section && b.section) return -1;
            if (a.section === b.section) return (a.searchRelevancyScore ?? 1) - (b.searchRelevancyScore ?? 1);
            return sortedSections.findIndex(([id])=>id === a.section) - sortedSections.findIndex(([id])=>id === b.section);
        });
    };
});
const $6294646e4edfb139$export$af5cf775e0899047 = 10e3;
parcelRegister("fChlq", function(module, exports) {
    $parcel$export(module.exports, "usePerformMode", ()=>$5ef8ac424e3864af$export$8d997d005eb1dc1c);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $gM5ou;
    var $d8lE2;
    const $5ef8ac424e3864af$export$8d997d005eb1dc1c = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry }, { executeCommand: executeCommand }] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteUsePerformModeState)();
        const hasLoadChildren = (0, (0, parcelRequire("gM5ou")).hasChildren)(expandedCommand);
        const selectedCommands = (0, $5uXOq.useMemo)(()=>hasLoadChildren ? childResult?.commands || [] : commands, [
            hasLoadChildren,
            childResult?.commands,
            commands
        ]);
        const foundCommand = (0, $5uXOq.useMemo)(()=>selectedCommands.find((command)=>command.mode && command.mode === search), [
            search,
            selectedCommands
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (foundCommand) executeCommand(foundCommand, {
                method: 'mode',
                createAnalyticsEvent: createAnalyticsEvent,
                attributes: (0, (0, parcelRequire("gM5ou")).getRegistryData)(registry, activeRegistry, foundCommand.id)
            });
        }, [
            executeCommand,
            createAnalyticsEvent,
            registry,
            activeRegistry,
            foundCommand
        ]);
    };
});
parcelRegister("bgJTS", function(module, exports) {
    $parcel$export(module.exports, "usePerformPendingCommandOnClose", ()=>$5e8be564573a780a$export$25863b30ab942012);
    var $5uXOq = parcelRequire("5uXOq");
    var $d8lE2;
    const $5e8be564573a780a$export$25863b30ab942012 = ()=>{
        const { performDialogCloseCommand: performDialogCloseCommand } = (0, (0, parcelRequire("d8lE2")).useActionsCommandPalette)();
        (0, $5uXOq.useEffect)(()=>()=>{
                performDialogCloseCommand();
            }, [
            performDialogCloseCommand
        ]);
    };
});
parcelRegister("eNg6o", function(module, exports) {
    $parcel$export(module.exports, "CommandBodyErrorBoundary", ()=>$166e8aef33de4a1d$export$3f5cc8366a41f7db);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $d8lE2;
    const $166e8aef33de4a1d$export$3f5cc8366a41f7db = ({ teamName: teamName, attributes: attributes, fallback: fallback, children: children })=>{
        const [{ expandedCommand: expandedCommand }] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteExpandedCommand)();
        const [capturedError, setCapturedError] = (0, $5uXOq.useState)();
        const [prevExpandedCommand, setPrevExpandedCommand] = (0, $5uXOq.useState)(expandedCommand);
        const [hasReset, setHasReset] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (hasReset) {
                setCapturedError(undefined);
                setHasReset(false);
            }
        }, [
            hasReset
        ]);
        const onRetry = (0, $5uXOq.useCallback)(()=>{
            setHasReset(true);
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (capturedError && !hasReset && prevExpandedCommand !== expandedCommand) onRetry();
            setPrevExpandedCommand(expandedCommand);
        }, [
            capturedError,
            expandedCommand,
            hasReset,
            onRetry,
            prevExpandedCommand
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "command.body",
            packageName: "jiraCommandPalette",
            teamName: teamName || 'deliveroo',
            attributes: attributes,
            onError: (_location, error)=>{
                setCapturedError(error);
            },
            fallback: fallback || 'unmount',
            resetCaughtError: hasReset ? capturedError : undefined
        }, children);
    };
});
parcelRegister("3OYpW", function(module, exports) {
    $parcel$export(module.exports, "Body", ()=>$fd9cdbb5a5f5b9d9$export$4b2c32e08f77ff18);
    var $5uXOq = parcelRequire("5uXOq");
    var $jiSaf;
    var $4DwnT;
    var $d8lE2;
    const $fd9cdbb5a5f5b9d9$export$4b2c32e08f77ff18 = ({ fallback: fallback, results: results, total: total, renderAfterCommands: renderAfterCommands })=>{
        const [{ expandedCommand: expandedCommand }, { setChildCommands: setChildCommands, setLoadingList: setLoadingList, setFallbackOverride: setFallbackOverride }] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteExpandedCommand)();
        const ExpandedBody = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("4DwnT")).getActiveCommandList)(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.components?.Body || (0, (0, parcelRequire("jiSaf")).components).Body, [
            expandedCommand
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(ExpandedBody, {
            setChildResult: setChildCommands,
            setLoading: setLoadingList,
            fallback: fallback,
            results: results,
            total: total,
            renderAfterCommands: renderAfterCommands,
            setFallbackOverride: setFallbackOverride
        });
    };
});
const $621e16c24c54300b$export$3545956e927a0d0a = 'command-palette.ui.modal.modal-content.no-results-container';
parcelRegister("2mlNs", function(module, exports) {
    $parcel$export(module.exports, "Footer", ()=>$5aa3d4736d044264$export$a06f1c675e846f6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $jiSaf;
    const $5aa3d4736d044264$export$a06f1c675e846f6f = (props)=>{
        const { activeCommand: activeCommand, ...rest } = props;
        const FooterComponent = activeCommand?.components?.Footer || (0, (0, parcelRequire("jiSaf")).components).Footer;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(FooterComponent, rest);
    };
});
parcelRegister("5c7Xb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b96539c7f2e0676$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lFKmC = parcelRequire("lFKmC");
    var $2NMNM;
    var $fVnbM;
    var $a88oa;
    var $tvuR8;
    var $eZJjh;
    var $3bDjY;
    var $4R6GH;
    var $koVbs;
    var $bcTvL;
    var $1mjMH;
    var $jiSaf;
    var $dzeHJ;
    var $gM5ou;
    var $4DwnT;
    var $d8lE2;
    var $1fSPc;
    const $7b96539c7f2e0676$export$8b251419efc915eb = ({ defaultAriaLabel: defaultAriaLabel, defaultPlaceholder: defaultPlaceholder, results: results, activeCommand: activeCommand })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ search: search, forceSearchFocus: forceSearchFocus, isOpen: isOpen, expandedCommand: expandedCommand, activeIndex: activeIndex, loadingList: loadingList, onAnalytics: onAnalytics, registry: registry, activeRegistry: activeRegistry }, { handleSearch: handleSearch, goBackLevel: goBackLevel, forceFocusSearch: forceFocusSearch, executeCommand: executeCommand, setFocusInput: setFocusInput }] = (0, (0, parcelRequire("d8lE2")).useCommandPalette)();
        const textFieldRef = (0, $5uXOq.useRef)();
        const onFocusInput = (isFocused)=>()=>{
                setFocusInput(isFocused);
            };
        const onInputKeyPress = (0, $5uXOq.useCallback)((event)=>{
            if (event.key === 'Backspace' && search === '') goBackLevel(false, {
                createAnalyticsEvent: createAnalyticsEvent,
                method: 'keyboard'
            });
            if (event.key === 'Enter') {
                event.preventDefault();
                const listed = results.find((result)=>!result.isGroup && result.index === activeIndex);
                if (listed) executeCommand(listed.command, {
                    method: 'keyboard',
                    createAnalyticsEvent: createAnalyticsEvent,
                    attributes: {
                        ...(0, (0, parcelRequire("gM5ou")).getAnalyticsAttributesFromResult)(listed),
                        ...(0, (0, parcelRequire("gM5ou")).getRegistryData)(registry, activeRegistry, listed.command.id)
                    }
                }, (0, (0, parcelRequire("gM5ou")).isSecondaryTrigger)(event));
            }
        }, [
            search,
            goBackLevel,
            createAnalyticsEvent,
            results,
            activeIndex,
            executeCommand,
            registry,
            activeRegistry
        ]);
        const onTypeAnalytics = (0, $5uXOq.useCallback)((query)=>{
            if (onAnalytics && createAnalyticsEvent) {
                const event = createAnalyticsEvent({});
                onAnalytics(event, (0, (0, parcelRequire("bcTvL")).TRACK_EVENT_TYPE), {
                    action: 'entered',
                    actionSubject: 'text',
                    actionSubjectId: 'commandPaletteSearch',
                    attributes: {
                        wordCount: (0, (0, parcelRequire("gM5ou")).getWordCount)(query),
                        queryLength: query.length,
                        queryHash: (0, (0, parcelRequire("gM5ou")).getQueryHash)(query),
                        queryVersion: -1
                    }
                });
            }
        }, [
            createAnalyticsEvent,
            onAnalytics
        ]);
        const onTypeAnalyticsDebounced = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($lFKmC)))(onTypeAnalytics, 400), [
            onTypeAnalytics
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                onTypeAnalyticsDebounced?.cancel?.();
            }, [
            onTypeAnalyticsDebounced
        ]);
        const onTypeSearch = (0, $5uXOq.useCallback)((ev)=>{
            const searchValue = ev.target.value;
            handleSearch(searchValue);
            onTypeAnalyticsDebounced(searchValue);
        }, [
            handleSearch,
            onTypeAnalyticsDebounced
        ]);
        const handleBackButton = (0, $5uXOq.useCallback)(()=>{
            goBackLevel(false, {
                createAnalyticsEvent: createAnalyticsEvent,
                method: 'mouse'
            });
        }, [
            createAnalyticsEvent,
            goBackLevel
        ]);
        if (!(0, (0, parcelRequire("4R6GH")).fg)('compal-ktlo-improvements-1')) (0, $5uXOq.useEffect)(()=>{
            if (textFieldRef.current && textFieldRef.current.value !== search) textFieldRef.current.value = search;
        }, [
            search
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (textFieldRef.current && forceSearchFocus) {
                textFieldRef.current.focus();
                forceFocusSearch(false);
            }
        }, [
            forceSearchFocus,
            forceFocusSearch
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isOpen && textFieldRef.current) textFieldRef.current.focus();
        }, [
            isOpen
        ]);
        const renderLozenge = (0, $5uXOq.useCallback)((command)=>{
            if (command.mode) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dzeHJ")).OutlinedLozenge), {
                key: command.id,
                "data-testid": (0, $9b53dd3a01dd0af4$export$a670752bd2308067)
            }, "\xa0", command.mode, "\xa0");
            const searchLozengeName = command.searchLozengeName || command.name;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dzeHJ")).SearchLozenge), {
                key: command.id,
                "data-testid": (0, $9b53dd3a01dd0af4$export$1bc358df5aba61fd)
            }, searchLozengeName);
        }, []);
        const elemBeforeInput = (0, $5uXOq.useMemo)(()=>{
            if (!expandedCommand) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("tvuR8"))))), {
                label: "",
                primaryColor: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N700})`
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement($7b96539c7f2e0676$var$ElemBeforeInputWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: formatMessage((0, (0, parcelRequire("1fSPc")).default).goBack)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($7b96539c7f2e0676$var$BackButton, {
                testId: (0, $9b53dd3a01dd0af4$export$69f261bc56a05f72),
                appearance: "subtle",
                onClick: handleBackButton
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("a88oa"))))), {
                size: "medium",
                label: formatMessage((0, (0, parcelRequire("1fSPc")).default).goBack),
                primaryColor: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N700})`
            }))), (0, ($parcel$interopDefault($5uXOq))).createElement($7b96539c7f2e0676$var$LozengeContainer, null, renderLozenge(expandedCommand)));
        }, [
            expandedCommand,
            formatMessage,
            handleBackButton,
            renderLozenge
        ]);
        const elemAfterInput = (0, $5uXOq.useMemo)(()=>{
            if (expandedCommand && loadingList) return (0, ($parcel$interopDefault($5uXOq))).createElement($7b96539c7f2e0676$var$SpinnerContainer, {
                "data-testid": (0, $9b53dd3a01dd0af4$export$b2afd57a1d4bc9e4)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: "small"
            }));
            return null;
        }, [
            expandedCommand,
            loadingList
        ]);
        const placeholder = (0, $5uXOq.useMemo)(()=>{
            if (expandedCommand) return expandedCommand.placeholder || expandedCommand.name;
            return defaultPlaceholder;
        }, [
            expandedCommand,
            defaultPlaceholder
        ]);
        const ModalHeader = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("4DwnT")).getActiveCommandList)(expandedCommand)?.components?.Header || (0, (0, parcelRequire("jiSaf")).components).Header, [
            expandedCommand
        ]);
        const ariaLabel = (0, $5uXOq.useMemo)(()=>{
            if (!expandedCommand && defaultAriaLabel) return defaultAriaLabel;
            return placeholder;
        }, [
            defaultAriaLabel,
            expandedCommand,
            placeholder
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(ModalHeader, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1mjMH")).CommandPaletteSearchInput), {
            ...(0, (0, parcelRequire("4R6GH")).fg)('aria_label_for_command_palette_search_input') ? {
                'aria-label': ariaLabel
            } : {
                'aria-label': placeholder
            },
            placeholder: placeholder,
            onKeyDown: onInputKeyPress,
            elemBeforeInput: elemBeforeInput,
            elemAfterInput: elemAfterInput,
            onChange: onTypeSearch,
            ref: textFieldRef,
            onFocus: onFocusInput(true),
            onBlur: onFocusInput(false),
            activeId: activeCommand?.id
        }));
    };
    var $7b96539c7f2e0676$export$2e2bcd8739ae039 = $7b96539c7f2e0676$export$8b251419efc915eb;
    const $7b96539c7f2e0676$var$BackButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsba982 _4t3ia982 _vwz4a982 _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _t7bl1lpd _4hh6hwed _1fyqhwed",
                __cmplp.className
            ])
        });
    });
    const $7b96539c7f2e0676$var$SpinnerContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1tcg",
                __cmplp.className
            ])
        });
    });
    const $7b96539c7f2e0676$var$ElemBeforeInputWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _zulp1b66",
                __cmplp.className
            ])
        });
    });
    const $7b96539c7f2e0676$var$LozengeContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1yb4 _zulp1b66 _2hwxv77o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("a88oa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
    function $7601289634e055f6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>$7601289634e055f6$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
        }, props, {
            newIcon: $7601289634e055f6$var$_chevronLeft.default,
            iconType: "utility"
        }));
    $7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
    var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;
});
parcelRegister("lRheX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fe9bebc953515e63$var$_UNSAFE_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $fe9bebc953515e63$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>$fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
            type: 'utility'
        }, props));
    $fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
    var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;
});
parcelRegister("1mjMH", function(module, exports) {
    $parcel$export(module.exports, "CommandPaletteSearchInput", ()=>$0b67d1fd6e1f08e8$export$1f98f66b42e34226);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hGgHi = parcelRequire("hGgHi");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $kY99m;
    var $4R6GH;
    var $d8lE2;
    const $0b67d1fd6e1f08e8$export$1f98f66b42e34226 = (0, $5uXOq.forwardRef)(({ activeId: activeId, ...rest }, ref)=>{
        const [{ shouldForceSearchValue: shouldForceSearchValue, search: search }, { resetShouldForceSearchValue: resetShouldForceSearchValue }] = (0, (0, parcelRequire("4R6GH")).fg)('compal-ktlo-improvements-1') ? (0, (0, parcelRequire("d8lE2")).useCommandPalette)() : [
            {
                shouldForceSearchValue: false,
                search: ''
            },
            {
                resetShouldForceSearchValue: (0, ($parcel$interopDefault($8Rkzz)))
            }
        ];
        if ((0, (0, parcelRequire("4R6GH")).fg)('compal-ktlo-improvements-1')) (0, $5uXOq.useEffect)(()=>{
            if (shouldForceSearchValue) resetShouldForceSearchValue();
        }, [
            resetShouldForceSearchValue,
            shouldForceSearchValue
        ]);
        const ariaProps = !(0, ($parcel$interopDefault($hGgHi)))(activeId) ? {
            'aria-expanded': true,
            'aria-controls': (0, $2350562822a34d03$export$9ffb4923f81813d9),
            role: 'combobox',
            ...(0, (0, parcelRequire("4R6GH")).fg)('compal_listbox_to_menu') ? {} : {
                'aria-activedescendant': `${0, $2350562822a34d03$export$b28d6b416aaf953a}-${activeId}`
            }
        } : {
            role: 'searchbox'
        };
        if ((0, (0, parcelRequire("4R6GH")).fg)('a11y_violations_fixes')) return (0, ($parcel$interopDefault($5uXOq))).createElement($0b67d1fd6e1f08e8$var$TextFieldStyle, {
            appearance: "none",
            testId: (0, $2350562822a34d03$export$d3cd230e107fbce),
            ref: ref,
            ...ariaProps,
            ...rest,
            ...shouldForceSearchValue ? {
                value: search
            } : {}
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement($0b67d1fd6e1f08e8$var$TextFieldStyle, {
            appearance: "none",
            testId: (0, $2350562822a34d03$export$d3cd230e107fbce),
            ref: ref,
            "aria-controls": (0, $2350562822a34d03$export$9ffb4923f81813d9),
            ...(0, (0, parcelRequire("4R6GH")).fg)('compal_listbox_to_menu') ? {} : {
                'aria-activedescendant': activeId !== undefined ? `${0, $2350562822a34d03$export$b28d6b416aaf953a}-${activeId}` : undefined
            },
            ...rest,
            ...shouldForceSearchValue ? {
                value: search
            } : {}
        });
    });
    const $0b67d1fd6e1f08e8$var$TextFieldStyle = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("kY99m")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1fxt _19itglyw _1yt4mqyj _swxz1doa _10wj1doa _v69yidpf _h61aidpf _1qtqidpf _1bayidpf _n9z41b66 _lmlq1b66 _pytkgktf _k2u0gktf _5ce61wmz _irr31r81",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kY99m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$509076ff0c6afa78$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $hbrbl;
    const $509076ff0c6afa78$var$analyticsParams = {
        componentName: 'textField',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $509076ff0c6afa78$var$Textfield = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
        const inputRef = (0, $5uXOq.useRef)(null);
        const handleOnFocus = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnBlur = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
            const target = event.target;
            if (target.tagName !== 'INPUT') event.preventDefault();
            if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
            onMouseDown && onMouseDown(event);
        }, [
            onMouseDown,
            isDisabled
        ]);
        const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
            inputRef.current = inputElement;
            if (!ref) return;
            if (typeof ref === 'object') ref.current = inputElement;
            if (typeof ref === 'function') ref(inputElement);
        }, [
            ref
        ]);
        const containerStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hbrbl")).containerStyles)(appearance, width), [
            appearance,
            width
        ]);
        const inputStyle = (0, (0, parcelRequire("hbrbl")).inputStyles)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "presentation",
            "data-disabled": isDisabled ? isDisabled : undefined,
            "data-invalid": isInvalid ? isInvalid : undefined,
            "data-ds--text-field--container": true,
            "data-testid": testId && `${testId}-container`,
            onMouseDown: handleOnMouseDown,
            css: containerStyles,
            className: className
        }, elemBeforeInput, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...spreadProps,
            "aria-invalid": isInvalid ? isInvalid : undefined,
            css: inputStyle,
            "data-compact": isCompact ? isCompact : undefined,
            "data-ds--text-field--input": true,
            "data-monospaced": isMonospaced ? isMonospaced : undefined,
            "data-testid": testId,
            disabled: isDisabled,
            name: name,
            onBlur: handleOnBlur,
            onChange: onChange,
            onFocus: handleOnFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: setInputRef,
            required: isRequired
        }), elemAfterInput));
    });
    var $509076ff0c6afa78$export$2e2bcd8739ae039 = $509076ff0c6afa78$var$Textfield;
});
parcelRegister("hbrbl", function(module, exports) {
    $parcel$export(module.exports, "containerStyles", ()=>$9b106cc21ace4b3b$export$5972a68b6e54f38f);
    $parcel$export(module.exports, "inputStyles", ()=>$9b106cc21ace4b3b$export$3eeb47dc8e6249d9);
    const $9b106cc21ace4b3b$var$backgroundColor = {
        standard: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorFocus = {
        standard: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        subtle: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorHover = {
        standard: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        subtle: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColor = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorFocus = {
        standard: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        subtle: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorHover = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: "var(--ds-border-input, transparent)",
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor = (appearance)=>({
            backgroundColor: $9b106cc21ace4b3b$var$backgroundColor[appearance],
            borderColor: $9b106cc21ace4b3b$var$borderColor[appearance],
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
            cursor: 'text',
            '&:hover:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorHover[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorHover[appearance]
            },
            '&:focus-within:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorFocus[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$9b106cc21ace4b3b$var$borderColorFocus[appearance]}`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                cursor: 'not-allowed',
                ...appearance === 'standard' && {
                    backgroundColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
                    borderColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`
                }
            },
            '&[data-invalid], &[data-invalid]:hover': {
                borderColor: `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`}`
            },
            '&[data-invalid]:focus-within': {
                backgroundColor: `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})`,
                borderColor: `var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`}`
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[data-invalid]:focus-within': {
                    borderColor: 'Highlight'
                },
                '&:focus-within': {
                    borderColor: 'Highlight'
                },
                '&[data-disabled]': {
                    borderColor: 'GrayText'
                }
            }
        });
    const $9b106cc21ace4b3b$var$widthMap = {
        xsmall: 80,
        small: 160,
        medium: 240,
        large: 320,
        xlarge: 480
    };
    const $9b106cc21ace4b3b$var$getMaxWidth = (width)=>!width ? `100%` : width in $9b106cc21ace4b3b$var$widthMap ? $9b106cc21ace4b3b$var$widthMap[width] : +width;
    const $9b106cc21ace4b3b$export$5972a68b6e54f38f = (appearance, width)=>({
            alignItems: 'center',
            ...$9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor(appearance),
            borderRadius: 3,
            borderWidth: "var(--ds-border-width, 1px)",
            ...appearance !== 'none' ? {
                padding: `${"var(--ds-border-width, 1px)"} 0`
            } : {},
            borderStyle: appearance === 'none' ? 'none' : 'solid',
            boxSizing: 'border-box',
            display: 'flex',
            flex: '1 1 100%',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            justifyContent: 'space-between',
            maxWidth: $9b106cc21ace4b3b$var$getMaxWidth(width),
            overflow: 'hidden',
            transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
            wordWrap: 'break-word',
            verticalAlign: 'top',
            pointerEvents: 'auto'
        });
    const $9b106cc21ace4b3b$export$3eeb47dc8e6249d9 = ()=>({
            backgroundColor: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            minWidth: '0',
            outline: 'none',
            width: '100%',
            '&[data-monospaced]': {
                fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
            },
            '&[data-compact]': {
                padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&:not([data-compact])': {
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&[disabled]': {
                WebkitTextFillColor: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
            },
            '&::-ms-clear': {
                display: 'none'
            },
            '&:invalid': {
                boxShadow: 'none'
            },
            '&:placeholder-shown': {
                textOverflow: 'ellipsis'
            },
            '&::placeholder': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                '&:disabled': {
                    color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
                }
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[disabled]': {
                    color: 'GrayText'
                }
            }
        });
});
const $9b53dd3a01dd0af4$export$d3cd230e107fbce = 'command-palette.ui.modal.header.search-input';
const $9b53dd3a01dd0af4$export$a670752bd2308067 = 'command-palette.ui.modal.header.command-mode';
const $9b53dd3a01dd0af4$export$69f261bc56a05f72 = 'command-palette.ui.modal.header.left-arrow';
const $9b53dd3a01dd0af4$export$b2afd57a1d4bc9e4 = 'command-palette.ui.modal.header.spinner-container';
const $9b53dd3a01dd0af4$export$1bc358df5aba61fd = 'command-palette.ui.modal.modal-content.header.search-lozenge';
parcelRegister("1fSPc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afdfeb0ffd4b2a56$export$2e2bcd8739ae039);
    var $7VHMR;
    var $afdfeb0ffd4b2a56$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        goBack: {
            "id": "command-palette.modal.modal-content.header.go-back",
            "defaultMessage": "Go back"
        }
    });
});
parcelRegister("5nIJM", function(module, exports) {
    $parcel$export(module.exports, "ScreenReaderContent", ()=>$e471ff516a544aad$export$d133a8e1226db0f3);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $koVbs;
    var $1XJ20;
    var $kw7jZ;
    var $d8lE2;
    var $j67DJ;
    const $e471ff516a544aad$export$d133a8e1226db0f3 = ({ activeCommand: activeCommand, results: results })=>{
        const [{ search: search, activeIndex: activeIndex }, { forceFocusSearch: forceFocusSearch }] = (0, (0, parcelRequire("d8lE2")).useCommandPalette)();
        const previousSearch = (0, (0, parcelRequire("1XJ20")).usePrevious)(search);
        const { getScreenReaderText: getScreenReaderText } = $e471ff516a544aad$export$a59db8e7afab3919();
        const [screenReaderText, setScreenReaderText] = (0, $5uXOq.useState)(null);
        const debouncedSetScreenReaderText = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($lFKmC)))(setScreenReaderText, 400), []);
        (0, $5uXOq.useEffect)(()=>()=>{
                debouncedSetScreenReaderText?.cancel?.();
            }, [
            debouncedSetScreenReaderText
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (previousSearch !== search) debouncedSetScreenReaderText(getScreenReaderText({
                activeCommand: activeCommand,
                results: results,
                activeIndex: activeIndex
            }));
        }, [
            activeCommand,
            getScreenReaderText,
            previousSearch,
            results,
            search,
            activeIndex,
            debouncedSetScreenReaderText
        ]);
        const onFocus = (0, $5uXOq.useCallback)(()=>{
            forceFocusSearch(true);
        }, [
            forceFocusSearch
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kw7jZ")).CommandPaletteScreenReaderContent), {
            "data-testid": "command-palette.ui.modal.modal-content.screen-reader-content.command-palette-screen-reader-content",
            onFocus: onFocus
        }, screenReaderText);
    };
    const $e471ff516a544aad$export$a59db8e7afab3919 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getScreenReaderText = ({ activeCommand: activeCommand, results: results, activeIndex: activeIndex })=>{
            if (!activeCommand) return null;
            const selectedOptionLabel = activeCommand?.name;
            const selectedIndex = activeIndex + 1;
            const totalSuggestions = results.filter((result)=>!result.isGroup).length;
            return formatMessage((0, (0, parcelRequire("j67DJ")).default).selectedOption, {
                selectedOptionLabel: selectedOptionLabel,
                selectedIndex: selectedIndex,
                totalSuggestions: totalSuggestions
            });
        };
        return {
            getScreenReaderText: getScreenReaderText
        };
    };
});
parcelRegister("kw7jZ", function(module, exports) {
    $parcel$export(module.exports, "CommandPaletteScreenReaderContent", ()=>$54eba072801bf4cc$export$ec21ebd320897134);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $54eba072801bf4cc$export$ec21ebd320897134 = ({ ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement($54eba072801bf4cc$var$ScreenReaderOnly, {
            "aria-live": "polite",
            "aria-atomic": "false",
            tabIndex: -1,
            ...props,
            id: (0, $2350562822a34d03$export$9e40a0642460a944)
        });
    const $54eba072801bf4cc$var$ScreenReaderOnly = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1bsbt94y _4t3it94y _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq _ogtocqaw _slp34jg8 _19itidpf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("j67DJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1bd2f3bb2588934c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1bd2f3bb2588934c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        selectedOption: {
            "id": "command-palette.modal.modal-content.screen-reader-content.selected-option",
            "defaultMessage": "{selectedOptionLabel}, selected, ({selectedIndex} of {totalSuggestions})"
        },
        selectedOptionWithSearch: {
            "id": "command-palette.modal.modal-content.screen-reader-content.selected-option-with-search",
            "defaultMessage": "{selectedOptionLabel}, selected, ({selectedIndex} of {totalSuggestions}) for {search}"
        }
    });
});
parcelRegister("aV3mV", function(module, exports) {
    $parcel$export(module.exports, "ModalWrapper", ()=>$065594b29b7f9be1$export$858bfd02c3f2fba5);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $4DwnT;
    var $d8lE2;
    const $065594b29b7f9be1$export$858bfd02c3f2fba5 = ({ children: children })=>{
        const [{ expandedCommand: expandedCommand }] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteExpandedCommand)();
        const Wrapper = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("4DwnT")).getActiveCommandList)(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.components?.Wrapper || (0, $5uXOq.Fragment), [
            expandedCommand
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($065594b29b7f9be1$var$ModalDialogWrapper, null, children));
    };
    const $065594b29b7f9be1$var$ModalDialogWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8r5cr _2rko7vkz _bfhk1bhr _16qs1e6u",
                __cmplp.className
            ])
        });
    });
});
const $896c010256263437$export$70d2130cb02f61fa = 'command-palette-integration.ui.container';
parcelRegister("ezMlR", function(module, exports) {
    $parcel$export(module.exports, "useCloseDotMenu", ()=>$707e8861343b9d8f$export$64ace3e915332feb);
    var $5uXOq = parcelRequire("5uXOq");
    var $d8lE2;
    var $2f2jJ;
    var $a0UwL;
    const $707e8861343b9d8f$export$64ace3e915332feb = ()=>{
        const [{ isShortcutsDialogVisible: isShortcutsDialogVisible }, { setShortcutsDialogVisibility: setShortcutsDialogVisibility }] = (0, (0, parcelRequire("a0UwL")).useShortcuts)();
        const [{ isOpen: isOpen }, { open: open }] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteIsOpen)();
        (0, $5uXOq.useEffect)(()=>{
            if (isOpen) return ()=>{};
            const handler = (ev)=>{
                const modifier = (0, (0, parcelRequire("2f2jJ")).isMacOs)() ? ev.metaKey : ev.ctrlKey;
                if (modifier && ev.key === 'k') {
                    const hasMonolithDotMenu = typeof JIRA !== 'undefined' && typeof JIRA?.Shifter?.dialog?.destroyed === 'function' && !JIRA?.Shifter?.dialog?.destroyed();
                    const dotOpen = isShortcutsDialogVisible || hasMonolithDotMenu;
                    if (!dotOpen) return;
                    if (isShortcutsDialogVisible) setShortcutsDialogVisibility(false);
                    if (hasMonolithDotMenu) JIRA.Shifter?.hide?.();
                    open();
                }
            };
            window.addEventListener('keydown', handler);
            return ()=>{
                window.removeEventListener('keydown', handler);
            };
        }, [
            isOpen,
            isShortcutsDialogVisible,
            open,
            setShortcutsDialogVisibility
        ]);
    };
});
parcelRegister("3oeAD", function(module, exports) {
    $parcel$export(module.exports, "useCompalBridge", ()=>$c76ba512e58a6b71$export$9e0258ef367c1984);
    var $5uXOq = parcelRequire("5uXOq");
    var $d8lE2;
    const $c76ba512e58a6b71$export$9e0258ef367c1984 = ()=>{
        const { open: open } = (0, (0, parcelRequire("d8lE2")).useActionsCommandPalette)();
        (0, $5uXOq.useEffect)(()=>{
            if (typeof window !== 'undefined') window.JIRA_COMPAL = {
                open: open
            };
            return ()=>{
                if (typeof window !== 'undefined') window.JIRA_COMPAL = undefined;
            };
        }, [
            open
        ]);
    };
});
parcelRegister("ht5ui", function(module, exports) {
    $parcel$export(module.exports, "useDisableCompalIfEmbed", ()=>$4545569469c3ab86$export$2b4e2f60c6063c36);
    var $5uXOq = parcelRequire("5uXOq");
    var $d8lE2;
    var $clHWF;
    const $4545569469c3ab86$export$2b4e2f60c6063c36 = ()=>{
        const { isEmbed: isEmbed } = (0, (0, parcelRequire("clHWF")).useIsEmbed)();
        const { setIsDisabled: setIsDisabled } = (0, (0, parcelRequire("d8lE2")).useActionsCommandPalette)();
        (0, $5uXOq.useEffect)(()=>{
            setIsDisabled(isEmbed);
        }, [
            isEmbed,
            setIsDisabled
        ]);
    };
});
parcelRegister("clHWF", function(module, exports) {
    $parcel$export(module.exports, "useIsEmbed", ()=>$9e75791e9a51e8c8$export$ce94463dec1ccebd);
    var $doZTA;
    const $9e75791e9a51e8c8$export$ce94463dec1ccebd = ()=>{
        const [{ location: { pathname: pathname } }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        if (pathname.endsWith('/embed')) return {
            isEmbed: true
        };
        return {
            isEmbed: false
        };
    };
});
parcelRegister("6ixD4", function(module, exports) {
    $parcel$export(module.exports, "useRegisterDismissCommand", ()=>$92e0506512f81009$export$ba1bbbf46b23917);
    var $5uXOq = parcelRequire("5uXOq");
    var $5p1kJ;
    var $d8lE2;
    var $8zOmE;
    var $2NMNM;
    var $gFHnq;
    const $92e0506512f81009$export$ba1bbbf46b23917 = ()=>{
        const [{ isOpen: isOpen }, { close: close }] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteIsOpen)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (!isOpen) return ()=>{};
            const dismissCommandPalette = (ev)=>{
                if (!(0, (0, parcelRequire("gFHnq")).isCommandPaletteTrigger)(ev)) return;
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent((0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_PRESSED_ANALYTICS)), (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_ID), {
                    key: 'k',
                    isDismissing: true
                });
                ev.preventDefault();
                close();
            };
            document.addEventListener('keydown', dismissCommandPalette);
            return ()=>{
                document.removeEventListener('keydown', dismissCommandPalette);
            };
        }, [
            close,
            createAnalyticsEvent,
            isOpen
        ]);
        return null;
    };
});
parcelRegister("gFHnq", function(module, exports) {
    $parcel$export(module.exports, "isCommandPaletteTrigger", ()=>$76605c8ea5774ab1$export$fdcbda728f65a22a);
    var $2f2jJ;
    const $76605c8ea5774ab1$export$fdcbda728f65a22a = (ev)=>{
        if (ev.key !== 'k') return false;
        if ((0, (0, parcelRequire("2f2jJ")).isMacOs)()) {
            if (!ev.metaKey) return false;
        } else if (!ev.ctrlKey) return false;
        return true;
    };
});
parcelRegister("kqiyM", function(module, exports) {
    $parcel$export(module.exports, "useRegisterSections", ()=>$21829c9b16b4c530$export$322b8dfd66fee25d);
    var $5uXOq = parcelRequire("5uXOq");
    var $5p1kJ;
    var $eC7F7;
    var $koVbs;
    var $9B2hh;
    const $21829c9b16b4c530$export$d67bb364b16506d = {
        [(0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).projectNavigation]: {
            message: (0, (0, parcelRequire("9B2hh")).messages).projectNavigationSection,
            priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS_PRIORITY).projectNavigation,
            actionCategory: 'projectNavigation'
        },
        [(0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).siteNavigation]: {
            message: (0, (0, parcelRequire("9B2hh")).messages).siteNavigationSection,
            priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS_PRIORITY).siteNavigation,
            actionCategory: 'siteNavigation'
        },
        [(0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).quickActions]: {
            message: (0, (0, parcelRequire("9B2hh")).messages).quickActionsSection,
            priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS_PRIORITY).quickActions,
            actionCategory: 'quickActions'
        },
        [(0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).personalSettings]: {
            message: (0, (0, parcelRequire("9B2hh")).messages).personalSettingsSection,
            priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS_PRIORITY).personalSettings,
            actionCategory: 'personalSettings'
        },
        [(0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).help]: {
            message: (0, (0, parcelRequire("9B2hh")).messages).helpSection,
            priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS_PRIORITY).help,
            actionCategory: 'help'
        },
        [(0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).jiraSettings]: {
            message: (0, (0, parcelRequire("9B2hh")).messages).jiraSettingsSection,
            priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS_PRIORITY).jiraSettings,
            actionCategory: 'jiraSettings'
        },
        [(0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).atlassianAdmin]: {
            message: (0, (0, parcelRequire("9B2hh")).messages).atlassianAdminSection,
            priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS_PRIORITY).atlassianAdmin,
            actionCategory: 'atlassianAdmin'
        },
        [(0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).quickSearch]: {
            message: (0, (0, parcelRequire("9B2hh")).messages).quickSearchSection,
            priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS_PRIORITY).quickSearch,
            actionCategory: 'quickSearch'
        }
    };
    const $21829c9b16b4c530$export$322b8dfd66fee25d = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const sections = (0, $5uXOq.useMemo)(()=>Object.entries($21829c9b16b4c530$export$d67bb364b16506d).reduce((acc, [key, entry])=>{
                acc[key] = {
                    name: formatMessage(entry.message),
                    priority: entry.priority,
                    actionCategory: entry.actionCategory
                };
                return acc;
            }, {}), [
            formatMessage
        ]);
        (0, (0, parcelRequire("eC7F7")).useRegisterCommandSections)(sections);
    };
});
parcelRegister("eC7F7", function(module, exports) {
    $parcel$export(module.exports, "useRegisterCommandSections", ()=>$8353d0ce7d354bfa$export$24e75e2bcad1489a);
    var $5uXOq = parcelRequire("5uXOq");
    var $d8lE2;
    const $8353d0ce7d354bfa$export$24e75e2bcad1489a = (sections, deps = [])=>{
        const { registerSections: registerSections, unregisterSections: unregisterSections } = (0, (0, parcelRequire("d8lE2")).useActionsCommandPalette)();
        const ids = Object.keys(sections);
        (0, $5uXOq.useEffect)(()=>{
            registerSections(sections);
            return ()=>{
                unregisterSections(sections);
            };
        }, [
            ...deps,
            registerSections,
            unregisterSections,
            ids.toString()
        ]);
    };
});
parcelRegister("9B2hh", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$586d67dad3dfd299$export$defe85febe8b728c);
    var $7VHMR;
    const $586d67dad3dfd299$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectNavigationSection: {
            "id": "command-palette-integration.controllers.use-register-sections.project-navigation-section",
            "defaultMessage": "Project navigation"
        },
        siteNavigationSection: {
            "id": "command-palette-integration.controllers.use-register-sections.site-navigation-section",
            "defaultMessage": "Site navigation"
        },
        quickActionsSection: {
            "id": "command-palette-integration.controllers.use-register-sections.quick-actions-section",
            "defaultMessage": "Quick actions"
        },
        personalSettingsSection: {
            "id": "command-palette-integration.controllers.use-register-sections.personal-settings-section",
            "defaultMessage": "Personal settings"
        },
        helpSection: {
            "id": "command-palette-integration.controllers.use-register-sections.help-section",
            "defaultMessage": "Help"
        },
        jiraSettingsSection: {
            "id": "command-palette-integration.controllers.use-register-sections.jira-settings-section",
            "defaultMessage": "Jira Settings"
        },
        atlassianAdminSection: {
            "id": "command-palette-integration.controllers.use-register-sections.atlassian-admin-section",
            "defaultMessage": "Atlassian admin"
        },
        quickSearchSection: {
            "id": "command-palette-integration.controllers.use-register-sections.quick-search-section",
            "defaultMessage": "Search work"
        }
    });
});
parcelRegister("30J2m", function(module, exports) {
    $parcel$export(module.exports, "FooterFeedbackContent", ()=>$11380617c82cbaf5$export$63ddf0170f2bf579);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $d8lE2;
    var $koVbs;
    var $8zOmE;
    var $fMS7c;
    var $aai1s;
    const $11380617c82cbaf5$export$63ddf0170f2bf579 = ()=>{
        const [openFeedbackCollectorDialog] = (0, (0, parcelRequire("fMS7c")).useCommandPaletteFeedbackCollector)();
        const { close: close } = (0, (0, parcelRequire("d8lE2")).useActionsCommandPalette)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($11380617c82cbaf5$var$FeedbackContentWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($11380617c82cbaf5$var$TextWrapper, null, " ", formatMessage((0, (0, parcelRequire("aai1s")).messages).feedbackContentText), " "), (0, ($parcel$interopDefault($5uXOq))).createElement($11380617c82cbaf5$var$FeedbackButton, {
            appearance: "subtle-link",
            testId: "command-palette-integration.ui.footer-feedback-content.feedback-button",
            onClick: (event, analyticsEvent)=>{
                close();
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'openCommandPaletteFeedbackForm');
                openFeedbackCollectorDialog();
            }
        }, formatMessage((0, (0, parcelRequire("aai1s")).messages).feedbackButtonText)));
    };
    const $11380617c82cbaf5$var$FeedbackContentWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _4cvr1h6o _11c8qk37 _1yt4h8dc _syaz1a45 _1bah1y6m _16ai1a45",
                __cmplp.className
            ])
        });
    });
    const $11380617c82cbaf5$var$TextWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c8qk37 _syaz1a45 _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $11380617c82cbaf5$var$FeedbackButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c8qk37 _4cvr1h6o _k48p1wq8 _18u0v77o _1yt41nxw _syaz1504 _4t3i1wug _vwz44jg8",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fMS7c", function(module, exports) {
    $parcel$export(module.exports, "useCommandPaletteFeedbackCollector", ()=>$2494c13edd81f2e7$export$6db0caae08144d99);
    var $5uXOq = parcelRequire("5uXOq");
    var $7iULw;
    var $dseDh;
    var $koVbs;
    var $aai1s;
    const $2494c13edd81f2e7$export$6db0caae08144d99 = ()=>{
        const { openFeedbackCollector: openFeedbackCollector, resetFeedbackCollectorState: resetFeedbackCollectorState } = (0, (0, parcelRequire("dseDh")).useFeedbackCollectorActions)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const openCommandPaletteFeedbackCollector = (0, $5uXOq.useCallback)((props)=>{
            openFeedbackCollector({
                entrypointId: (0, (0, parcelRequire("7iULw")).ENTRYPOINT_ID_JIRA_COMMAND_PALETTE),
                feedbackTitle: formatMessage((0, (0, parcelRequire("aai1s")).messages).feedbackTitle),
                ...props
            });
        }, [
            formatMessage,
            openFeedbackCollector
        ]);
        return [
            openCommandPaletteFeedbackCollector,
            resetFeedbackCollectorState
        ];
    };
});
parcelRegister("aai1s", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$78e02ca0c9823c33$export$defe85febe8b728c);
    var $7VHMR;
    const $78e02ca0c9823c33$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        feedbackTitle: {
            "id": "command-palette-integration.controllers.use-feedback-collector.feedback-title",
            "defaultMessage": "Share your thoughts"
        },
        feedbackButtonText: {
            "id": "command-palette-integration.controllers.use-feedback-collector.feedback-button-text",
            "defaultMessage": "Let us know"
        },
        feedbackContentText: {
            "id": "command-palette-integration.controllers.use-feedback-collector.feedback-content-text",
            "defaultMessage": "Got feedback?"
        }
    });
});
parcelRegister("faBOu", function(module, exports) {
    $parcel$export(module.exports, "useRegisterInitialCommands", ()=>$5c9653a49e3aeaec$export$c84e12da7f59adc);
    var $1Kt4o;
    var $5zCdk;
    var $lAw61;
    var $auYbh;
    var $gLlXj;
    const $5c9653a49e3aeaec$export$c84e12da7f59adc = ()=>{
        const copyCommand = (0, (0, parcelRequire("auYbh")).useCopyPageUrlCommand)();
        const navigationCommands = (0, (0, parcelRequire("gLlXj")).useNavigationCommands)();
        const { issueNavigatorLink: issueNavigatorLink } = (0, (0, parcelRequire("lAw61")).useIssueNavigatorLink)();
        (0, (0, parcelRequire("5zCdk")).useRegisterCommands)((0, (0, parcelRequire("1Kt4o")).COMMAND_PALETTE_REGISTRY_IDS).COPY_URL, [
            copyCommand
        ]);
        (0, (0, parcelRequire("5zCdk")).useRegisterCommands)((0, (0, parcelRequire("1Kt4o")).COMMAND_PALETTE_REGISTRY_IDS).NAVIGATION_COMMANDS, navigationCommands, [
            issueNavigatorLink
        ]);
    };
});
parcelRegister("5zCdk", function(module, exports) {
    $parcel$export(module.exports, "useRegisterCommands", ()=>$c2fc115f119fcec7$export$3f626f8a5dbc29e4);
    var $6QoIp;
    const $c2fc115f119fcec7$export$3f626f8a5dbc29e4 = (0, (0, parcelRequire("6QoIp")).useRegisterCommandsWithRegistry);
});
parcelRegister("6QoIp", function(module, exports) {
    $parcel$export(module.exports, "useRegisterCommandsWithRegistry", ()=>$9d04f6fb396fa7c9$export$8a824ae164ff968d);
    var $5uXOq = parcelRequire("5uXOq");
    var $fIZf0;
    function $9d04f6fb396fa7c9$export$8a824ae164ff968d(registrationId, commands, dependencies = []) {
        const subscribe = (0, (0, parcelRequire("fIZf0")).useSubscribeCommandsWithRegistry)();
        const commandCache = (0, $5uXOq.useRef)(commands);
        (0, $5uXOq.useEffect)(()=>{
            commandCache.current = commands;
        }, [
            commands
        ]);
        (0, $5uXOq.useEffect)(()=>subscribe(registrationId, commandCache.current), [
            ...dependencies,
            subscribe
        ]);
    }
});
parcelRegister("fIZf0", function(module, exports) {
    $parcel$export(module.exports, "useSubscribeCommandsWithRegistry", ()=>$72118e9f2599bc72$export$880fc01e31710b27);
    var $5uXOq = parcelRequire("5uXOq");
    var $d8lE2;
    function $72118e9f2599bc72$export$880fc01e31710b27() {
        const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, (0, parcelRequire("d8lE2")).useActionsCommandPalette)();
        const subscribe = (0, $5uXOq.useCallback)((registrationId, commands)=>{
            updateActiveRegistry(registrationId, commands);
            addCommands(commands);
            return ()=>{
                removeCommands(commands);
                removeFromActiveRegistry(registrationId, commands);
            };
        }, [
            addCommands,
            removeCommands,
            removeFromActiveRegistry,
            updateActiveRegistry
        ]);
        return subscribe;
    }
});
parcelRegister("lAw61", function(module, exports) {
    $parcel$export(module.exports, "useIssueNavigatorLink", ()=>$76a7c5131d60f2ad$export$3e785a826ba5bd41);
    var $2vSU6;
    var $43qGj;
    var $dAfqg;
    var $gg0fv;
    const $76a7c5131d60f2ad$export$3e785a826ba5bd41 = ()=>{
        const { data: projectContextData } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const { data: features } = (0, (0, parcelRequire("43qGj")).useFeatures)();
        if (!projectContextData?.projectType || !projectContextData?.projectKey || typeof projectContextData?.simplified !== 'boolean') return {
            issueNavigatorLink: null
        };
        const issueNavigatorLink = (0, (0, parcelRequire("gg0fv")).generateNinBasePath)(projectContextData.projectKey, projectContextData.projectType, projectContextData.simplified);
        let isIssueNavigatoraEnabled = true;
        if (projectContextData.projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)) isIssueNavigatoraEnabled = features?.hasSIN || false;
        return {
            issueNavigatorLink: isIssueNavigatoraEnabled ? issueNavigatorLink : null
        };
    };
});
parcelRegister("43qGj", function(module, exports) {
    $parcel$export(module.exports, "useFeatures", ()=>$64d4caaed133b77d$export$4a39035bacc4ed76);
    var $5uXOq = parcelRequire("5uXOq");
    var $1J3t1;
    var $4bPSV;
    var $hDSPU;
    var $iHqA4;
    var $j8sa8;
    const $64d4caaed133b77d$export$4a39035bacc4ed76 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useJiraSoftwareProjectNavigation)();
        const isEligibleForFeatureToggle = (0, (0, parcelRequire("j8sa8")).useShouldApplyFeatureToggle)();
        const [sidebarFeatureToggled] = (0, (0, parcelRequire("hDSPU")).useSidebarFeatureToggled)();
        const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("4bPSV")).extractData)(data), [
            data
        ]);
        const features = (0, $5uXOq.useMemo)(()=>{
            if (!extractedData || !isEligibleForFeatureToggle || !sidebarFeatureToggled) return extractedData;
            return {
                ...extractedData,
                ...sidebarFeatureToggled
            };
        }, [
            extractedData,
            isEligibleForFeatureToggle,
            sidebarFeatureToggled
        ]);
        (0, (0, parcelRequire("iHqA4")).useClearSidebarToggled)();
        return {
            data: features,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("4bPSV", function(module, exports) {
    $parcel$export(module.exports, "extractData", ()=>$4795c1c4367ea315$export$9df5fa0a366163d2);
    var $6s1PB;
    var $4R6GH;
    const $4795c1c4367ea315$export$9df5fa0a366163d2 = (navData)=>{
        const { permissionInfo: permissionInfo, hasBacklog: hasBacklog, hasBoard: hasBoard, hasCode: hasCode, hasGoals: hasGoals, hasGetStarted: hasGetStarted, hasSecurity: hasSecurity, hasDeployments: hasDeployments, hasList: hasList, hasOpsgenieSchedule: hasOpsgenieSchedule, hasPages: hasPages, hasReleases: hasReleases, hasRoadmap: hasRoadmap, hasReports: hasReports, hasRequests: hasRequests, hasIssues: hasIssues, hasSprint: hasSprint, hasIncidents: hasIncidents, hasCalendar: hasCalendar, hasForms: hasForms, hasSummaryPage: hasSummaryPage, aiInfo: aiInfo } = navData;
        const isProjectOrJiraAdmin = permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
        return {
            hasBacklog: hasBacklog,
            hasBoard: hasBoard,
            hasRoadmap: hasRoadmap,
            hasCode: hasCode,
            hasGoals: hasGoals,
            hasGetStarted: isProjectOrJiraAdmin && hasGetStarted,
            hasSecurity: hasSecurity,
            hasDeployments: hasDeployments,
            hasList: (0, (0, parcelRequire("6s1PB")).expValEquals)('jsw_list_view', 'cohort', 'variation') ? hasList : false,
            hasReleases: hasReleases,
            hasSIN: hasIssues,
            hasReports: hasReports,
            hasRequests: hasRequests,
            hasPages: hasPages,
            hasOpsgenie: hasOpsgenieSchedule,
            hasShortcutsAdd: isProjectOrJiraAdmin,
            hasSettings: isProjectOrJiraAdmin,
            hasSprint: hasSprint,
            hasIncidents: hasIncidents,
            hasCalendar: hasCalendar,
            hasForms: (0, (0, parcelRequire("6s1PB")).expValEquals)('forms_for_jsw_experiment', 'isEnabled', true) && hasForms,
            hasSummaryPage: (0, (0, parcelRequire("4R6GH")).fg)('enable_jsw_summary_page') && hasSummaryPage,
            hasAIInNIN: hasIssues && aiInfo?.isEnabledInIssueNavigator === true
        };
    };
});
parcelRegister("hDSPU", function(module, exports) {
    $parcel$export(module.exports, "useFeature", ()=>$605ea180d8f833cc$export$fc97652867e5867e);
    $parcel$export(module.exports, "useEnablingFeature", ()=>$605ea180d8f833cc$export$207b461610a7fca6);
    $parcel$export(module.exports, "useSidebarFeatureToggled", ()=>$605ea180d8f833cc$export$9eef668f94562feb);
    var $3sQ5x;
    var $iXqE5;
    var $6wyfe;
    const $605ea180d8f833cc$var$initialState = {
        features: [],
        isLoading: false,
        enablingFeatures: [],
        isFetchError: false,
        sidebarFeatureToggled: null
    };
    const $605ea180d8f833cc$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'feature-toggle',
        initialState: $605ea180d8f833cc$var$initialState,
        actions: (0, parcelRequire("6wyfe")).actions
    });
    const $605ea180d8f833cc$export$fc97652867e5867e = (0, (0, parcelRequire("3sQ5x")).createHook)($605ea180d8f833cc$var$store);
    const $605ea180d8f833cc$export$207b461610a7fca6 = (0, (0, parcelRequire("3sQ5x")).createHook)($605ea180d8f833cc$var$store, {
        selector: (state, { feature: feature })=>state.enablingFeatures.some((f)=>f === feature)
    });
    const $605ea180d8f833cc$export$e7699ed698eeb9ec = (0, (0, parcelRequire("3sQ5x")).createHook)($605ea180d8f833cc$var$store, {
        selector: (state, { feature: feature })=>state.features.find((f)=>f.feature === feature)?.state
    });
    const $605ea180d8f833cc$export$9eef668f94562feb = (0, (0, parcelRequire("3sQ5x")).createHook)($605ea180d8f833cc$var$store, {
        selector: (state)=>state.sidebarFeatureToggled
    });
});
parcelRegister("6wyfe", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$158a47dbcbb0832b$export$e324594224ef24da);
    var $jcw0u;
    var $6s1PB;
    var $8zOmE;
    var $3Jf4N;
    var $czzsL;
    var $iZZTd;
    var $ke207;
    const $158a47dbcbb0832b$var$clearSiderbarFeatureToggled = ()=>({ setState: setState })=>{
            setState({
                sidebarFeatureToggled: null
            });
        };
    const $158a47dbcbb0832b$var$fetchFeatures = (boardId)=>async ({ getState: getState, setState: setState })=>{
            const { features: features, isLoading: isLoading } = getState();
            if (isLoading) return;
            setState({
                isFetchError: false
            });
            try {
                if (features.length === 0) {
                    setState({
                        isLoading: true
                    });
                    const data = await (0, (0, parcelRequire("iZZTd")).getBoardFeatures)(boardId);
                    const filteredFeatures = (0, (0, parcelRequire("czzsL")).filterAndSort)(data);
                    (0, (0, parcelRequire("czzsL")).fireErrorAnalyticsOnUnmatchFeatureKey)(filteredFeatures);
                    setState({
                        isLoading: false,
                        features: filteredFeatures
                    });
                }
            } catch (error) {
                setState({
                    isFetchError: true,
                    isLoading: false
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        ...(0, (0, parcelRequire("3Jf4N")).commonErrorAnalyticsMeta),
                        id: 'fetchFeatures'
                    },
                    error: error
                });
            }
        };
    const $158a47dbcbb0832b$var$syncFeatures = (sidebarFeatureStatus)=>({ getState: getState, setState: setState })=>{
            const { features: features } = getState();
            const featureMap = (0, (0, parcelRequire("3Jf4N")).getFeatureMap)({
                isListViewEnabled: (0, (0, parcelRequire("6s1PB")).expValEquals)('jsw_list_view', 'cohort', 'variation')
            });
            const synced = features.map((f)=>{
                const id = f.feature;
                if (featureMap[id]) {
                    const { statusKey: statusKey } = featureMap[id];
                    return {
                        ...f,
                        state: sidebarFeatureStatus[statusKey] ? 'ENABLED' : 'DISABLED'
                    };
                }
                return f;
            });
            setState({
                features: synced
            });
        };
    const $158a47dbcbb0832b$var$updateFeature = ({ boardId: boardId, feature: feature, dependentFeature: dependentFeature, analyticsEvent: analyticsEvent, onError: onError, onAfterUpdate: onAfterUpdate })=>async ({ getState: getState, setState: setState })=>{
            const { features: features, enablingFeatures: enablingFeatures, sidebarFeatureToggled: sidebarFeatureToggled } = getState();
            let featureMap = (0, (0, parcelRequire("3Jf4N")).getFeatureMap)();
            if ((0, (0, parcelRequire("6s1PB")).expValEquals)('jsw_list_view', 'cohort', 'variation')) featureMap = {
                ...featureMap,
                ...(0, (0, parcelRequire("3Jf4N")).listFeature)
            };
            const currentStatus = features.find((f)=>f.feature === feature)?.state;
            const isEnabling = currentStatus === 'DISABLED';
            if (!boardId || feature.length === 0 || !currentStatus) return;
            try {
                setState({
                    features: features.map((0, (0, parcelRequire("czzsL")).updateFeatureState)(feature, dependentFeature)),
                    sidebarFeatureToggled: {
                        ...sidebarFeatureToggled ?? {},
                        [featureMap[feature].statusKey]: isEnabling,
                        ...dependentFeature && {
                            [featureMap[dependentFeature].statusKey]: isEnabling
                        }
                    },
                    ...isEnabling && {
                        enablingFeatures: [
                            ...enablingFeatures,
                            feature
                        ]
                    }
                });
                await (0, (0, parcelRequire("ke207")).updateBoardFeature)({
                    boardId: boardId,
                    feature: feature,
                    enabling: isEnabling
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'featureStatus updated', {
                    featureId: feature,
                    newStatus: currentStatus
                });
                onAfterUpdate?.(feature, isEnabling);
            } catch (error) {
                onError?.();
                setState({
                    features: features,
                    sidebarFeatureToggled: sidebarFeatureToggled
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        ...(0, (0, parcelRequire("3Jf4N")).commonErrorAnalyticsMeta),
                        id: 'updateFeature'
                    },
                    error: error
                });
            }
            if (isEnabling) setState({
                enablingFeatures: getState().enablingFeatures.filter((f)=>f !== feature)
            });
        };
    const $158a47dbcbb0832b$export$e324594224ef24da = {
        fetchFeatures: $158a47dbcbb0832b$var$fetchFeatures,
        updateFeature: $158a47dbcbb0832b$var$updateFeature,
        syncFeatures: $158a47dbcbb0832b$var$syncFeatures,
        clearSiderbarFeatureToggled: $158a47dbcbb0832b$var$clearSiderbarFeatureToggled
    };
});
parcelRegister("3Jf4N", function(module, exports) {
    $parcel$export(module.exports, "commonErrorAnalyticsMeta", ()=>$d07f845012e39eac$export$47825241dc3c472c);
    $parcel$export(module.exports, "MANAGE_FEATURE_MENU_ITEM_TEST_ID", ()=>$d07f845012e39eac$export$143e1d685830adbe);
    $parcel$export(module.exports, "listFeature", ()=>$d07f845012e39eac$export$4ddfd7a9f5527982);
    $parcel$export(module.exports, "getFeatureMap", ()=>$d07f845012e39eac$export$6ac50cf33852adb5);
    $parcel$export(module.exports, "ERROR_FLAG_ID", ()=>$d07f845012e39eac$export$f5e4c120ac01b615);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $8QpSo;
    var $adDD5;
    var $v8Zna;
    var $90gd1;
    var $8sgpE;
    var $eWXbg;
    var $i3vuN;
    var $65Ltd;
    const $d07f845012e39eac$export$47825241dc3c472c = {
        packageName: 'jiraTmpFeatureToggle',
        teamName: 'jlove-makkuro'
    };
    const $d07f845012e39eac$export$143e1d685830adbe = 'manage-feature-menu-item';
    const $d07f845012e39eac$export$4ddfd7a9f5527982 = {
        'jsw.agility.list_view': {
            descriptionKey: 'listDescription',
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("90gd1"))))), {
                label: ""
            }),
            statusKey: 'hasList',
            order: 35,
            redirectOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST)
            ]
        }
    };
    const $d07f845012e39eac$export$a712b1e96d47b856 = {
        'jsw.agility.simple-roadmap': {
            descriptionKey: 'timelineDescription',
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("i3vuN"))))), {
                label: ""
            }),
            statusKey: 'hasRoadmap',
            order: 10,
            redirectOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE),
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ROADMAP)
            ]
        },
        'jsw.agility.backlog': {
            descriptionKey: 'backlogDescription',
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("adDD5"))))), {
                label: ""
            }),
            statusKey: 'hasBacklog',
            order: 20,
            redirectOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BACKLOG)
            ]
        },
        'jsw.agility.board': {
            descriptionKey: 'boardDescription',
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("v8Zna"))))), {
                label: ""
            }),
            statusKey: 'hasBoard',
            order: 30
        },
        'jsw.agility.issue_navigator': {
            descriptionKey: 'issueNavigatorDescription',
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8sgpE"))))), {
                label: ""
            }),
            statusKey: 'hasSIN',
            order: 40,
            redirectOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE)
            ]
        },
        'jsw.agility.sprints': {
            descriptionKey: 'releasesDescription',
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null),
            statusKey: 'hasSprint',
            order: 50,
            isHidden: true
        }
    };
    const $d07f845012e39eac$export$6ac50cf33852adb5 = (0, (0, parcelRequire("8QpSo")).default)(({ isSimplifyNavExperimentEnabled: isSimplifyNavExperimentEnabled, isListViewEnabled: isListViewEnabled } = {})=>({
            'jsw.agility.simple-roadmap': {
                descriptionKey: 'timelineDescription',
                icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("i3vuN"))))), {
                    label: ""
                }),
                statusKey: 'hasRoadmap',
                order: 10,
                redirectOn: [
                    (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE),
                    (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ROADMAP)
                ]
            },
            'jsw.agility.backlog': {
                descriptionKey: 'backlogDescription',
                icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("adDD5"))))), {
                    label: ""
                }),
                statusKey: 'hasBacklog',
                order: 20,
                redirectOn: [
                    (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BACKLOG)
                ]
            },
            'jsw.agility.board': {
                descriptionKey: 'boardDescription',
                icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("v8Zna"))))), {
                    label: ""
                }),
                statusKey: 'hasBoard',
                order: 30
            },
            ...!isSimplifyNavExperimentEnabled && {
                'jsw.agility.issue_navigator': {
                    descriptionKey: 'issueNavigatorDescription',
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8sgpE"))))), {
                        label: ""
                    }),
                    statusKey: 'hasSIN',
                    order: 40,
                    redirectOn: [
                        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
                        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE)
                    ]
                }
            },
            'jsw.agility.sprints': {
                descriptionKey: 'releasesDescription',
                icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null),
                statusKey: 'hasSprint',
                order: 50,
                isHidden: true
            },
            'jsw.agility.pages': {
                descriptionKey: 'projectPagesDescription',
                icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("eWXbg"))))), {
                    label: ""
                }),
                statusKey: 'hasPages',
                order: 60,
                redirectOn: [
                    (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_PAGES)
                ]
            },
            ...isListViewEnabled && $d07f845012e39eac$export$4ddfd7a9f5527982
        }), (0, ($parcel$interopDefault($ajpes))));
    const $d07f845012e39eac$export$f5e4c120ac01b615 = 'feature-toggle-error-flag';
});
parcelRegister("adDD5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7709dbddc6671c4c$var$_react = $7709dbddc6671c4c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $7709dbddc6671c4c$var$_backlog = $7709dbddc6671c4c$var$_interopRequireDefault((parcelRequire("bRTCF")));
    function $7709dbddc6671c4c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7709dbddc6671c4c$var$BacklogIcon = (props)=>$7709dbddc6671c4c$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.002C5 19 17 19 17 19v-2.002C17 17 5 17 5 17zm-2-2.004C3 15.894 3.895 15 4.994 15h12.012c1.101 0 1.994.898 1.994 1.998v2.004A1.997 1.997 0 0 1 17.006 21H4.994A2 2 0 0 1 3 19.002z"/><path d="M5 15h12v-2H5zm-2-4h16v6H3z"/><path d="M7 11.002C7 11 19 11 19 11V8.998C19 9 7 9 7 9zM5 8.998C5 7.894 5.895 7 6.994 7h12.012C20.107 7 21 7.898 21 8.998v2.004A1.997 1.997 0 0 1 19.006 13H6.994A2 2 0 0 1 5 11.002z"/><path d="M5 5v2h12V5zm-2-.002C3 3.894 3.895 3 4.994 3h12.012C18.107 3 19 3.898 19 4.998V9H3z"/></g></svg>`
        }, props, {
            newIcon: $7709dbddc6671c4c$var$_backlog.default
        }));
    $7709dbddc6671c4c$var$BacklogIcon.displayName = 'BacklogIcon';
    var $7709dbddc6671c4c$var$_default = module.exports.default = $7709dbddc6671c4c$var$BacklogIcon;
});
parcelRegister("bRTCF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8a3fca7537c506d3$var$_react = $8a3fca7537c506d3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8a3fca7537c506d3$var$_UNSAFE_baseNew = $8a3fca7537c506d3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $8a3fca7537c506d3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8a3fca7537c506d3$var$BacklogIcon = (props)=>$8a3fca7537c506d3$var$_react.default.createElement($8a3fca7537c506d3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 5.917V3c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v2.917m-12.5 0v4.166m0-4.166h12.5m-12.5 4.166V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-2.917m-12.5 0h12.5m0-4.166v4.166"/>`
        }, props));
    $8a3fca7537c506d3$var$BacklogIcon.displayName = 'BacklogIcon';
    var $8a3fca7537c506d3$var$_default = module.exports.default = $8a3fca7537c506d3$var$BacklogIcon;
});
parcelRegister("90gd1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $68e0afe9fd548c5c$var$_react = $68e0afe9fd548c5c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $68e0afe9fd548c5c$var$_listBulleted = $68e0afe9fd548c5c$var$_interopRequireDefault((parcelRequire("bEjt9")));
    function $68e0afe9fd548c5c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $68e0afe9fd548c5c$var$BulletListIcon = (props)=>$68e0afe9fd548c5c$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="10" y="15" rx="1"/><rect width="2" height="2" x="6" y="15" rx="1"/><rect width="8" height="2" x="10" y="11" rx="1"/><rect width="2" height="2" x="6" y="11" rx="1"/><rect width="8" height="2" x="10" y="7" rx="1"/><rect width="2" height="2" x="6" y="7" rx="1"/></g></svg>`
        }, props, {
            newIcon: $68e0afe9fd548c5c$var$_listBulleted.default
        }));
    $68e0afe9fd548c5c$var$BulletListIcon.displayName = 'BulletListIcon';
    var $68e0afe9fd548c5c$var$_default = module.exports.default = $68e0afe9fd548c5c$var$BulletListIcon;
});
parcelRegister("bEjt9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $87b28849bcb64a34$var$_react = $87b28849bcb64a34$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $87b28849bcb64a34$var$_UNSAFE_baseNew = $87b28849bcb64a34$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $87b28849bcb64a34$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $87b28849bcb64a34$var$ListBulletedIcon = (props)=>$87b28849bcb64a34$var$_react.default.createElement($87b28849bcb64a34$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M2.75 2.75a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M5 2.75h10M5 8h10M5 13.25h10M2.75 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0-10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`
        }, props));
    $87b28849bcb64a34$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
    var $87b28849bcb64a34$var$_default = module.exports.default = $87b28849bcb64a34$var$ListBulletedIcon;
});
parcelRegister("eWXbg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ae246388ea520792$var$_react = $ae246388ea520792$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $ae246388ea520792$var$_page = $ae246388ea520792$var$_interopRequireDefault((parcelRequire("kdfZa")));
    function $ae246388ea520792$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ae246388ea520792$var$PageIcon = (props)=>$ae246388ea520792$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="8" height="2" x="8" y="9" rx="1"/><rect width="4" height="2" x="8" y="12" rx="1"/><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/></g></svg>`
        }, props, {
            newIcon: $ae246388ea520792$var$_page.default
        }));
    $ae246388ea520792$var$PageIcon.displayName = 'PageIcon';
    var $ae246388ea520792$var$_default = module.exports.default = $ae246388ea520792$var$PageIcon;
});
parcelRegister("kdfZa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eb716bf3c984513d$var$_react = $eb716bf3c984513d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $eb716bf3c984513d$var$_UNSAFE_baseNew = $eb716bf3c984513d$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $eb716bf3c984513d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eb716bf3c984513d$var$PageIcon = (props)=>$eb716bf3c984513d$var$_react.default.createElement($eb716bf3c984513d$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 5.25h8m-8 3.5h6m-7 5.5h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
        }, props));
    $eb716bf3c984513d$var$PageIcon.displayName = 'PageIcon';
    var $eb716bf3c984513d$var$_default = module.exports.default = $eb716bf3c984513d$var$PageIcon;
});
parcelRegister("i3vuN", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d250f039686fbf24$var$_react = $d250f039686fbf24$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $d250f039686fbf24$var$_roadmap = $d250f039686fbf24$var$_interopRequireDefault((parcelRequire("ifnb0")));
    function $d250f039686fbf24$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d250f039686fbf24$var$RoadmapIcon = (props)=>$d250f039686fbf24$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 2h10a3 3 0 0 1 0 6H6a3 3 0 1 1 0-6m0 2a1 1 0 1 0 0 2h10a1 1 0 0 0 0-2zm4 5h8a3 3 0 0 1 0 6h-8a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2zm-4 5h6a3 3 0 0 1 0 6H6a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z"/></svg>`
        }, props, {
            newIcon: $d250f039686fbf24$var$_roadmap.default
        }));
    $d250f039686fbf24$var$RoadmapIcon.displayName = 'RoadmapIcon';
    var $d250f039686fbf24$var$_default = module.exports.default = $d250f039686fbf24$var$RoadmapIcon;
});
parcelRegister("ifnb0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d48b9b12f073239d$var$_react = $d48b9b12f073239d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $d48b9b12f073239d$var$_UNSAFE_baseNew = $d48b9b12f073239d$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $d48b9b12f073239d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d48b9b12f073239d$var$RoadmapIcon = (props)=>$d48b9b12f073239d$var$_react.default.createElement($d48b9b12f073239d$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M.75 4c0-.69.56-1.25 1.25-1.25h9c.69 0 1.25.56 1.25 1.25v1c0 .69-.56 1.25-1.25 1.25H2C1.31 6.25.75 5.69.75 5zm3 7c0-.69.56-1.25 1.25-1.25h9c.69 0 1.25.56 1.25 1.25v1c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25z"/>`
        }, props));
    $d48b9b12f073239d$var$RoadmapIcon.displayName = 'RoadmapIcon';
    var $d48b9b12f073239d$var$_default = module.exports.default = $d48b9b12f073239d$var$RoadmapIcon;
});
parcelRegister("czzsL", function(module, exports) {
    $parcel$export(module.exports, "filterAndSort", ()=>$0a04151ee5a00965$export$d0e0de50c701304c);
    $parcel$export(module.exports, "findDependentFeature", ()=>$0a04151ee5a00965$export$4c8205136225a4e2);
    $parcel$export(module.exports, "updateFeatureState", ()=>$0a04151ee5a00965$export$2bdeae30201d513c);
    $parcel$export(module.exports, "fireErrorAnalyticsOnUnmatchFeatureKey", ()=>$0a04151ee5a00965$export$5da1e8c5ba5c0dc2);
    var $hqTkp = parcelRequire("hqTkp");
    var $jcw0u;
    var $6s1PB;
    var $3Jf4N;
    const $0a04151ee5a00965$export$b70265791d2079d4 = (hasFeature)=>hasFeature ? 'ENABLED' : 'DISABLED';
    const $0a04151ee5a00965$export$d0e0de50c701304c = (features)=>{
        const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jsw_simplify_navigation_m2');
        const featureMap = (0, (0, parcelRequire("3Jf4N")).getFeatureMap)({
            isSimplifyNavExperimentEnabled: expConfig.get('isEnabled', false),
            isListViewEnabled: (0, (0, parcelRequire("6s1PB")).expValEquals)('jsw_list_view', 'cohort', 'variation')
        });
        return features.filter((f)=>Object.keys(featureMap).includes(f.feature)).sort((a, b)=>featureMap[a.feature].order - featureMap[b.feature].order);
    };
    const $0a04151ee5a00965$export$4c8205136225a4e2 = (features, featureId)=>{
        const featureToDisable = features.find((f)=>f.feature === featureId);
        if (featureToDisable?.state !== 'ENABLED') return undefined;
        return features.find((f)=>f.prerequisites.includes(featureId) && f.state === 'ENABLED');
    };
    const $0a04151ee5a00965$export$2bdeae30201d513c = (featureId, dependentFeatureId)=>(feature)=>feature.feature === featureId || dependentFeatureId && feature.feature === dependentFeatureId ? {
                ...feature,
                state: feature.state === 'ENABLED' ? 'DISABLED' : 'ENABLED'
            } : feature;
    const $0a04151ee5a00965$export$5da1e8c5ba5c0dc2 = (filteredFeatures)=>{
        const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jsw_simplify_navigation_m2');
        const featureMap = (0, (0, parcelRequire("3Jf4N")).getFeatureMap)({
            isSimplifyNavExperimentEnabled: expConfig.get('isEnabled', false),
            isListViewEnabled: (0, (0, parcelRequire("6s1PB")).expValEquals)('jsw_list_view', 'cohort', 'variation')
        });
        if (filteredFeatures.length < Object.keys(featureMap).length) {
            const unmatchedFeatureKeys = (0, ($parcel$interopDefault($hqTkp)))(Object.keys(featureMap), ...filteredFeatures.map((f)=>f.feature));
            (0, (0, parcelRequire("jcw0u")).default)({
                error: new Error("Some feature keys don't match . Please check API response"),
                meta: {
                    ...(0, (0, parcelRequire("3Jf4N")).commonErrorAnalyticsMeta),
                    id: 'unmatchFeatureKey'
                },
                attributes: {
                    unmatchedFeatureKeys: unmatchedFeatureKeys.toString()
                }
            });
        }
    };
});
parcelRegister("hqTkp", function(module, exports) {
    var $55pzo = parcelRequire("55pzo");
    var $g7i7g = parcelRequire("g7i7g");
    var $f3SOL = parcelRequire("f3SOL");
    var $cb0fc8686550aa11$var$without = $g7i7g(function(array, values) {
        return $f3SOL(array) ? $55pzo(array, values) : [];
    });
    module.exports = $cb0fc8686550aa11$var$without;
});
parcelRegister("iZZTd", function(module, exports) {
    $parcel$export(module.exports, "getBoardFeatures", ()=>$140b4a0769fd2090$export$c20100b185d41ab0);
    var $eusud;
    var $8djOx;
    const $140b4a0769fd2090$export$c20100b185d41ab0 = async (boardId)=>{
        const data = await (0, (0, parcelRequire("eusud")).performGetRequest)((0, (0, parcelRequire("8djOx")).getBoardFeaturesUrl)(boardId));
        return data.features;
    };
});
parcelRegister("8djOx", function(module, exports) {
    $parcel$export(module.exports, "getBoardFeaturesUrl", ()=>$45a3789113fa4e8b$export$3f9939d302766b52);
    const $45a3789113fa4e8b$export$3f9939d302766b52 = (boardId)=>`/rest/agile/latest/board/${boardId}/features`;
});
parcelRegister("ke207", function(module, exports) {
    $parcel$export(module.exports, "updateBoardFeature", ()=>$1ce9149bd154bcf9$export$61f6bbb745b3a3);
    var $eusud;
    var $8djOx;
    const $1ce9149bd154bcf9$export$61f6bbb745b3a3 = async (request)=>{
        const data = await (0, (0, parcelRequire("eusud")).performPutRequest)((0, (0, parcelRequire("8djOx")).getBoardFeaturesUrl)(request.boardId), {
            body: JSON.stringify(request)
        });
        const newState = data.features.find((f)=>f.feature === request.feature)?.state;
        return newState ?? (request.enabling ? 'ENABLED' : 'DISABLED');
    };
});
parcelRegister("iHqA4", function(module, exports) {
    $parcel$export(module.exports, "useClearSidebarToggled", ()=>$b80f211a69d994c6$export$2946f555c6f48127);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $1J3t1;
    var $1XJ20;
    var $hDSPU;
    var $j8sa8;
    const $b80f211a69d994c6$export$2946f555c6f48127 = ()=>{
        const { data: data, refresh: refresh } = (0, (0, parcelRequire("1J3t1")).useJiraSoftwareProjectNavigation)();
        const [sidebarFeatureToggled, { clearSiderbarFeatureToggled: clearSiderbarFeatureToggled }] = (0, (0, parcelRequire("hDSPU")).useSidebarFeatureToggled)();
        const isEligibleForFeatureToggle = (0, (0, parcelRequire("j8sa8")).useShouldApplyFeatureToggle)();
        const sidebarHasChanged = (0, $5uXOq.useRef)(false);
        const previousData = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(data);
        const shouldClear = (0, $5uXOq.useMemo)(()=>isEligibleForFeatureToggle && !(0, ($parcel$interopDefault($ajpes)))(previousData, data), [
            isEligibleForFeatureToggle,
            previousData,
            data
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (shouldClear) clearSiderbarFeatureToggled();
        }, [
            shouldClear,
            clearSiderbarFeatureToggled
        ]);
        (0, $5uXOq.useEffect)(()=>{
            sidebarHasChanged.current = isEligibleForFeatureToggle && !!sidebarFeatureToggled;
        }, [
            isEligibleForFeatureToggle,
            sidebarFeatureToggled
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                if (sidebarHasChanged.current) refresh();
            }, [
            refresh
        ]);
    };
});
parcelRegister("j8sa8", function(module, exports) {
    $parcel$export(module.exports, "useShouldApplyFeatureToggle", ()=>$d568e02a383436d9$export$7deca16ba2d9eb74);
    var $2vSU6;
    var $dAfqg;
    var $dkqym;
    const $d568e02a383436d9$export$7deca16ba2d9eb74 = ()=>{
        const { data: project } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const firstActivationDateMs = (0, (0, parcelRequire("dkqym")).useFirstActivationDateMs)() || 0;
        const isJSW = project?.projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT);
        const isTMP = !!project?.simplified;
        const isProjectAdmin = !!project?.isProjectAdmin;
        const isNewInstance = new Date(firstActivationDateMs) >= new Date('2023-09-25T15:00:00');
        return isJSW && isTMP && isProjectAdmin && isNewInstance;
    };
});
parcelRegister("dkqym", function(module, exports) {
    $parcel$export(module.exports, "useFirstActivationDateMs", ()=>$61794ef454831b86$export$9df3a539e50a284b);
    var $9OXo1;
    const $61794ef454831b86$export$9df3a539e50a284b = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.firstActivationDateMs != null ? tenantContext.firstActivationDateMs : null;
    };
});
parcelRegister("gg0fv", function(module, exports) {
    $parcel$export(module.exports, "generateNinBasePath", ()=>$1f09af27cff5f032$export$47d9a807c1277671);
    var $2vSU6;
    const $1f09af27cff5f032$export$ddaf187654250a8d = '/issues/';
    const $1f09af27cff5f032$export$47d9a807c1277671 = (projectKey, projectType, isSimplifiedProject)=>{
        const getMainPath = (projectPath, simplified = true)=>`/jira/${projectPath}${!simplified ? '/c' : ''}/projects/${projectKey}/issues`;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return getMainPath('core');
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return getMainPath('servicedesk');
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                return getMainPath('software', isSimplifiedProject);
            default:
                return $1f09af27cff5f032$export$ddaf187654250a8d;
        }
    };
});
parcelRegister("auYbh", function(module, exports) {
    $parcel$export(module.exports, "useCopyPageUrlCommand", ()=>$65c115d952a83ae0$export$e4eb2b3d3a5a5045);
    var $5uXOq = parcelRequire("5uXOq");
    var $eE13R;
    var $5p1kJ;
    var $5rVQI;
    var $eG9rp;
    var $jh7L9;
    var $jcw0u;
    var $pa9q9;
    var $koVbs;
    var $bSVn9;
    var $gHgQ0;
    const $65c115d952a83ae0$export$e4eb2b3d3a5a5045 = ()=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const copyToClipboard = async ()=>{
            try {
                await (0, (0, parcelRequire("gHgQ0")).getNavigator)().clipboard.writeText((0, (0, parcelRequire("gHgQ0")).getWindow)().location.href);
                showFlag({
                    type: 'success',
                    title: (0, (0, parcelRequire("bSVn9")).messages).successTitleCopiedUrl
                });
            } catch (err) {
                showFlag({
                    type: 'error',
                    title: (0, (0, parcelRequire("bSVn9")).messages).errorTitleCopiedUrl,
                    description: (0, (0, parcelRequire("bSVn9")).messages).errorDescriptionCopiedUrl
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: err,
                    meta: {
                        id: 'commandPaletteCopyUrlToClipboard',
                        packageName: 'jiraCommandPaletteIntegration',
                        teamName: 'deliveroo'
                    }
                });
            }
        };
        const { getKeywords: getKeywords } = (0, (0, parcelRequire("eG9rp")).useCommandKeywords)();
        return {
            id: 'copy-page-url',
            name: formatMessage((0, (0, parcelRequire("bSVn9")).messages).commandCommandLabel),
            keywords: getKeywords('copyCurrentPageUrlSynonyms'),
            primaryAction: {
                type: (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM,
                perform: copyToClipboard
            },
            section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).quickActions,
            priority: (0, (0, parcelRequire("5rVQI")).COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).copyUrl,
            components: {
                LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("eE13R"))))), {
                        label: formatMessage((0, (0, parcelRequire("bSVn9")).messages).commandCommandLabel)
                    })
            },
            analytics: {
                action: 'copyPageURL'
            }
        };
    };
});
parcelRegister("eE13R", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $aa959fe1f5a86e24$var$_react = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $aa959fe1f5a86e24$var$_copy = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("8w53e")));
    function $aa959fe1f5a86e24$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $aa959fe1f5a86e24$var$CopyIcon = (props)=>$aa959fe1f5a86e24$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
        }, props, {
            newIcon: $aa959fe1f5a86e24$var$_copy.default
        }));
    $aa959fe1f5a86e24$var$CopyIcon.displayName = 'CopyIcon';
    var $aa959fe1f5a86e24$var$_default = module.exports.default = $aa959fe1f5a86e24$var$CopyIcon;
});
parcelRegister("8w53e", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $63353af41c1756be$var$_react = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $63353af41c1756be$var$_UNSAFE_baseNew = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $63353af41c1756be$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $63353af41c1756be$var$CopyIcon = (props)=>$63353af41c1756be$var$_react.default.createElement($63353af41c1756be$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
        }, props));
    $63353af41c1756be$var$CopyIcon.displayName = 'CopyIcon';
    var $63353af41c1756be$var$_default = module.exports.default = $63353af41c1756be$var$CopyIcon;
});
parcelRegister("5rVQI", function(module, exports) {
    $parcel$export(module.exports, "COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY", ()=>$c7aab549acec9d6e$export$5ea2dca0a260365d);
    var $c7aab549acec9d6e$export$5ea2dca0a260365d;
    (function(COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY) {
        COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["createIssue"] = 0] = "createIssue";
        COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["searchOnCurrentPage"] = 1] = "searchOnCurrentPage";
        COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openQuickSearch"] = 2] = "openQuickSearch";
        COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["copyUrl"] = 3] = "copyUrl";
        COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["checkNotifications"] = 4] = "checkNotifications";
    })($c7aab549acec9d6e$export$5ea2dca0a260365d || ($c7aab549acec9d6e$export$5ea2dca0a260365d = {}));
});
parcelRegister("eG9rp", function(module, exports) {
    $parcel$export(module.exports, "useCommandKeywords", ()=>$61ebfb9239c4f8e5$export$4d8fe3ef6385358);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dYWZb;
    const $61ebfb9239c4f8e5$export$4d8fe3ef6385358 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getKeywords = (0, $5uXOq.useCallback)((keywordGroup)=>(0, (0, parcelRequire("dYWZb")).messages)[keywordGroup] ? formatMessage((0, (0, parcelRequire("dYWZb")).messages)[keywordGroup]) : undefined, [
            formatMessage
        ]);
        return {
            getKeywords: getKeywords
        };
    };
});
parcelRegister("dYWZb", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$df7d7dd7b88156b7$export$defe85febe8b728c);
    var $7VHMR;
    const $df7d7dd7b88156b7$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        searchYourIssuesSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.search-your-issues-synonyms",
            "defaultMessage": "Find my ideas tickets requests tasks work"
        },
        changeStatusSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.change-status-synonyms",
            "defaultMessage": "Move through workflow  Progress Done Complete transition"
        },
        assignToMeSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.assign-to-me-synonyms",
            "defaultMessage": "self"
        },
        assignIssueSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.assign-issue-synonyms",
            "defaultMessage": "Choose person Give work Pick assignee Select ticket idea"
        },
        startWatchingIssueSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.start-watching-issue-synonyms",
            "defaultMessage": "Follow work Track Unwatch Unfollow"
        },
        backlogSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.backlog-synonyms",
            "defaultMessage": "Inventory Go"
        },
        boardSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.board-synonyms",
            "defaultMessage": "Boards Sprint Kanban Swimlanes Do Go"
        },
        reportsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.reports-synonyms",
            "defaultMessage": "Summary Insights Burndown Go"
        },
        timelineSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.timeline-synonyms",
            "defaultMessage": "Plan Work calendar Schedule Overview Delivery Go Roadmap"
        },
        quickSearchSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.quick-search-synonyms",
            "defaultMessage": "Search products across Atlassian Go to"
        },
        pageSearchSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.page-search-synonyms",
            "defaultMessage": "Control f Command cmd cntrl Go find ctrl"
        },
        createIssueSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.create-issue-synonyms",
            "defaultMessage": "work Start idea New ticket task"
        },
        switchDarkThemeSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.switch-dark-theme-synonyms",
            "defaultMessage": "light Darkmode lightmode Change Appearance Colours colors nightmode daymode"
        },
        matchSystemThemeSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.match-system-theme-synonyms",
            "defaultMessage": "Sync settings Darkmode lightmode Change Appearance Colours colors nightmode daymode"
        },
        copyCurrentPageUrlSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.copy-current-page-url-synonyms",
            "defaultMessage": "link website address"
        },
        getHelpSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.get-help-synonyms",
            "defaultMessage": "In-product Support Documentation Questions Answers"
        },
        viewKeyboardShortcutsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-keyboard-shortcuts-synonyms",
            "defaultMessage": "Hotkeys Show See"
        },
        editDescriptionSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.edit-description-synonyms",
            "defaultMessage": "Completion criteria Info Information Details Add Write"
        },
        addAttachmentSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.add-attachment-synonyms",
            "defaultMessage": "Attach Upload Document Media"
        },
        addCommentSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.add-comment-synonyms",
            "defaultMessage": "Write Message"
        },
        logWorkSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.log-work-synonyms",
            "defaultMessage": "Track Record hours Time spent"
        },
        addRemoveFlagSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.add-remove-flag-synonyms",
            "defaultMessage": "Unflag Mark Unmark Star Unstar"
        },
        cloneIssueSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.clone-issue-synonyms",
            "defaultMessage": "Copy Duplicate Task Idea Request"
        },
        linkConfluencePageSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.link-confluence-page-synonyms",
            "defaultMessage": "Relate Add Connect"
        },
        addAUrlSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.add-a-url-synonyms",
            "defaultMessage": "Connect Weblink Link Website Domain"
        },
        goToIssuesSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms",
            "defaultMessage": "Advanced issue search Project Filter JQL search list View all"
        },
        goToPersonalSettingsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.go-to-personal-settings-synonyms",
            "defaultMessage": "Preferences Notifications Theme Jira labs"
        },
        goToAccountSettingsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.go-to-account-settings-synonyms",
            "defaultMessage": "Preferences Privacy Profile Your details Personal information"
        },
        viewAllIssuesSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms",
            "defaultMessage": "Site issues JQL View all"
        },
        viewAllProjectsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-projects-synonyms",
            "defaultMessage": "List Go"
        },
        viewAllPlansSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-plans-synonyms",
            "defaultMessage": "List Go"
        },
        viewAllBoardsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-boards-synonyms",
            "defaultMessage": "List Go"
        },
        viewAllFiltersSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-filters-synonyms",
            "defaultMessage": "List Go"
        },
        viewAllDashboardsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-dashboards-synonyms",
            "defaultMessage": "List Go"
        },
        checkNotificationsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.check-notifications-synonyms",
            "defaultMessage": "window See Updates"
        },
        goToUserManagementSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.go-to-user-management-synonyms",
            "defaultMessage": "Permissions"
        }
    });
});
parcelRegister("bSVn9", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$afbd00f8ee321a49$export$defe85febe8b728c);
    var $7VHMR;
    const $afbd00f8ee321a49$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        successTitleCopiedUrl: {
            "id": "command-palette-integration.initial-commands.use-copy-page-url.success-title-copied-url",
            "defaultMessage": "Page URL copied to clipboard"
        },
        errorTitleCopiedUrl: {
            "id": "command-palette-integration.initial-commands.use-copy-page-url.error-title-copied-url",
            "defaultMessage": "We couldn't copy the page URL"
        },
        errorDescriptionCopiedUrl: {
            "id": "command-palette-integration.initial-commands.use-copy-page-url.error-description-copied-url",
            "defaultMessage": "Please check your browser settings."
        },
        commandCommandLabel: {
            "id": "command-palette-integration.initial-commands.use-copy-page-url.command-command-label",
            "defaultMessage": "Copy current page URL"
        }
    });
});
parcelRegister("gHgQ0", function(module, exports) {
    $parcel$export(module.exports, "getWindow", ()=>$aa7ea9975b9801d2$export$38b2d434cce3ea22);
    $parcel$export(module.exports, "getNavigator", ()=>$aa7ea9975b9801d2$export$a56241c767c1d89f);
    const $aa7ea9975b9801d2$export$38b2d434cce3ea22 = ()=>window;
    const $aa7ea9975b9801d2$export$a56241c767c1d89f = ()=>navigator;
});
parcelRegister("gLlXj", function(module, exports) {
    $parcel$export(module.exports, "useNavigationCommands", ()=>$8320b3f6a0447126$export$997e3c408ba63e3b);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RBk4;
    var $lzUP9;
    var $3JGmH;
    var $5p1kJ;
    var $4l54H;
    var $eG9rp;
    var $koVbs;
    var $2EqxS;
    var $1C2yb;
    var $h9iZl;
    var $cYlk7;
    var $4s7hB;
    var $3zTeb;
    var $13DBR;
    var $4TyVn;
    var $1xIol;
    var $cojyC;
    var $9OXo1;
    var $lAw61;
    var $afAJS;
    const $8320b3f6a0447126$export$997e3c408ba63e3b = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { getKeywords: getKeywords } = (0, (0, parcelRequire("eG9rp")).useCommandKeywords)();
        const { issueNavigatorLink: issueNavigatorLink } = (0, (0, parcelRequire("lAw61")).useIssueNavigatorLink)();
        const { hideAndTransformNavigationCommands: hideAndTransformNavigationCommands } = (0, (0, parcelRequire("4l54H")).useTransformNavigationCommands)();
        const { data: data } = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        const email = data.user?.emailAddress;
        const accountSettingsLink = (0, (0, parcelRequire("2EqxS")).useAtlassianPersonalSettingsLink)(email || undefined);
        const [isPlansVisible] = (0, (0, parcelRequire("h9iZl")).useNavigationPlansVisibility)();
        const { isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const commands = hideAndTransformNavigationCommands([
            {
                command: {
                    id: (0, $e4a6563fd1445b08$export$2d4af8d3471f446),
                    name: formatMessage((0, (0, parcelRequire("afAJS")).default).viewAllProjects),
                    keywords: getKeywords('viewAllProjectsSynonyms'),
                    section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).siteNavigation,
                    priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).goToProjects,
                    components: {
                        LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
                                label: formatMessage((0, (0, parcelRequire("afAJS")).default).viewAllProjects)
                            })
                    },
                    analytics: {
                        action: 'viewAllProjects'
                    }
                },
                path: (0, (0, parcelRequire("1xIol")).projectsDirectoryRoute)
            },
            {
                command: {
                    id: (0, $e4a6563fd1445b08$export$bfa43d3c5bfbcf35),
                    name: formatMessage((0, (0, parcelRequire("afAJS")).default).viewAllFilters),
                    keywords: getKeywords('viewAllFiltersSynonyms'),
                    section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).siteNavigation,
                    priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).goToFilters,
                    components: {
                        LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
                                label: formatMessage((0, (0, parcelRequire("afAJS")).default).viewAllFilters)
                            })
                    },
                    analytics: {
                        action: 'viewAllFilters'
                    }
                },
                path: (0, (0, parcelRequire("13DBR")).filtersDirectoryRoute)
            },
            {
                command: {
                    id: (0, $e4a6563fd1445b08$export$538e0daca84e7e29),
                    name: formatMessage((0, (0, parcelRequire("afAJS")).default).viewAllDashboards),
                    keywords: getKeywords('viewAllDashboardsSynonyms'),
                    section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).siteNavigation,
                    priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).goToDashboards,
                    components: {
                        LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
                                label: formatMessage((0, (0, parcelRequire("afAJS")).default).viewAllDashboards)
                            })
                    },
                    analytics: {
                        action: 'viewAllDashboards'
                    }
                },
                path: (0, (0, parcelRequire("3zTeb")).dashboardsDirectoryRoute)
            },
            {
                command: {
                    id: (0, $e4a6563fd1445b08$export$98cbb2f7230db2a1),
                    name: formatMessage((0, (0, parcelRequire("afAJS")).default).goToPersonalSettings),
                    keywords: getKeywords('goToPersonalSettingsSynonyms'),
                    section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).personalSettings,
                    priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY).goToPersonalSettings,
                    components: {
                        LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lzUP9"))))), {
                                label: formatMessage((0, (0, parcelRequire("afAJS")).default).goToPersonalSettings)
                            })
                    },
                    analytics: {
                        action: 'goToPersonalSettings'
                    }
                },
                path: (0, (0, parcelRequire("cojyC")).getGeneralPersonalSettingsRouteForLink)(),
                hideCommandPath: (0, (0, parcelRequire("1C2yb")).getGeneralPersonalSettingsPath)()
            },
            {
                command: {
                    id: (0, $e4a6563fd1445b08$export$7e8556985118cd1e),
                    name: formatMessage((0, (0, parcelRequire("afAJS")).default).viewAllBoards),
                    keywords: getKeywords('viewAllBoardsSynonyms'),
                    section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).siteNavigation,
                    components: {
                        LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
                                label: formatMessage((0, (0, parcelRequire("afAJS")).default).viewAllBoards)
                            })
                    },
                    priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).goToBoards,
                    analytics: {
                        action: 'viewAllBoards'
                    }
                },
                path: (0, (0, parcelRequire("4s7hB")).boardsDirectoryRoute)
            },
            {
                command: {
                    id: (0, $e4a6563fd1445b08$export$7976f2daa1e8078a),
                    name: formatMessage((0, (0, parcelRequire("afAJS")).default).goToAccountSettings),
                    keywords: getKeywords('goToAccountSettingsSynonyms'),
                    section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).personalSettings,
                    components: {
                        LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lzUP9"))))), {
                                label: formatMessage((0, (0, parcelRequire("afAJS")).default).goToAccountSettings)
                            })
                    },
                    priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY).goToAccountSettings,
                    analytics: {
                        action: 'goToAccountSettings'
                    }
                },
                path: accountSettingsLink,
                shouldAlwaysOpenNewTab: true
            },
            ...issueNavigatorLink ? [
                {
                    command: {
                        id: (0, $e4a6563fd1445b08$export$f3211b812cd1a523),
                        name: formatMessage((0, (0, parcelRequire("afAJS")).default).goToIssues),
                        keywords: getKeywords('goToIssuesSynonyms'),
                        section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).projectNavigation,
                        components: {
                            LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
                                    label: formatMessage((0, (0, parcelRequire("afAJS")).default).goToIssues)
                                })
                        },
                        priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY).goToIssues,
                        analytics: {
                            action: 'goToIssues'
                        }
                    },
                    path: issueNavigatorLink,
                    hideCommandPath: (0, (0, parcelRequire("1xIol")).projectsDirectoryRoute).path
                }
            ] : [],
            ...isPlansVisible ? [
                {
                    command: {
                        id: (0, $e4a6563fd1445b08$export$653733b43ae1b993),
                        name: formatMessage((0, (0, parcelRequire("afAJS")).default).viewAllPlans),
                        keywords: getKeywords('viewAllPlansSynonyms'),
                        section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).siteNavigation,
                        components: {
                            LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
                                    label: formatMessage((0, (0, parcelRequire("afAJS")).default).viewAllPlans)
                                })
                        },
                        priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).goToPlans,
                        analytics: {
                            action: 'viewAllPlans'
                        }
                    },
                    path: (0, (0, parcelRequire("4TyVn")).plansDirectoryRoute)
                }
            ] : [],
            ...isSiteAdmin ? [
                {
                    command: {
                        id: (0, $e4a6563fd1445b08$export$9ede11404253696),
                        name: formatMessage((0, (0, parcelRequire("afAJS")).default).goToUserManagement),
                        keywords: getKeywords('goToUserManagementSynonyms'),
                        section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).atlassianAdmin,
                        priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY).userManagement,
                        components: {
                            LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lzUP9"))))), {
                                    label: formatMessage((0, (0, parcelRequire("afAJS")).default).goToUserManagement)
                                })
                        },
                        analytics: {
                            action: 'goToUserManagement'
                        }
                    },
                    path: (0, (0, parcelRequire("3JGmH")).SITE_ADMIN_SETTINGS_ITEM_HREFS).USER_MANAGEMENT,
                    shouldAlwaysOpenNewTab: true
                },
                {
                    command: {
                        id: (0, $e4a6563fd1445b08$export$bf77ae178e5e5984),
                        name: formatMessage((0, (0, parcelRequire("afAJS")).default).goToBilling),
                        section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).atlassianAdmin,
                        priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY).billing,
                        components: {
                            LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lzUP9"))))), {
                                    label: formatMessage((0, (0, parcelRequire("afAJS")).default).goToBilling)
                                })
                        },
                        analytics: {
                            action: 'goToBilling'
                        }
                    },
                    path: (0, (0, parcelRequire("3JGmH")).SITE_ADMIN_SETTINGS_ITEM_HREFS).BILLING,
                    shouldAlwaysOpenNewTab: true
                }
            ] : []
        ]);
        return commands;
    };
});
parcelRegister("3JGmH", function(module, exports) {
    $parcel$export(module.exports, "JIRA_SETTINGS_SECTION_IDS", ()=>$421ed2d9886b9bc8$export$7266225366740ba0);
    $parcel$export(module.exports, "ADMIN_SETTINGS_ITEM_IDS", ()=>$421ed2d9886b9bc8$export$4718c8ac53a477e1);
    $parcel$export(module.exports, "SITE_ADMIN_SETTINGS_ITEM_IDS", ()=>$421ed2d9886b9bc8$export$b23679adb37958a8);
    $parcel$export(module.exports, "SITE_ADMIN_SETTINGS_ITEM_HREFS", ()=>$421ed2d9886b9bc8$export$9cc74e3c0b8831f9);
    const $421ed2d9886b9bc8$export$7266225366740ba0 = {
        SETTINGS_TITLE: 'settings-title',
        SITE_ADMIN: 'site-admin',
        SYSTEM_ADMIN: 'system-admin',
        TRUSTED_USER: 'trusted-user',
        PERSONAL: 'personal-settings'
    };
    const $421ed2d9886b9bc8$export$4718c8ac53a477e1 = {
        SYSTEM: 'admin-system-menu',
        APPLICATIONS: 'admin-applications-menu',
        ISSUES: 'admin-issues-menu',
        PLUGINS: 'admin-plugins-menu',
        RECOMMENDATIONS: 'admin-recommendations',
        MANAGE_PROJECTS: 'admin-manage-project-menu'
    };
    const $421ed2d9886b9bc8$export$b23679adb37958a8 = {
        USER_MANAGEMENT: 'user-management-section',
        BILLING: 'admin-billing-section'
    };
    const $421ed2d9886b9bc8$export$58a409d1d7fded14 = {
        USER_MANAGEMENT: 'trusted-admin-user-management-section',
        DISCOVER_APPLICATIONS: 'discover-applications-section'
    };
    const $421ed2d9886b9bc8$export$9cc74e3c0b8831f9 = {
        USER_MANAGEMENT: '/admin/users?referrerName=JIRA',
        BILLING: '/admin/billing-preview?referrerName=JIRA'
    };
});
parcelRegister("2EqxS", function(module, exports) {
    $parcel$export(module.exports, "useAtlassianPersonalSettingsLink", ()=>$58d844745b0a5554$export$8ac70acdad00754b);
    $parcel$export(module.exports, "useSwitchAccountLink", ()=>$58d844745b0a5554$export$dce6af3168fb6ced);
    $parcel$export(module.exports, "useProfileLink", ()=>$58d844745b0a5554$export$b8f25e615dd30d7b);
    $parcel$export(module.exports, "getBeforeEntity", ()=>$58d844745b0a5554$export$5b8580d0254a9349);
    $parcel$export(module.exports, "getBoardLink", ()=>$58d844745b0a5554$export$ff5c49b7852aca68);
    $parcel$export(module.exports, "getLinkFromProject", ()=>$58d844745b0a5554$export$dd9458ee44edd0c6);
    $parcel$export(module.exports, "getQueueLink", ()=>$58d844745b0a5554$export$b44363840d1b683e);
    $parcel$export(module.exports, "getIsClassicSoftwareProject", ()=>$58d844745b0a5554$export$286ea82aef1c76e9);
    $parcel$export(module.exports, "getUsersApps", ()=>$58d844745b0a5554$export$ad0fd737fbd4a083);
    var $ebyGx = parcelRequire("ebyGx");
    var $kTK0a;
    var $j0xEB;
    var $lsCQw;
    var $9v9ib;
    var $gAdgD;
    var $3e6VG;
    var $aIkD8;
    var $2gnjX;
    var $k7fxM;
    var $5mLQj;
    var $ee0rS;
    var $90yGq;
    var $lmyls;
    const $58d844745b0a5554$export$ab902790e443b0ec = ()=>`${(0, (0, parcelRequire("kTK0a")).getATLContextUrl)('id')}/login`;
    const $58d844745b0a5554$export$8ac70acdad00754b = (destinationAccountEmail)=>{
        const loginLink = $58d844745b0a5554$export$ab902790e443b0ec();
        const destinationUrl = `${(0, (0, parcelRequire("kTK0a")).getATLContextUrl)('id')}/manage-profile/profile-and-visibility`;
        return destinationAccountEmail ? `${loginLink}?${(0, ($parcel$interopDefault($ebyGx))).stringify({
            application: 'jira',
            continue: destinationUrl,
            login_hint: destinationAccountEmail,
            prompt: 'none'
        })}` : destinationUrl;
    };
    const $58d844745b0a5554$export$dce6af3168fb6ced = ()=>{
        const loginLink = $58d844745b0a5554$export$ab902790e443b0ec();
        const { href: href } = (0, (0, parcelRequire("j0xEB")).default)() || {};
        return `${loginLink}?${(0, ($parcel$interopDefault($ebyGx))).stringify({
            application: 'jira',
            continue: href,
            prompt: 'select_account'
        })}`;
    };
    const $58d844745b0a5554$export$b8f25e615dd30d7b = ()=>{
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        return `/jira/people/${accountId || ''}`;
    };
    const $58d844745b0a5554$export$5b8580d0254a9349 = (favoriteItems)=>favoriteItems && favoriteItems.length > 0 ? {
            id: String(favoriteItems[0].id),
            type: favoriteItems[0].type
        } : {
            id: undefined,
            type: undefined
        };
    const $58d844745b0a5554$export$ff5c49b7852aca68 = (item)=>{
        const { attributes: attributes, attributes: { parentType: parentType }, id: id } = item;
        const boardId = String(id);
        if (parentType === 'project') {
            const { nextgen: nextgen, projectKey: projectKey, projectType: projectType } = attributes;
            if (projectType === 'business') return {
                params: {
                    projectKey: projectKey
                },
                query: {},
                route: (0, (0, parcelRequire("9v9ib")).jiraBusinessProjectRedirectRoute)
            };
            if (projectType === 'service_desk') return {
                params: {
                    boardId: boardId,
                    projectKey: projectKey
                },
                query: {},
                route: (0, (0, parcelRequire("gAdgD")).jsmBoardRoute)
            };
            if (nextgen === 'true') return {
                params: {
                    boardId: boardId,
                    projectKey: projectKey
                },
                query: {},
                route: (0, (0, parcelRequire("2gnjX")).softwareBoardRoute)
            };
            return {
                params: {
                    boardId: boardId,
                    projectKey: projectKey
                },
                query: {},
                route: (0, (0, parcelRequire("k7fxM")).classicSoftwareBoardRoute)
            };
        }
        if (parentType === 'user') {
            const { userAccountId: accountId } = attributes;
            return {
                params: {
                    boardId: boardId,
                    accountId: accountId
                },
                query: {},
                route: (0, (0, parcelRequire("5mLQj")).userBoardRoute)
            };
        }
        return {
            params: undefined,
            query: undefined,
            route: undefined
        };
    };
    const $58d844745b0a5554$export$dd9458ee44edd0c6 = (item)=>{
        const { attributes: { projectType: projectType, boardId: boardId, nextgen: nextgen, projectKey: projectKey } } = item;
        if (projectType === 'business') return {
            params: {
                projectKey: projectKey
            },
            query: {},
            route: (0, (0, parcelRequire("9v9ib")).jiraBusinessProjectRedirectRoute)
        };
        if (boardId !== undefined) {
            if (nextgen === 'true') return {
                params: {
                    boardId: boardId,
                    projectKey: projectKey
                },
                query: {},
                route: (0, (0, parcelRequire("2gnjX")).softwareBoardRoute)
            };
            return {
                params: {
                    boardId: boardId,
                    projectKey: projectKey
                },
                query: {},
                route: (0, (0, parcelRequire("k7fxM")).classicSoftwareBoardRoute)
            };
        }
        if (projectType === 'service_desk') return {
            params: {
                projectKey: projectKey
            },
            query: {},
            route: (0, (0, parcelRequire("3e6VG")).projectServiceDeskRoute)
        };
        return {
            params: {
                projectKey: projectKey
            },
            query: {},
            route: (0, (0, parcelRequire("lsCQw")).browseProjectRedirectRoute)
        };
    };
    const $58d844745b0a5554$export$b44363840d1b683e = (item)=>{
        const { attributes: { projectKey: projectKey, queuesCategory: queuesCategory }, id: id } = item;
        return {
            params: {
                projectKey: projectKey,
                ...queuesCategory != null && queuesCategory !== '' ? {
                    practiceType: (0, (0, parcelRequire("ee0rS")).toShortFormItsmPractice)(queuesCategory)
                } : {},
                queueId: String(id)
            },
            route: queuesCategory != null && queuesCategory !== '' ? (0, (0, parcelRequire("aIkD8")).customPracticeQueueRoute) : (0, (0, parcelRequire("aIkD8")).customQueueRoute)
        };
    };
    const $58d844745b0a5554$export$286ea82aef1c76e9 = (attributes)=>attributes.parentType === 'user' || attributes.parentType === 'project' && attributes.projectType === 'software' && attributes.nextgen === 'false';
    const $58d844745b0a5554$export$ad0fd737fbd4a083 = (items)=>items.filter((item)=>item.id !== (0, (0, parcelRequire("lmyls")).ADDON_ID).DISCOVER);
});
parcelRegister("j0xEB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b1198aeec732ce1$export$2e2bcd8739ae039);
    var $9b1198aeec732ce1$export$2e2bcd8739ae039 = ()=>{
        if (typeof window !== 'undefined') return window.location;
        return undefined;
    };
});
parcelRegister("lsCQw", function(module, exports) {
    $parcel$export(module.exports, "browseProjectRedirectRoute", ()=>$8f408b6bf8b1e91d$export$f9cac37753487f39);
    var $65Ltd;
    const $8f408b6bf8b1e91d$export$f9cac37753487f39 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT),
        path: '/browse/:projectKey([^-/]+)',
        exact: true
    };
});
parcelRegister("9v9ib", function(module, exports) {
    $parcel$export(module.exports, "jiraBusinessProjectRedirectRoute", ()=>$21f2029296bcfd0c$export$73b60789ceb8e1eb);
    $parcel$export(module.exports, "jiraBusinessOverviewRedirectRoute", ()=>$21f2029296bcfd0c$export$5ab0e07528c31349);
    var $65Ltd;
    const $21f2029296bcfd0c$export$73b60789ceb8e1eb = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT),
        path: '/jira/core/projects/:projectKey',
        exact: true
    };
    const $21f2029296bcfd0c$export$5ab0e07528c31349 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT),
        path: '/jira/core/overviews/:overviewId',
        exact: true
    };
});
parcelRegister("gAdgD", function(module, exports) {
    $parcel$export(module.exports, "jsmBoardRoute", ()=>$5c5a2553f427d19f$export$a192088aab559fa1);
    var $65Ltd;
    const $5c5a2553f427d19f$export$a192088aab559fa1 = {
        path: '/jira/servicedesk/projects/:projectKey/boards/:boardId',
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS),
        exact: true
    };
});
parcelRegister("3e6VG", function(module, exports) {
    $parcel$export(module.exports, "projectServiceDeskRoute", ()=>$b4bfd79e01394a60$export$1cfc858068dd8718);
    var $65Ltd;
    const $b4bfd79e01394a60$export$1cfc858068dd8718 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REDIRECT),
        path: '/jira/servicedesk/projects/:projectKey',
        exact: true
    };
});
parcelRegister("aIkD8", function(module, exports) {
    $parcel$export(module.exports, "customQueueRoute", ()=>$4c49d5efc3cf0837$export$e1fac82ca0b0d637);
    $parcel$export(module.exports, "customPracticeQueueRoute", ()=>$4c49d5efc3cf0837$export$59d0bd42aa07faad);
    var $65Ltd;
    const $4c49d5efc3cf0837$export$e1fac82ca0b0d637 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE),
        path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/:issueKey?',
        query: [
            'oldIssueView?'
        ],
        exact: true
    };
    const $4c49d5efc3cf0837$export$59d0bd42aa07faad = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE),
        path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/:issueKey?',
        query: [
            'oldIssueView?'
        ],
        exact: true
    };
});
parcelRegister("2gnjX", function(module, exports) {
    $parcel$export(module.exports, "softwareBoardRoute", ()=>$3dfae82cef4e3065$export$9ae2c0a566d4e0f6);
    $parcel$export(module.exports, "softwareBoardEmbedRoute", ()=>$3dfae82cef4e3065$export$f55626b64e3fcb4f);
    var $65Ltd;
    const $3dfae82cef4e3065$export$9ae2c0a566d4e0f6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BOARDS),
        exact: true,
        path: '/jira/software/projects/:projectKey/boards/:boardId'
    };
    const $3dfae82cef4e3065$export$f55626b64e3fcb4f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BOARDS_EMBED),
        exact: true,
        path: '/jira/software/projects/:projectKey/boards/:boardId/embed'
    };
});
parcelRegister("k7fxM", function(module, exports) {
    $parcel$export(module.exports, "classicSoftwareBoardRoute", ()=>$b2c149f7138f811f$export$131d51ca54849e97);
    $parcel$export(module.exports, "classicSoftwareBoardEmbedRoute", ()=>$b2c149f7138f811f$export$122afcef7dfd252);
    var $65Ltd;
    const $b2c149f7138f811f$export$131d51ca54849e97 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId'
    };
    const $b2c149f7138f811f$export$122afcef7dfd252 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/embed'
    };
});
parcelRegister("5mLQj", function(module, exports) {
    $parcel$export(module.exports, "userBoardRoute", ()=>$94b3bd76047e314a$export$57a2a0fe739f16);
    var $65Ltd;
    const $94b3bd76047e314a$export$57a2a0fe739f16 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BOARD),
        path: '/jira/people/:accountId/boards/:boardId'
    };
});
parcelRegister("ee0rS", function(module, exports) {
    $parcel$export(module.exports, "toShortFormItsmPractice", ()=>$3a8490f36704bba6$export$db58a56259f511a2);
    var $oCMSG;
    const $3a8490f36704bba6$var$longToShortConversionMap = {
        [(0, (0, parcelRequire("oCMSG")).CHANGES)]: (0, (0, parcelRequire("oCMSG")).SHORT_FORM_CHANGES),
        [(0, (0, parcelRequire("oCMSG")).INCIDENTS)]: (0, (0, parcelRequire("oCMSG")).SHORT_FORM_INCIDENTS),
        [(0, (0, parcelRequire("oCMSG")).PROBLEMS)]: (0, (0, parcelRequire("oCMSG")).SHORT_FORM_PROBLEMS),
        [(0, (0, parcelRequire("oCMSG")).SERVICE_REQUEST)]: (0, (0, parcelRequire("oCMSG")).SHORT_FORM_SERVICE_REQUEST),
        [(0, (0, parcelRequire("oCMSG")).POST_INCIDENT_REVIEWS)]: (0, (0, parcelRequire("oCMSG")).SHORT_FORM_POST_INCIDENT_REVIEWS),
        [(0, (0, parcelRequire("oCMSG")).DEVELOPER_ESCALATION)]: (0, (0, parcelRequire("oCMSG")).SHORT_FORM_DEVELOPER_ESCALATION)
    };
    function $3a8490f36704bba6$var$isLongForm(workCategoryKey) {
        return !!workCategoryKey && workCategoryKey in $3a8490f36704bba6$var$longToShortConversionMap;
    }
    const $3a8490f36704bba6$export$db58a56259f511a2 = (workCategoryKey)=>{
        if ($3a8490f36704bba6$var$isLongForm(workCategoryKey)) return $3a8490f36704bba6$var$longToShortConversionMap[workCategoryKey];
        return null;
    };
});
parcelRegister("lmyls", function(module, exports) {
    $parcel$export(module.exports, "ADDON_ID", ()=>$ee51d260cb059727$export$6c4866a933650d1d);
    $parcel$export(module.exports, "MENU_ID", ()=>$ee51d260cb059727$export$d4cd258d01c03112);
    $parcel$export(module.exports, "SIDEBAR_ID", ()=>$ee51d260cb059727$export$adf978edbdfaf080);
    const $ee51d260cb059727$export$6c4866a933650d1d = {
        DISCOVER: 'com.atlassian.jira.emcee__enduser-discover'
    };
    const $ee51d260cb059727$export$d4cd258d01c03112 = {
        ADDONS: 'ADDONS',
        APP_SWITCHER: 'APP_SWITCHER',
        DASHBOARDS: 'DASHBOARDS',
        FILTERS: 'FILTERS',
        HELP: 'HELP',
        HOME: 'HOME',
        INSIGHT: 'INSIGHT',
        NOTIFICATIONS: 'NOTIFICATIONS',
        PEOPLE: 'PEOPLE',
        PLANS: 'PLANS',
        PROFILE: 'PROFILE',
        PROJECTS: 'PROJECTS',
        ROADMAPS: 'ROADMAPS',
        SEARCH: 'SEARCH',
        SERVICE_HUB: 'SERVICE_HUB',
        SETTINGS: 'SETTINGS',
        HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
    };
    const $ee51d260cb059727$export$adf978edbdfaf080 = {
        BOARD_SETTINGS: 'BOARD_SETTINGS',
        GLOBAL_APPS_SETTINGS: 'GLOBAL_APPS_SETTINGS',
        GLOBAL_ISSUES_SETTINGS: 'GLOBAL_ISSUES_SETTINGS',
        GLOBAL_PRODUCTS_SETTINGS: 'GLOBAL_PRODUCTS_SETTINGS',
        GLOBAL_PROJECTS_SETTINGS: 'GLOBAL_PROJECTS_SETTINGS',
        GLOBAL_SYSTEM_SETTINGS: 'GLOBAL_SYSTEM_SETTINGS',
        HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
        PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
        PLAN_SETTINGS: 'PLAN_SETTINGS',
        PROJECT_SETTINGS: 'PROJECT_SETTINGS'
    };
});
parcelRegister("1C2yb", function(module, exports) {
    $parcel$export(module.exports, "LEGACY_PERSONAL_SETTINGS_PATH", ()=>$63706130a90445cd$export$b468ccdb67523656);
    $parcel$export(module.exports, "GENERAL_PERSONAL_SETTINGS_PATH", ()=>$63706130a90445cd$export$693b70d1bcef8627);
    $parcel$export(module.exports, "NOTIFICATIONS_PERSONAL_SETTINGS_PATH", ()=>$63706130a90445cd$export$21946ea4c58fd4c9);
    $parcel$export(module.exports, "OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", ()=>$63706130a90445cd$export$2321c59d517801c8);
    $parcel$export(module.exports, "getGeneralPersonalSettingsPath", ()=>$63706130a90445cd$export$db9e3ccc1e5e3317);
    $parcel$export(module.exports, "getNotificationsPersonalSettingsPath", ()=>$63706130a90445cd$export$64a672523a583594);
    const $63706130a90445cd$export$b468ccdb67523656 = '/secure/ViewPersonalSettings.jspa';
    const $63706130a90445cd$export$a974f4af282a75ba = '/jira/settings/personal';
    const $63706130a90445cd$export$693b70d1bcef8627 = `${$63706130a90445cd$export$a974f4af282a75ba}/general`;
    const $63706130a90445cd$export$21946ea4c58fd4c9 = `${$63706130a90445cd$export$a974f4af282a75ba}/notifications`;
    const $63706130a90445cd$export$2321c59d517801c8 = `${$63706130a90445cd$export$a974f4af282a75ba}/alert-notifications`;
    function $63706130a90445cd$export$db9e3ccc1e5e3317() {
        return $63706130a90445cd$export$693b70d1bcef8627;
    }
    function $63706130a90445cd$export$88a45ae8c4b1c664() {
        return $63706130a90445cd$export$2321c59d517801c8;
    }
    function $63706130a90445cd$export$64a672523a583594() {
        return $63706130a90445cd$export$21946ea4c58fd4c9;
    }
});
parcelRegister("cYlk7", function(module, exports) {
    $parcel$export(module.exports, "useCurrentUser", ()=>$cdd4ab536fcf9459$export$3901076af3749fa9);
    var $5uXOq = parcelRequire("5uXOq");
    var $lzeFL;
    var $9OXo1;
    var $leRCk;
    const $cdd4ab536fcf9459$var$useCurrentUserBasic = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return (0, $5uXOq.useMemo)(()=>({
                data: {
                    user: {
                        accountId: tenantContext.atlassianAccountId,
                        isAdmin: tenantContext.isAdmin,
                        isAnonymous: tenantContext.isAnonymous,
                        isSiteAdmin: tenantContext.isSiteAdmin,
                        locale: tenantContext.locale || (0, (0, parcelRequire("lzeFL")).defaultLocale),
                        siteAdminStatus: tenantContext.siteAdminStatus,
                        userFullname: tenantContext.userFullname || ''
                    }
                },
                loading: false,
                error: null
            }), [
            tenantContext.atlassianAccountId,
            tenantContext.isAdmin,
            tenantContext.isAnonymous,
            tenantContext.isSiteAdmin,
            tenantContext.locale,
            tenantContext.siteAdminStatus,
            tenantContext.userFullname
        ]);
    };
    const $cdd4ab536fcf9459$var$useCurrentUserFull = ()=>{
        const { data: dataBasic } = $cdd4ab536fcf9459$var$useCurrentUserBasic();
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, (0, parcelRequire("leRCk")).useUserSubscriber)();
        (0, $5uXOq.useEffect)(()=>{
            tenantContext.atlassianAccountId && fetch({
                params: {
                    accountId: tenantContext.atlassianAccountId
                }
            }, false);
        }, [
            fetch,
            tenantContext.atlassianAccountId
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: {
                    ...dataBasic,
                    user: {
                        ...dataBasic.user,
                        ...data
                    }
                },
                loading: loading,
                error: error
            }), [
            data,
            dataBasic,
            error,
            loading
        ]);
    };
    const $cdd4ab536fcf9459$export$3901076af3749fa9 = ()=>(0, (0, parcelRequire("9OXo1")).useTenantContext)().isAnonymous ? $cdd4ab536fcf9459$var$useCurrentUserBasic() : $cdd4ab536fcf9459$var$useCurrentUserFull();
    const $cdd4ab536fcf9459$export$6414ebbbfff99d4c = ({ children: children })=>{
        const result = $cdd4ab536fcf9459$export$3901076af3749fa9();
        return children(result);
    };
});
parcelRegister("4s7hB", function(module, exports) {
    $parcel$export(module.exports, "boardsDirectoryRoute", ()=>$77dc14d95c28fe1d$export$f0fc6f4e8be87e85);
    $parcel$export(module.exports, "boardsDirectoryRedirectRoute", ()=>$77dc14d95c28fe1d$export$a4fba1ebd6ba91ee);
    var $65Ltd;
    const $77dc14d95c28fe1d$export$f0fc6f4e8be87e85 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BOARDS_DIRECTORY),
        path: '/jira/boards'
    };
    const $77dc14d95c28fe1d$export$a4fba1ebd6ba91ee = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BOARDS_DIRECTORY)}-redirect`,
        path: '/secure/ManageRapidViews.jspa'
    };
});
parcelRegister("3zTeb", function(module, exports) {
    $parcel$export(module.exports, "dashboardsDirectoryRoute", ()=>$ce3faeb59dd926fb$export$41bba408475cab16);
    $parcel$export(module.exports, "dashboardsDirectoryRedirectRoute", ()=>$ce3faeb59dd926fb$export$b96f6fb3c35a6fe5);
    var $65Ltd;
    const $ce3faeb59dd926fb$export$41bba408475cab16 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY),
        path: '/jira/dashboards'
    };
    const $ce3faeb59dd926fb$export$b96f6fb3c35a6fe5 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE),
        path: '/secure/ConfigurePortalPages(!default.jspa|.jspa)'
    };
});
parcelRegister("13DBR", function(module, exports) {
    $parcel$export(module.exports, "filtersDirectoryRoute", ()=>$4b1900cd8840fb6b$export$6350f52c8b40042d);
    $parcel$export(module.exports, "filtersDirectoryRedirectRoute", ()=>$4b1900cd8840fb6b$export$f4f86e1ddc30a625);
    $parcel$export(module.exports, "secureFiltersDirectoryRedirectRoute", ()=>$4b1900cd8840fb6b$export$50796f2aecd63181);
    var $65Ltd;
    const $4b1900cd8840fb6b$export$6350f52c8b40042d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY),
        path: '/jira/filters'
    };
    const $4b1900cd8840fb6b$export$f4f86e1ddc30a625 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY)}-redirect`,
        path: '/ManageFilters.jspa'
    };
    const $4b1900cd8840fb6b$export$50796f2aecd63181 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY_SECURE)}-redirect`,
        path: '/secure/ManageFilters.jspa'
    };
});
parcelRegister("4TyVn", function(module, exports) {
    $parcel$export(module.exports, "plansDirectoryRoute", ()=>$ed241e9e9a1b449e$export$143b4a1ef2ffc051);
    var $65Ltd;
    const $ed241e9e9a1b449e$export$143b4a1ef2ffc051 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLANS_DIRECTORY),
        path: '/jira/plans'
    };
});
parcelRegister("1xIol", function(module, exports) {
    $parcel$export(module.exports, "projectsDirectoryRoute", ()=>$4b60f76eec2e5934$export$74114064f06cd71b);
    $parcel$export(module.exports, "manageProjectsDirectoryRoute", ()=>$4b60f76eec2e5934$export$281a4490a0f8fb4c);
    $parcel$export(module.exports, "projectsDirectoryRedirectRoute", ()=>$4b60f76eec2e5934$export$d44f1be3782f0fde);
    $parcel$export(module.exports, "projectsDirectoryLegacyPathRedirectRoute", ()=>$4b60f76eec2e5934$export$c713f57300a82898);
    $parcel$export(module.exports, "projectsDirectoryManageRedirectRoute", ()=>$4b60f76eec2e5934$export$dbd3b6c012e8b6dc);
    $parcel$export(module.exports, "projectsDirectoryManageRootRedirectRoute", ()=>$4b60f76eec2e5934$export$4531e3b2e25fad23);
    var $65Ltd;
    const $4b60f76eec2e5934$export$74114064f06cd71b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY),
        path: '/jira/projects',
        exact: true
    };
    const $4b60f76eec2e5934$export$281a4490a0f8fb4c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE),
        path: '/jira/settings/projects/manage'
    };
    const $4b60f76eec2e5934$export$d44f1be3782f0fde = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY)}-redirect`,
        path: '/projects',
        exact: true
    };
    const $4b60f76eec2e5934$export$c713f57300a82898 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA)}-redirect`,
        path: '/secure/BrowseProjects.jspa'
    };
    const $4b60f76eec2e5934$export$dbd3b6c012e8b6dc = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE)}-redirect`,
        path: '/secure/project/ViewProjects.jspa'
    };
    const $4b60f76eec2e5934$export$4531e3b2e25fad23 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE)}-root-redirect`,
        path: '/jira/settings/projects',
        exact: true
    };
});
parcelRegister("cojyC", function(module, exports) {
    $parcel$export(module.exports, "legacyPersonalSettingsRoute", ()=>$e797a93ba9e40aac$export$dd556eb586bb36b8);
    $parcel$export(module.exports, "generalPersonalSettingsRoute", ()=>$e797a93ba9e40aac$export$7a6c9715a86f906b);
    $parcel$export(module.exports, "notificationsPersonalSettingsRoute", ()=>$e797a93ba9e40aac$export$55ab09b9d6beb8be);
    $parcel$export(module.exports, "opsNotificationsPersonalSettingsRoute", ()=>$e797a93ba9e40aac$export$68ebdd4eccb7b383);
    $parcel$export(module.exports, "getGeneralPersonalSettingsRouteForLink", ()=>$e797a93ba9e40aac$export$cbf079e07fb96768);
    $parcel$export(module.exports, "getNotificationsPersonalSettingsRouteForLink", ()=>$e797a93ba9e40aac$export$9b4c78a3c84b549f);
    var $65Ltd;
    var $1C2yb;
    const $e797a93ba9e40aac$export$dd556eb586bb36b8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PERSONAL_SETTINGS),
        path: (0, (0, parcelRequire("1C2yb")).LEGACY_PERSONAL_SETTINGS_PATH)
    };
    const $e797a93ba9e40aac$export$7a6c9715a86f906b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PERSONAL_SETTINGS_GENERAL),
        path: (0, (0, parcelRequire("1C2yb")).GENERAL_PERSONAL_SETTINGS_PATH)
    };
    const $e797a93ba9e40aac$export$55ab09b9d6beb8be = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PERSONAL_SETTINGS_NOTIFICATIONS),
        path: (0, (0, parcelRequire("1C2yb")).NOTIFICATIONS_PERSONAL_SETTINGS_PATH)
    };
    const $e797a93ba9e40aac$export$68ebdd4eccb7b383 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PERSONAL_SETTINGS_OPS_NOTIFICATIONS),
        path: (0, (0, parcelRequire("1C2yb")).OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH)
    };
    const $e797a93ba9e40aac$export$cbf079e07fb96768 = ()=>{
        return $e797a93ba9e40aac$export$7a6c9715a86f906b;
    };
    const $e797a93ba9e40aac$export$9b4c78a3c84b549f = ()=>{
        return $e797a93ba9e40aac$export$55ab09b9d6beb8be;
    };
});
const $e4a6563fd1445b08$export$2d4af8d3471f446 = 'view-all-projects';
const $e4a6563fd1445b08$export$bfa43d3c5bfbcf35 = 'view-all-filters';
const $e4a6563fd1445b08$export$538e0daca84e7e29 = 'view-all-dashboards';
const $e4a6563fd1445b08$export$f3211b812cd1a523 = 'go-to-issues';
const $e4a6563fd1445b08$export$98cbb2f7230db2a1 = 'go-to-personal-settings';
const $e4a6563fd1445b08$export$7e8556985118cd1e = 'view-all-boards';
const $e4a6563fd1445b08$export$7976f2daa1e8078a = 'go-to-account-settings';
const $e4a6563fd1445b08$export$653733b43ae1b993 = 'view-all-plans';
const $e4a6563fd1445b08$export$9ede11404253696 = 'site-admin-user-management';
const $e4a6563fd1445b08$export$bf77ae178e5e5984 = 'site-admin-billing';
const $e4a6563fd1445b08$export$c85cfa6ec2ae0df7 = 'shortcut-icon';
parcelRegister("afAJS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9764882f15a7a1cd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9764882f15a7a1cd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        viewAllProjects: {
            "id": "command-palette-integration.initial-commands.use-navigation-commands.view-all-projects",
            "defaultMessage": "View all projects"
        },
        viewAllFilters: {
            "id": "command-palette-integration.initial-commands.use-navigation-commands.view-all-filters",
            "defaultMessage": "View all filters"
        },
        viewAllDashboards: {
            "id": "command-palette-integration.initial-commands.use-navigation-commands.view-all-dashboards",
            "defaultMessage": "View all dashboards"
        },
        goToIssues: {
            "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-issues",
            "defaultMessage": "Go to issues"
        },
        goToPersonalSettings: {
            "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-personal-settings",
            "defaultMessage": "Go to personal settings"
        },
        viewAllBoards: {
            "id": "command-palette-integration.initial-commands.use-navigation-commands.view-all-boards",
            "defaultMessage": "View all boards"
        },
        goToAccountSettings: {
            "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-account-settings",
            "defaultMessage": "Go to account settings"
        },
        viewAllPlans: {
            "id": "command-palette-integration.initial-commands.use-navigation-commands.view-all-plans",
            "defaultMessage": "View all plans"
        },
        goToUserManagement: {
            "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-user-management",
            "defaultMessage": "Go to user management"
        },
        goToBilling: {
            "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-billing",
            "defaultMessage": "Go to billing"
        }
    });
});
parcelRegister("ad6ff", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$1e99e569448179a2$export$defe85febe8b728c);
    var $7VHMR;
    const $1e99e569448179a2$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        defaultPlaceholder: {
            "id": "command-palette-integration.default-placeholder",
            "defaultMessage": "Search actions, settings, or type \"/\" to search work"
        },
        noResultsFound: {
            "id": "command-palette-integration.no-results-found",
            "defaultMessage": "No commands match your search."
        },
        onErrorFallback: {
            "id": "command-palette-integration.on-error-fallback",
            "defaultMessage": "We're having trouble loading this data. Wait a few moments, then try again."
        },
        recommendedSection: {
            "id": "command-palette-integration.recommended-section",
            "defaultMessage": "Recommended"
        },
        defaultSearchInputAriaLabel: {
            "id": "command-palette-integration.default-search-input-aria-label",
            "defaultMessage": "Search actions, settings, or type forward slash to search work"
        }
    });
});
parcelRegister("79Tnk", function(module, exports) {
    $parcel$export(module.exports, "RegisterDynamicCommands", ()=>$dbf14dd9a47bf5f0$export$54040e80edbe5eaf);
    var $5uXOq = parcelRequire("5uXOq");
    var $3kC6W;
    var $bWyrc;
    var $jM38v;
    const $dbf14dd9a47bf5f0$export$54040e80edbe5eaf = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWyrc")).InitialiseAdminNavCommands), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3kC6W")).QuickSearchCommands), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jM38v")).ThemeModeCommands), null));
});
parcelRegister("3kC6W", function(module, exports) {
    $parcel$export(module.exports, "QuickSearchCommands", ()=>$aaacf6dc51c0b9d5$export$6e94ce71acbaa493);
    var $5uXOq = parcelRequire("5uXOq");
    var $1Kt4o;
    var $fVMIs;
    var $18wuq;
    var $b5pc0;
    const $aaacf6dc51c0b9d5$var$useQuickSearchCommands = ()=>{
        const subscribe = (0, (0, parcelRequire("fVMIs")).useSubscribeCommands)();
        const { quickSearchCommand: quickSearchCommand } = (0, (0, parcelRequire("b5pc0")).useQuickSearchCommand)({
            keepSearch: false
        });
        (0, $5uXOq.useEffect)(()=>subscribe((0, (0, parcelRequire("1Kt4o")).COMMAND_PALETTE_REGISTRY_IDS).QUICK_SEARCH, [
                quickSearchCommand
            ]), [
            quickSearchCommand,
            subscribe
        ]);
        return null;
    };
    const $aaacf6dc51c0b9d5$var$QuickSearchCommandsInner = ()=>{
        $aaacf6dc51c0b9d5$var$useQuickSearchCommands();
        return null;
    };
    const $aaacf6dc51c0b9d5$export$6e94ce71acbaa493 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("18wuq")).QuickSearchWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement($aaacf6dc51c0b9d5$var$QuickSearchCommandsInner, null));
});
parcelRegister("fVMIs", function(module, exports) {
    $parcel$export(module.exports, "useSubscribeCommands", ()=>$05800ad334e2646e$export$c13b008422be19c7);
    var $fIZf0;
    const $05800ad334e2646e$export$c13b008422be19c7 = (0, (0, parcelRequire("fIZf0")).useSubscribeCommandsWithRegistry);
});
parcelRegister("bWyrc", function(module, exports) {
    $parcel$export(module.exports, "InitialiseAdminNavCommands", ()=>$a4eff5f6fd6b7353$export$397d6a5dfe0b6bae);
    var $5uXOq = parcelRequire("5uXOq");
    var $ioK7w;
    var $d8lE2;
    var $7XluA;
    var $4mO32;
    const $a4eff5f6fd6b7353$var$entryPointParams = {};
    const $a4eff5f6fd6b7353$export$397d6a5dfe0b6bae = ()=>{
        const [initialised, setInitialised] = (0, $5uXOq.useState)(false);
        const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("ioK7w")).compalAdminNavigationEntrypoint), $a4eff5f6fd6b7353$var$entryPointParams);
        const [{ isOpen: isOpen }] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteIsOpen)();
        (0, $5uXOq.useEffect)(()=>{
            if (!initialised) return;
            if (isOpen) entryPointActions.load();
            else entryPointActions.unload();
        }, [
            isOpen,
            entryPointActions,
            initialised
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!initialised && isOpen) setInitialised(true);
        }, [
            isOpen,
            initialised
        ]);
        const props = (0, $5uXOq.useMemo)(()=>({}), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "commandPaletteAsyncAdminNavigation",
            packageName: "jiraCommandPaletteIntegration",
            teamName: "deliveroo",
            fallback: null,
            errorFallback: "flag",
            runtimeProps: props
        });
    };
});
parcelRegister("ioK7w", function(module, exports) {
    $parcel$export(module.exports, "compalAdminNavigationEntrypoint", ()=>$9df289896dcd40f5$export$ec97befbb495acbe);
    var $eufEc;
    var $fEDBv;
    const $9df289896dcd40f5$export$ec97befbb495acbe = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("erwx9")).then((module)=>module.AdminNavCommands), {
            moduleId: "1ee8a073"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("erwx9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8iIng").then(()=>parcelRequire('kki7C'));
});
parcelRegister("jM38v", function(module, exports) {
    $parcel$export(module.exports, "ThemeModeCommands", ()=>$4013ec61deab79f6$export$cecc9cf59bb74e7d);
    var $5uXOq = parcelRequire("5uXOq");
    var $lzUP9;
    var $5p1kJ;
    var $eG9rp;
    var $1Kt4o;
    var $5zCdk;
    var $jh7L9;
    var $b9op4;
    var $8XWT9;
    var $gbWPi;
    var $koVbs;
    var $2Ql51;
    var $QbdOh;
    const $4013ec61deab79f6$export$17b41f710dd67667 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { theme: currentTheme = 'light', setTheme: setTheme } = (0, (0, parcelRequire("2Ql51")).useThemePreference)();
        const { triggerCustomNavBarColorsFlag: triggerCustomNavBarColorsFlag } = (0, (0, parcelRequire("gbWPi")).default)();
        const setThemeWithCustomNavBarFlag = (0, $5uXOq.useCallback)(async (newTheme)=>{
            await setTheme(newTheme);
            triggerCustomNavBarColorsFlag(newTheme);
        }, [
            setTheme,
            triggerCustomNavBarColorsFlag
        ]);
        const { getKeywords: getKeywords } = (0, (0, parcelRequire("eG9rp")).useCommandKeywords)();
        const createThemeCommand = (0, $5uXOq.useCallback)((theme, message, priority)=>({
                id: `command-palette-integration-change-theme-mode-${theme}`,
                name: formatMessage(message),
                keywords: theme === 'auto' ? getKeywords('matchSystemThemeSynonyms') : getKeywords('switchDarkThemeSynonyms'),
                primaryAction: {
                    type: (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM,
                    perform: ()=>setThemeWithCustomNavBarFlag(theme)
                },
                components: {
                    LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lzUP9"))))), {
                            label: formatMessage(message)
                        })
                },
                section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).personalSettings,
                priority: priority,
                analytics: {
                    action: 'toggleTheme'
                }
            }), [
            formatMessage,
            getKeywords,
            setThemeWithCustomNavBarFlag
        ]);
        const themeModeCommands = (0, $5uXOq.useMemo)(()=>{
            const availableThemesMode = {
                dark: createThemeCommand('dark', (0, (0, parcelRequire("QbdOh")).messages).commandDarkTheme, (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY).switchToDarkTheme),
                light: createThemeCommand('light', (0, (0, parcelRequire("QbdOh")).messages).commandLightTheme, (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY).switchToLightTheme),
                auto: createThemeCommand('auto', (0, (0, parcelRequire("QbdOh")).messages).commandAutoTheme, (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY).switchToSystemTheme)
            };
            const listOfCommands = [];
            Object.entries(availableThemesMode).forEach(([key, command])=>{
                if (key !== currentTheme && (0, (0, parcelRequire("b9op4")).ThemeOptions).includes(key)) listOfCommands.push(command);
            });
            return listOfCommands;
        }, [
            createThemeCommand,
            currentTheme
        ]);
        return themeModeCommands;
    };
    const $4013ec61deab79f6$export$cecc9cf59bb74e7d = ()=>{
        const [{ flagIsDismissed: flagIsDismissed }] = (0, (0, parcelRequire("8XWT9")).useCustomNavBarColorWarnings)();
        const command = $4013ec61deab79f6$export$17b41f710dd67667();
        const commandIds = command.map(({ id: id })=>id).toString();
        (0, (0, parcelRequire("5zCdk")).useRegisterCommands)((0, (0, parcelRequire("1Kt4o")).COMMAND_PALETTE_REGISTRY_IDS).THEME_MODE, command, [
            commandIds,
            flagIsDismissed
        ]);
        return null;
    };
});
parcelRegister("b9op4", function(module, exports) {
    $parcel$export(module.exports, "ThemeOptions", ()=>$a1d11c8212b90b3e$export$abe7936539cefefe);
    $parcel$export(module.exports, "DEFAULT_THEME", ()=>$a1d11c8212b90b3e$export$2faeed762aac6741);
    const $a1d11c8212b90b3e$export$abe7936539cefefe = [
        'light',
        'dark',
        'auto'
    ];
    const $a1d11c8212b90b3e$export$2faeed762aac6741 = 'light';
});
parcelRegister("8XWT9", function(module, exports) {
    $parcel$export(module.exports, "useCustomNavBarColorWarnings", ()=>$28ca8e14b9652104$export$c3d02c4eeb80172a);
    var $3sQ5x;
    var $iXqE5;
    var $hrJZF;
    const $28ca8e14b9652104$var$initialState = {
        isLoading: true
    };
    const $28ca8e14b9652104$var$CustomNavBarColorsFlagDismissalStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $28ca8e14b9652104$var$initialState,
        actions: (0, parcelRequire("hrJZF")).actions,
        name: 'custom-nav-bar-colors-flag-dismissal'
    });
    const $28ca8e14b9652104$export$c3d02c4eeb80172a = (0, (0, parcelRequire("3sQ5x")).createHook)($28ca8e14b9652104$var$CustomNavBarColorsFlagDismissalStore);
});
parcelRegister("hrJZF", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$77586aec2cac1312$export$e324594224ef24da);
    var $aIx7d;
    const $77586aec2cac1312$export$e324594224ef24da = {
        initialFetch: ()=>async ({ setState: setState, getState: getState })=>{
                const { isLoading: isLoading } = getState();
                if (!isLoading) return;
                setState({
                    isLoading: false
                });
                const [flagDismissedRes, sectionMessageDismissedRes] = await Promise.allSettled([
                    (0, (0, parcelRequire("aIx7d")).getCustomNavBarFlagDismissed)(),
                    (0, (0, parcelRequire("aIx7d")).getCustomNavBarMessageDismissed)()
                ]);
                setState({
                    flagIsDismissed: flagDismissedRes.status === 'fulfilled' ? flagDismissedRes.value || false : false,
                    sectionMessageIsDismissed: sectionMessageDismissedRes.status === 'fulfilled' ? sectionMessageDismissedRes.value || false : false
                });
            },
        setFlagIsDismissed: ()=>({ setState: setState })=>{
                setState({
                    flagIsDismissed: true
                });
                (0, (0, parcelRequire("aIx7d")).setCustomNavBarFlagDismissed)(true);
            },
        setMessageIsDismissed: ()=>({ setState: setState })=>{
                setState({
                    sectionMessageIsDismissed: true
                });
                (0, (0, parcelRequire("aIx7d")).setCustomNavBarMessageDismissed)(true);
            }
    };
});
parcelRegister("aIx7d", function(module, exports) {
    $parcel$export(module.exports, "setCustomNavBarFlagDismissed", ()=>$8c6bdc5d8e0ccf04$export$96c3ac24c205921e);
    $parcel$export(module.exports, "getCustomNavBarFlagDismissed", ()=>$8c6bdc5d8e0ccf04$export$4875b5188973cc41);
    $parcel$export(module.exports, "getCustomNavBarMessageDismissed", ()=>$8c6bdc5d8e0ccf04$export$234ec7e66f5f0d80);
    $parcel$export(module.exports, "setCustomNavBarMessageDismissed", ()=>$8c6bdc5d8e0ccf04$export$81fcff1db07fc096);
    var $jcw0u;
    var $aHuqL;
    var $dDTxW;
    const $8c6bdc5d8e0ccf04$export$96c3ac24c205921e = async (value)=>{
        try {
            await (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).set((0, (0, parcelRequire("dDTxW")).CUSTOM_NAV_BAR_COLORS_FLAG_DISMISSED_KEY), value);
        } catch (err) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: err,
                meta: {
                    id: 'setCustomNavBarFlagDismissed',
                    packageName: 'jiraCustomNavBarColorsFlag'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
    const $8c6bdc5d8e0ccf04$export$4875b5188973cc41 = async ()=>{
        try {
            return await (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).get((0, (0, parcelRequire("dDTxW")).CUSTOM_NAV_BAR_COLORS_FLAG_DISMISSED_KEY));
        } catch (err) {
            if (err.statusCode !== 404) (0, (0, parcelRequire("jcw0u")).default)({
                error: err,
                meta: {
                    id: 'getCustomNavBarFlagDismissed',
                    packageName: 'jiraCustomNavBarColorsFlag'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return null;
        }
    };
    const $8c6bdc5d8e0ccf04$export$234ec7e66f5f0d80 = async ()=>{
        try {
            return await (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).get((0, (0, parcelRequire("dDTxW")).CUSTOM_NAV_BAR_COLORS_SECTION_MESSAGE_DISMISSED_KEY));
        } catch (err) {
            if (err.statusCode !== 404) (0, (0, parcelRequire("jcw0u")).default)({
                error: err,
                meta: {
                    id: 'getCustomNavBarMessageDismissed',
                    packageName: 'jiraCustomNavBarColorsFlag'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return null;
        }
    };
    const $8c6bdc5d8e0ccf04$export$81fcff1db07fc096 = async (value)=>{
        try {
            await (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).set((0, (0, parcelRequire("dDTxW")).CUSTOM_NAV_BAR_COLORS_SECTION_MESSAGE_DISMISSED_KEY), value);
        } catch (err) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: err,
                meta: {
                    id: 'setCustomTopNavDarkModeDismissed',
                    packageName: 'jiraCustomNavBarColorsFlag'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
});
parcelRegister("dDTxW", function(module, exports) {
    $parcel$export(module.exports, "CUSTOM_NAV_BAR_COLORS_FLAG_DISMISSED_KEY", ()=>$c0e20f2a55cada89$export$e322337c75e7fd2e);
    $parcel$export(module.exports, "CUSTOM_NAV_BAR_COLORS_SECTION_MESSAGE_DISMISSED_KEY", ()=>$c0e20f2a55cada89$export$d37f7f5db461e560);
    $parcel$export(module.exports, "CUSTOM_NAV_BAR_COLORS_FLAG_ID", ()=>$c0e20f2a55cada89$export$385ef2d36e85217);
    $parcel$export(module.exports, "HELP_ARTICLE_ID", ()=>$c0e20f2a55cada89$export$1da9e2242c8f1be7);
    var $7HGHK;
    const $c0e20f2a55cada89$export$e322337c75e7fd2e = 'jira.user.theme.custom-nav-bar-flag.dismissed';
    const $c0e20f2a55cada89$export$d37f7f5db461e560 = 'jira.user.theme.custom-nav-bar-section-message.dismissed';
    const $c0e20f2a55cada89$export$385ef2d36e85217 = (0, (0, parcelRequire("7HGHK")).toFlagId)('onThemeChangeCustomColorsFlag');
    const $c0e20f2a55cada89$export$1da9e2242c8f1be7 = '1QC8AUgw7MAmoVtoYXQDxM';
});
parcelRegister("gbWPi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8bd9ca6946fb47c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9MAC1;
    var $pa9q9;
    var $dDTxW;
    var $8XWT9;
    var $aPd0G;
    const $8bd9ca6946fb47c1$var$useCustomNavBarColorsFlag = ()=>{
        const { hasFlag: hasFlag, showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const [{ navigationTheme: navigationTheme }] = (0, (0, parcelRequire("9MAC1")).useTheme)();
        const [{ flagIsDismissed: flagIsDismissed, sectionMessageIsDismissed: sectionMessageIsDismissed, isLoading: isLoading }, { setFlagIsDismissed: setFlagIsDismissed, initialFetch: initialFetch }] = (0, (0, parcelRequire("8XWT9")).useCustomNavBarColorWarnings)();
        (0, $5uXOq.useEffect)(()=>{
            initialFetch();
        }, [
            initialFetch
        ]);
        const handleDismiss = (0, $5uXOq.useCallback)(()=>{
            dismissFlag((0, (0, parcelRequire("dDTxW")).CUSTOM_NAV_BAR_COLORS_FLAG_ID));
            setFlagIsDismissed();
        }, [
            dismissFlag,
            setFlagIsDismissed
        ]);
        const shouldShowFlag = (0, $5uXOq.useCallback)((theme)=>!isLoading && !hasFlag?.((0, (0, parcelRequire("dDTxW")).CUSTOM_NAV_BAR_COLORS_FLAG_ID)) && (theme === 'dark' || theme === 'auto') && navigationTheme.usesCustomColours && flagIsDismissed === false && sectionMessageIsDismissed === false, [
            hasFlag,
            navigationTheme.usesCustomColours,
            isLoading,
            flagIsDismissed,
            sectionMessageIsDismissed
        ]);
        const triggerCustomNavBarColorsFlag = (0, $5uXOq.useCallback)((newTheme)=>{
            if (shouldShowFlag(newTheme)) showFlag({
                id: (0, (0, parcelRequire("dDTxW")).CUSTOM_NAV_BAR_COLORS_FLAG_ID),
                render: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aPd0G")).default), {
                        ...props,
                        onDismiss: handleDismiss,
                        analyticsAttributes: {
                            backgroundColor: navigationTheme.backgroundColor,
                            highlightColor: navigationTheme.highlightColor
                        }
                    })
            });
        }, [
            shouldShowFlag,
            handleDismiss,
            showFlag,
            navigationTheme
        ]);
        return {
            triggerCustomNavBarColorsFlag: triggerCustomNavBarColorsFlag
        };
    };
    var $8bd9ca6946fb47c1$export$2e2bcd8739ae039 = $8bd9ca6946fb47c1$var$useCustomNavBarColorsFlag;
});
parcelRegister("9MAC1", function(module, exports) {
    $parcel$export(module.exports, "useTheme", ()=>$a1f770a9d49220c1$export$93d4e7f90805808f);
    $parcel$export(module.exports, "ThemeContainer", ()=>$a1f770a9d49220c1$export$11eb671888ed6e7d);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    var $LtWMd;
    const $a1f770a9d49220c1$var$initialState = {
        navigationTheme: {
            shouldShowTitle: false,
            logoUrl: '',
            usesCustomColours: false,
            backgroundColor: '',
            highlightColor: ''
        }
    };
    const $a1f770a9d49220c1$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'theme',
        initialState: $a1f770a9d49220c1$var$initialState,
        actions: (0, parcelRequire("LtWMd"))
    });
    const $a1f770a9d49220c1$export$74e6aa5aeff5e82e = (0, (0, parcelRequire("51nlc")).createSubscriber)($a1f770a9d49220c1$var$Store);
    const $a1f770a9d49220c1$export$93d4e7f90805808f = (0, (0, parcelRequire("3sQ5x")).createHook)($a1f770a9d49220c1$var$Store);
    const $a1f770a9d49220c1$export$11eb671888ed6e7d = (0, (0, parcelRequire("gg7kZ")).createContainer)($a1f770a9d49220c1$var$Store, {
        onInit: (0, parcelRequire("LtWMd")).bootstrap
    });
});
parcelRegister("LtWMd", function(module, exports) {
    $parcel$export(module.exports, "bootstrap", ()=>$9594f0aa641d3463$export$36aff1fbb4f5dfc6);
    $parcel$export(module.exports, "update", ()=>$9594f0aa641d3463$export$722fbec263ad908a);
    const $9594f0aa641d3463$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState }, { getMeta: getMeta })=>{
            const ajsBackgroundColor = getMeta('ajs-lf-navigation-bgcolour');
            const ajsHighlightColor = getMeta('ajs-lf-navigation-highlightcolour');
            const hasNavv3CustomColors = ajsBackgroundColor != null && ajsHighlightColor != null && (ajsBackgroundColor !== (0, $829f609a65d26a98$exports).N0 || ajsHighlightColor !== (0, $829f609a65d26a98$exports).B400);
            const navigationTheme = {
                shouldShowTitle: getMeta('ajs-lf-top-adg3-shouldshowtitle') === 'true',
                logoUrl: getMeta('ajs-lf-top-adg3-logourl') || '',
                usesCustomColours: getMeta('ajs-lf-top-adg3-hascustomcolours') === 'true',
                backgroundColor: ajsBackgroundColor || `var(--ds-background-inverse-subtle, ${(0, $829f609a65d26a98$exports).N0})`,
                highlightColor: ajsHighlightColor || `var(--ds-text-brand, ${(0, $829f609a65d26a98$exports).B400})`
            };
            if (hasNavv3CustomColors) navigationTheme.usesCustomColours = true;
            setState({
                navigationTheme: navigationTheme
            });
        };
    const $9594f0aa641d3463$export$722fbec263ad908a = (item)=>({ setState: setState, getState: getState })=>{
            const navigationTheme = {
                ...getState().navigationTheme,
                ...item
            };
            setState({
                navigationTheme: navigationTheme
            });
        };
});
parcelRegister("aPd0G", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1272b579c76deef$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2hXfb;
    var $3KRpp;
    var $5Zxxp;
    var $koVbs;
    var $8zOmE;
    var $dDTxW;
    var $6aFdn;
    const $d1272b579c76deef$export$e5995f97d3b9e5eb = 'router-resources.theme-preference.custom-nav-bar-colors-flag';
    const $d1272b579c76deef$var$CustomNavBarColorsFlag = ({ onDismiss: onDismiss, analyticsAttributes: analyticsAttributes })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onOpenInProductHelpArticle = (0, (0, parcelRequire("5Zxxp")).useHelpPanelLink)();
        const onDismissFn = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'customTopNavUserFlagWarningDismissButton', analyticsAttributes);
            onDismiss();
        }, [
            onDismiss,
            analyticsAttributes
        ]);
        return (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).InfoFlag), {
                icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2hXfb"))))), {
                    primaryColor: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
                    label: ""
                }),
                testId: $d1272b579c76deef$export$e5995f97d3b9e5eb,
                id: (0, (0, parcelRequire("dDTxW")).CUSTOM_NAV_BAR_COLORS_FLAG_ID),
                title: formatMessage((0, (0, parcelRequire("6aFdn")).default).title),
                description: formatMessage((0, (0, parcelRequire("6aFdn")).default).description),
                onDismissed: onDismissFn,
                actions: [
                    {
                        content: formatMessage((0, (0, parcelRequire("6aFdn")).default).learnMoreAction),
                        onClick: (_, analyticsEvent)=>{
                            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'customTopNavUserFlagWarningMoreButton', analyticsAttributes);
                            onOpenInProductHelpArticle?.((0, (0, parcelRequire("dDTxW")).HELP_ARTICLE_ID));
                        }
                    },
                    {
                        content: formatMessage((0, (0, parcelRequire("6aFdn")).default).dismissAction),
                        onClick: onDismissFn
                    }
                ]
            }), [
            formatMessage,
            onDismissFn,
            onOpenInProductHelpArticle,
            analyticsAttributes
        ]);
    };
    var $d1272b579c76deef$export$2e2bcd8739ae039 = $d1272b579c76deef$var$CustomNavBarColorsFlag;
});
parcelRegister("3KRpp", function(module, exports) {
    $parcel$export(module.exports, "CommonFlag", ()=>$ef767762d5402ccf$export$13d73238a031436b);
    $parcel$export(module.exports, "ErrorFlag", ()=>$ef767762d5402ccf$export$518ba8e0e60f145f);
    $parcel$export(module.exports, "ErrorAutoDismissFlag", ()=>$ef767762d5402ccf$export$3f75672bb90a4431);
    $parcel$export(module.exports, "InfoFlag", ()=>$ef767762d5402ccf$export$6a55b52e74c1e48e);
    $parcel$export(module.exports, "SuccessAutoDismissFlag", ()=>$ef767762d5402ccf$export$74a3c0748aa31355);
    $parcel$export(module.exports, "SuccessFlag", ()=>$ef767762d5402ccf$export$93bd4963a1d00fd5);
    $parcel$export(module.exports, "WarningFlag", ()=>$ef767762d5402ccf$export$23695d8281998f27);
    $parcel$export(module.exports, "FlagGroup", ()=>$ef767762d5402ccf$export$a2c3479950310d7d);
    var $5uXOq = parcelRequire("5uXOq");
    var $1eg3p;
    var $kxZPA;
    const $ef767762d5402ccf$var$ForPaintJiraCommonFlag = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintJiraCommonFlag = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$CommonFlagImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintJiraCommonFlag, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintJiraCommonFlag, props);
    const $ef767762d5402ccf$var$ForPaintFlagGroup = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintFlagGroup = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$FlagGroupImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintFlagGroup, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintFlagGroup, props);
    const $ef767762d5402ccf$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, props));
    const $ef767762d5402ccf$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            ...props
        }));
    const $ef767762d5402ccf$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "info",
            ...props
        }));
    const $ef767762d5402ccf$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            ...props
        }));
    const $ef767762d5402ccf$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "warning",
            ...props
        }));
    const $ef767762d5402ccf$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$FlagGroupImpl, props));
});
parcelRegister("1eg3p", function(module, exports) {
    $parcel$export(module.exports, "FlagsBoundary", ()=>$6fa78f2e53e42d4a$export$8b4a0fffcddd96f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $lfTZh;
    const $6fa78f2e53e42d4a$export$8b4a0fffcddd96f4 = ({ children: children, packageName: packageName })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "flags",
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "flags-boundary",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, children));
});
parcelRegister("lKKug", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4yB9l")
    ]).then(()=>parcelRequire('8ZHDV'));
});
parcelRegister("fhw5b", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("Fkef4").then(()=>parcelRequire('5pz6a'));
});
parcelRegister("5Zxxp", function(module, exports) {
    $parcel$export(module.exports, "useHelpPanelLink", ()=>$b0d1b3c2fea05784$export$dc5c3cc39ce0d138);
    $parcel$export(module.exports, "default", ()=>$b0d1b3c2fea05784$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $bHDKL;
    var $e4yMr;
    var $jpY8v;
    var $4R6GH;
    var $6BNJk;
    var $kspz4;
    var $hsmeR;
    const $b0d1b3c2fea05784$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
        const { openRightSidebar: openRightSidebar } = (0, (0, parcelRequire("hsmeR")).useRightSidebarController)();
        const [, { setNavigationData: setNavigationData }] = (0, (0, parcelRequire("kspz4")).useHelpPanelActions)();
        const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
            openRightSidebar((0, (0, parcelRequire("6BNJk")).HELP_PANEL_ID), (0, (0, parcelRequire("6BNJk")).HELP_PANEL_WIDTH), false, true);
            if (resetHistory) setNavigationData({
                articleId: {
                    id: id,
                    type: (0, (0, parcelRequire("bHDKL")).ARTICLE_TYPE)[type]
                },
                history: []
            });
            else setNavigationData({
                articleId: {
                    id: id,
                    type: (0, (0, parcelRequire("bHDKL")).ARTICLE_TYPE)[type]
                }
            });
        };
        return !(0, (0, parcelRequire("jpY8v")).isIE11)() ? handleOnClick : undefined;
    };
    const $b0d1b3c2fea05784$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, fallbackComponent: fallbackComponent = null, onClick: onClick, href: href, ...props })=>{
        const onOpenInProductHelpArticle = $b0d1b3c2fea05784$export$dc5c3cc39ce0d138();
        const handleOnClick = (event, analyticsEvent)=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('help_panel_as_link')) event.preventDefault();
            onClick?.(event, analyticsEvent);
            onOpenInProductHelpArticle?.(articleId, (0, (0, parcelRequire("bHDKL")).ARTICLE_TYPE)[type]);
        };
        if ((0, (0, parcelRequire("4R6GH")).fg)('help_panel_as_link')) return onOpenInProductHelpArticle ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
            ...props,
            onClick: handleOnClick,
            href: href ?? 'https://support.atlassian.com',
            appearance: "default",
            testId: props.testId
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, fallbackComponent);
        return onOpenInProductHelpArticle ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ...props,
            onClick: handleOnClick,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1"
            ])
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, fallbackComponent);
    };
    var $b0d1b3c2fea05784$export$2e2bcd8739ae039 = $b0d1b3c2fea05784$var$HelpPanelLink;
    const $b0d1b3c2fea05784$var$buttonWrapperStyles = null;
});
parcelRegister("6BNJk", function(module, exports) {
    $parcel$export(module.exports, "HELP_PANEL_VERSION", ()=>$20386d7da4313ff0$export$c43c7444da662fa1);
    $parcel$export(module.exports, "HELP_PANEL_ID", ()=>$20386d7da4313ff0$export$e99efa3985fa3c26);
    $parcel$export(module.exports, "HELP_PANEL_WIDTH", ()=>$20386d7da4313ff0$export$23aa6670f346c214);
    var $gwIPs;
    const $20386d7da4313ff0$export$c43c7444da662fa1 = '1';
    const $20386d7da4313ff0$export$e99efa3985fa3c26 = 'helpPanel';
    const $20386d7da4313ff0$export$23aa6670f346c214 = (0, (0, parcelRequire("gwIPs")).gridSize) * 46;
});
parcelRegister("kspz4", function(module, exports) {
    $parcel$export(module.exports, "useHelpPanel", ()=>$aee6103177ce0723$export$3fe94d66377a53b8);
    $parcel$export(module.exports, "useHelpPanelActions", ()=>$aee6103177ce0723$export$c61f56f4797e22db);
    var $3sQ5x;
    var $51nlc;
    var $jgGDm;
    const $aee6103177ce0723$export$3fe94d66377a53b8 = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("jgGDm")).default));
    const $aee6103177ce0723$export$c61f56f4797e22db = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("jgGDm")).default), {
        selector: null
    });
    const $aee6103177ce0723$export$513717a84f55db1a = (0, (0, parcelRequire("51nlc")).createSubscriber)((0, (0, parcelRequire("jgGDm")).default), {
        displayName: 'HelpPanelSubscriber'
    });
    const $aee6103177ce0723$export$5f4de38bd79f4446 = (0, (0, parcelRequire("51nlc")).createSubscriber)((0, (0, parcelRequire("jgGDm")).default), {
        displayName: 'HelpPanelActionsSubscriber',
        selector: null
    });
});
parcelRegister("jgGDm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$465615692863cce9$export$2e2bcd8739ae039);
    var $eNf8a;
    var $iXqE5;
    var $958ua;
    const $465615692863cce9$var$iphStorage = (0, (0, parcelRequire("eNf8a")).createSessionStorageProvider)('iph');
    const $465615692863cce9$var$initialState = {
        navigationData: {
            articleId: {
                id: '',
                type: 'HELP_ARTICLE'
            },
            history: $465615692863cce9$var$iphStorage.get('history') || []
        },
        releaseNotesNotifications: 100
    };
    var $465615692863cce9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'help-panel',
        initialState: $465615692863cce9$var$initialState,
        actions: (0, parcelRequire("958ua"))
    });
});
parcelRegister("958ua", function(module, exports) {
    $parcel$export(module.exports, "setNavigationData", ()=>$177ac56c5a5bf49e$export$ab1b80f40ca898ed);
    $parcel$export(module.exports, "setReleaseNotesNotifications", ()=>$177ac56c5a5bf49e$export$cdabe01d01a8da1e);
    var $eNf8a;
    const $177ac56c5a5bf49e$var$iphStorage = (0, (0, parcelRequire("eNf8a")).createSessionStorageProvider)('iph');
    const $177ac56c5a5bf49e$export$ab1b80f40ca898ed = (navigationData)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                navigationData: {
                    articleId: navigationData.articleId ? navigationData.articleId : currentState.navigationData.articleId,
                    history: navigationData.history ? navigationData.history : currentState.navigationData.history
                }
            });
            $177ac56c5a5bf49e$var$iphStorage.set('history', []);
        };
    const $177ac56c5a5bf49e$export$cdabe01d01a8da1e = (releaseNotesNotifications)=>({ setState: setState })=>{
            setState({
                releaseNotesNotifications: releaseNotesNotifications
            });
        };
});
parcelRegister("hsmeR", function(module, exports) {
    $parcel$export(module.exports, "useActiveRightSidebarState", ()=>$39a48ee662f10943$export$ba763ab7661c3103);
    $parcel$export(module.exports, "useRightSidebarState", ()=>$39a48ee662f10943$export$d1828e7f46a4960b);
    $parcel$export(module.exports, "useRightSidebarController", ()=>$39a48ee662f10943$export$ebe5e907fb0bb63a);
    var $5uXOq = parcelRequire("5uXOq");
    var $3sQ5x;
    var $byk51;
    var $5e5zm;
    const $39a48ee662f10943$var$useActiveRightSidebar = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>{
            const rightSidebarState = (0, (0, parcelRequire("byk51")).selectCurrentRightSidebar)(state.content.rightSidebar);
            if (!rightSidebarState) return null;
            return {
                ...rightSidebarState,
                shouldRender: !state.isChromeless
            };
        }
    });
    const $39a48ee662f10943$export$ba763ab7661c3103 = ()=>{
        const [rightSidebar] = $39a48ee662f10943$var$useActiveRightSidebar();
        return rightSidebar;
    };
    const $39a48ee662f10943$var$useRightSidebar = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>state.content.rightSidebar
    });
    const $39a48ee662f10943$export$d1828e7f46a4960b = ()=>{
        const [rightSidebarState] = $39a48ee662f10943$var$useRightSidebar();
        return rightSidebarState;
    };
    const $39a48ee662f10943$export$ebe5e907fb0bb63a = ()=>{
        const [, { setRightSidebarState: setRightSidebarState, openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar, closeAllRightSidebar: closeAllRightSidebar, minimiseRightSidebar: minimiseRightSidebar }] = (0, (0, parcelRequire("5e5zm")).useLayoutStoreActions)();
        return (0, $5uXOq.useMemo)(()=>({
                setRightSidebarState: setRightSidebarState,
                closeRightSidebar: closeRightSidebar,
                openRightSidebar: openRightSidebar,
                closeCurrentRightSidebar: closeCurrentRightSidebar,
                closeAllRightSidebar: closeAllRightSidebar,
                minimiseRightSidebar: minimiseRightSidebar
            }), [
            closeAllRightSidebar,
            closeCurrentRightSidebar,
            closeRightSidebar,
            openRightSidebar,
            setRightSidebarState,
            minimiseRightSidebar
        ]);
    };
});
parcelRegister("byk51", function(module, exports) {
    $parcel$export(module.exports, "selectCurrentRightSidebar", ()=>$4dabd377b098e1a2$export$57758d0cfaeec2c);
    $parcel$export(module.exports, "setRightSidebarState", ()=>$4dabd377b098e1a2$export$f5584170a8c1db02);
    $parcel$export(module.exports, "closeAllRightSidebar", ()=>$4dabd377b098e1a2$export$d91a6e55d52aa3e9);
    $parcel$export(module.exports, "closeCurrentRightSidebar", ()=>$4dabd377b098e1a2$export$a9a5075d3d1b2165);
    $parcel$export(module.exports, "closeRightSidebar", ()=>$4dabd377b098e1a2$export$d7149233c76efb32);
    $parcel$export(module.exports, "minimiseRightSidebar", ()=>$4dabd377b098e1a2$export$4eedf7fa26a2749a);
    $parcel$export(module.exports, "openRightSidebar", ()=>$4dabd377b098e1a2$export$c8dafe074328c4ca);
    var $ajpes = parcelRequire("ajpes");
    const $4dabd377b098e1a2$var$arrayMove = (array, oldIndex, newIndex)=>{
        const arrayCopy = [
            ...array
        ];
        const f = arrayCopy.splice(oldIndex, 1)[0];
        arrayCopy.splice(newIndex, 0, f);
        return arrayCopy;
    };
    const $4dabd377b098e1a2$var$dedupe = (stackState = [])=>{
        const visited = {};
        return stackState.filter((item)=>{
            if (visited[item.panelId]) return false;
            visited[item.panelId] = true;
            return true;
        });
    };
    const $4dabd377b098e1a2$export$57758d0cfaeec2c = (state)=>{
        if (state.stackState.length === 1) return state.stackState[0];
        return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
    };
    const $4dabd377b098e1a2$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: $4dabd377b098e1a2$var$dedupe(newState.stackState)
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: []
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const currentStack = content.rightSidebar.stackState || [];
            if (!currentStack.length) return;
            const currentRightSidebar = $4dabd377b098e1a2$export$57758d0cfaeec2c(content.rightSidebar);
            if (!currentRightSidebar) return;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const currentStack = content.rightSidebar.stackState || [];
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: currentStack.filter((item)=>item.panelId !== panelId)
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const currentStack = content.rightSidebar.stackState || [];
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: currentStack.map((item)=>{
                            if (item.panelId !== panelId) return item;
                            return {
                                ...item,
                                isMinimised: true
                            };
                        })
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
                ...content.rightSidebar.stackState.map((item)=>{
                    if (item.panelId === panelId) return {
                        ...item,
                        isMinimised: isMinimised,
                        width: width
                    };
                    return item;
                })
            ] : [];
            const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
            if (matchedPanelIndex >= 0) {
                const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
                tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
                tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
                const newRightSidebarStackStateValue = $4dabd377b098e1a2$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
                newRightSidebarStackStateValue[nextIdx].width = width;
                setState({
                    content: {
                        ...content,
                        rightSidebar: {
                            stackState: newRightSidebarStackStateValue
                        }
                    }
                });
                return;
            }
            const newRightSidebarStackStateValue = toTop ? [
                {
                    panelId: panelId,
                    width: width,
                    isCollapsed: false,
                    isMinimised: isMinimised
                },
                ...tempRightSidebarStackStateValue
            ] : [
                ...tempRightSidebarStackStateValue,
                {
                    panelId: panelId,
                    width: width,
                    isCollapsed: false,
                    isMinimised: isMinimised
                }
            ];
            if ((0, ($parcel$interopDefault($ajpes)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
        };
});
parcelRegister("5e5zm", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", ()=>$0c99a19d69d506cf$export$539e68c09584883a);
    $parcel$export(module.exports, "layoutStore", ()=>$0c99a19d69d506cf$export$b8cdfd44cddaf07);
    $parcel$export(module.exports, "useLayoutStoreActions", ()=>$0c99a19d69d506cf$export$6136bc3b9858cff4);
    $parcel$export(module.exports, "useDetailPanelWidth", ()=>$0c99a19d69d506cf$export$95fd7b6da3b9bbb0);
    $parcel$export(module.exports, "useDetailPanelActions", ()=>$0c99a19d69d506cf$export$99e05a60cac05e86);
    var $3sQ5x;
    var $iXqE5;
    var $8CM3x;
    const $0c99a19d69d506cf$export$539e68c09584883a = 240;
    const $0c99a19d69d506cf$export$b92df8810d2fcd01 = 0;
    const $0c99a19d69d506cf$var$initialState = {
        isChromeless: false,
        isFullscreen: false,
        banner: {
            height: 0,
            activeBanner: null
        },
        topNavigation: {
            isVisible: true
        },
        leftPanel: {
            isVisible: true,
            width: 0
        },
        rightPanel: {
            isVisible: true,
            width: 0
        },
        bottomRightCorner: {
            container: undefined,
            portals: []
        },
        content: {
            leftSidebar: {
                width: $0c99a19d69d506cf$export$539e68c09584883a,
                isCollapsed: true,
                isVisible: true,
                isFlyoutOpen: false
            },
            rightSidebar: {
                stackState: []
            }
        }
    };
    const $0c99a19d69d506cf$export$b8cdfd44cddaf07 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $0c99a19d69d506cf$var$initialState,
        actions: (0, parcelRequire("8CM3x")).actions,
        name: 'JiraLayoutStore'
    });
    const $0c99a19d69d506cf$export$6136bc3b9858cff4 = (0, (0, parcelRequire("3sQ5x")).createHook)($0c99a19d69d506cf$export$b8cdfd44cddaf07, {
        selector: null
    });
    const $0c99a19d69d506cf$var$detailPanelWidthStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'detailPanelWidth',
        initialState: {
            width: 0
        },
        actions: {
            setWidth: (value)=>({ setState: setState })=>{
                    setState({
                        width: value
                    });
                }
        }
    });
    const $0c99a19d69d506cf$export$95fd7b6da3b9bbb0 = (0, (0, parcelRequire("3sQ5x")).createHook)($0c99a19d69d506cf$var$detailPanelWidthStore);
    const $0c99a19d69d506cf$export$99e05a60cac05e86 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($0c99a19d69d506cf$var$detailPanelWidthStore);
});
parcelRegister("8CM3x", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$939ad82f8ddcb8d9$export$e324594224ef24da);
    var $4oU0I;
    var $flhve;
    var $f5TQt;
    var $hPsAX;
    var $gqQUV;
    var $byk51;
    const $939ad82f8ddcb8d9$export$e324594224ef24da = {
        setIsChromeless: (0, parcelRequire("f5TQt")).setIsChromeless,
        setIsFullscreen: (0, parcelRequire("hPsAX")).setIsFullscreen,
        showBanner: (0, parcelRequire("4oU0I")).showBanner,
        dismissCurrentBanner: (0, parcelRequire("4oU0I")).dismissCurrentBanner,
        setLeftSidebarState: (0, parcelRequire("gqQUV")).setLeftSidebarState,
        setRightSidebarState: (0, parcelRequire("byk51")).setRightSidebarState,
        openRightSidebar: (0, parcelRequire("byk51")).openRightSidebar,
        closeRightSidebar: (0, parcelRequire("byk51")).closeRightSidebar,
        closeAllRightSidebar: (0, parcelRequire("byk51")).closeAllRightSidebar,
        closeCurrentRightSidebar: (0, parcelRequire("byk51")).closeCurrentRightSidebar,
        minimiseRightSidebar: (0, parcelRequire("byk51")).minimiseRightSidebar,
        registerBottomRightCornerContainer: (0, parcelRequire("flhve")).registerBottomRightCornerContainer,
        insertBottomRightCornerPortal: (0, parcelRequire("flhve")).insertBottomRightCornerPortal,
        removeBottomRightCornerPortal: (0, parcelRequire("flhve")).removeBottomRightCornerPortal
    };
});
parcelRegister("4oU0I", function(module, exports) {
    $parcel$export(module.exports, "showBanner", ()=>$820929f36789bf81$export$f5c0eb035ef26e87);
    $parcel$export(module.exports, "dismissCurrentBanner", ()=>$820929f36789bf81$export$a45bccc0cc9ac424);
    const $820929f36789bf81$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
            setState({
                banner: newState
            });
        };
    const $820929f36789bf81$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
            dispatch($820929f36789bf81$export$f5c0eb035ef26e87({
                height: 0,
                activeBanner: null
            }));
        };
});
parcelRegister("flhve", function(module, exports) {
    $parcel$export(module.exports, "registerBottomRightCornerContainer", ()=>$560ff4740e75fa9e$export$2992ecf780497763);
    $parcel$export(module.exports, "insertBottomRightCornerPortal", ()=>$560ff4740e75fa9e$export$3ed25a6bee272520);
    $parcel$export(module.exports, "removeBottomRightCornerPortal", ()=>$560ff4740e75fa9e$export$928bf7e228ce06d2);
    const $560ff4740e75fa9e$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
            const { bottomRightCorner: bottomRightCorner } = getState();
            setState({
                bottomRightCorner: {
                    ...bottomRightCorner,
                    container: ref ?? undefined
                }
            });
        };
    const $560ff4740e75fa9e$export$3ed25a6bee272520 = (item)=>({ setState: setState, getState: getState })=>{
            const { bottomRightCorner: bottomRightCorner } = getState();
            const { portals: portals } = bottomRightCorner;
            const sorted = [
                item,
                ...portals
            ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
            const index = sorted.findIndex((portal)=>portal.id === item.id);
            setState({
                bottomRightCorner: {
                    ...bottomRightCorner,
                    portals: sorted
                }
            });
            return index;
        };
    const $560ff4740e75fa9e$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
            const { bottomRightCorner: bottomRightCorner } = getState();
            const { portals: portals } = bottomRightCorner;
            setState({
                bottomRightCorner: {
                    ...bottomRightCorner,
                    portals: portals.filter((portal)=>portal.id !== id)
                }
            });
        };
});
parcelRegister("f5TQt", function(module, exports) {
    $parcel$export(module.exports, "setIsChromeless", ()=>$0389a2d5715d1f25$export$1998c4816ad37edb);
    const $0389a2d5715d1f25$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
            setState({
                isChromeless: isChromeless
            });
        };
});
parcelRegister("hPsAX", function(module, exports) {
    $parcel$export(module.exports, "setIsFullscreen", ()=>$e3c9e6899dc6b3f0$export$9c73b2f282069160);
    const $e3c9e6899dc6b3f0$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
            setState({
                isFullscreen: isFullscreen
            });
        };
});
parcelRegister("gqQUV", function(module, exports) {
    $parcel$export(module.exports, "setLeftSidebarState", ()=>$54ca906cbb882b25$export$3e0fd2d894ef83c8);
    const $54ca906cbb882b25$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            setState({
                content: {
                    ...content,
                    leftSidebar: {
                        ...content.leftSidebar,
                        ...newState
                    }
                }
            });
        };
});
parcelRegister("6aFdn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7a352393f0769184$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7a352393f0769184$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "custom-nav-bar-colors-flag.title",
            "defaultMessage": "Your top navigation menu has custom colors"
        },
        description: {
            "id": "custom-nav-bar-colors-flag.description",
            "defaultMessage": "If the color of your navigation menu doesn't look right in this theme, notify your Jira admin."
        },
        learnMoreAction: {
            "id": "custom-nav-bar-colors-flag.learn-more-action",
            "defaultMessage": "Learn more"
        },
        dismissAction: {
            "id": "custom-nav-bar-colors-flag.dismiss-action",
            "defaultMessage": "Dismiss"
        }
    });
});
parcelRegister("2Ql51", function(module, exports) {
    $parcel$export(module.exports, "themePreferenceResource", ()=>$14feb59df5995657$export$e5a423d1eb1cf1d0);
    $parcel$export(module.exports, "useThemePreference", ()=>$14feb59df5995657$export$3416635c8aeb5bab);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    var $2M1hQ;
    var $2YP9W;
    var $Y0b1l;
    const $14feb59df5995657$var$getDataLoader = ()=>(parcelRequire("7QoEx"));
    const $14feb59df5995657$export$e5a423d1eb1cf1d0 = (0, (0, parcelRequire("2M1hQ")).createResource)({
        type: 'RESOURCE_THEME_PREFERENCE',
        getKey: ()=>'state',
        getDataLoader: $14feb59df5995657$var$getDataLoader,
        maxAge: 300000
    });
    const $14feb59df5995657$export$3416635c8aeb5bab = ()=>{
        const { data: data, update: updateThemePreferenceResource } = (0, (0, parcelRequire("2YP9W")).useResource)($14feb59df5995657$export$e5a423d1eb1cf1d0);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireThemeAnalytics = (0, $5uXOq.useCallback)((current, next)=>{
            const OStheme = window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
            const analyticsEvent = createAnalyticsEvent({
                action: (0, $d0956fbcd917153f$export$89c5cf64ad15c3ea),
                actionSubject: (0, $d0956fbcd917153f$export$9e2cc65718a61846)
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                newPreference: next,
                oldPreference: current,
                OStheme: OStheme
            });
        }, [
            createAnalyticsEvent
        ]);
        const setTheme = (0, $5uXOq.useCallback)(async (theme)=>{
            updateThemePreferenceResource(()=>({
                    theme: theme
                }));
            if (data?.theme !== theme) {
                fireThemeAnalytics(data?.theme, theme);
                await (0, (0, parcelRequire("Y0b1l")).setThemePreference)(theme);
            }
        }, [
            data?.theme,
            updateThemePreferenceResource,
            fireThemeAnalytics
        ]);
        return {
            theme: data?.theme,
            setTheme: setTheme
        };
    };
});
const $d0956fbcd917153f$export$40bd77e1c9f49c27 = 'jira.user.theme.preference';
const $d0956fbcd917153f$export$9e2cc65718a61846 = 'themePreference';
const $d0956fbcd917153f$export$89c5cf64ad15c3ea = 'changed';
parcelRegister("Y0b1l", function(module, exports) {
    $parcel$export(module.exports, "setThemePreference", ()=>$fb319b2ef1da4e47$export$a6b84eebd33787e2);
    $parcel$export(module.exports, "getThemePreference", ()=>$fb319b2ef1da4e47$export$2f7a12048d96237);
    var $b9op4;
    var $jcw0u;
    var $aHuqL;
    const $fb319b2ef1da4e47$export$a6b84eebd33787e2 = (theme)=>{
        const promise = (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).set((0, $d0956fbcd917153f$export$40bd77e1c9f49c27), theme);
        promise.catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'ThemePreferenceCRUD',
                    packageName: 'jiraRouterResourcesThemePreference'
                },
                error: error,
                attributes: {
                    op: 'put',
                    errName: String(error.name),
                    statusCode: error.statusCode,
                    param: `to:${theme}`
                }
            });
        });
        return promise;
    };
    const $fb319b2ef1da4e47$export$2f7a12048d96237 = async ()=>{
        const promise = (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).get((0, $d0956fbcd917153f$export$40bd77e1c9f49c27));
        promise.catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'ThemePreferenceCRUD',
                    packageName: 'jiraRouterResourcesThemePreference'
                },
                error: error,
                attributes: {
                    op: 'get',
                    errName: String(error.name),
                    statusCode: error.statusCode
                }
            });
        });
        promise.then((theme)=>{
            if (theme && !(0, (0, parcelRequire("b9op4")).ThemeOptions).includes(theme)) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'ThemePreferenceCRUD',
                    packageName: 'jiraRouterResourcesThemePreference'
                },
                error: new Error('Unrecognized theme!'),
                attributes: {
                    op: 'get',
                    theme: theme,
                    errName: 'unrecognized value!'
                }
            });
        });
        const theme = await promise;
        return theme && (0, (0, parcelRequire("b9op4")).ThemeOptions).includes(theme) ? theme : undefined;
    };
});
parcelRegister("7QoEx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5DvFw")
    ]).then(()=>parcelRequire('jyeNt'));
});
parcelRegister("QbdOh", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$fcd42d35db30fa36$export$defe85febe8b728c);
    var $7VHMR;
    const $fcd42d35db30fa36$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        commandLightTheme: {
            "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.command-light-theme",
            "defaultMessage": "Switch to light theme"
        },
        commandDarkTheme: {
            "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.command-dark-theme",
            "defaultMessage": "Switch to dark theme"
        },
        commandAutoTheme: {
            "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.command-auto-theme",
            "defaultMessage": "Match system theme"
        },
        themeKeywords: {
            "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.theme-keywords-no-translate",
            "defaultMessage": "switch to dark theme switch to light theme dark mode light mode change appearance change colors night mode day mode theme dark switch theme light switch theme switch switch theme appearance change colors change"
        },
        themeKeywordsMisspelt: {
            "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.theme-keywords-misspelt-no-translate",
            "defaultMessage": "lite theme darkmode lightmode nightmode daymode change colours change"
        },
        autoThemeKeywords: {
            "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.auto-theme-keywords-no-translate",
            "defaultMessage": "match system theme sync to system settings dark mode light mode change appearance change colors night mode day mode system theme match match theme system sync theme to system system theme sync theme dark switch theme light switch theme switch appearance change colors change"
        },
        autoThemeKeywordsMisspelt: {
            "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.auto-theme-keywords-misspelt-no-translate",
            "defaultMessage": "match sistem theme sinc system theme matxh system theme match sytem theme darkmode lightmode nightmode daymode change colours change"
        }
    });
});
